// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.container {
  max-width: 1300px;
  width: 100%;
}

.disabled {
  opacity: 0.6;
  cursor: not-allowed !important;
}
.disabled label {
  cursor: not-allowed !important;
}

.cards-step-2 .body-card {
  color: #6e7889;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 4px;
}
.cards-step-2 iframe {
  width: 100%;
  height: 120px;
  border: none;
  background-color: transparent;
}
.cards-step-2 .UploadDocs .input-content {
  height: 78px;
}
.cards-step-2 .UploadDocs .input-content input {
  height: 78px;
}

.card__generic {
  border-radius: 10px;
  border: 1px solid #929fb0;
  box-shadow: 0px 0px 3px 0px rgba(11, 19, 26, 0.18);
  width: 100%;
  padding: 16px;
}

.form-item__input,
.form-item .ant-input {
  padding: 12px 0;
  border: 0;
  border-bottom: 1px solid #404859;
  border-radius: 0;
}
.form-item__input::placeholder,
.form-item .ant-input::placeholder {
  color: #929fb0;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.card-upload {
  border-radius: 10px;
  border: 1px solid #2a2f3c;
  padding: 12px 16px;
  box-shadow: 0px 0px 3px 0px rgba(11, 19, 26, 0.18);
}
.card-upload .link {
  color: #6e7889;
  text-align: right;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
}
.card-upload p {
  margin: 10px 0;
}

.flex-btw {
  display: flex;
  justify-content: space-between;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.flex-col {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
}

.mt-20 {
  margin-top: 20px;
}
.mt-25 {
  margin-top: 25px;
}
.mt-30 {
  margin-top: 30px;
}
.mt-40 {
  margin-top: 40px;
}
.mt-50 {
  margin-top: 50px;
}
.mt-60 {
  margin-top: 60px;
}
.mt-12 {
  margin-top: 12px;
}
.mt-6 {
  margin-top: 6px;
}
.mt-5 {
  margin-top: 5px;
}
.mt-10 {
  margin-top: 10px;
}
.mt-15 {
  margin-top: 15px;
}

.divider-top {
  border-top: 1px solid #afbdcc;
}

.input-transparent {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0;
}
.input-number {
  width: 100%;
  height: 48px;
  border-radius: 10px;
  border: 1px solid #2a2f3c;
  background: #fff;
}
.input-number .ant-input-number-input-wrap {
  height: 45px;
}
.input-number .ant-input-number-input-wrap .ant-input-number-input {
  height: 45px;
}
.input-number .ant-input-prefix {
  color: #404859;
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
}
.input-number input::placeholder {
  color: #929fb0;
  font-family: Inter;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
}
.input-placeholder-bold::placeholder {
  color: #9bbceb;
  font-family: Inter;
  font-size: 16px;
  font-style: italic;
  font-weight: 500;
  line-height: normal;
}

.body-placeholder::placeholder {
  color: #929fb0;
  font-family: Inter;
  font-size: 14px;
  font-style: italic;
  font-weight: 600;
  line-height: normal;
}
.body-placeholder-w4::placeholder {
  font-weight: 400;
}

.fz-14 {
  font-size: 14px;
}

.fz-12 {
  font-size: 12px;
}

.children {
  padding-bottom: 20px;
}

/* http://meyerweb.com/eric/tools/css/reset/
   v2.0-modified | 20110126
   License: none (public domain)
*/
* {
  box-sizing: border-box;
}

html,
body,
#root {
  margin: 0;
  height: 100%;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* make sure to set some focus styles for accessibility */
:focus {
  outline: 0;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-decoration,
input[type=search]::-webkit-search-results-button,
input[type=search]::-webkit-search-results-decoration {
  -webkit-appearance: none;
  -moz-appearance: none;
}

input[type=search] {
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: content-box;
}

textarea {
  overflow: auto;
  vertical-align: top;
  resize: vertical;
}

/**
   * Correct \`inline-block\` display not defined in IE 6/7/8/9 and Firefox 3.
   */
audio,
canvas,
video {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  max-width: 100%;
}

/**
   * Prevent modern browsers from displaying \`audio\` without controls.
   * Remove excess height in iOS 5 devices.
   */
audio:not([controls]) {
  display: none;
  height: 0;
}

/**
   * Address styling not present in IE 7/8/9, Firefox 3, and Safari 4.
   * Known issue: no IE 6 support.
   */
[hidden] {
  display: none;
}

/**
   * 1. Correct text resizing oddly in IE 6/7 when body \`font-size\` is set using
   *    \`em\` units.
   * 2. Prevent iOS text size adjust after orientation change, without disabling
   *    user zoom.
   */
html {
  font-size: 100%; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -ms-text-size-adjust: 100%; /* 2 */
}

/**
   * Address \`outline\` inconsistency between Chrome and other browsers.
   */
a:focus {
  outline: thin dotted;
}

/**
   * Improve readability when focused and also mouse hovered in all browsers.
   */
a:active,
a:hover {
  outline: 0;
}

/**
   * 1. Remove border when inside \`a\` element in IE 6/7/8/9 and Firefox 3.
   * 2. Improve image quality when scaled in IE 7.
   */
img {
  border: 0; /* 1 */
  -ms-interpolation-mode: bicubic; /* 2 */
}

/**
   * Address margin not present in IE 6/7/8/9, Safari 5, and Opera 11.
   */
figure {
  margin: 0;
}

/**
   * Correct margin displayed oddly in IE 6/7.
   */
form {
  margin: 0;
}

/**
   * Define consistent border, margin, and padding.
   */
fieldset {
  border: 0px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

/**
   * 1. Correct color not being inherited in IE 6/7/8/9.
   * 2. Correct text not wrapping in Firefox 3.
   * 3. Correct alignment displayed oddly in IE 6/7.
   */
legend {
  border: 0; /* 1 */
  padding: 0;
  white-space: normal; /* 2 */
  *margin-left: -7px; /* 3 */
}

/**
   * 1. Correct font size not being inherited in all browsers.
   * 2. Address margins set differently in IE 6/7, Firefox 3+, Safari 5,
   *    and Chrome.
   * 3. Improve appearance and consistency in all browsers.
   */
button,
input,
select,
textarea {
  font-size: 100%; /* 1 */
  margin: 0; /* 2 */
  vertical-align: baseline; /* 3 */
  *vertical-align: middle; /* 3 */
}

/**
   * Address Firefox 3+ setting \`line-height\` on \`input\` using \`!important\` in
   * the UA stylesheet.
   */
button,
input {
  line-height: normal;
}

/**
   * Address inconsistent \`text-transform\` inheritance for \`button\` and \`select\`.
   * All other form control elements do not inherit \`text-transform\` values.
   * Correct \`button\` style inheritance in Chrome, Safari 5+, and IE 6+.
   * Correct \`select\` style inheritance in Firefox 4+ and Opera.
   */
button,
select {
  text-transform: none;
}

/**
   * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native \`audio\`
   *    and \`video\` controls.
   * 2. Correct inability to style clickable \`input\` types in iOS.
   * 3. Improve usability and consistency of cursor style between image-type
   *    \`input\` and others.
   * 4. Remove inner spacing in IE 7 without affecting normal text inputs.
   *    Known issue: inner spacing remains in IE 6.
   */
button,
html input[type=button],
input[type=reset],
input[type=submit] {
  -webkit-appearance: button; /* 2 */
  cursor: pointer; /* 3 */
  *overflow: visible; /* 4 */
}

/**
   * Re-set default cursor for disabled elements.
   */
button[disabled],
html input[disabled] {
  cursor: default;
}

/**
   * 1. Address box sizing set to content-box in IE 8/9.
   * 2. Remove excess padding in IE 8/9.
   * 3. Remove excess padding in IE 7.
   *    Known issue: excess padding remains in IE 6.
   */
input[type=checkbox],
input[type=radio] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
  *height: 13px; /* 3 */
  *width: 13px; /* 3 */
}

/**
   * 1. Address \`appearance\` set to \`searchfield\` in Safari 5 and Chrome.
   * 2. Address \`box-sizing\` set to \`border-box\` in Safari 5 and Chrome
   *    (include \`-moz\` to future-proof).
   */
input[type=search] {
  -webkit-appearance: textfield; /* 1 */ /* 2 */
  box-sizing: content-box;
}

/**
   * Remove inner padding and search cancel button in Safari 5 and Chrome
   * on OS X.
   */
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
   * Remove inner padding and border in Firefox 3+.
   */
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/**
   * 1. Remove default vertical scrollbar in IE 6/7/8/9.
   * 2. Improve readability and alignment in all browsers.
   */
textarea {
  overflow: auto; /* 1 */
  vertical-align: top; /* 2 */
}

/**
   * Remove most spacing between table cells.
   */
table {
  border-collapse: collapse;
  border-spacing: 0;
}

html,
button,
input,
select,
textarea {
  color: #222;
}

::selection {
  background: #b3d4fc;
  text-shadow: none;
}

img {
  vertical-align: middle;
}

fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}

textarea {
  resize: vertical;
}

.chromeframe {
  margin: 0.2em 0;
  background: #ccc;
  color: #000;
  padding: 0.2em 0;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.h1 {
  color: #404859;
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.h2 {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.h2-w8 {
  font-weight: 800;
}

.h3 {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 135%;
}

.h4 {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 115%;
}
.h4-cp {
  text-transform: capitalize;
}
.h4-w4 {
  font-weight: 400;
}
.h4-w5 {
  font-weight: 500;
}

.title-blue-bold {
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: #355c7d;
}

.body-regular {
  color: #404859;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.body-regular-italic {
  font-style: italic;
}
.body-regular-up {
  text-transform: uppercase;
}
.body-regular-bold, .body-regular-w6 {
  font-weight: 600;
}
.body-regular-w5 {
  font-weight: 500;
}

.placeholder {
  color: #929fb0;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.placeholder-w6 {
  font-weight: 600;
}

.button-txt-big {
  color: #f5faff;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.24px;
}

.body-small {
  color: #404859;
  font-family: Inter;
  font-size: 10px !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.body-small-w4 {
  font-weight: 400;
}
.body-small-w6 {
  font-weight: 600;
}
.body-small-up {
  text-transform: uppercase;
}

.small-detail {
  color: #6e7889;
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.body-card {
  color: #404859;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.body-card-bold-line {
  font-weight: 700;
  text-decoration-line: underline;
}
.body-card-w6 {
  font-weight: 600;
}
.body-card-w7 {
  font-weight: 700;
}
.body-card-w5 {
  font-weight: 500;
}

.blue-bold {
  color: #5e8eb7;
  cursor: pointer;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%;
}
.blue-bold img {
  height: 10px;
  margin-left: 5px;
}

.bold {
  font-weight: 600;
}

.bold-little {
  font-weight: 500;
}

.cursor {
  cursor: pointer;
}

.disabled {
  color: #2A2F3C !important;
}
.disabled div {
  border-color: #AFBDCC !important;
}

.button {
  height: 32px;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.button-empty {
  background-color: transparent;
  padding: 0;
  border: none;
  box-shadow: none;
}
.button-empty span {
  color: #404859 !important;
  font-family: Inter;
  font-size: 10px !important;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.2px;
}
.button-modal-ok {
  width: 100%;
  border-radius: 6px;
  border: 1px solid #ffc857 !important;
  background: #ffc857 !important;
  height: 40px;
  color: #66564d !important;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.21px;
}
.button-modal-cancel {
  width: 100%;
  border-radius: 6px;
  border: 1px solid #ddaa42 !important;
  background: #fff9ee !important;
  height: 40px;
  color: #3c302a !important;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.21px;
}
.button-primary {
  width: 100%;
  height: 48px;
  flex-shrink: 0;
  border-radius: 6px;
  border: 1px solid #162e43;
  background: #162e43;
  border: none;
}
.button-primary:hover {
  border: none;
  color: #f5faff !important;
}
.button-secondary {
  width: 179px;
  border-radius: 6px;
  border: 1px solid #355c7d;
  color: #355c7d;
}
.button-secondary:hover {
  color: #355c7d !important;
  border: 1px solid #355c7d !important;
}
.button-grey {
  color: #6e7889 !important;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.18px;
  border-radius: 6px;
  border: 1px solid #eff3f5 !important;
  background: #eff3f5;
  width: 100%;
}
.button-transparent {
  padding: 0;
  background-color: transparent;
  border: none;
  box-shadow: none;
  color: #48759a;
}
.button-transparent .anticon {
  color: #48759a;
}
.button-transparent:hover {
  color: #48759a !important;
}
.button-gray {
  padding: 0;
  background-color: transparent;
  border: none;
  box-shadow: none;
  color: #afbdcc;
}
.button-gray .anticon {
  color: #afbdcc;
}
.button-gray:hover {
  color: #afbdcc !important;
}
.button-card {
  width: 100%;
  color: #000000;
  border: 1px solid #ccd3db;
}
.button-card:hover {
  color: #000000 !important;
  border: 1px solid #ccd3db !important;
}
.button-submit {
  border-radius: 6px;
  border: 1px solid #122536 !important;
  background: #122536 !important;
  color: #fff !important;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.18px;
  width: 100%;
}
.button-submit-delete {
  all: unset;
  border: none !important;
  background-color: transparent !important;
}
.button-submit-delete:hover {
  background: none !important;
  border-color: transparent !important;
}
.button-submit:disabled {
  background-color: #DFE4EB !important;
  border-color: #DFE4EB !important;
}
.button-submit:disabled span {
  color: #929FB0 !important;
}
.button-submit:disabled:hover {
  background-color: #DFE4EB !important;
  border-color: #DFE4EB !important;
}
.button-submit:disabled:hover span {
  color: #929FB0 !important;
}
.button-submit:not(.button-submit-delete):hover {
  background-color: #EBF6FF !important;
  border-color: #EBF6FF !important;
}
.button-submit:not(.button-submit-delete):hover span {
  color: #355D7D !important;
}
.button-link {
  width: 100%;
  background-color: transparent;
  border: none;
  box-shadow: none;
  font-weight: 400;
  color: #000000;
}
.button-link:hover {
  color: #000000 !important;
}
.button-link-REVIEW {
  color: #161616 !important;
}
.button-link-border {
  width: 100%;
  border-radius: 6px;
  border: 1px solid #162E43 !important;
  background: none;
  color: #3c302a !important;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.21px;
}
.button-link-border:disabled {
  background-color: #DFE4EB !important;
  border-color: #DFE4EB !important;
  color: #929FB0 !important;
}
.button-link-blue {
  color: #5E8EB7;
}
.button-link-blue span {
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration-line: underline;
}
.button-link-blue:hover {
  color: #5E8EB7 !important;
}
.button-blue {
  color: #5E8EB7;
}
.button-blue span {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.button-blue:hover {
  color: #5E8EB7 !important;
}
.button-open-modal {
  width: 100%;
}
.button-open-modal:hover {
  border-color: #ccd3db !important;
  color: #000000 !important;
}
.button-open-modal-REVIEW {
  border-color: #AC78B3;
  color: #161616;
}
.button-open-modal-REVIEW:hover {
  border-color: #AC78B3 !important;
  background-color: #693B6F !important;
  color: white !important;
}

.select-primary {
  width: 100%;
  height: 40px;
}
.select-primary .ant-select-selector {
  height: 40px !important;
  padding: 2px 11px !important;
  border-radius: 10px !important;
  border: 1px solid #5e8eb7 !important;
}
.select-primary .ant-select-selector .ant-select-selection-search-input {
  height: 40px !important;
}

.circle {
  background-color: #fff;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #2a2f3c;
  display: flex;
  justify-content: center;
  align-items: center;
}
.circle .upload {
  width: auto;
  height: 18px;
  object-fit: cover;
}

.circles-tags {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 8px;
}

.circle-state-tooltip {
  padding: 6px 7px !important;
  opacity: 1 !important;
}
.circle-state-tooltip b {
  font-weight: 600;
}
.circle-state-tooltip span {
  margin-top: 10px;
}
.circle-state-tooltip-APPROVED {
  background-color: #549358 !important;
}
.circle-state-tooltip-DRAFT {
  background-color: #404859 !important;
}
.circle-state-tooltip-REQUEST_ERROR {
  background-color: #c94f4a !important;
}
.circle-state-tooltip-REVIEW {
  background-color: #855791 !important;
}

.error-box {
  width: 100%;
  min-height: 43px;
  top: 615px;
  left: 126px;
  border-width: 1px;
  border-radius: 6px;
  border: 1px solid #DDAA42;
  background: #FCF8F7;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.error-box span {
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  line-height: 145%;
  color: #775614;
  flex: 1 1;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.error-box img {
  padding-left: 6px;
  flex-shrink: 0;
}

.DrodownBasic {
  height: 40px;
  padding: 1px 3px !important;
  display: flex;
  align-items: center;
  border: 1px solid #6E7889;
  width: 100%;
}
.DrodownBasic span {
  color: #6E7889;
  padding-left: 16px;
}
.DrodownBasic-blue {
  border: 1px solid #9BBCEB;
  border-radius: 10px;
}
.DrodownBasic-blue .ant-dropdown-menu {
  padding: 0px;
  width: 160px;
}
.DrodownBasic-blue .ant-dropdown-menu-item:hover {
  background-color: #EBF6FF !important;
}
.DrodownBasic-blue .ant-dropdown-menu-item:hover .ant-dropdown-menu-title-content {
  color: #355c7d;
  font-weight: 600;
}
.DrodownBasic-blue .ant-dropdown-menu-title-content {
  color: #5E8EB7;
  font-weight: 400;
}
.DrodownBasic-blue .ant-dropdown-menu-title-content:hover {
  color: #355c7d;
  font-weight: 600;
}

.checkbox-basic .ant-checkbox-wrapper {
  color: #244560;
}
.checkbox-basic .ant-checkbox-wrapper:hover .ant-checkbox-inner {
  border: 1px solid #5E8EB7 !important;
}
.checkbox-basic .ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #5E8EB7 !important;
}
.checkbox-basic .ant-checkbox,
.checkbox-basic .ant-checkbox-input {
  border: none;
}
.checkbox-basic .ant-checkbox:hover .ant-checkbox-inner,
.checkbox-basic .ant-checkbox-input:hover .ant-checkbox-inner {
  border: 1px solid #5E8EB7 !important;
}
.checkbox-basic .ant-checkbox:hover .ant-checkbox-checked .ant-checkbox-inner,
.checkbox-basic .ant-checkbox-input:hover .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #5E8EB7 !important;
}
.checkbox-basic .ant-checkbox-inner {
  width: 18px;
  height: 18px;
  border: 1px solid #5E8EB7;
}
.checkbox-basic .ant-checkbox-disabled .ant-checkbox-inner {
  border-radius: 2px;
  background: #DFE4EB !important;
  border: 1px solid #DFE4EB;
}
.checkbox-basic .ant-checkbox-checked:hover .ant-checkbox-inner {
  background-color: #5E8EB7 !important;
}
.checkbox-basic .ant-checkbox-checked .ant-checkbox-inner {
  border-radius: 2px;
  background: #5E8EB7;
}

.Layout {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.Layout .content {
  width: 100%;
}
.Layout .BarLogin {
  padding: 16px;
  background-color: #eff3f5;
  width: 64px;
  height: 100vh;
  border-right: 1px solid #dfe4eb;
}
.Layout .BarLogin .logo {
  width: 32px;
}

.select-section-selected .ant-select-selector {
  background: #F5FAFF !important;
  border: 1px solid #5E8EB7 !important;
  padding-left: 10px !important;
}
.select-section-selected .ant-select-selector .ant-select-selection-item {
  color: #355C7D !important;
}
.select-section-selected .ant-select-selector .ant-select-selection-item-content {
  color: #5E8EB7 !important;
}
.select-section .ant-select {
  display: block;
  height: 40px;
  margin-top: 6px;
}
.select-section .ant-select .ant-select-selection-placeholder {
  margin-bottom: 0;
  color: #6E7889 !important;
}

.ant-select-dropdown div {
  color: #6E7889;
}
.ant-select-dropdown .anticon {
  display: none;
}
.ant-select-dropdown .circle {
  width: 14px !important;
  height: 14px !important;
  border-color: #CCD3DB;
}

.ant-select-outlined.ant-select-multiple .ant-select-selection-item {
  background: none;
  border: none;
}
.ant-select-outlined.ant-select-multiple .ant-select-selection-item span {
  color: rgb(53, 92, 125) !important;
}

.ant-select-item-option-selected .ant-select-item-option-content div {
  color: #48759A !important;
}

.task-item-list .circle-state-tooltip {
  padding: 6px 7px;
  opacity: 1;
}
.task-item-list .circle-state-tooltip b {
  font-weight: 600;
}
.task-item-list .circle-state-tooltip span {
  margin-top: 10px;
}
.task-item-list .circle-state-tooltip-APPROVED {
  background-color: #549358;
}
.task-item-list .circle-state-tooltip-DRAFT {
  background-color: #c0cad7;
}
.task-item-list .circle-state-tooltip-REQUEST_ERROR {
  background-color: #c94f4a;
}
.task-item-list .circle-state-tooltip-REVIEW {
  background-color: #855791;
}
.task-item-list .circles-tags {
  display: flex;
  align-items: end;
  gap: 20px;
  margin-top: 5px;
}
.task-item-list .circle {
  width: 16px;
  height: 16px;
}
.task-item-list .circle-APPROVED {
  background-color: #6eac72;
  border-color: #587e5b;
}
.task-item-list .circle-APPROVED:hover {
  background-color: #549358;
}
.task-item-list .circle-APPROVED-active {
  background-color: #549358;
}
.task-item-list .circle-REVIEW {
  background-color: #AC78B3;
  border-color: #AC78B3;
}
.task-item-list .circle-REVIEW:hover {
  background-color: #855791;
}
.task-item-list .circle-REVIEW-active {
  background-color: #855791;
}
.task-item-list .circle-REQUEST_ERROR {
  background-color: #FFD4CF;
  border-color: #c94f4a;
}
.task-item-list .circle-REQUEST_ERROR:hover {
  background-color: #c94f4a;
}
.task-item-list .circle-REQUEST_ERROR-active {
  background-color: #c94f4a;
}
.task-item-list .circle-DRAFT {
  background-color: #DFE4EB;
  border: 1px solid #CCD3DB;
}
.task-item-list .circle-DRAFT:hover {
  background-color: #cfd7e1;
}
.task-item-list .circle-DRAFT-active {
  background-color: #cfd7e1;
}
.task-item-list .circle-INCOMPLETE {
  background-color: #2a2f3c;
  border: 1px solid #2a2f3c;
}
.task-item-list .circle-INCOMPLETE:hover {
  background-color: #20232d;
}
.task-item-list .circle-INCOMPLETE-active {
  background-color: #20232d;
}

.LoanProgress {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
}
.LoanProgress .tab {
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.LoanProgress .tab .popover-label {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.LoanProgress .tab .bar-status {
  cursor: pointer;
  width: 100%;
  width: calc(100% + 20px);
  height: 8px;
  border-radius: 16px;
  margin-top: 6px;
  background-color: #dfe4eb;
}
.LoanProgress .tab-complete .text-status {
  color: #141F15;
}
.LoanProgress .tab-complete .body-small {
  color: #2D7032;
}
.LoanProgress .tab-complete .bar-status {
  background-color: #4CA852;
}
.LoanProgress .tab-complete .bar-status-selected {
  background-color: #2D7032;
}
.LoanProgress .tab-complete .bar-status-selected:hover {
  background-color: #2D7032 !important;
}
.LoanProgress .tab-complete .bar-status:hover {
  background-color: #3F9545;
}
.LoanProgress .tab-complete .bar-status:hover .body-small {
  color: #2D7032;
}
.LoanProgress .tab-blocked .body-small {
  color: #8A130F;
}
.LoanProgress .tab-blocked .text-status {
  color: #610805;
}
.LoanProgress .tab-blocked .bar-status {
  background-color: #C13934;
}
.LoanProgress .tab-blocked .bar-status-selected {
  background-color: #8A130F;
}
.LoanProgress .tab-blocked .bar-status-selected:hover {
  background-color: #8A130F !important;
}
.LoanProgress .tab-blocked .bar-status:hover {
  background-color: #A31C17;
}
.LoanProgress .tab-blocked .bar-status:hover .body-small {
  color: #8A130F;
}
.LoanProgress .tab-error .body-small {
  color: #8A130F;
}
.LoanProgress .tab-error .text-status {
  color: #610805;
}
.LoanProgress .tab-error .bar-status {
  background-color: #FFDAD6;
}
.LoanProgress .tab-error .bar-status-selected {
  background-color: #8A130F;
}
.LoanProgress .tab-error .bar-status-selected:hover {
  background-color: #8A130F !important;
}
.LoanProgress .tab-error .bar-status:hover {
  background-color: #C13934;
}
.LoanProgress .tab-error .bar-status:hover .body-small {
  color: #8A130F;
}
.LoanProgress .tab-progress .text-status {
  color: #122536;
}
.LoanProgress .tab-progress .body-small {
  color: #404859;
}
.LoanProgress .tab-progress .bar-status {
  background-color: #5E8EB7;
}
.LoanProgress .tab-progress .bar-status-selected {
  background-color: #355C7D;
}
.LoanProgress .tab-progress .bar-status-selected:hover {
  background-color: #355C7D !important;
}
.LoanProgress .tab-progress .bar-status:hover {
  background-color: #48759A;
}
.LoanProgress .tab-progress .bar-status:hover .body-small {
  color: #404859;
}
.LoanProgress .tab-not-started .bar-status {
  background-color: white;
  border: 1px solid #404859;
}
.LoanProgress .tab-not-started .bar-status-selected {
  background-color: #404859;
}
.LoanProgress .tab-not-started .bar-status-selected:hover {
  background-color: #404859 !important;
}
.LoanProgress .tab-not-started .bar-status:hover {
  background-color: #929FB0;
}
.LoanProgress .tab-open-content {
  position: absolute;
  border: 1px solid #929FB0;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.1019607843);
  height: auto;
  min-height: 253px;
  width: 825px;
  background: white;
  top: 150px;
  border-radius: 10px;
  z-index: 99;
}
.LoanProgress .tab-open-content .content-bar-status {
  width: 823px;
  height: 68px;
  background: white;
  border-radius: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: start;
  gap: 8px;
  padding-left: 8px;
  padding-top: 3px;
}
.LoanProgress .tab-open-content .content-bar-status .tab .body-small {
  font-size: 12px !important;
}
.LoanProgress .tab-open-content .content-bar-status .tab-error span {
  color: #610805;
}
.LoanProgress .tab-open-content .content-bar-status .bar-status {
  width: -webkit-fill-available;
  height: 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.LoanProgress .tab-open-content .content-bar-status .bar-status .text-status {
  display: flex;
  align-items: center;
  gap: 3px;
}
.LoanProgress .tab-open-content .content-bar-status .bar-status .text-status span {
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
}
.LoanProgress .tab-open-content .content-bar-status .bar-status:hover span {
  display: none;
}
.LoanProgress .tab-open-content .content-bar-status .bar-status:hover .text-status {
  display: none;
}
.LoanProgress .tab-open-content .content-bar-status .tab {
  margin: 0 0;
}
.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(1) {
  width: 10%;
}
.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(2) {
  width: 22%;
}
.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(3) {
  width: 38%;
}
.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(4) {
  width: 14%;
}
.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(5) {
  width: 11%;
}
.LoanProgress .tab-open-content .content-phase-select {
  width: 823px;
  height: auto;
  min-height: 183px;
  border-radius: 10px;
  background: #F9FAFB;
  border-top: 1px solid #DFE4EB;
}
.LoanProgress .tab-open-content .content-phase-select-complete {
  background: #F8FFF8;
  border-top: 1px solid #C2F0C5;
}
.LoanProgress .tab-open-content .content-phase-select-complete .tag-state {
  background: #C2F0C5;
}
.LoanProgress .tab-open-content .content-phase-select-complete .tag-state b,
.LoanProgress .tab-open-content .content-phase-select-complete .tag-state span {
  color: #141F15;
}
.LoanProgress .tab-open-content .content-phase-select-complete .content-phase b {
  color: #1F4222;
}
.LoanProgress .tab-open-content .content-phase-select-complete .content-phase p {
  color: #1F4222 !important;
}
.LoanProgress .tab-open-content .content-phase-select-complete .content-phase-first b {
  color: #2D7032;
}
.LoanProgress .tab-open-content .content-phase-select-blocked {
  background: #FCF8F7;
  border-top: 1px solid #FFC6BF;
}
.LoanProgress .tab-open-content .content-phase-select-blocked .tag-state {
  background: #FFD4CF;
}
.LoanProgress .tab-open-content .content-phase-select-blocked .tag-state b,
.LoanProgress .tab-open-content .content-phase-select-blocked .tag-state span {
  color: #610805;
}
.LoanProgress .tab-open-content .content-phase-select-blocked .content-phase b {
  color: #2A2F3C;
}
.LoanProgress .tab-open-content .content-phase-select-blocked .content-phase-first b {
  color: #610805;
}
.LoanProgress .tab-open-content .content-phase-select-error {
  background: #FCF8F7;
  border-top: 1px solid #FFC6BF;
}
.LoanProgress .tab-open-content .content-phase-select-error .tag-state {
  background: #FFD4CF;
}
.LoanProgress .tab-open-content .content-phase-select-error .tag-state b,
.LoanProgress .tab-open-content .content-phase-select-error .tag-state span {
  color: #610805;
}
.LoanProgress .tab-open-content .content-phase-select-error .content-phase b {
  color: #2A2F3C;
}
.LoanProgress .tab-open-content .content-phase-select-error .content-phase-first b {
  color: #610805;
}
.LoanProgress .tab-open-content .content-phase-select-progress {
  background: #F5FAFF;
  border-top: 1px solid #B6DCFC;
}
.LoanProgress .tab-open-content .content-phase-select-progress .tag-state {
  background: #B6DCFC;
}
.LoanProgress .tab-open-content .content-phase-select-progress .tag-state b,
.LoanProgress .tab-open-content .content-phase-select-progress .tag-state span {
  color: #122536;
}
.LoanProgress .tab-open-content .content-phase-select-progress .content-phase b {
  color: #2A2F3C;
}
.LoanProgress .tab-open-content .content-phase-select-progress .content-phase-first b {
  color: #244560;
}
.LoanProgress .tab-open-content .content-phase-select-not-started .tag-state {
  border: 1px solid #404859;
}
.LoanProgress .tab-open-content .content-phase-select .tag-state {
  height: 16px;
  width: max-content;
  display: flex;
  align-items: center;
  gap: 3.5px;
  border-radius: 10px;
  padding: 3px 7px;
  margin: 16px 23px;
}
.LoanProgress .tab-open-content .content-phase-select .tag-state b {
  font-size: 10px;
  font-weight: 600;
}
.LoanProgress .tab-open-content .content-phase-select .tag-state span {
  font-size: 10px;
  font-weight: 400;
}
.LoanProgress .tab-open-content .content-phase-select .divider {
  border: 0.7px solid #929FB0;
  height: auto;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase {
  margin: 0px 24px;
  padding-bottom: 23px;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase b {
  font-size: 12px;
  font-weight: 600;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase p {
  font-size: 12px;
  font-weight: 400;
  color: #2A2F3C;
  margin-top: 6px;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase-first {
  width: 270px;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase-first b {
  font-size: 16px;
  font-weight: 600;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase-second {
  width: 240px;
  margin-left: 20px;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase-third .task-item {
  display: inline-flex;
  max-width: 335px;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase-third .task-item .task-label {
  min-width: 0;
  word-break: break-word;
  overflow-wrap: break-word;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase-third .task-item .task-label b {
  display: inline;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 4px;
  width: max-content;
  border-radius: 4px;
  padding: 2px 3px;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item span {
  font-family: Inter;
  font-size: 12px;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item b {
  font-family: Inter;
  font-weight: 500;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item .bold {
  font-weight: 600 !important;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item .circle {
  width: 12px;
  height: 12px;
  border: 1px solid #6E7889;
  border-radius: 50%;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED {
  background-color: #D5F7E2;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED span,
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED b,
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED strong {
  color: #2D7032;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR, .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED {
  background: #FFC6BF;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR span,
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR b,
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR strong, .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED span,
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED b,
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED strong {
  color: #610805;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW {
  background: #F7EDFC;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW span,
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW b,
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW strong {
  color: #855791;
}

.borrowers {
  padding: 24px 25px;
}
.borrowers .dropdown-review-bold {
  color: #AC78B3 !important;
  height: 26px;
  display: unset;
  padding: 0 !important;
}
.borrowers .dropdown-review-bold span {
  font-weight: 600;
  text-decoration-line: underline;
}
.borrowers .top-container {
  box-sizing: content-box;
  width: 100%;
  margin-bottom: 33px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
}
.borrowers .top-container .title {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.borrowers .top-container .title > span {
  cursor: pointer;
  color: var(--blue60, #5E8EB7);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration-line: underline;
}
.borrowers .badges-container {
  display: flex;
}
.borrowers-container {
  padding: 16px 0px;
}
.borrowers-container > * {
  margin-bottom: 16px;
}
.borrowers-container > *:last-child {
  margin-bottom: 0px;
}

.search-box {
  cursor: pointer;
  box-sizing: border-box;
  width: 384px;
  padding: 5px 18px 5px 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 10px;
  border: 1px solid var(--400-grey, #CCD3DB);
  background: var(--gray-100, #F9FAFB);
  color: var(--700-grey, #6E7889);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}
.search-box > input {
  all: unset;
  width: 100%;
  margin-left: 8px;
}

.status-badge {
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  background: var(--300-grey, #DFE4EB);
  margin-right: 12px;
}
.status-badge .title {
  margin-right: 4px;
  color: var(--800-grey, #404859);
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 133.333% */
  white-space: nowrap;
}
.status-badge .count {
  color: var(--800-grey, #404859);
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
}
.status-badge.selected {
  background: #355C7D;
}
.status-badge.selected .title, .status-badge.selected .count {
  color: #FFFFFF;
}

.borrower-list-item {
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 10px 24px;
  border-radius: 10px;
  border: 1px solid var(--600-grey, #929FB0);
  background: var(--white, #FFF);
}
.borrower-list-item > * {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.borrower-list-item > *.loan-status-badge-container {
  flex: 0.8 1;
}
.borrower-list-item > *.borrower-summary-container {
  flex: 0.7 1;
}
.borrower-list-item > *:last-child {
  flex: 0 0 auto;
  overflow: visible;
  align-items: flex-end;
}
.borrower-list-item .loan-status-badge {
  display: inline-block;
  border-radius: 76px;
  border: 1px solid var(--blue60, #5E8EB7);
  padding: 4px 7px;
  color: var(--70, #48759A);
  text-align: center;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.2px;
  text-transform: uppercase;
}
.borrower-list-item .borrower-summary .caption {
  color: var(--700-grey, #6E7889);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
  text-transform: capitalize;
  margin-bottom: 2px;
}
.borrower-list-item .borrower-summary .borrower-name {
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 115%;
  text-transform: capitalize;
}
.borrower-list-item .entities-summary .caption {
  color: var(--700-grey, #6E7889);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
  text-transform: capitalize;
  margin-bottom: 2px;
}
.borrower-list-item .entities-summary .content {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
  text-transform: capitalize;
  white-space: nowrap;
  display: flex;
  gap: 3px;
  align-items: center;
  min-width: 0;
  max-width: 100%;
}
.borrower-list-item .entities-summary .content > span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.borrower-list-item .task-summary {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.borrower-list-item .task-summary .address {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
}
.borrower-list-item .task-summary .address > *:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 0 1 auto;
}
.borrower-list-item .task-summary .address > *:not(:first-child) {
  flex: 0 0 auto;
}
.borrower-list-item .task-summary .caption {
  color: var(--700-grey, #6E7889);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
  text-transform: capitalize;
  margin-bottom: 2.5px;
}
.borrower-list-item .task-summary .task-item-container {
  display: flex;
  gap: 9px;
}
.borrower-list-item .task-summary .task-item-container .task-item {
  box-sizing: border-box;
  height: 15px;
  width: 15px;
  border-radius: 100px;
  margin-right: 8px;
  background-color: #DFE4EB;
  border: 1.5px solid #CCD3DB;
}
.borrower-list-item .task-summary .task-item-container .task-item.completed {
  background-color: #4CA852;
  border: unset;
}
.borrower-list-item .task-summary .task-item-container .task-item.review {
  background-color: #855791;
  border: unset;
}
.borrower-list-item .action-container {
  color: var(--blue60, #5E8EB7);
  text-align: right;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
  align-self: flex-end;
}
.borrower-list-item:hover {
  border-radius: 10px;
  border: 1px solid var(--blue-40, #97BCF0);
  background: var(--10, #F5FAFF);
  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);
}
.borrower-list-item:hover .borrower-summary .caption {
  color: var(--70, #48759A);
}
.borrower-list-item:hover .borrower-summary .borrower-name {
  color: var(--90, #244560);
}
.borrower-list-item:hover .address-summary .caption {
  color: var(--70, #48759A);
}
.borrower-list-item:hover .address-summary .address {
  color: var(--blue-80, #355C7D);
}
.borrower-list-item:hover .task-summary .caption {
  color: var(--70, #48759A);
}
.borrower-list-item:hover .action-container {
  color: var(--70, #48759A);
  font-weight: 600;
}
.borrower-list-item:hover .action-container:hover {
  color: var(--90, #244560);
  font-weight: 700;
}

.right-scenes {
  position: fixed;
  background: rgba(42, 47, 60, 0.55);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  top: 0;
  left: 70px;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.right-scenes-content {
  position: relative;
  width: calc(100% - 70px); /* Ancho de la pantalla menos 70px */
  background-color: #fff;
  height: 100%;
  animation: slideIn 1s forwards;
}
@keyframes slideIn {
  from {
    transform: translateX(calc(-100% + 70px));
  }
  to {
    transform: translateX(0);
  }
}
.right-scenes .button-close-mask {
  width: 30%;
  height: 100%;
  background-color: rgba(255, 0, 0, 0);
  box-shadow: none;
  border: none;
}
.right-scenes .button-close-mask:hover, .right-scenes .button-close-mask:active, .right-scenes .button-close-mask:focus {
  background-color: rgba(255, 0, 0, 0);
  box-shadow: none;
  border: none;
}

.view-borrower-detail {
  padding: 50px 15px;
}
.view-borrower-detail-header .title {
  color: #404859;
  font-size: 32px;
  font-weight: 600;
  gap: 5px;
}
.view-borrower-detail-header .title button {
  height: 32px;
}
.view-borrower-detail-header .title button span {
  font-size: 32px;
}
.view-borrower-detail .button-r,
.view-borrower-detail .button-r:hover {
  width: 58px;
  height: 20px;
  border: 1px solid #bb8d2f;
  color: #bb8d2f;
  border-radius: 76px;
  padding: 0;
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
  line-height: 12.1px;
  margin: 0 15px;
}
.view-borrower-detail .button-delete,
.view-borrower-detail .button-delete:hover {
  height: 20px;
  border: none;
  color: #c94f4a;
  padding: 0;
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
  line-height: 12.1px;
  margin: 0 15px;
}
.view-borrower-detail .flex-2-col {
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
  width: 100%;
  gap: 30px;
}
.view-borrower-detail .flex-2-col .box {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 50%;
}
.view-borrower-detail .gap-3 {
  gap: 6px;
}
.view-borrower-detail .card-profile-generic {
  border: 1px solid #afbdcc;
  border-radius: 10px;
  padding: 15px;
  width: 100%;
}
.view-borrower-detail .card-profile-generic .card-title {
  font-family: Inter;
  font-size: 24px;
  font-weight: 400;
  line-height: 29.05px;
  text-align: left;
}
.view-borrower-detail .card-profile-generic .table {
  width: 100%;
  margin-top: 10px;
}
.view-borrower-detail .card-profile-generic .table-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 7px;
}
.view-borrower-detail .card-profile-generic .table-row .title {
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  text-align: left;
  color: #6e7889;
}
.view-borrower-detail .card-profile-generic .table-row .flex {
  display: flex;
  justify-content: space-between;
}
.view-borrower-detail .card-profile-generic .table-row .flex .col {
  width: 50%;
}
.view-borrower-detail .card-profile-generic .table-row .flex .col .italic {
  font-family: Inter;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 16.94px;
  text-align: left;
  color: #929fb0;
}
.view-borrower-detail .card-profile-generic .avatar .ant-avatar-string {
  font-size: 25px;
}
.view-borrower-detail .card-profile-generic .avatar .ant-upload {
  width: 68px !important;
  height: 68px !important;
}
.view-borrower-detail .card-profile-generic .ant-upload-wrapper.ant-upload-picture-circle-wrapper {
  width: auto;
}
.view-borrower-detail .card-profile-generic .title-bold {
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 16.94px;
  text-align: left;
  color: #404859;
}
.view-borrower-detail .card-profile-generic .title-bold .bold {
  font-weight: 600;
}
.view-borrower-detail .card-profile-generic .body-bold {
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.94px;
  text-align: right;
}
.view-borrower-detail .card-profile-generic .button-transparent,
.view-borrower-detail .card-profile-generic .button-transparent:hover {
  padding: 0;
  height: 20px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.94px;
  text-align: left;
  color: #8a130f;
}
.view-borrower-detail .card-profile-generic .button-round {
  width: 75px;
  height: 20px;
  padding: 0;
  border-radius: 76px;
  border: 2px solid #404859;
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
}
.view-borrower-detail .card-profile-generic .button-edit,
.view-borrower-detail .card-profile-generic .button-edit:hover {
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  text-align: left;
  color: #5e8eb7;
}
.view-borrower-detail .card-profile-generic .button-edit .edit,
.view-borrower-detail .card-profile-generic .button-edit:hover .edit {
  width: 10px;
  height: 10px;
  margin-right: 3px;
}
.view-borrower-detail .card-profile-generic .link {
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.94px;
  text-align: left;
  color: #5e8eb7;
  text-decoration: none;
}
.view-borrower-detail .card-profile-generic .link .arrow {
  width: 15px;
  margin-left: 5px;
}
.view-borrower-detail .card-profile-generic .text-footer {
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  text-align: left;
  color: #6e7889;
  margin-top: 14px;
}
.view-borrower-detail .card-profile-generic .text-footer span {
  color: #4e8aff;
}
.view-borrower-detail .card-report {
  position: relative;
}
.view-borrower-detail .card-report .button span {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  letter-spacing: 0.015em;
  text-align: center;
}
.view-borrower-detail .card-report .button-edit {
  position: absolute;
  top: 8px;
  right: 15px;
}
.view-borrower-detail .card-report .button-edit span {
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  text-align: left;
  color: #5e8eb7;
}
.view-borrower-detail .card-report-head {
  display: flex;
  justify-content: space-between;
}
.view-borrower-detail .card-report .date-expires {
  font-family: Inter;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 16.94px;
  text-align: right;
  color: #6E7889;
}
.view-borrower-detail .card-report .upload-report-span {
  cursor: pointer;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.94px;
  text-align: right;
  color: #5E8EB7;
  text-decoration: underline;
}
.view-borrower-detail .card-report .credit-score-input input {
  text-align: end;
}
.view-borrower-detail .card-report .credit-score-input-text {
  text-align: end;
  padding: 5px 0px;
}

.loan-details {
  padding: 43px 40px;
  overflow: hidden;
}
.loan-details .loan-details-top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid #929FB0;
  margin-bottom: 22px;
}
.loan-details .loan-details-top-bar .loan-info {
  margin-bottom: 2px;
}
.loan-details .loan-details-top-bar .loan-info .loan-borrower-name {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.24px;
  text-transform: uppercase;
}
.loan-details .loan-details-top-bar .loan-info .loan-address {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.24px;
  text-transform: uppercase;
}
.loan-details .loan-details-top-bar .close-button-container {
  cursor: pointer;
  color: var(--800-grey, #404859);
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.24px;
  text-transform: uppercase;
}
.loan-details .loan-details-first-row {
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px #CCD3DB;
  margin-bottom: 16px;
}
.loan-details .loan-details-first-row .loan-progress {
  flex: 6 1;
}
.loan-details .loan-details-first-row .loan-progress .loan-info .loan-status {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.36px;
}
.loan-details .loan-details-first-row .loan-progress .loan-info .loan-closing-date {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.36px;
}
.loan-details .loan-details-first-row .loan-progress .loan-info .loan-closing-date b {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.36px;
}
.loan-details .loan-details-first-row .loan-progress .loan-address {
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
}
.loan-details .loan-details-first-row .loan-progress .loan-progress-section {
  margin-bottom: 20px;
}
.loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container {
  display: flex;
  flex-direction: row;
}
.loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container > * {
  flex: 1 1;
  margin-right: 8px;
}
.loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container .loan-progress-item-caption {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  white-space: nowrap;
  margin-bottom: 6px;
  flex: 0.13 1;
}
.loan-details .loan-details-first-row .loan-progress .loan-values-summary {
  margin-bottom: 8px;
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
}
.loan-details .loan-details-first-row .loan-progress .loan-values-summary span {
  cursor: pointer;
  color: var(--blue60, #5E8EB7);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 115%;
}
.loan-details .loan-details-first-row .loan-progress .closed-loan {
  display: flex;
  align-items: center;
  border: 1px solid #5E8EB7;
}
.loan-details .loan-details-first-row .loan-progress .closed-loan span, .loan-details .loan-details-first-row .loan-progress .closed-loan a {
  color: #122536;
  font-weight: 600;
}
.loan-details .loan-details-first-row .loan-progress .closed-loan a {
  text-decoration: underline;
}
.loan-details .loan-details-first-row .placeholder {
  flex: 3 1;
}
.loan-details .loan-details-first-row .borrower-card {
  flex: 1 1;
}
.loan-details .loan-details-main {
  display: flex;
}
.loan-details .loan-details-main > * {
  flex: 1 1;
  box-sizing: border-box;
}
.loan-details .loan-details-main .left-column {
  padding-right: 15px;
}
.loan-details .loan-details-main .left-column > * {
  margin-bottom: 16px;
}
.loan-details .loan-details-main .left-column > *:last-of-type {
  margin-bottom: 0px;
}
.loan-details .loan-details-main .left-column .loan-summary {
  display: flex;
  justify-content: space-between;
}
.loan-details .loan-details-main .left-column .loan-summary .closing {
  flex: 1 1;
  border-radius: 10px;
  border: 1px solid var(--500-grey, #AFBDCC);
  padding: 16px 20px;
  margin-right: 16px;
}
.loan-details .loan-details-main .left-column .loan-summary .closing .label {
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 18px;
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar {
  width: 128px;
  border-radius: 10px;
  border: 1px solid var(--blue60, #5E8EB7);
  background: var(--10, #F5FAFF);
  margin-bottom: 8px;
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled {
  border: 1px solid var(--600-grey, #929FB0);
  background: var(--200-grey, #EFF3F5);
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled .date {
  color: var(--70, #48759A);
  border-bottom: 1px solid #929FB0;
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled .day {
  color: var(--300-grey, #DFE4EB);
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar .date {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 26px;
  border-bottom: 1px solid #5E8EB7;
  color: var(--70, #48759A);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 114.286% */
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar .day {
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--blue-80, #355C7D);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.loan-details .loan-details-main .left-column .loan-summary .closing .caption {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.loan-details .loan-details-main .left-column .loan-summary .closing .caption b {
  font-weight: 600;
  color: #404859;
}
.loan-details .loan-details-main .left-column .loan-summary .content-box {
  flex: 5 1;
}
.loan-details .loan-details-main .right-column {
  padding-left: 15px;
}
.loan-details .loan-details-main .right-column .borrower-tasks > .title {
  margin-bottom: 8px;
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
}
.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-status-container {
  display: flex;
  margin-bottom: 16px;
}
.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 7px;
}
.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions > div {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  margin-left: 16px;
  color: var(--700-grey, #6E7889);
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.24px;
  text-transform: uppercase;
}
.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions > div svg {
  position: relative;
}
.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-list {
  margin-bottom: 17px;
}
.loan-details .loan-details-main .right-column .action-button {
  border: 1px solid var(--100, #162E43);
  background: var(--100, #162E43);
  text-align: center;
  border-radius: 6px;
  padding: 14px 0px;
  margin-bottom: 30px;
  color: var(--10, #F5FAFF);
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.24px;
  cursor: pointer;
}
.loan-details .loan-details-main .right-column .action-button:hover {
  background-color: #EBF6FF !important;
  border-color: #EBF6FF !important;
  color: #355D7D !important;
}
.loan-details .loan-details-main .right-column .loan-documents > .title {
  margin-bottom: 8px;
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
}
.loan-details .loan-details-main .right-column .loan-documents .loan-documents-docs-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 7px;
}
.loan-details .loan-details-main .right-column .loan-documents .loan-documents-docs-actions > div {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  margin-left: 16px;
  color: var(--700-grey, #6E7889);
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.24px;
  text-transform: uppercase;
}
.loan-details .loan-details-main .right-column .loan-documents .loan-documents-docs-actions > div svg {
  position: relative;
}
.loan-details .loan-details-main .right-column .approve-loan {
  padding: 14px 0px;
  text-align: center;
  border-radius: 6px;
  border: 1px solid var(--300-grey, #DFE4EB);
  background: var(--300-grey, #DFE4EB);
  color: var(--600-grey, #929FB0);
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.24px;
}

.loan-progress-item .caption {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  text-align: center;
  margin-bottom: 4px;
}
.loan-progress-item .loan-progress-bar {
  width: 100%;
  height: 6px;
  border-radius: 16px;
  background: var(--300-grey, #DFE4EB);
}

.content-box {
  border-radius: 10px;
  border: 1px solid var(--500-grey, #AFBDCC);
  padding: 16px 20px;
}
.content-box .label {
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 10px;
}
.content-box .content {
  border-left: 1px solid #97BCF0;
  padding: 2px 0px;
  padding-left: 12px;
  min-width: 0;
  overflow: hidden;
}
.content-box .content .item {
  margin-bottom: 8px;
}
.content-box .content .item:last-of-type {
  margin-bottom: 0px;
}
.content-box .content .item-row {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.content-box .content .item-row .value i {
  color: var(--700-grey, #6E7889);
}
.content-box .content .item-row .value span {
  cursor: pointer;
  color: var(--blue60, #5E8EB7);
  text-align: right;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.content-box .content .item-row.extra {
  margin-top: 8px;
  padding-left: 16px;
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: normal;
}
.content-box .content .item-row.extra .value {
  color: var(--700-grey, #6E7889);
}
.content-box .quill {
  height: auto;
}
.content-box .quill .ql-container {
  height: auto !important;
}
.content-box .quill .ql-tooltip.ql-hidden {
  display: none !important;
}
.content-box .quill .ql-editor {
  height: auto !important;
  min-height: unset !important;
  overflow: visible !important;
  padding: 0 !important;
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}
.content-box .quill .ql-editor strong {
  font-weight: bold;
}
.content-box .quill .ql-editor em {
  font-style: italic;
}

.document-item {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid var(--400-grey, #CCD3DB);
  background: var(--white, #FFF);
  margin-bottom: 12px;
}
.document-item .row {
  padding-right: 16px;
  padding-bottom: 11px;
  padding-left: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.document-item .row:first-child {
  padding-top: 11px;
}
.document-item .row .box-message-state-review {
  width: 100%;
  margin-left: 45px;
  margin-right: 13px;
  padding: 5px 8px;
  padding-bottom: 10px;
  background-color: #FDFCFF;
  color: #855791;
  border: 1px solid #D7B8E5;
}
.document-item .row .box-message-state-review span {
  font-size: 12px;
  font-weight: 400;
}
.document-item .row .box-message-state-review b {
  font-size: 12px;
  font-weight: 700;
  text-decoration: underline;
}
.document-item .row .box-message-state-review button {
  height: auto;
  padding: 0px;
}
.document-item .row .box-message-state-review button span {
  text-decoration: underline;
  color: #855791;
  font-size: 12px;
}
.document-item .row .box-message-state-review button svg {
  width: 12px;
  height: 12px;
}
.document-item .row .box-message-state-review button .anticon {
  margin-inline-start: 5px;
}
.document-item .row .box-message-state-review .button-bold span {
  font-weight: 600;
  text-decoration: none;
}
.document-item-COMPLETE {
  border-radius: 10px;
  border: 1px solid var(--green-60, #4CA852);
  background: #FAFCFC;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);
}
.document-item-COMPLETE .label {
  color: var(--green-90, #1F4222);
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.document-item-COMPLETE svg:not(.trash) path {
  stroke: #1F4222;
}
.document-item-COMPLETE .status-badge {
  background: var(--30, #C2F0C5);
  color: var(--100, #141F15);
}
.document-item-VERIFY\\/UPDATE {
  border-radius: 10px;
  border: 1px solid var(--60, #C59ED5);
  background: var(--10, #FAF9FC);
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);
}
.document-item-VERIFY\\/UPDATE .label {
  color: var(--90, #653B6F);
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.document-item-VERIFY\\/UPDATE svg:not(.trash) path {
  stroke: var(--90, #653B6F);
}
.document-item-VERIFY\\/UPDATE .status-badge {
  background: #EAD6FF;
  color: var(--100, #141F15);
}
.document-item-MANUAL {
  border-radius: 10px;
  border: 1px solid var(--60, #C59ED5);
  background: var(--10, #FAF9FC);
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);
}
.document-item-MANUAL .label {
  color: var(--90, #653B6F);
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.document-item-MANUAL svg:not(.trash) path {
  stroke: var(--90, #653B6F);
}
.document-item-MANUAL .status-badge {
  background: #EAD6FF;
  color: var(--100, #141F15);
}
.document-item-UPLOAD {
  border-radius: 10px;
  border: 1px solid #C13934;
  background: #FAFCFC;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);
}
.document-item-UPLOAD .label {
  color: #610805;
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.document-item-UPLOAD svg:not(.trash) path {
  stroke: #610805;
}
.document-item-UPLOAD .status-badge {
  background: #FFC6BF;
  color: var(--100, #141F15);
}
.document-item-DRAFT svg:not(.trash) path {
  stroke: #929FB0;
}
.document-item-DRAFT svg.trash path {
  stroke: #FFC6BF;
}
.document-item-DRAFT .label {
  color: var(--600-grey, #929FB0);
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.document-item-DRAFT .status-badge {
  background: var(--30, #EFF3F5);
  color: var(--100, #404859);
}
.document-item svg {
  height: 16px;
  width: 16px;
  margin-right: 8px;
}
.document-item svg:last-of-type {
  margin-right: 0px;
}
.document-item .actions-container {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 40px;
}
.document-item .actions-container .disabled {
  opacity: 0.3;
  cursor: auto;
}
.document-item .label {
  flex: 1 1;
  min-width: 0;
  font-size: 22px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 24px;
  row-gap: 0;
  word-break: break-word;
  overflow-wrap: break-word;
}
.document-item .label .expires-label {
  font-family: Inter;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  text-align: left;
}
.document-item .label .expires-label-error {
  color: #E56A5C !important;
}
.document-item .label .expires-label-approved {
  color: #3F9545 !important;
}
.document-item .feedback-actions-container {
  display: flex;
  align-items: start;
}
.document-item .feedback-actions-container .action-blocked-disabled {
  opacity: 0.3;
  cursor: auto;
}
.document-item .feedback-actions-container .action-blocked-blocked svg {
  fill: #FFC6BF;
}
.document-item .feedback-actions-container .action-blocked-blocked svg:not(.trash) path {
  stroke: #610805;
}
.document-item .content-right {
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: end;
  flex-shrink: 0;
}
.document-item .content-right .document-state {
  width: 200px;
  display: flex;
  justify-content: end;
}
.document-item .expand {
  flex: 0.2 1;
}

.borrower-card {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background: var(--gray-100, #F9FAFB);
  height: 112px;
  padding: 7px 14px;
}
.borrower-card .borrower-summary {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 256px;
  position: relative;
  bottom: 8px;
}
.borrower-card .borrower-summary .photo-container {
  position: absolute;
  top: -8px;
  border-radius: 24px;
  background: lightgray 50%;
  margin-bottom: 4px;
}
.borrower-card .borrower-summary .borrower-caption {
  margin-top: 22px;
  color: var(--700-grey, #6E7889);
  text-align: center;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
}
.borrower-card .borrower-summary .borrower-name {
  color: var(--900-grey, #2A2F3C);
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.borrower-card .contact-info-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 8px;
}
.borrower-card .buttons-container {
  width: 100%;
}
.borrower-card .buttons-container > *:first-child {
  margin-right: 8px;
}
.borrower-card .buttons-container .button-blue {
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--100, #122536);
  text-align: center;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.15px;
  height: 24px;
  padding: 0px 6px;
  border-radius: 6px;
  border: 1px solid var(--100, #162E43);
  background: var(--100, #122536);
}
.borrower-card .buttons-container .button-blue:hover {
  color: var(--100, #122536) !important;
}
.borrower-card .buttons-container .button-blue.outlined {
  color: var(--100, #122536);
  background: #FFF;
}

.borrower-task-item {
  display: flex;
  flex-direction: column;
  padding: 11px 16px;
  border-radius: 10px;
  border: 1px solid var(--400-grey, #CCD3DB);
  background: var(--white, #FFF);
  margin-bottom: 12px;
}
.borrower-task-item .row-1 {
  display: flex;
  align-items: center;
}
.borrower-task-item .row-1 .actions-container {
  display: flex;
  align-items: center;
  width: 40px;
  gap: 8px;
}
.borrower-task-item .row-1 .actions-container img, .borrower-task-item .row-1 .actions-container svg {
  cursor: pointer;
}
.borrower-task-item .row-1 .label {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  word-break: break-word;
  overflow-wrap: break-word;
  margin-left: 10px;
  width: 20em;
}
.borrower-task-item .row-1 .feedback-actions-container {
  display: flex;
  width: 50px;
  max-width: 5em;
  gap: 8px;
}
.borrower-task-item .row-1 .feedback-actions-container svg {
  cursor: pointer;
}
.borrower-task-item .row-1 .content-right {
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: end;
  width: 50%;
}
.borrower-task-item .row-1 .content-right .content-status {
  width: 150px;
  display: flex;
  justify-content: end;
}
.borrower-task-item .row-1 .expand {
  width: 20px;
}
.borrower-task-item svg {
  height: 16px;
  width: 16px;
  margin-right: 8px;
}
.borrower-task-item svg:last-of-type {
  margin-right: 0px;
}
.borrower-task-item svg:not(.trash) path {
  stroke: #2A2F3C;
}
.borrower-task-item .label {
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.borrower-task-item .status-badge {
  background: var(--30, #404859);
}
.borrower-task-item .status-badge .title {
  color: var(--100, #FFFFFF);
}
.borrower-task-item.DRAFT svg:not(.trash) path {
  stroke: #404859;
}
.borrower-task-item.DRAFT .status-badge {
  border: 1px solid var(--60, #404859);
  background: var(--30, #FFFFFF);
}
.borrower-task-item.DRAFT .status-badge .title {
  color: var(--100, #404859);
}
.borrower-task-item.REVIEW {
  border: 1px solid var(--60, #C59ED5);
  background: var(--10, #FAF9FC);
}
.borrower-task-item.REVIEW .label {
  color: var(--90, #653B6F);
}
.borrower-task-item.REVIEW svg:not(.trash) path {
  stroke: #653B6F;
}
.borrower-task-item.REVIEW .status-badge {
  background: var(--30, #EAD6FF);
}
.borrower-task-item.REVIEW .status-badge .title {
  color: var(--100, #241226);
}
.borrower-task-item.REVIEW .liquidity-info .title {
  color: #653B6F !important;
}
.borrower-task-item.REVIEW .liquidity-info .max {
  color: #653B6F;
}
.borrower-task-item.REVIEW .box-message-state-review {
  margin-top: 10px;
  margin-left: 45px;
  margin-right: 28px;
  padding: 5px 8px;
  background-color: #FDFCFF;
  color: #855791;
  border: 1px solid #D7B8E5;
}
.borrower-task-item.REVIEW .box-message-state-review span {
  font-size: 12px;
  font-weight: 400;
}
.borrower-task-item.REVIEW .box-message-state-review b {
  font-size: 12px;
  font-weight: 700;
}
.borrower-task-item.REVIEW .box-message-state-review button {
  height: auto;
  padding: 0px;
}
.borrower-task-item.REVIEW .box-message-state-review button span {
  text-decoration: underline;
  color: #855791;
  font-size: 12px;
}
.borrower-task-item.REVIEW .box-message-state-review button svg {
  width: 12px;
  height: 12px;
}
.borrower-task-item.REVIEW .box-message-state-review button .anticon {
  margin-inline-start: 5px;
}
.borrower-task-item.REVIEW .box-message-state-review .button-bold span {
  font-weight: 600;
  text-decoration: none;
}
.borrower-task-item.REQUEST_ERROR {
  border: 1px solid var(--60, #C13934);
  background: var(--10, #FFFFFF);
}
.borrower-task-item.REQUEST_ERROR .label {
  color: var(--90, #610805);
}
.borrower-task-item.REQUEST_ERROR svg:not(.trash) path {
  stroke: #610805;
}
.borrower-task-item.REQUEST_ERROR .status-badge {
  background: var(--30, #FFC6BF);
}
.borrower-task-item.REQUEST_ERROR .status-badge .title {
  color: var(--100, #241226);
}
.borrower-task-item.APPROVED {
  border: 1px solid var(--60, #4CA852);
  background: var(--10, #FAFCFC);
}
.borrower-task-item.APPROVED .label {
  color: var(--90, #1F4222);
}
.borrower-task-item.APPROVED svg:not(.trash) path {
  stroke: #1F4222;
}
.borrower-task-item.APPROVED .status-badge {
  background: var(--30, #C2F0C5);
}
.borrower-task-item.APPROVED .status-badge .title {
  color: var(--100, #241226);
}
.borrower-task-item .liquidity-info {
  margin-top: 10px;
  margin-left: 55px;
}
.borrower-task-item .liquidity-info .label {
  font-weight: 500;
  font-size: 12px;
}
.borrower-task-item .liquidity-info .max {
  font-weight: 600;
  font-size: 12px;
}

.cont-modal {
  width: 100%;
}

.ModalTask {
  position: fixed;
  background: rgba(42, 47, 60, 0.55);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 300;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ModalTask .content-add {
  margin-top: 50px;
}
.ModalTask-content {
  width: 70%;
  background-color: #fff;
  height: 100%;
}
.ModalTask .button-close-mask {
  width: 30%;
  height: 100%;
  background-color: rgba(255, 0, 0, 0);
  box-shadow: none;
  border: none;
}
.ModalTask .button-close-mask:hover, .ModalTask .button-close-mask:active, .ModalTask .button-close-mask:focus {
  background-color: rgba(255, 0, 0, 0);
  box-shadow: none;
  border: none;
}
.ModalTask .content-modal {
  padding-bottom: 0;
}
.ModalTask .content-modal .modal-title {
  width: 100%;
  padding: 40px;
  padding-bottom: 0;
}
.ModalTask .content-modal .modal-title .flex-btw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #929fb0;
}
.ModalTask .content-modal .modal-title button,
.ModalTask .content-modal .modal-title button:hover,
.ModalTask .content-modal .modal-title button:active,
.ModalTask .content-modal .modal-title button:focus {
  background-color: transparent;
  border: none !important;
  padding: 0 !important;
  box-shadow: none !important;
  color: #404859 !important;
}
.ModalTask .content-modal .modal-title .body-card {
  color: #404859;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.24px;
}
.ModalTask .content-modal .modal-container {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: calc(100vh - 180px);
}
.ModalTask .content-modal .modal-container .dots {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 45%;
  left: 30px;
  gap: 9px;
}
.ModalTask .content-modal .modal-container .dots-button {
  padding: 0;
  border: 1.5px solid #6e7889;
  background: #fff;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.ModalTask .content-modal .modal-container .dots-button-success {
  border: 1px solid #6EAC72;
  background: #C5F0C8;
}
.ModalTask .content-modal .modal-container .dots-button-active {
  height: 25px;
  width: 25px;
  border: 2px dotted #ddaa42;
}
.ModalTask .content-modal .modal-container .dots-button-review-active {
  height: 25px;
  width: 25px;
  border: 2px dotted #ddaa42;
  background: #e3ddf0;
}
.ModalTask .content-modal .modal-container .modal-title {
  border-bottom: 0;
  align-items: flex-end;
}
.ModalTask .content-modal .modal-container .modal-title button {
  height: 18px;
  text-transform: uppercase;
  color: #8a5791 !important;
}
.ModalTask .content-modal .modal-container .modal-title button img {
  margin-top: -0.9px;
  margin-right: 3px;
}
.ModalTask .content-modal .modal-container .text {
  margin-top: 5px;
}
.ModalTask .content-modal .modal-container .text a {
  margin-left: 6px;
}
.ModalTask .content-modal .modal-container .text a:hover {
  color: #2a2f3c;
}
.ModalTask .content-modal .modal-container .modal-cards {
  width: 100%;
  height: 100%;
  padding-bottom: 20px;
  padding-top: 64px;
  overflow: auto;
  padding-right: 10px;
  max-width: 576px;
  /* Track */
  /* Handle */
  /* Handle on hover */
}
.ModalTask .content-modal .modal-container .modal-cards--full {
  max-width: none;
  display: flex;
  justify-content: center;
}
.ModalTask .content-modal .modal-container .modal-cards-mx-w {
  max-width: 576px;
  width: 100%;
  padding-bottom: 20px;
}
.ModalTask .content-modal .modal-container .modal-cards .flex-btw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 12px;
}
.ModalTask .content-modal .modal-container .modal-cards .flex-btw .button {
  text-transform: uppercase;
  color: #404859;
  text-align: right;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  text-transform: uppercase;
}
.ModalTask .content-modal .modal-container .modal-cards .flex-btw .button .anticon {
  color: #404859;
}
.ModalTask .content-modal .modal-container .modal-cards .title {
  background: #e3ddf0;
  border-radius: 140px;
  display: flex;
  padding: 5px 12px 5px 10px;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.ModalTask .content-modal .modal-container .modal-cards .title .body-regular {
  color: #48244d;
}
.ModalTask .content-modal .modal-container .modal-cards .h2 {
  margin-top: 12px;
  word-break: break-word;
  overflow-wrap: break-word;
}
.ModalTask .content-modal .modal-container .modal-cards .h2-w8 {
  color: #ac78b3;
}
.ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar {
  width: 8px;
  border-radius: 5px;
}
.ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}
.ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.ModalTask .modal-review-task__footer {
  border-top: 1px solid #dfe4eb;
  height: 180px;
}
.ModalTask .modal-review-task__footer .text-footer .placeholder {
  color: #6e7889;
}
.ModalTask .modal-review-task__footer .text-footer .placeholder span {
  color: #f5faff;
  font-weight: 600;
  background-color: #5e8eb7;
  padding: 0 5px;
  border-radius: 3px;
}
.ModalTask .modal-review-task__footer .footer-grey .h4 {
  color: #6e7889;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 170%;
}
.ModalTask .modal-review-task__footer .body-regular {
  color: #6e7889;
}
.ModalTask .modal-review-task__footer .footer_dost {
  align-items: center;
}
.ModalTask .modal-review-task__footer .footer_dost .body-regular {
  color: #404859;
}
.ModalTask .modal-review-task__footer .footer_dost .circles {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
}
.ModalTask .modal-review-task__footer .footer_dost .circles .circle {
  border-radius: 64px;
  border: 1px solid #404859;
  width: 20px;
  height: 20px;
}
.ModalTask .modal-review-task__footer .modal-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  padding-right: 15px;
}
.ModalTask .modal-review-task__footer .modal-container .modal-cards {
  width: 100%;
  height: 100%;
  max-width: 576px;
  padding: 14px 0;
}
.ModalTask .modal-review-task__footer .modal-container .modal-cards .h4-w4 {
  color: #ac78b3;
  margin-bottom: 10px;
}
.ModalTask .modal-review-task__footer .modal-container .modal-cards .h4-w4 .h4 {
  color: #6e7889;
}
.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
}
.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles .circle {
  border-radius: 100%;
  border: 1px solid #8a5791;
  background: #dfb8e5;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles .circle-active {
  border: 1px solid #587e5b;
  background: #6eac72;
}
.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles .circle-active img {
  display: none;
}

.ModalTask-content-right {
  width: 35%;
  background-color: #fff;
  height: 100%;
  border-left: 1px solid #ccd3db;
  overflow: scroll;
  padding: 60px 45px 25px 30px;
}
.ModalTask-content-right .w-md-editor .title {
  line-height: unset !important;
  font-size: unset !important;
  font-weight: unset !important;
}
.ModalTask-content-right .button-close {
  position: absolute;
  top: 10px;
  right: 10px;
  color: black;
}
.ModalTask-content-right .button-close:hover {
  color: black !important;
}

.modal-end-submit {
  border-radius: 10px;
  border: 1px solid var(--yellow-400, #ffd47d);
  background: var(--yellow-100, #fff9ee);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
  padding: 0;
  width: 556px !important;
  top: 202px !important;
}
.modal-end-submit .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #162e43 !important;
  border-color: #162e43 !important;
}
.modal-end-submit .coin {
  width: 49.334px;
  height: 34px;
}
.modal-end-submit .tag {
  width: 53px;
  height: 47.06px;
}
.modal-end-submit .ant-modal-content {
  background-color: transparent;
  padding: 32px;
}
.modal-end-submit .ant-modal-content .h2 {
  margin-top: 15px;
  margin-bottom: 5px;
}
.modal-end-submit .ant-modal-content .h4 {
  color: #66564d;
}
.modal-end-submit .ant-modal-content .divider {
  border-top: 1px solid #ddaa42;
  padding-top: 20px;
  margin-top: 26px;
}
.modal-end-submit .ant-modal-content .buttons {
  margin-top: 35px;
}
.modal-end-submit .ant-modal-content .button {
  margin-top: 16px;
  height: 40px !important;
}
.modal-end-submit .ant-modal-content .ant-modal-footer {
  display: none;
}
.modal-end-submit .anticon {
  color: #997120;
}
.modal-end-submit .ant-checkbox-wrapper {
  margin-top: 10px;
}
.modal-end-submit .ant-checkbox-wrapper span {
  color: #244560;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.18px;
}
.modal-end-submit--white {
  background: #fff;
  border-color: #fff;
}
.modal-end-submit--white .anticon {
  color: #6e7889;
}
.modal-end-submit--white .ant-modal-content .h2 {
  color: #162e43;
}
.modal-end-submit--white .ant-modal-content .h4 {
  color: #48759a;
}
.modal-end-submit--white .ant-modal-content .buttons .button-modal-ok {
  border: 1px solid #162e43 !important;
  background: #162e43 !important;
  color: #ffffff !important;
}
.modal-end-submit--white .ant-modal-content .buttons .button-modal-cancel {
  border: 1px solid #162e43 !important;
  background: #fff !important;
  color: #162e43 !important;
}
.modal-end-submit--white .ant-modal-content .buttons .button-modal-cancel-delete {
  font-weight: 600 !important;
  color: #122536 !important;
}
.modal-end-submit--white .ant-modal-content .buttons .button-modal-delete {
  border: 1px solid #A31C17 !important;
  background: #A31C17 !important;
  color: #F5FAFF !important;
  font-weight: 600 !important;
}

.QuestionBasic .body-regular {
  color: #6e7889;
}
.QuestionBasic .h3 {
  margin-bottom: 40px;
}
.QuestionBasic .options {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 18px;
  margin-top: 25px;
}
.QuestionBasic .options .content-left {
  display: flex;
  flex-direction: column;
}
.QuestionBasic .options .Button-option {
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid #ccd3db;
  background: #f9fafb;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);
  min-height: 56px;
  height: auto;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 19px 24px;
}
.QuestionBasic .options .Button-option-text {
  color: #2a2f3c !important;
}
.QuestionBasic .options .Button-option .flex-btw {
  margin-bottom: 0 !important;
}
.QuestionBasic .options .Button-option .flex-start {
  display: none;
}
.QuestionBasic .options .Button-option-active {
  border-radius: 10px;
  border: 1px solid #9bbceb;
  background: #ebf6ff;
  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);
}
.QuestionBasic .options .Button-option-active .flex-start {
  display: flex;
  gap: 6px;
  align-items: flex-start;
}
.QuestionBasic .options .Button-option-active .flex-start img {
  margin-top: 3px;
}
.QuestionBasic .options .Button-option-active .flex-start .body-regular {
  max-width: 300px;
}
.QuestionBasic .options .Button-option-active-text {
  color: #355c7d !important;
}
.QuestionBasic .options .Button-option-active .body-regular {
  color: #5e8eb7;
}
.QuestionBasic .options .Button-option-active .sub-title {
  font-weight: 500;
}
.QuestionBasic .Button-option-active .ModalEndSubmit {
  width: 100%;
}
.QuestionBasic .Button-option-active .ModalEndSubmit .button {
  height: 36px;
}
.QuestionBasic .Button-option-active .ModalEndSubmit .button span {
  color: #f5faff !important;
}
.QuestionBasic .Button-option-active .Button-option-text {
  color: #355c7d !important;
}
.QuestionBasic .Button-option-active-description {
  color: #5E8EB7 !important;
  font-size: 14px;
  margin-top: 5px;
}
.QuestionBasic .list {
  list-style-type: disc;
  list-style: disc;
  padding-left: 25px;
  margin-top: 15px;
}
.QuestionBasic .list .h4 {
  color: #404859;
  line-height: 145%;
}

.spinner-container {
  position: relative;
  width: auto;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: end;
  overflow: hidden; /* Evita desbordamientos */
}

.spinner {
  position: relative;
}

.spinner div {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #c4cdd5;
  border-radius: 50%;
  animation: spin 1.2s linear infinite;
}

/* Colocación inicial de los 12 círculos */
.spinner div:nth-child(1) {
  transform: rotate(30deg) translate(40px);
}

.spinner div:nth-child(2) {
  transform: rotate(60deg) translate(40px);
}

.spinner div:nth-child(3) {
  transform: rotate(90deg) translate(40px);
}

.spinner div:nth-child(4) {
  transform: rotate(120deg) translate(40px);
}

.spinner div:nth-child(5) {
  transform: rotate(150deg) translate(40px);
}

.spinner div:nth-child(6) {
  transform: rotate(180deg) translate(40px);
}

.spinner div:nth-child(7) {
  transform: rotate(210deg) translate(40px);
}

.spinner div:nth-child(8) {
  transform: rotate(240deg) translate(40px);
}

.spinner div:nth-child(9) {
  transform: rotate(270deg) translate(40px);
}

.spinner div:nth-child(10) {
  transform: rotate(300deg) translate(40px);
}

.spinner div:nth-child(11) {
  transform: rotate(330deg) translate(40px);
}

.spinner div:nth-child(12) {
  transform: rotate(0deg) translate(40px);
}

/* Animación para cambiar el color de los círculos */
@keyframes spin {
  0%, 100% {
    background-color: #c4cdd5;
  }
  8.3% {
    background-color: #4e8de6;
  }
}
/* Cambia el retardo de cada círculo */
.spinner div:nth-child(1) {
  animation-delay: -1.1s;
}

.spinner div:nth-child(2) {
  animation-delay: -1s;
}

.spinner div:nth-child(3) {
  animation-delay: -0.9s;
}

.spinner div:nth-child(4) {
  animation-delay: -0.8s;
}

.spinner div:nth-child(5) {
  animation-delay: -0.7s;
}

.spinner div:nth-child(6) {
  animation-delay: -0.6s;
}

.spinner div:nth-child(7) {
  animation-delay: -0.5s;
}

.spinner div:nth-child(8) {
  animation-delay: -0.4s;
}

.spinner div:nth-child(9) {
  animation-delay: -0.3s;
}

.spinner div:nth-child(10) {
  animation-delay: -0.2s;
}

.spinner div:nth-child(11) {
  animation-delay: -0.1s;
}

.spinner div:nth-child(12) {
  animation-delay: 0s;
}

.ButtonTabsFilters {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}
.ButtonTabsFilters .tab {
  border-radius: 100px;
  background: #dfe4eb;
  color: #404859;
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  border: none;
  box-shadow: none;
  height: 24px;
}
.ButtonTabsFilters .tab .number {
  font-weight: 400;
  margin-left: 3px;
}
.ButtonTabsFilters .tab:hover {
  background: #5E8EB7 !important;
  color: white !important;
}
.ButtonTabsFilters .tab-active {
  background-color: #355c7d;
  color: #ffffff;
}
.ButtonTabsFilters .tab-active:hover {
  background-color: #355c7d;
  color: #ffffff !important;
}

.CardAlertError {
  border-radius: 10px;
  border: 1px solid #d7b8e5;
  background: #f7edfc;
  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);
  padding: 18px 24px;
}
.CardAlertError .h4-w5 {
  color: #241226;
  margin-bottom: 5px;
}
.CardAlertError .h4-w4 {
  color: #653b6f;
  margin-bottom: 30px;
}

.CardDetailInformationBank {
  border-radius: 10px;
  border: 1px solid #929fb0;
  background: #fff;
  padding: 20px 16px;
}
.CardDetailInformationBank .h4 {
  margin-bottom: 24px;
}
.CardDetailInformationBank .label {
  color: #6e7889;
  margin-bottom: 4px;
}
.CardDetailInformationBank .info {
  color: #929fb0;
  font-style: italic;
}
.CardDetailInformationBank .row {
  display: flex;
  justify-content: center;
  align-items: center;
}
.CardDetailInformationBank .row .column {
  width: 50%;
}
.CardDetailInformationBank .column {
  margin-bottom: 20px;
}
.CardDetailInformationBank .column-line {
  border-bottom: 1px solid #dfe4eb;
  padding-bottom: 16px;
}

.CardLoanTasks {
  width: 396px;
  height: 192px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid #6e7889;
  background: #fafcfc;
  padding: 12px 19px;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.CardLoanTasks .state-name {
  color: #404859;
  font-family: Inter;
  font-size: 10px !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.CardLoanTasks .state-name-w6 {
  font-weight: 600;
}
.CardLoanTasks .withBorder {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #ccd3db;
  background: #fff;
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.CardLoanTasks .withOutBorder {
  width: 100%;
  border-radius: 10px;
  border: none;
  background: none;
  box-shadow: none;
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.CardLoanTasks__top__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}
.CardLoanTasks__top__head .flex-end {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  align-items: center;
}
.CardLoanTasks__top__head .flex-end .svg-grid {
  height: 12px;
  width: 12px;
  fill: none;
}
.CardLoanTasks__top__head .flex-end .quick-task path {
  stroke: #6e7889;
}
.CardLoanTasks__top__head .flex-end .quick-task path:first-child {
  fill: #6e7889;
}
.CardLoanTasks__top__head .flex-end .major-task path {
  stroke: #6e7889;
  fill: #6e7889;
}
.CardLoanTasks__top .h4 {
  margin-bottom: 4px;
}
.CardLoanTasks__top .text {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.CardLoanTasks__top .body-card-full {
  margin-left: 5px;
  padding: 0 5px;
  font-weight: 700;
  border-radius: 2px;
}
.CardLoanTasks .TaskProgress {
  margin-top: 10px;
}
.CardLoanTasks__bottom .body-small-up {
  color: #587e5b;
  margin-bottom: 8px;
}
.CardLoanTasks__bottom .flex-betwen .body-card {
  color: #587e5b;
}
.CardLoanTasks-buttons-actions {
  gap: 10px;
  display: flex;
  justify-content: space-between;
}
.CardLoanTasks-APPROVED {
  border-color: #6eac72;
}
.CardLoanTasks-APPROVED .state {
  border-radius: 76px;
  background: #c5f0c8;
  padding: 4px 8px 4px 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.CardLoanTasks-APPROVED .state .check {
  margin-right: 2px;
}
.CardLoanTasks-APPROVED .state .state-name {
  color: #355137;
}
.CardLoanTasks-APPROVED .h4 {
  color: #466849;
}
.CardLoanTasks-APPROVED .body-card-full {
  background-color: #c5f0c8;
  color: #466849;
}
.CardLoanTasks-APPROVED .flex-end .svg-grid path {
  stroke: #6eac72;
}
.CardLoanTasks-APPROVED .flex-end .svg-grid path:first-child {
  fill: #6eac72;
}
.CardLoanTasks-APPROVED .flex-end .major-task path {
  stroke: #6eac72;
  fill: #6eac72;
}
.CardLoanTasks-APPROVED .flex-end .state-name {
  color: #6eac72;
}
.CardLoanTasks-APPROVED .button-card {
  border: 1px solid #6eac72;
  background: #fafcfc;
  color: #466849;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);
}
.CardLoanTasks-REVIEW {
  border-color: #ac78b3;
  background: #FEFAFF;
}
.CardLoanTasks-REVIEW .body-card-full {
  color: #48244d;
  background: #e3ddf0;
}
.CardLoanTasks-REVIEW .body-card--green {
  background-color: #e3ddf0;
}
.CardLoanTasks-REVIEW .state-name {
  color: #8a5791;
}
.CardLoanTasks-REVIEW .CardLoanTasks__top__head .flex-end .major-task path {
  stroke: #ac78b3;
  fill: #ac78b3;
}
.CardLoanTasks-REVIEW .state {
  border-radius: 76px;
  background: #e3ddf0;
  padding: 4px 8px 4px 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.CardLoanTasks-REVIEW .state .state-name {
  color: #48244d;
}
.CardLoanTasks-REVIEW .body-card {
  color: #48244d;
}
.CardLoanTasks-REVIEW .button-card {
  color: #693b6f;
  border-radius: 6px;
  border: 1px solid #ac78b3;
  background: #fdfcff;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.03);
}
.CardLoanTasks-DRAFT {
  border-color: #929fb0;
}
.CardLoanTasks-DRAFT .body-card-w5 {
  color: #48244d;
}
.CardLoanTasks-DRAFT .state {
  border-radius: 76px;
  background: #404859;
  padding: 4px 8px 4px 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.CardLoanTasks-DRAFT .state .state-name {
  color: #f9fafb;
}
.CardLoanTasks-REQUEST_ERROR {
  border-color: #c94f4a;
}
.CardLoanTasks-REQUEST_ERROR .body-card-w5 {
  color: #ac3e3a;
}
.CardLoanTasks-REQUEST_ERROR .state {
  border-radius: 76px;
  background: #ffd4cf;
  padding: 4px 8px 4px 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.CardLoanTasks-REQUEST_ERROR .state .state-name {
  color: #712220;
}
.CardLoanTasks-REQUEST_ERROR .h4,
.CardLoanTasks-REQUEST_ERROR .body-card {
  color: #712220;
}
.CardLoanTasks-REQUEST_ERROR .h4-text-2,
.CardLoanTasks-REQUEST_ERROR .body-card-text-2 {
  color: #ac3e3a;
}
.CardLoanTasks-REQUEST_ERROR .button-card {
  border-color: #c94f4a;
}
.CardLoanTasks-REQUEST_ERROR .flex-betwen .button,
.CardLoanTasks-REQUEST_ERROR .flex-betwen .button-link {
  color: #712220;
}
.CardLoanTasks-REQUEST_ERROR .flex-end .svg-grid path {
  stroke: #c94f4a;
}
.CardLoanTasks-REQUEST_ERROR .flex-end .svg-grid path:first-child {
  fill: #c94f4a;
}
.CardLoanTasks-REQUEST_ERROR .flex-end .major-task path {
  stroke: #c94f4a;
  fill: #c94f4a;
}
.CardLoanTasks-REQUEST_ERROR .flex-end .state-name {
  color: #c94f4a;
}
.CardLoanTasks-beginTask .ModalCardState {
  width: 100% !important;
}

.CardSomeoneElse {
  margin-top: 10px;
  width: 100%;
}
.CardSomeoneElse input {
  background-color: transparent;
  border: none !important;
  box-shadow: none !important;
  padding: 0;
  color: #48759a;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.CardSomeoneElse input::placeholder {
  color: #9bbceb;
  font-family: Inter;
  font-size: 16px;
  font-style: italic;
  font-weight: 500;
  line-height: normal;
}
.CardSomeoneElse .ant-form-item {
  width: 100%;
  margin-bottom: 15px;
}
.CardSomeoneElse .row {
  display: flex;
  justify-content: center;
  align-items: center;
}
.CardSomeoneElse .row .ant-form-item {
  width: 100%;
}

.card-upload-response {
  position: relative;
  border-radius: 10px;
  border: 1px solid #2A2F3C;
  padding: 10px 16px;
}
.card-upload-response .template {
  margin-bottom: 10px;
}
.card-upload-response .template .arrow-right {
  width: 14px;
  margin-left: 5px;
}
.card-upload-response .template button {
  padding: 0;
}
.card-upload-response .header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}
.card-upload-response .header .h4 {
  display: flex;
  align-items: center;
  word-break: break-word;
  overflow-wrap: break-word;
}
.card-upload-response .header .link {
  padding: 0;
  color: rgb(110, 120, 137);
  font-size: 12px;
}
.card-upload-response .header .link span {
  text-decoration: underline;
}
.card-upload-response .header .link:hover {
  color: rgb(110, 120, 137);
}
.card-upload-response .description {
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 12px;
}
.card-upload-response .description .description-button-link {
  padding-left: 0;
  text-decoration: underline;
  color: #5e8eb7;
}
.card-upload-response .description .description-button-link:hover {
  color: #5e8eb7;
}
.card-upload-response-REVIEW {
  border: 1px solid #AC78B3;
  background-color: #FDFCFF;
}
.card-upload-response-REVIEW .h4 {
  color: #161616 !important;
}
.card-upload-response-REVIEW .description {
  color: #161616 !important;
}
.card-upload-response-REVIEW .link {
  color: #161616 !important;
}
.card-upload-response-APPROVED {
  border: 1px solid #92c295;
  background-color: white;
}
.card-upload-response-APPROVED .h4 {
  color: #404859 !important;
}
.card-upload-response-APPROVED .description {
  color: #404859 !important;
}
.card-upload-response-APPROVED .link {
  color: #404859 !important;
}
.card-upload-response-REQUEST_ERROR {
  border: 1px solid #c94f4a;
  background-color: #FFFFFF;
}
.card-upload-response-REQUEST_ERROR .h4 {
  color: #404859 !important;
}
.card-upload-response-REQUEST_ERROR .description {
  color: #404859 !important;
}
.card-upload-response-REQUEST_ERROR .link {
  color: #404859 !important;
}

.DrodownBlue {
  height: 20px;
  padding: 1px 3px !important;
  display: flex;
  align-items: center;
}
.DrodownBlue:hover {
  background-color: #5E8EB7 !important;
  color: white !important;
}
.DrodownBlue:hover span {
  text-decoration-line: none !important;
}
.DrodownBlue:disabled {
  background-color: white !important;
  color: #5E8EB7 !important;
}
.DrodownBlue:disabled span {
  text-decoration-line: underline !important;
}
.DrodownBlue-blue {
  border: 1px solid #9BBCEB;
  border-radius: 10px;
}
.DrodownBlue-blue .ant-dropdown-menu {
  padding: 0px;
}
.DrodownBlue-blue .ant-dropdown-menu-item:hover {
  background-color: #EBF6FF !important;
}
.DrodownBlue-blue .ant-dropdown-menu-item:hover .ant-dropdown-menu-title-content {
  color: #355c7d;
  font-weight: 600;
}
.DrodownBlue-blue .ant-dropdown-menu-title-content {
  color: #5E8EB7;
  font-weight: 400;
}
.DrodownBlue-blue .ant-dropdown-menu-title-content:hover {
  color: #355c7d;
  font-weight: 600;
}

.InputAmount {
  border-radius: 10px;
  border: 1px solid #929fb0;
  background: #fff;
  padding: 13px 16px;
}
.InputAmount .h4 {
  color: #404859;
}
.InputAmount .button-operation {
  padding: 0;
  height: 23px;
  border: 0;
  background: none;
  box-shadow: none;
}
.InputAmount .button-operation .anticon {
  color: #5e8eb7;
}
.InputAmount .button-operation .anticon-full {
  display: none;
}
.InputAmount .button-operation:hover .anticon {
  color: #5e8eb7;
  display: none;
}
.InputAmount .button-operation:hover .anticon-full {
  display: block;
  margin-left: 0;
}
.InputAmount .flex {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}
.InputAmount .flex .h4 {
  color: #929fb0;
}
.InputAmount .flex span {
  color: #929fb0;
  font-family: Inter;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: normal;
}
.InputAmount .flex .text-bold {
  color: #5e8eb7;
  font-weight: 600;
  font-style: normal;
}

.InputBorderNone .input {
  color: #775614;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-break: break-word;
}
.InputBorderNone .body-placeholder-w4 {
  color: #775614;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  word-break: break-word;
}
.InputBorderNone .bold-lith {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
}
.InputBorderNone .bold-lith::placeholder {
  color: #929fb0;
  font-family: Inter;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 145%;
}
.InputBorderNone .bold {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
}
.InputBorderNone .percentage-bottom {
  border: 0;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #afbdcc;
  padding-top: 1px;
  margin-bottom: 10px !important;
  width: 90% !important;
}
.InputBorderNone .percentage-bottom .body-regular span {
  font-size: 12px;
}
.InputBorderNone .ant-input-number-input {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  line-height: normal;
  padding: 5px 0px !important;
}
.InputBorderNone .ant-input-number-input .default {
  font-weight: 400;
  color: #404859;
}
.InputBorderNone .ant-input-number-input .warning {
  font-weight: 600;
  color: #775614;
}
.InputBorderNone .ant-input-number-input::placeholder {
  color: #929fb0;
  font-family: Inter;
  font-style: italic !important;
  font-weight: 400;
}
.InputBorderNone-edit-number {
  border-bottom: 1px solid #afbdcc;
}
.InputBorderNone-edit-number input[type=number] {
  appearance: textfield;
}
.InputBorderNone-edit-number input[type=number]::-webkit-inner-spin-button, .InputBorderNone-edit-number input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.InputBorderNone-edit-date {
  border-bottom: 1px solid #afbdcc;
}

.InputUploadedFile .file-ok {
  margin: 10px 0;
}
.InputUploadedFile .file-ok .file {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9fafb;
  position: relative;
}
.InputUploadedFile .file-ok .file-content {
  height: 28px;
  border-radius: 10px;
  border: 1px solid #2a2f3c;
  background-color: #f9fafb;
  width: 100%;
  padding: 0 20px;
  padding-right: 12px;
}
.InputUploadedFile .file-ok .file-content-approved {
  border: 1px solid #92c295 !important;
  background: #f5faf7 !important;
}
.InputUploadedFile .file-ok .file-content-request_error {
  border: 1px solid #c94f4a !important;
  background: #fff4f3 !important;
}
.InputUploadedFile .file-ok .file-content-request_error .name,
.InputUploadedFile .file-ok .file-content-request_error .anticon {
  color: #712220 !important;
}
.InputUploadedFile .file-ok .file-content-review {
  border: 1px solid #AC78B3 !important;
  background: #e3ddf0 !important;
}
.InputUploadedFile .file-ok .file-content-review .name,
.InputUploadedFile .file-ok .file-content-review .anticon {
  color: #693B6F !important;
}
.InputUploadedFile .file-ok .file .file-name {
  width: 80%;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 7px;
}
.InputUploadedFile .file-ok .file .file-name .name {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.InputUploadedFile .file-ok .file .file-name .anticon {
  font-size: 15px;
}
.InputUploadedFile .file-ok .file .content-buttons {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 7px;
}
.InputUploadedFile .file-ok .file .content-buttons .anticon {
  font-size: 15px;
}
.InputUploadedFile .file-ok .file .flex {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  gap: 12px;
}
.InputUploadedFile .file-ok .file .flex:first-child {
  gap: 4px;
}
.InputUploadedFile .file-ok .file .upload {
  margin-bottom: 0;
}
.InputUploadedFile .file-ok .file .flex-btw {
  margin-bottom: 0;
  height: 100%;
  border-bottom: none;
}
.InputUploadedFile .file-ok .file .circle-input {
  background-color: #fff;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #2a2f3c;
  display: flex;
  position: absolute;
  left: 0;
  justify-content: center;
  align-items: center;
}
.InputUploadedFile .file-ok .file .circle-input .upload {
  width: auto;
  height: 18px;
  object-fit: cover;
}

.ProgressSteps {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
}
.ProgressSteps .tab {
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.ProgressSteps .tab .bar-status {
  width: 100%;
  width: calc(100% + 20px);
  height: 6px;
  border-radius: 16px;
  margin-top: 6px;
  background-color: #dfe4eb;
}
.ProgressSteps .tab-complete .body-small {
  color: #587e5b;
}
.ProgressSteps .tab-complete .bar-status {
  background-color: #6eac72;
}
.ProgressSteps .tab-started:hover .bar-status {
  background-color: #404859;
}

.ant-popover-content .ant-popover-inner {
  padding: 0;
}
.ant-popover-content .popover-content {
  padding: 10px 8px;
  border-radius: 10px;
  width: 240px;
  position: relative;
}
.ant-popover-content .popover-content .body-small {
  color: #fafcfa;
}
.ant-popover-content .popover-content .body-small-w6 {
  margin-bottom: 6px;
}
.ant-popover-content .popover-content .divider {
  height: 1px;
  width: 100%;
  margin: 8px 0;
}
.ant-popover-content .popover-content .button {
  display: flex;
  gap: 4px;
  align-items: center;
}
.ant-popover-content .popover-content .flecha-darck,
.ant-popover-content .popover-content .flecha {
  display: none;
  width: 16px;
  height: 8px;
}
.ant-popover-content .popover-content .felx-between {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.ant-popover-content .popover-content .felx-between .flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.ant-popover-content .popover-content .felx-between .flex img {
  margin-right: 5px;
}
.ant-popover-content .popover-content .felx-between .button {
  background-color: transparent;
  border: none;
  padding: 0;
  height: 20px;
  box-shadow: none;
}
.ant-popover-content .popover-content .felx-between .button .flecha {
  margin-left: 5px;
  width: 12px;
}
.ant-popover-content .popover-content .warning {
  display: none;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  margin-top: 10px;
}
.ant-popover-content .popover-content .warning svg {
  width: 10px;
  height: 11px;
  fill: none;
}
.ant-popover-content .popover-content .warning .body-small {
  margin-bottom: 0;
  color: #8f2f2c;
  text-decoration-line: underline;
}
.ant-popover-content .popover-content-complete, .ant-popover-content .popover-content-started {
  background-color: #587e5b;
}
.ant-popover-content .popover-content-complete .divider, .ant-popover-content .popover-content-started .divider {
  background-color: #fafcfa;
}
.ant-popover-content .popover-content-complete .flecha, .ant-popover-content .popover-content-started .flecha {
  display: block;
}
.ant-popover-content .popover-content-complete .button:hover, .ant-popover-content .popover-content-complete .button:active, .ant-popover-content .popover-content-complete .button:focus, .ant-popover-content .popover-content-started .button:hover, .ant-popover-content .popover-content-started .button:active, .ant-popover-content .popover-content-started .button:focus {
  color: #fafcfa;
}
.ant-popover-content .popover-content-complete::after, .ant-popover-content .popover-content-started::after {
  content: "*";
  font-size: 0;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 11px solid #587e5b;
  position: absolute;
  left: 46%;
  top: -10px;
  z-index: 3;
}
.ant-popover-content .popover-content-started {
  background-color: #404859;
  width: 270px;
}
.ant-popover-content .popover-content-started .warning {
  display: flex;
}
.ant-popover-content .popover-content-started .warning .body-small {
  color: #ffd4cf;
}
.ant-popover-content .popover-content-started .warning svg path {
  stroke: #ffd4cf;
}
.ant-popover-content .popover-content-started::after {
  content: "*";
  font-size: 0;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 11px solid #404859;
  position: absolute;
  left: 46%;
  top: -10px;
  z-index: 3;
}
.ant-popover-content .popover-content-not-started {
  background-color: #ccd3db;
  width: 270px;
}
.ant-popover-content .popover-content-not-started .body-small {
  color: #000000;
}
.ant-popover-content .popover-content-not-started .warning {
  display: flex;
}
.ant-popover-content .popover-content-not-started svg path {
  stroke: #8f2f2c;
}
.ant-popover-content .popover-content-not-started .button:hover, .ant-popover-content .popover-content-not-started .button:active, .ant-popover-content .popover-content-not-started .button:focus {
  color: #000000;
}
.ant-popover-content .popover-content-not-started .divider {
  background-color: #404859;
}
.ant-popover-content .popover-content-not-started .flecha-darck {
  display: block;
}
.ant-popover-content .popover-content-not-started::after {
  content: "*";
  font-size: 0;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 11px solid #ccd3db;
  position: absolute;
  left: 46%;
  top: -10px;
  z-index: 3;
}
.ant-popover-content .popover-content .green-all .body-small {
  color: #c5f0c8;
}

.TaskProgress .bar {
  width: 100%;
  background-color: #dfe4eb;
  height: 8px;
  border-radius: 8px;
  display: flex;
}
.TaskProgress .bar :first-child {
  border-bottom-left-radius: 8px;
  border-top-left-radius: 8px;
}
.TaskProgress .bar :last-child {
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
}
.TaskProgress .bar-percentage {
  height: 8px;
}
.TaskProgress .h4 {
  color: #404859 !important;
  text-transform: none;
}

.SelectPrimary .body-regular {
  color: #2a2f3c;
  font-weight: 500;
}
.SelectPrimary .ant-space-item {
  width: 100%;
}

.state-tag {
  width: max-content;
  border-radius: 76px;
  padding: 4px 8px 4px 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.state-tag .check {
  margin-right: 2px;
}
.state-tag .state-name {
  font-weight: 600;
  font-family: Inter;
  line-height: 11px;
  letter-spacing: 0.02em;
  font-size: 10px;
}
.state-tag-APPROVED {
  border-color: #C2F0C5;
  background: #C2F0C5;
}
.state-tag-APPROVED .state-name {
  color: #404859 !important;
}
.state-tag-REVIEW {
  border-color: #e3ddf0;
  background: #e3ddf0;
}
.state-tag-REVIEW .state-name {
  color: #161616 !important;
}
.state-tag-REQUEST_ERROR {
  border-color: #FFD4CF;
  background: #FFD4CF;
}
.state-tag-REQUEST_ERROR .state-name {
  color: #404859 !important;
}
.state-tag-DRAFT .state-name {
  color: #2a2f3c !important;
}

.UploadDocs {
  position: relative;
}
.UploadDocs .modal-see-file {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: red;
}
.UploadDocs .button-upload {
  height: 78px;
  width: 100%;
  border: 1px dashed #6e7889;
}
.UploadDocs .button-upload p {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.UploadDocs .button-upload p span {
  font-size: 10px;
  color: #4e8aff;
}
.UploadDocs .circles {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}
.UploadDocs .circles .circle {
  border-radius: 50%;
  width: 16px;
  height: 16px;
  border: 1px solid #404859;
}
.UploadDocs .circles .circle-review {
  background-color: #AC78B3;
  border-color: #AC78B3;
}
.UploadDocs .circles .circle-approved {
  background-color: #C2F0C5;
  border-color: #92c295;
}
.UploadDocs .ant-upload {
  width: 100%;
  margin-bottom: 12px;
}
.UploadDocs .button {
  border-radius: 6px;
  border: #122536;
  background: #122536;
  width: 100%;
  height: 32px;
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.18px;
}
.UploadDocs .button-transparent {
  background-color: transparent;
  border: none !important;
  box-shadow: none !important;
}
.UploadDocs .body-small .blue {
  color: #4e8aff;
}
.UploadDocs .upload {
  width: 20px;
  height: 20px;
  margin-bottom: 7px;
}
.UploadDocs .empty-input {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.UploadDocs .empty-input .small-detail {
  margin-top: 4px;
}
.UploadDocs--container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
}
.UploadDocs .input-content {
  position: relative;
  height: 128px;
  width: 100%;
  border-radius: 10px;
  background: var(--colors-gradient);
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #6e7889;
}
.UploadDocs .input-content .white {
  background-color: #fff;
  height: 10px;
  width: 20px;
  position: absolute;
  left: 0px;
  top: 0px;
  border-top-left-radius: 5px;
  z-index: 200;
}
.UploadDocs .input-content input {
  height: 126px;
  width: 100%;
  border-radius: 10px;
  background-color: rgba(255, 0, 0, 0);
  font-size: 0 !important;
  position: absolute;
  z-index: 2;
  top: 0;
  cursor: pointer;
}
.UploadDocs .input-content .cont-img {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}
.UploadDocs .input-content .cont-img img {
  width: 100px;
}
.UploadDocs .input-content-wh {
  background: var(--colors-white);
  box-shadow: -3px 1px 10px -7px var(--colors-black);
  margin: 30px 40px;
}
.UploadDocs .input-content .edit {
  position: absolute;
  bottom: 0;
  height: auto;
  width: 99px;
  border-radius: 0;
}
.UploadDocs .content-flex {
  align-items: flex-start;
  gap: 16px;
}
.UploadDocs .content-flex .input-content,
.UploadDocs .content-flex .file-ok {
  width: 50% !important;
}

.circle-tag .circle {
  width: 20px;
  height: 20px;
}
.circle-tag .circle-APPROVED {
  border-color: #92c295;
  background-color: #C2F0C5;
}
.circle-tag .circle-APPROVED:hover {
  background-color: #549358;
}
.circle-tag .circle-REVIEW {
  background-color: #AC78B3;
  border-color: #AC78B3;
}
.circle-tag .circle-REVIEW:hover {
  background-color: #855791;
}
.circle-tag .circle-REQUEST_ERROR {
  background-color: #FFD4CF;
  border-color: #c94f4a;
}
.circle-tag .circle-REQUEST_ERROR:hover {
  background-color: #c94f4a;
}

.MinimumLiquidity {
  padding-bottom: 30px;
}
.MinimumLiquidity .h4 {
  color: #404859 !important;
}
.MinimumLiquidity .divider-top {
  padding-top: 10px;
}
.MinimumLiquidity .h4-error {
  color: #712220 !important;
  margin-bottom: 7px;
}
.MinimumLiquidity .h2-w8 {
  color: #2a2f3c !important;
}

.CardStateAccount {
  border-radius: 10px;
  border: 1px solid #7b7b7b;
  padding: 12px 16px;
  position: relative;
}
.CardStateAccount .label {
  border-radius: 100px;
  min-width: 81px;
  width: auto;
  max-width: 95px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 4px;
  gap: 4px;
  margin-bottom: 8px;
  background: #969696;
}
.CardStateAccount .label .body-small {
  margin-bottom: 0;
}
.CardStateAccount_head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}
.CardStateAccount .box {
  width: 300px !important;
}
.CardStateAccount .box .body-card {
  margin-bottom: 6px;
}
.CardStateAccount .box .body-regular {
  margin-bottom: 16px;
}
.CardStateAccount .box .file-ok {
  margin-top: 0 !important;
}
.CardStateAccount .box-error .flex .button:last-child {
  display: none !important;
}
.CardStateAccount .box-success .flex .button:last-child {
  display: none !important;
}
.CardStateAccount .divider {
  border-top: 1px solid #afbdcc;
  margin-top: 20px;
}
.CardStateAccount--inReview {
  background: #fdfcff;
  border: 1px solid #ac78b3;
}
.CardStateAccount--inReview .label {
  background: #e3ddf0;
}
.CardStateAccount--inReview .label .body-small {
  color: #48244d;
}
.CardStateAccount--inReview .box .body-card {
  color: #48244d;
}
.CardStateAccount--inReview .box .body-card-dark {
  color: #2a2f3c;
}
.CardStateAccount--inReview .box .body-regular {
  color: #48244d;
}
.CardStateAccount--inReview .file-ok .file-content .name {
  color: #693b6f !important;
}
.CardStateAccount--inReview .file-ok .file-content .anticon {
  color: #693b6f !important;
}
.CardStateAccount--error {
  border: 1px solid #c94f4a;
}
.CardStateAccount--error .label {
  background: #ffd4cf;
}
.CardStateAccount--error .label img {
  margin-top: 1px;
}
.CardStateAccount--error .label .body-small {
  color: #712220;
}
.CardStateAccount--error .UploadDocs .input-content {
  border: 1px dashed #e67f73;
}
.CardStateAccount--error .row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.CardStateAccount--error .row .box {
  width: 40%;
}
.CardStateAccount--error .row .box .body-card {
  margin-bottom: 4px;
}
.CardStateAccount--error .divider {
  margin-top: 20px;
  border-top: 1px solid #ffd4cf;
  padding-top: 8px;
}
.CardStateAccount--approved {
  border: 1px solid #3F9545;
}
.CardStateAccount--approved .label {
  background: #C5F0C8;
}
.CardStateAccount--approved .label img {
  margin-top: 1px;
}
.CardStateAccount--approved .label .body-small {
  color: #355137;
}
.CardStateAccount--approved .UploadDocs .input-content {
  border: 1px dashed #C5F0C8;
}
.CardStateAccount--approved .row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.CardStateAccount--approved .row .box {
  width: 40%;
}
.CardStateAccount--approved .row .box .body-card {
  margin-bottom: 4px;
}
.CardStateAccount--approved .divider {
  margin-top: 20px;
  border-top: 1px solid #C5F0C8;
  padding-top: 8px;
}
.CardStateAccount--approved .file-ok .file-content {
  border: 1px solid #75C27A !important;
  background-color: #C5F0C8 !important;
}
.CardStateAccount--approved .file-ok .file-content .name {
  color: #355137 !important;
}
.CardStateAccount--approved .file-ok .file-content .anticon {
  color: #355137 !important;
}
.CardStateAccount .row-btw .box {
  width: 100%;
}
.CardStateAccount .section-upload .UploadDocs .file-content {
  height: 28px !important;
  border-radius: 10px;
  border: 1px solid #eff3f5 !important;
  background: #eff3f5 !important;
  padding-left: 12px !important;
}
.CardStateAccount .section-upload .UploadDocs .InputUploadedFile .file-ok .file .circle {
  display: none;
}

.SectionError {
  border-radius: 10px;
  border: 1px solid #c94f4a;
  padding: 12px 15px;
}
.SectionError .flex-end button {
  height: 30px;
}
.SectionError .description {
  overflow: hidden;
}
.SectionError .description .body-regular {
  display: -webkit-box; /* Utiliza el modelo de caja flexible de tipo webkit */
  -webkit-box-orient: vertical; /* Orientación vertical */
  -webkit-line-clamp: 2; /* Número máximo de líneas */
  overflow: hidden; /* Oculta el contenido que sobresale */
}
.SectionError .flex-btw {
  margin-bottom: 5px;
}
.SectionError .body-regular {
  color: #c94f4a;
}
.SectionError .body-regular-w6 {
  color: #712220;
}
.SectionError .button {
  color: #712220;
  text-align: right;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
}
.SectionError .button span {
  text-decoration: underline;
}
.SectionError .button span:hover {
  color: #712220;
}
.SectionError .button .anticon {
  color: #712220;
  margin-top: 2px;
}

.SectionNewBank .h4,
.SectionNewBank .body-regular {
  margin-bottom: 8px;
  color: #2a2f3c;
  line-height: 145%;
}
.SectionNewBank .button {
  width: auto !important;
  font-size: 20px;
  font-weight: 600;
}
.SectionNewBank .button-block {
  width: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-add-account {
  border-radius: 10px;
  border: 1px solid #2a2f3c;
  padding: 16px;
  margin-top: 16px;
}
.card-add-account .ModalEndSubmit .button {
  margin-bottom: 5px;
}
.card-add-account .flex-btw {
  margin-bottom: 0 !important;
}
.card-add-account .flex-btw .box {
  height: 100%;
}
.card-add-account .UploadDocs .flex-btw {
  border: none;
}
.card-add-account .body-card {
  color: #404859 !important;
}
.card-add-account .box {
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.card-add-account .box .h4 {
  color: #929fb0;
  font-style: italic;
  margin-bottom: 16px;
}
.card-add-account .box .ModalEndSubmit .button {
  display: none;
}
.card-add-account .button-submit {
  margin-bottom: 20px;
  border-radius: 6px;
}
.card-add-account .button-submit span {
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.18px;
}
.card-add-account .top-InfoExpand {
  border-top: 1px solid #afbdcc;
}

.DscrQuestionsAgreements .Step3 .h2 {
  margin-top: 4px;
  margin-bottom: 10px;
}
.DscrQuestionsAgreements .Step3 .h2 .blue-bold {
  color: #5e8eb7;
  font-weight: 800;
  text-decoration-line: underline;
  color: #2A2F3C;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 800;
  line-height: 135%;
  text-decoration-line: unset;
}
.DscrQuestionsAgreements .Step3 .rent-input {
  border: none;
  width: auto;
  display: inline;
}
.DscrQuestionsAgreements .Step3 .rent-input.touched {
  color: #404859;
}
.DscrQuestionsAgreements .Step3 .month {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.DscrQuestionsAgreements .Step3 #rent-button {
  margin-top: 16px;
}
.DscrQuestionsAgreements .Step3 .UploadDocs .contenedor-flex {
  display: flex;
  width: 100%;
}
.DscrQuestionsAgreements .Step3 .UploadDocs .contenedor-flex .cont-files {
  width: 100%;
}
.DscrQuestionsAgreements .Step3 .UploadDocs .contenedor-flex .UploadDocs--container {
  gap: 20px;
  justify-content: center;
  align-items: flex-start;
  flex-direction: row;
  width: 100%;
}
.DscrQuestionsAgreements .InputAmount-edit {
  margin-bottom: 0px !important;
  border: none !important;
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.DscrQuestionsAgreements .InputAmount-edit .flex {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}
.DscrQuestionsAgreements .InputAmount-edit .flex .text-bold {
  color: #5e8eb7;
  font-weight: 600;
  font-style: normal;
}
.DscrQuestionsAgreements .InputAmount-edit .flex .input-edit {
  all: unset;
  color: #6E7889;
  animation: none;
  cursor: pointer;
  font-style: italic;
  font-weight: 400;
  line-height: 19.36px;
  text-align: right;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.DscrQuestionsAgreements .InputAmount-edit .button-edit {
  all: unset;
  border: none;
  color: #5E8EB7;
  animation: none;
  cursor: pointer;
  margin-left: 10px;
}
.DscrQuestionsAgreements .InputAmount-edit .button-edit span {
  margin-left: 5px;
  font-weight: 500;
  color: #5E8EB7;
  font-family: Inter;
  font-style: normal;
}
.DscrQuestionsAgreements .InputAmount-edit .button-edit-disabled span {
  color: #6E7889 !important;
}

.CardLeaseAgreements {
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #929fb0;
}
.CardLeaseAgreements .flex-btw .flex {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 28px;
}
.CardLeaseAgreements .flex-btw .flex .circle {
  border-radius: 50%;
  width: 16px;
  height: 16px;
  border: 1px solid #404859;
}
.CardLeaseAgreements .flex-btw .flex .circle--active {
  background-color: #404859;
}
.CardLeaseAgreements-REVIEW {
  border: 1px solid #AC78B3;
  background-color: #FDFCFF;
}
.CardLeaseAgreements-APPROVED {
  border: 1px solid #92c295;
  background-color: white;
}
.CardLeaseAgreements-APPROVED .h4 {
  color: #404859 !important;
}
.CardLeaseAgreements-APPROVED .description {
  color: #404859 !important;
}
.CardLeaseAgreements-APPROVED .link {
  color: #404859 !important;
}
.CardLeaseAgreements-REQUEST_ERROR {
  border: 1px solid #c94f4a;
  background-color: #FFFFFF;
}
.CardLeaseAgreements-REQUEST_ERROR .h4 {
  color: #404859 !important;
}
.CardLeaseAgreements-REQUEST_ERROR .description {
  color: #404859 !important;
}
.CardLeaseAgreements-REQUEST_ERROR .link {
  color: #404859 !important;
}

.CardMarketRent {
  border-radius: 4px;
  border: 1px solid #929fb0;
  padding: 12px 16px;
}
.CardMarketRent .body-regular-italic {
  color: #929fb0;
}
.CardMarketRent .flex-btw {
  margin-bottom: 9px !important;
}
.CardMarketRent-REVIEW {
  border: 1px solid #AC78B3;
  background-color: #FDFCFF;
}
.CardMarketRent-APPROVED {
  border: 1px solid #92c295;
  background-color: white;
}
.CardMarketRent-APPROVED .h4 {
  color: #404859 !important;
}
.CardMarketRent-APPROVED .description {
  color: #404859 !important;
}
.CardMarketRent-APPROVED .link {
  color: #404859 !important;
}
.CardMarketRent-REQUEST_ERROR {
  border: 1px solid #c94f4a;
  background-color: #FFFFFF;
}
.CardMarketRent-REQUEST_ERROR .h4 {
  color: #404859 !important;
}
.CardMarketRent-REQUEST_ERROR .description {
  color: #404859 !important;
}
.CardMarketRent-REQUEST_ERROR .link {
  color: #404859 !important;
}
.CardMarketRent .ant-form {
  all: unset;
  margin-top: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.CardMarketRent .ant-form .form-row {
  all: unset;
  display: flex;
  align-items: baseline;
  gap: 5px;
  max-height: 35px;
}
.CardMarketRent .ant-form .form-row .bold {
  font-weight: 600 !important;
  color: #404859 !important;
}
.CardMarketRent .ant-form .rent-container {
  display: flex;
  align-items: baseline;
  position: relative;
}
.CardMarketRent .ant-form .rent-input {
  width: auto;
  min-width: 56px;
  max-width: 58px;
  text-align: right;
  font-weight: 600;
  color: #404859;
  border: none;
  outline: none;
  background: transparent;
}
.CardMarketRent .ant-form .unit-input {
  width: 25px !important;
}

.CardTotalUnits {
  border: 1px solid #929fb0;
  padding: 12px 16px;
}
.CardTotalUnits .body-regular-italic {
  color: #929fb0;
}
.CardTotalUnits .flex-btw {
  margin-bottom: 16px !important;
}

.EntityGuarantorCreation .task-footer .dropdown-blue-bold {
  height: 26px;
  display: unset;
  padding: 0 !important;
}
.EntityGuarantorCreation .task-footer .dropdown-blue-bold span {
  font-weight: 600;
  text-decoration-line: underline;
}
.EntityGuarantorCreation .task-footer .dropdown-review-bold {
  color: #AC78B3 !important;
  height: 26px;
  display: unset;
  padding: 0 !important;
}
.EntityGuarantorCreation .task-footer .dropdown-review-bold span {
  font-weight: 600;
  text-decoration-line: underline;
}
.EntityGuarantorCreation .task-footer .owners-tags {
  display: flex;
  justify-content: space-between;
  align-items: end;
}
.EntityGuarantorCreation .task-footer .owners-tags .circles-tags {
  display: flex;
  align-items: end;
  gap: 10px;
}
.EntityGuarantorCreation .task-footer .owners-tags .circle {
  width: 20px;
  height: 20px;
}
.EntityGuarantorCreation .task-footer .owners-tags .circle-step3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.main {
  position: relative;
  border-radius: 10px;
}
.main .icon-delete {
  font-size: 20px;
  position: absolute;
  top: 50%;
  right: -9.5px;
  transform: translateY(-50%);
  color: #5E8EB7;
  cursor: pointer;
  visibility: hidden;
}
.main:hover .icon-delete {
  visibility: visible;
}
.main .content-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid #ccd3db;
  min-height: 56px;
  height: auto;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 10px 18px 5px 16px;
}
.main .content-card-hover-removed:hover {
  border: 1px solid #ccd3db !important;
}
.main .content-card:hover {
  border: 1px dashed #929fb0;
}
.main .content-card .input-disabled-color input:disabled {
  color: black;
}
.main .content-card-REVIEW {
  border: 1px solid #AC78B3;
  background-color: #FDFCFF;
}
.main .content-card-REVIEW .body-regular {
  color: #161616 !important;
}
.main .content-card-REVIEW .bold-lith {
  color: #161616 !important;
}
.main .content-card-REVIEW .ant-input-number-suffix {
  color: #161616 !important;
}
.main .content-card-REVIEW .ant-picker-input input {
  color: #161616 !important;
}
.main .content-card-REVIEW .ant-form-item-no-colon {
  color: #161616 !important;
}
.main .content-card-REVIEW .ant-input-number-input-wrap {
  color: #161616 !important;
}
.main .content-card-REVIEW .ant-input-number-input-wrap input {
  font-weight: 500;
}
.main .content-card-APPROVED {
  border: 1px solid #92c295;
  background-color: white;
}
.main .content-card-APPROVED .body-regular {
  color: #404859 !important;
}
.main .content-card-APPROVED .bold-lith {
  color: #404859 !important;
}
.main .content-card-APPROVED .ant-input-number-suffix {
  color: #404859 !important;
}
.main .content-card-APPROVED .ant-picker-input input {
  color: #404859 !important;
}
.main .content-card-APPROVED .ant-form-item-no-colon {
  color: #404859 !important;
}
.main .content-card-APPROVED .ant-input-number-input-wrap {
  color: #404859 !important;
}
.main .content-card-APPROVED .ant-input-number-input-wrap input {
  font-weight: 500;
}
.main .content-card-APPROVED .file-name {
  color: #404859 !important;
}
.main .content-card-REQUEST_ERROR {
  border: 1px solid #c94f4a;
  background-color: white;
}
.main .content-card-REQUEST_ERROR .body-regular {
  color: #712220 !important;
}
.main .content-card-REQUEST_ERROR .bold-lith {
  color: #712220 !important;
}
.main .content-card-REQUEST_ERROR .ant-form-item-no-colon {
  color: #712220 !important;
}
.main .content-card-REQUEST_ERROR .ant-picker-input input {
  color: #712220 !important;
}
.main .content-card-REQUEST_ERROR .ant-input-number-suffix {
  color: #712220 !important;
}
.main .content-card-REQUEST_ERROR .ant-input-number-input-wrap {
  color: #712220 !important;
}
.main .content-card-REQUEST_ERROR .ant-input-number-input-wrap input {
  font-weight: 500;
}
.main .content-card-REQUEST_ERROR .file-name {
  color: #712220 !important;
}
.main .content-card .card-ownership {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.main .content-card .card-ownership .section-1 {
  display: flex;
  width: 70%;
  flex-direction: column;
}
.main .content-card .card-ownership .section-1 .names {
  display: flex;
  gap: 30px;
}
.main .content-card .card-ownership .section-1 .names .name {
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: auto;
  gap: 5px;
}
.main .content-card .card-ownership .section-1 .names .name span {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
}
.main .content-card .card-ownership .section-1 .names .name label {
  font-size: 12px;
}
.main .content-card .card-ownership .section-1 .footer .approved {
  color: #587e5b;
}
.main .content-card .card-ownership .section-1 .footer .error {
  color: #404859;
}
.main .content-card .card-ownership .section-1 .footer button {
  color: #6e7889;
}
.main .content-card .card-ownership .section-1 .footer button .anticon {
  margin-inline-start: 4px;
}
.main .content-card .card-ownership .section-1 .footer button:hover {
  color: #6e7889;
}
.main .content-card .card-ownership .section-1 .footer span {
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
}
.main .content-card .card-ownership .section-2 {
  display: flex;
  flex-direction: column;
  align-items: end;
}
.main .content-card .card-ownership .section-2 .suffix-null input {
  margin-top: 18px;
  padding-right: 0 !important;
}
.main .content-card .card-ownership .section-2 input {
  width: 100px;
  text-align: end;
  padding-right: 13px !important;
}
.main .content-card .card-ownership .section-2 .guarantor {
  margin-top: 7px;
  font-size: 10px;
  color: #5E8EB7;
}
.main .content-card .card-ownership .section-2 .ant-input-number-suffix {
  margin-inline-end: 0px;
  color: black;
}
.main .content-card .form-edit {
  width: 100%;
  height: auto;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  display: grid;
  grid-template-columns: 45% 35% 20%;
  grid-template-areas: "ssn datebirth textedit" "phone email ." "address address address" "identification identification identification" "submit submit submit";
}
.main .content-card .form-edit .ant-input-status-error {
  color: #404859;
}
.main .content-card .form-edit .ant-form-item-row {
  display: block;
}
.main .content-card .form-edit .ant-form-item-label {
  text-align: start;
  height: 27px;
}
.main .content-card .form-edit .ant-form-item-label label {
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14.52px;
  color: #6e7889;
}
.main .content-card .form-edit .ant-form-item-control-input {
  min-height: 20px;
}
.main .content-card .form-edit .ant-form-item {
  margin-bottom: 15px;
}
.main .content-card .form-edit .ssn {
  grid-area: ssn;
}
.main .content-card .form-edit .datebirth {
  grid-area: datebirth;
}
.main .content-card .form-edit .datebirth .ant-picker-input input::placeholder {
  color: #929fb0;
  font-family: Inter;
  font-style: italic !important;
  font-weight: 400;
}
.main .content-card .form-edit .datebirth .ant-picker-input input:disabled {
  color: black;
}
.main .content-card .form-edit .textedit {
  grid-area: textedit;
  font-size: 11px;
  text-align: end;
  color: #5E8EB7;
  display: flex;
  align-items: start;
  gap: 6px;
  justify-content: end;
  margin-top: 5px;
}
.main .content-card .form-edit .phone {
  grid-area: phone;
}
.main .content-card .form-edit .email {
  grid-area: email;
}
.main .content-card .form-edit .address {
  grid-area: address;
}
.main .content-card .form-edit .identification {
  grid-area: identification;
}
.main .content-card .form-edit .identification label {
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
}
.main .content-card .form-edit .submit {
  grid-area: submit;
}

.step-3 .blue-bold {
  font-size: 24px;
  font-style: normal;
  font-weight: 800;
  text-decoration: underline;
}
.step-3 .owner-REVIEW {
  color: #161616;
}
.step-3 .owner-APPROVED {
  color: #404859;
}
.step-3 .owner-REQUEST_ERROR {
  color: #404859;
}
.step-3 .content-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.step-3 .content-owner-new {
  display: flex;
  justify-content: space-between;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.step-3 .content-owner-new button {
  padding: 0;
}
.step-3 .content-owner-new .text-add {
  display: flex;
  gap: 5px;
  align-items: center;
}
.step-3 .content-owner-new .total {
  display: flex;
  gap: 15px;
  align-items: center;
}

.action-accept-reject {
  position: absolute;
  top: -10px;
  right: 15px;
  width: 60px;
  z-index: 99;
}
.action-accept-reject .content-actions {
  display: flex;
  justify-content: end;
  gap: 15px;
  width: 60px;
}
.action-accept-reject .circle-input {
  cursor: pointer;
}

.EntityDocs .task-footer .dropdown-blue-bold {
  height: 26px;
  display: unset;
  padding: 0 !important;
}
.EntityDocs .task-footer .dropdown-blue-bold span {
  font-weight: 600;
  text-decoration-line: underline;
}
.EntityDocs .task-footer .dropdown-review-bold {
  color: #AC78B3 !important;
  height: 26px;
  display: unset;
  padding: 0 !important;
}
.EntityDocs .task-footer .dropdown-review-bold span {
  font-weight: 600;
  text-decoration-line: underline;
}
.EntityDocs .task-footer .owners-tags {
  display: flex;
  justify-content: space-between;
  align-items: end;
}
.EntityDocs .task-footer .owners-tags .circles-tags {
  display: flex;
  align-items: end;
  gap: 10px;
}
.EntityDocs .task-footer .owners-tags .circle {
  width: 20px;
  height: 20px;
}
.EntityDocs .task-footer .owners-tags .circle-APPROVED {
  background-color: #C2F0C5;
  border-color: #92c295;
}
.EntityDocs .task-footer .owners-tags .circle-REVIEW {
  background-color: #AC78B3;
  border-color: #AC78B3;
}
.EntityDocs .task-footer .owners-tags .circle-REQUEST_ERROR {
  background-color: #FFD4CF;
  border-color: #c94f4a;
}

.entity-docs-step-2 .section-1 span {
  font-size: 20px !important;
}
.entity-docs-step-2 .dropdown-blue-bold {
  display: unset;
  height: auto;
}
.entity-docs-step-2 .dropdown-review-bold {
  color: #AC78B3 !important;
  display: unset;
  padding: 0 !important;
}
.entity-docs-step-2 .dropdown-review-bold span {
  text-decoration-line: underline;
}
.entity-docs-step-2 .submits {
  display: flex;
  justify-content: space-between;
  gap: 15px;
}
.entity-docs-step-2 .submits section {
  width: 100%;
}

.InvestmentExperienceVerification .card__generic-REVIEW {
  border: 1px solid #AC78B3;
  background-color: #FDFCFF;
}
.InvestmentExperienceVerification .card__generic-REQUEST_ERROR {
  border: 1px solid #c94f4a;
  background-color: #FFFFFF;
}
.InvestmentExperienceVerification .card__generic-APPROVED {
  border: 1px solid #92c295;
  background-color: white;
}
.InvestmentExperienceVerification .card__generic .UploadDocs .input-content,
.InvestmentExperienceVerification .card__generic .UploadDocs .input-content input {
  height: 79px;
}
.InvestmentExperienceVerification .circle-review {
  background-color: #AC78B3;
  border-color: #AC78B3 !important;
}
.InvestmentExperienceVerification .circle-approved {
  border: 1px solid #92c295 !important;
  background-color: #C2F0C5;
}

.ConstructionBudget input::-webkit-outer-spin-button,
.ConstructionBudget input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.ConstructionBudget .h2 {
  margin-top: 30px !important;
}
.ConstructionBudget .UploadDocs .input-content,
.ConstructionBudget .UploadDocs .input-content input {
  height: 78px;
}
.ConstructionBudget .UploadDocs .input-content .empty-input .body-small,
.ConstructionBudget .UploadDocs .input-content input .empty-input .body-small {
  color: #2a2f3c;
}
.ConstructionBudget .card__generic .s-title .h4 {
  color: #404859;
}
.ConstructionBudget .card__generic .body-regular {
  margin-bottom: 20px;
}
.ConstructionBudget .link {
  color: #5e8eb7;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  text-decoration: none;
  line-height: 145%;
}
.ConstructionBudget .link .arrow {
  height: 10px;
  margin-left: 5px;
}

.title-company-step-1 {
  border-radius: 10px;
  border: 1px solid #ccd3db;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);
  padding: 16px 24px 5px;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.title-company-step-1 .ant-form {
  margin-top: 15px;
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: 50% 5% 45%;
  grid-template-areas: "titleCompany titleCompany titleCompany" "name name ." "phone . email" "submit submit submit";
}
.title-company-step-1-REVIEW {
  border: 1px solid #AC78B3;
  background-color: #FDFCFF;
}
.title-company-step-1-REVIEW .h4 {
  color: #161616 !important;
}
.title-company-step-1-REVIEW .description {
  color: #161616 !important;
}
.title-company-step-1-REVIEW .link {
  color: #161616 !important;
}
.title-company-step-1-APPROVED {
  border: 1px solid #92c295;
  background-color: white;
}
.title-company-step-1-APPROVED .h4 {
  color: #404859 !important;
}
.title-company-step-1-APPROVED .description {
  color: #404859 !important;
}
.title-company-step-1-APPROVED .link {
  color: #404859 !important;
}
.title-company-step-1-REQUEST_ERROR {
  border: 1px solid #c94f4a;
  background-color: #FFFFFF;
}
.title-company-step-1-REQUEST_ERROR .h4 {
  color: #404859 !important;
}
.title-company-step-1-REQUEST_ERROR .description {
  color: #404859 !important;
}
.title-company-step-1-REQUEST_ERROR .link {
  color: #404859 !important;
}
.title-company-step-1 .ant-form-item-row {
  display: block;
}
.title-company-step-1 .ant-form-item-label {
  text-align: start;
  height: 27px;
}
.title-company-step-1 .ant-form-item-label label {
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14.52px;
  color: #6e7889;
}
.title-company-step-1 .ant-form-item-control-input {
  min-height: 20px;
}
.title-company-step-1 .ant-form-item {
  margin-bottom: 15px;
}
.title-company-step-1 .titleCompany {
  grid-area: titleCompany;
}
.title-company-step-1 .titleCompany input {
  font-size: 16px !important;
}
.title-company-step-1 .name {
  grid-area: name;
}
.title-company-step-1 .phone {
  grid-area: phone;
}
.title-company-step-1 .email {
  grid-area: email;
}
.title-company-step-1 .submit {
  grid-area: submit;
}
.title-company-step-1 .submit button {
  border-radius: 6px;
}

.insurance-step-2 .ant-collapse-header-text {
  max-width: 335px;
  margin-inline-end: unset !important;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
}
.insurance-step-2 .ant-collapse-expand-icon {
  padding-inline-start: 0px !important;
}

.payoff-footer .dropdown-blue-bold {
  display: unset;
  padding: 0 !important;
  border: none !important;
}
.payoff-footer .dropdown-blue-bold span {
  background-color: white !important;
  color: #5E8EB7 !important;
  padding: 0 !important;
}
.payoff-footer .is-review {
  color: #AC78B3 !important;
}

.insurance-step-2 .ant-collapse-header-text {
  max-width: 335px;
  margin-inline-end: unset !important;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
}
.insurance-step-2 .ant-collapse-expand-icon {
  padding-inline-start: 0px !important;
}

.entities-list {
  padding: 24px 25px;
}
.entities-list .top-container {
  box-sizing: content-box;
  width: 100%;
  margin-bottom: 33px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
}
.entities-list .top-container .title {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.entities-list .top-container .title > span {
  cursor: pointer;
  color: var(--blue60, #5E8EB7);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration-line: underline;
}
.entities-list .entities-container {
  padding: 16px 0px;
}
.entities-list .entities-container > * {
  margin-bottom: 16px;
}
.entities-list .entities-container > *:last-child {
  margin-bottom: 0px;
}
.entities-list .search-box {
  cursor: pointer;
  box-sizing: border-box;
  width: 384px;
  padding: 5px 18px 5px 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 10px;
  border: 1px solid var(--400-grey, #CCD3DB);
  background: var(--gray-100, #F9FAFB);
  color: var(--700-grey, #6E7889);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}
.entities-list .search-box > input {
  all: unset;
  width: 100%;
  margin-left: 8px;
}

@keyframes horizontal-shaking {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-3px);
  }
  50% {
    transform: translateX(3px);
  }
  75% {
    transform: translateX(-1px);
  }
  100% {
    transform: translateX(1px);
  }
}
.Login {
  display: flex;
  justify-content: space-between;
  min-height: calc(100vh - 56px);
}
.Login-form,
.Login .rigth {
  width: 50%;
}
.Login-form {
  padding: 32px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
}
.Login-form .coin {
  margin-bottom: 13px;
}
.Login-form .h1 {
  margin-bottom: 24px;
}
.Login-form .ant-form {
  width: 100%;
}
.Login-form .error-message {
  margin-top: 50px;
  color: #8f2f2c;
}
.Login-form .button {
  margin-top: 10px;
}
.Login-form .link:hover {
  color: #404859;
}
.Login-form .link .body-regular-bold {
  text-decoration: underline;
}
.Login-form .link-absolute {
  position: absolute;
  bottom: 30px;
  left: 32px;
  text-decoration: none;
}
.Login-form .link-absolute .body-regular-bold {
  text-decoration: underline;
}
.Login .right {
  padding-top: 48px;
  width: 55%;
  background-color: #F9FAFB;
  position: relative;
}
.Login .right .content {
  padding-left: 72px;
  padding-right: 0px;
}
.Login .right .star {
  margin-bottom: 16px;
}
.Login .right .phrase {
  margin: 0px;
  color: #2A2F3C;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 24px */
  margin-bottom: 12px;
}
.Login .right .author {
  color: #355C7D;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 140%; /* 22.4px */
}
.Login .right .author b {
  font-weight: 600;
}
.Login .right .home {
  height: 70vh;
  position: absolute;
  bottom: -90px;
  left: 48px;
  border-color: #355C7D;
  border-width: 2px 0px 0px 2px;
  border-style: solid;
  border-radius: 10px 0px 0px 0px;
}
.Login > .right-column {
  background: #F9FAFB;
  padding: 64px 64px 0px 56px;
}
.Login > .right-column .testimonial {
  margin: 0px;
  margin-bottom: 4px;
  font-weight: 600;
  font-size: 24px;
  line-height: 28.8px;
  color: #2A2F3C;
}
.Login > .right-column .testimonial.description {
  font-weight: 400;
  font-size: 16px;
  line-height: 125%;
  color: #777b83;
  margin-bottom: 6px;
  margin-right: 16px;
}
.Login > .right-column .caption {
  margin: 0px;
  font-weight: 400;
  font-size: 14px;
  line-height: 19.6px;
  color: #404859;
}
.Login > .right-column .caption > b {
  font-weight: 600;
}
.Login > .right-column .welcome-image {
  position: absolute;
  bottom: -40px;
  right: 0px;
  max-height: 65vh;
  width: 91%;
  border-color: #355C7D;
  border-width: 8px 0px 0px 8px;
  border-style: solid;
  border-radius: 10px 0px 0px 0px;
}
@media (min-height: 735px) {
  .Login .bottom-flex {
    height: 470px;
  }
  .Login .bottom-flex img {
    height: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/main.scss","webpack://./src/sass/base/_generic.scss","webpack://./src/sass/utils/_variables.scss","webpack://./src/sass/base/_reset.scss","webpack://./src/sass/base/_typography.scss","webpack://./src/sass/base/_Buttons.scss","webpack://./src/sass/base/_Selects.scss","webpack://./src/sass/base/_Tags.scss","webpack://./src/components/Atoms/Alerts/ErrorBox.scss","webpack://./src/components/Dropdowns/DropdownBasic/DropdownBasic.scss","webpack://./src/components/Atoms/Checkboxs/CheckboxBasic/CheckboxBasic.scss","webpack://./src/scenes/Public/components/Layout/Layout.scss","webpack://./src/components/ApprovalRejectSection/components/SelectSection/SelectSection.scss","webpack://./src/scenes/Private/LoanList/components/TaskItemList.scss","webpack://./src/scenes/Private/LoanDetails/Progress/Progress.scss","webpack://./src/scenes/Private/Borrowers/Borrowers.scss","webpack://./src/components/RightScenes/RightScenes.scss","webpack://./src/scenes/Private/Borrowers/BorrowerDetail/BorrowerDetail.scss","webpack://./src/scenes/Private/LoanDetails/LoanDetails.scss","webpack://./src/scenes/Private/LoanDetails/LoanDocuments/LoanDocuments.scss","webpack://./src/scenes/Private/LoanDetails/BorrowerCard/BorrowerCard.scss","webpack://./src/components/BorrowerTask/BorrowerTask.scss","webpack://./src/components/BorrowerTask/components/Organisms/Modals/ModalTask/ModalTask.scss","webpack://./src/components/BorrowerTask/components/Organisms/Modals/ModalTask/SectionRight/SectionRight.scss","webpack://./src/components/BorrowerTask/components/Organisms/Modals/ModalEndSubmit/ModalEndSubmit.scss","webpack://./src/components/BorrowerTask/components/Organisms/QuestionBasic/QuestionBasic.scss","webpack://./src/components/Atoms/Loader/Spin.scss","webpack://./src/components/BorrowerTask/components/Atoms/ButtonTabsFilters/ButtonTabsFilters.scss","webpack://./src/components/BorrowerTask/components/Atoms/Cards/CardAlertError/CardAlertError.scss","webpack://./src/components/BorrowerTask/components/Atoms/Cards/CardDetailInformationBank/CardDetailInformationBank.scss","webpack://./src/components/BorrowerTask/components/Atoms/Cards/CardLoanTasks/CardLoanTasks.scss","webpack://./src/components/BorrowerTask/components/Atoms/Cards/CardSomeoneElse/CardSomeoneElse.scss","webpack://./src/components/BorrowerTask/components/Atoms/Cards/CardUploadResponse/CardUploadResponse.scss","webpack://./src/components/BorrowerTask/components/Atoms/Dropdown/DropdownBlue/DropdownBlue.scss","webpack://./src/components/BorrowerTask/components/Atoms/Inputs/InputAmount/InputAmount.scss","webpack://./src/components/BorrowerTask/components/Atoms/Inputs/InputBorderNone/InputBorderNone.scss","webpack://./src/components/BorrowerTask/components/Atoms/Inputs/InputUploadedFile/InputUploadedFile.scss","webpack://./src/components/BorrowerTask/components/Atoms/Progress/ProgressSteps/ProgressSteps.scss","webpack://./src/components/BorrowerTask/components/Atoms/Progress/TaskProgress/TaskProgress.scss","webpack://./src/components/BorrowerTask/components/Atoms/Selects/SelectPrimary/SelectPrimary.scss","webpack://./src/components/BorrowerTask/components/Atoms/Tags/StateTag/StateTag.scss","webpack://./src/components/BorrowerTask/components/Atoms/UploadDocs/UploadDocs.scss","webpack://./src/components/BorrowerTask/components/Atoms/Tags/CircleTag/CircleTag.scss","webpack://./src/components/BorrowerTask/MinimumLiquidity/MinimunLiquidity.scss","webpack://./src/components/BorrowerTask/MinimumLiquidity/Step2/CardStateAccount/CardStateAccount.scss","webpack://./src/components/BorrowerTask/MinimumLiquidity/Step2/SectionError/SectionError.scss","webpack://./src/components/BorrowerTask/MinimumLiquidity/Step2/SectionNewBank/SectionNewBank.scss","webpack://./src/components/BorrowerTask/DscrQuestionsAgreements/DscrQuestionsAgreements.scss","webpack://./src/components/BorrowerTask/DscrQuestionsAgreements/Step3/CardLeaseAgreements/CardLeaseAgreements.scss","webpack://./src/components/BorrowerTask/DscrQuestionsAgreements/Step3/CardMarketRent/CardMarketRent.scss","webpack://./src/components/BorrowerTask/DscrQuestionsAgreements/Step3/CardTotalUnits/CardTotalUnits.scss","webpack://./src/components/BorrowerTask/EntityGuarantorCreation/EntityGuarantorCreation.scss","webpack://./src/components/BorrowerTask/EntityGuarantorCreation/CardOwnership/CardOwnership.scss","webpack://./src/components/BorrowerTask/EntityGuarantorCreation/Step3/Step3.scss","webpack://./src/components/ActionAcceptAndReject/ActionAcceptAndReject.scss","webpack://./src/components/BorrowerTask/EntityDocs/EntityDocs.scss","webpack://./src/components/BorrowerTask/EntityDocs/Step2/Step2.scss","webpack://./src/components/BorrowerTask/InvestmentExperienceVerification/InvestmentExperienceVerification.scss","webpack://./src/components/BorrowerTask/ConstructionBudget/ConstructionBudget.scss","webpack://./src/components/BorrowerTask/TitleCompany/Step1/Step1.scss","webpack://./src/components/BorrowerTask/Insurance/Step2/Step2.scss","webpack://./src/components/BorrowerTask/Payoff/Payoff.scss","webpack://./src/components/BorrowerTask/Payoff/Step2/Step2.scss","webpack://./src/scenes/Private/EntitiesList/EntitiesList.scss","webpack://./src/sass/utils/_animations.scss","webpack://./src/scenes/Public/Login/Login.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,iBAAA;EACA,WAAA;ADIF;;ACDA;EACE,YAAA;EACA,8BAAA;ADIF;ACFE;EACE,8BAAA;ADIJ;;ACCE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;ADEJ;ACAE;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;ADEJ;ACAE;EACE,YAAA;ADEJ;ACAI;EACE,YAAA;ADEN;;ACGE;EACE,mBAAA;EACA,yBAAA;EACA,kDAAA;EACA,WAAA;EACA,aAAA;ADAJ;;ACKI;;EAEE,eAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;ADFN;ACGM;;EACE,cC7CW;ED8CX,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADAR;;ACKA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kDAAA;ADFF;ACGE;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;ADDJ;ACGE;EACE,cAAA;ADDJ;;ACIA;EACE,aAAA;EACA,8BAAA;ADDF;;ACGA;EACE,aAAA;EACA,yBAAA;ADAF;;ACEA;EACE,aAAA;EACA,2BAAA;ADCF;;ACCA;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;ADEF;;ACCE;EACE,gBAAA;ADEJ;ACAE;EACE,gBAAA;ADEJ;ACAE;EACE,gBAAA;ADEJ;ACAE;EACE,gBAAA;ADEJ;ACAE;EACE,gBAAA;ADEJ;ACAE;EACE,gBAAA;ADEJ;ACAE;EACE,gBAAA;ADEJ;ACAE;EACE,eAAA;ADEJ;ACAE;EACE,eAAA;ADEJ;ACAE;EACE,gBAAA;ADEJ;ACAE;EACE,gBAAA;ADEJ;;ACCA;EACE,6BAAA;ADEF;;ACGE;EACE,wCAAA;EACA,uBAAA;EACA,2BAAA;EACA,UAAA;ADAJ;ACEE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;ADAJ;ACCI;EACE,YAAA;ADCN;ACAM;EACE,YAAA;ADER;ACCI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;ADCN;ACEM;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ADAR;ACKI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADHN;;ACQE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADLJ;ACQI;EACE,gBAAA;ADNN;;ACUA;EACE,eAAA;ADPF;;ACSA;EACE,eAAA;ADNF;;ACSA;EACE,oBAAA;ADNF;;AG9MA;;;CAAA;AAIA;EACE,sBAAA;AHiNF;;AG9MA;;;EAGE,SAAA;EACA,YAAA;AHiNF;;AG9MA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;AHiNF;;AG9MA,yDAAA;AACA;EACE,UAAA;AHiNF;;AG9MA,gDAAA;AACA;;;;;;;;;;;EAWE,cAAA;AHiNF;;AG9MA;EACE,cAAA;AHiNF;;AG9MA;;EAEE,gBAAA;AHiNF;;AG9MA;;EAEE,YAAA;AHiNF;;AG9MA;;;;EAIE,WAAA;EACA,aAAA;AHiNF;;AG9MA;EACE,yBAAA;EACA,iBAAA;AHiNF;;AG9MA;;;;EAIE,wBAAA;EACA,qBAAA;AHiNF;;AG9MA;EACE,wBAAA;EACA,qBAAA;EAGA,uBAAA;AHiNF;;AG9MA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;AHiNF;;AG9MA;;IAAA;AAIA;;;EAGE,qBAAA;GHgNA,eG/MA;GHgNA,OG/MA;EACA,eAAA;AHgNF;;AG7MA;;;IAAA;AAKA;EACE,aAAA;EACA,SAAA;AH+MF;;AG5MA;;;IAAA;AAKA;EACE,aAAA;AH8MF;;AG3MA;;;;;IAAA;AAOA;EACE,eAAA,EAAA,MAAA;EACA,8BAAA,EAAA,MAAA;EACA,0BAAA,EAAA,MAAA;AH6MF;;AG1MA;;IAAA;AAIA;EACE,oBAAA;AH4MF;;AGzMA;;IAAA;AAIA;;EAEE,UAAA;AH2MF;;AGxMA;;;IAAA;AAKA;EACE,SAAA,EAAA,MAAA;EACA,+BAAA,EAAA,MAAA;AH0MF;;AGvMA;;IAAA;AAIA;EACE,SAAA;AHyMF;;AGtMA;;IAAA;AAIA;EACE,SAAA;AHwMF;;AGrMA;;IAAA;AAIA;EACE,yBAAA;EACA,aAAA;EACA,8BAAA;AHuMF;;AGpMA;;;;IAAA;AAMA;EACE,SAAA,EAAA,MAAA;EACA,UAAA;EACA,mBAAA,EAAA,MAAA;GHsMA,iBGrMA,EAAA,MAAA;AHsMF;;AGnMA;;;;;IAAA;AAOA;;;;EAIE,eAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;EACA,wBAAA,EAAA,MAAA;GHqMA,sBGpMA,EAAA,MAAA;AHqMF;;AGlMA;;;IAAA;AAKA;;EAEE,mBAAA;AHoMF;;AGjMA;;;;;IAAA;AAOA;;EAEE,oBAAA;AHmMF;;AGhMA;;;;;;;;IAAA;AAUA;;;;EAIE,0BAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;GHkMA,iBGjMA,EAAA,MAAA;AHkMF;;AG/LA;;IAAA;AAIA;;EAEE,eAAA;AHiMF;;AG9LA;;;;;IAAA;AAOA;;EAEE,sBAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;GHgMA,YG/LA,EAAA,MAAA;GHgMA,WG/LA,EAAA,MAAA;AHgMF;;AG7LA;;;;IAAA;AAMA;EACE,6BAAA,EAAA,MAAA,EAEA,MAAA;EACA,uBAAA;AH+LF;;AG5LA;;;IAAA;AAKA;;EAEE,wBAAA;AH8LF;;AG3LA;;IAAA;AAIA;;EAEE,SAAA;EACA,UAAA;AH6LF;;AG1LA;;;IAAA;AAKA;EACE,cAAA,EAAA,MAAA;EACA,mBAAA,EAAA,MAAA;AH4LF;;AGzLA;;IAAA;AAIA;EACE,yBAAA;EACA,iBAAA;AH2LF;;AGxLA;;;;;EAKE,WAAA;AH2LF;;AGnLA;EACE,mBAAA;EACA,iBAAA;AH2LF;;AGxLA;EACE,sBAAA;AH2LF;;AGxLA;EACE,SAAA;EACA,SAAA;EACA,UAAA;AH2LF;;AGxLA;EACE,gBAAA;AH2LF;;AGxLA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AH2LF;;AGxLA;EACE,SAAA;EACA,8JAAA;EAEA,mCAAA;EACA,kCAAA;AH0LF;;AGvLA;EACE,+EAAA;AH0LF;;AI5oBA;EACE,cFQW;EEPX,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AJ+oBF;;AI7oBA;EACE,cFKW;EEJX,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AJgpBF;AI/oBE;EACE,gBAAA;AJipBJ;;AI9oBA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AJipBF;;AI/oBA;EACE,cFdW;EEeX,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AJkpBF;AIjpBE;EACE,0BAAA;AJmpBJ;AIjpBE;EACE,gBAAA;AJmpBJ;AIjpBE;EACE,gBAAA;AJmpBJ;;AIhpBA;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cFnCgB;AFsrBlB;;AIjpBA;EACE,cF5CW;EE6CX,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AJopBF;AInpBE;EACE,kBAAA;AJqpBJ;AInpBE;EACE,yBAAA;AJqpBJ;AInpBE;EAEE,gBAAA;AJopBJ;AIlpBE;EACE,gBAAA;AJopBJ;;AIhpBA;EACE,cFhEiB;EEiEjB,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AJmpBF;AIlpBE;EACE,gBAAA;AJopBJ;;AIjpBA;EACE,cFzEiB;EE0EjB,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AJopBF;;AIlpBA;EACE,cFvFW;EEwFX,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AJqpBF;AIppBE;EACE,gBAAA;AJspBJ;AIppBE;EACE,gBAAA;AJspBJ;AIppBE;EACE,yBAAA;AJspBJ;;AInpBA;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AJspBF;;AIppBA;EACE,cFhHW;EEiHX,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AJupBF;AItpBE;EACE,gBAAA;EACA,+BAAA;AJwpBJ;AItpBE;EACE,gBAAA;AJwpBJ;AItpBE;EACE,gBAAA;AJwpBJ;AItpBE;EACE,gBAAA;AJwpBJ;;AIrpBA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AJwpBF;AIvpBE;EACE,YAAA;EACA,gBAAA;AJypBJ;;AIrpBA;EACE,gBAAA;AJwpBF;;AIrpBA;EACE,gBAAA;AJwpBF;;AIrpBA;EACE,eAAA;AJwpBF;;AIrpBA;EACE,yBAAA;AJwpBF;AItpBE;EACE,gCAAA;AJwpBJ;;AKn0BA;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ALs0BF;AKr0BE;EACE,6BAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;ALu0BJ;AKt0BI;EACE,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;ALw0BN;AKr0BE;EACE,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,8BAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;ALu0BJ;AKr0BE;EACE,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,8BAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;ALu0BJ;AKr0BE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBH9CmB;EG+CnB,YAAA;ALu0BJ;AKt0BI;EACE,YAAA;EACA,yBAAA;ALw0BN;AKr0BE;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,cHtDc;AF63BlB;AKr0BI;EACE,yBAAA;EACA,oCAAA;ALu0BN;AKp0BE;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,WAAA;ALs0BJ;AKp0BE;EACE,UAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;ALs0BJ;AKr0BI;EACE,cAAA;ALu0BN;AKr0BI;EACE,yBAAA;ALu0BN;AKp0BE;EACE,UAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;ALs0BJ;AKr0BI;EACE,cAAA;ALu0BN;AKr0BI;EACE,yBAAA;ALu0BN;AKp0BE;EACE,WAAA;EACA,cHpGI;EGqGJ,yBAAA;ALs0BJ;AKr0BI;EACE,yBAAA;EACA,oCAAA;ALu0BN;AKp0BE;EACE,kBAAA;EACA,oCAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;ALs0BJ;AKp0BI;EACE,UAAA;EACA,uBAAA;EACA,wCAAA;ALs0BN;AKr0BM;EACE,2BAAA;EACA,oCAAA;ALu0BR;AKn0BI;EACE,oCAAA;EACA,gCAAA;ALq0BN;AKn0BM;EACE,yBAAA;ALq0BR;AKl0BM;EACE,oCAAA;EACA,gCAAA;ALo0BR;AKn0BQ;EACE,yBAAA;ALq0BV;AKh0BI;EACE,oCAAA;EACA,gCAAA;ALk0BN;AKj0BM;EACE,yBAAA;ALm0BR;AK9zBE;EACE,WAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,cHnKI;AFm+BR;AK9zBI;EACE,yBAAA;ALg0BN;AK7zBI;EACE,yBAAA;AL+zBN;AK3zBE;EACE,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AL6zBJ;AK3zBI;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AL6zBN;AKzzBE;EACE,cAAA;AL2zBJ;AK1zBI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AL4zBN;AKzzBI;EACE,yBAAA;AL2zBN;AKvzBE;EACE,cAAA;ALyzBJ;AKxzBI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AL0zBN;AKvzBI;EACE,yBAAA;ALyzBN;AKrzBE;EACE,WAAA;ALuzBJ;AKrzBI;EACE,gCAAA;EACA,yBAAA;ALuzBN;AKpzBI;EACE,qBH9NgB;EG+NhB,cH7Nc;AFmhCpB;AKpzBM;EACE,gCAAA;EACA,oCAAA;EACA,uBAAA;ALszBR;;AMxjCE;EACE,WAAA;EACA,YAAA;AN2jCJ;AM1jCI;EACE,uBAAA;EACA,4BAAA;EACA,8BAAA;EACA,oCAAA;AN4jCN;AM3jCM;EACE,uBAAA;AN6jCR;;AOvkCA;EACI,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AP0kCJ;AOxkCI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AP0kCR;;AOtkCA;EACE,aAAA;EACA,qCAAA;EACA,QAAA;APykCF;;AOtkCA;EACI,2BAAA;EACA,qBAAA;APykCJ;AOvkCI;EACI,gBAAA;APykCR;AOtkCI;EACI,gBAAA;APwkCR;AOrkCI;EACI,oCAAA;APukCR;AOpkCI;EACI,oCAAA;APskCR;AOnkCI;EACI,oCAAA;APqkCR;AOlkCI;EACI,oCAAA;APokCR;;AQpnCA;EACE,WAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;ARunCF;AQtnCE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,qBAAA;EACA,yBAAA;ARwnCJ;AQtnCE;EACE,iBAAA;EACA,cAAA;ARwnCJ;;AS9oCA;EACI,YAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;ATipCJ;AS/oCI;EACI,cAAA;EACA,kBAAA;ATipCR;AS7oCI;EACI,yBAAA;EACA,mBAAA;AT+oCR;AS7oCQ;EACI,YAAA;EACA,YAAA;AT+oCZ;AS3oCY;EACI,oCAAA;AT6oChB;AS3oCgB;EACI,cA9BF;EA+BE,gBAAA;AT6oCpB;ASxoCQ;EACI,cAtCE;EAuCF,gBAAA;AT0oCZ;ASxoCY;EACI,cAzCE;EA0CF,gBAAA;AT0oChB;;AUnrCE;EACE,cAAA;AVsrCJ;AUnrCM;EACE,oCAAA;AVqrCR;AUjrCQ;EACE,oCAAA;AVmrCV;AU7qCE;;EAEE,YAAA;AV+qCJ;AU5qCM;;EACE,oCAAA;AV+qCR;AU3qCQ;;EACE,oCAAA;AV8qCV;AUxqCE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AV0qCJ;AUtqCI;EACE,kBAAA;EACA,8BAAA;EACA,yBAAA;AVwqCN;AUlqCM;EACE,oCAAA;AVoqCR;AUhqCI;EACE,kBAAA;EACA,mBAAA;AVkqCN;;AW5tCA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AX+tCF;AW9tCE;EACE,WAAA;AXguCJ;AW9tCE;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;AXguCJ;AW/tCI;EACE,WAAA;AXiuCN;;AY5uCI;EACE,8BAAA;EACA,oCAAA;EACA,6BAAA;AZ+uCN;AY7uCM;EACE,yBAAA;AZ+uCR;AY5uCM;EACE,yBAAA;AZ8uCR;AYzuCE;EACE,cAAA;EACA,YAAA;EACA,eAAA;AZ2uCJ;AYzuCI;EACE,gBAAA;EACA,yBAAA;AZ2uCN;;AYpuCE;EACE,cAAA;AZuuCJ;AYpuCE;EACE,aAAA;AZsuCJ;AYnuCE;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;AZquCJ;;AYjuCA;EACE,gBAAA;EACA,YAAA;AZouCF;AYluCE;EACE,kCAAA;AZouCJ;;AY9tCI;EACE,yBAAA;AZiuCN;;Aa3xCE;EACE,gBAAA;EACA,UAAA;Ab8xCJ;Aa5xCI;EACE,gBAAA;Ab8xCN;Aa3xCI;EACE,gBAAA;Ab6xCN;Aa1xCI;EACE,yBX4BuB;AFgwC7B;AazxCI;EACE,yBAAA;Ab2xCN;AaxxCI;EACE,yBX6Be;AF6vCrB;AavxCI;EACE,yBXSe;AFgxCrB;AarxCE;EACE,aAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;AbuxCJ;AapxCE;EACE,WAAA;EACA,YAAA;AbsxCJ;AapxCI;EACE,yBXnBa;EWoBb,qBXrBkB;AF2yCxB;AapxCM;EACE,yBXJqB;AF0xC7B;AanxCM;EACE,yBXRqB;AF6xC7B;AajxCI;EACE,yBXxBgB;EWyBhB,qBX3BS;AF8yCf;AajxCM;EACE,yBXxBa;AF2yCrB;AahxCM;EACE,yBX5Ba;AF8yCrB;Aa9wCI;EACE,yBXZmB;EWanB,qBXlBe;AFkyCrB;Aa9wCM;EACE,yBXrBa;AFqyCrB;Aa7wCM;EACE,yBXzBa;AFwyCrB;Aa3wCI;EACE,yBAAA;EACA,yBAAA;Ab6wCN;Aa3wCM;EACE,yBAAA;Ab6wCR;Aa1wCM;EACE,yBAAA;Ab4wCR;AaxwCI;EACE,yBXhFO;EWiFP,yBAAA;Ab0wCN;AaxwCM;EACE,yBAAA;Ab0wCR;AavwCM;EACE,yBAAA;AbywCR;;Ac/2CA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;Adk3CF;Ach3CE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;Adk3CJ;Ach3CI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;Adk3CN;Ac/2CI;EACE,eAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,yBZVa;AF23CnB;Ac72CM;EACE,cAAA;Ad+2CR;Ac52CM;EACE,cAAA;Ad82CR;Ac32CM;EACE,yBAAA;Ad62CR;Ac32CQ;EACE,yBAAA;Ad62CV;Ac32CU;EACE,oCAAA;Ad62CZ;Acz2CQ;EACE,yBAAA;Ad22CV;Acz2CU;EACE,cAAA;Ad22CZ;Acp2CM;EACE,cAAA;Ads2CR;Acn2CM;EACE,cAAA;Adq2CR;Acl2CM;EACE,yBAAA;Ado2CR;Acl2CQ;EACE,yBAAA;Ado2CV;Acl2CU;EACE,oCAAA;Ado2CZ;Ach2CQ;EACE,yBAAA;Adk2CV;Ach2CU;EACE,cAAA;Adk2CZ;Ac31CM;EACE,cAAA;Ad61CR;Ac11CM;EACE,cAAA;Ad41CR;Acz1CM;EACE,yBAAA;Ad21CR;Acz1CQ;EACE,yBAAA;Ad21CV;Acz1CU;EACE,oCAAA;Ad21CZ;Acv1CQ;EACE,yBAAA;Ady1CV;Acv1CU;EACE,cAAA;Ady1CZ;Acj1CM;EACE,cAAA;Adm1CR;Ach1CM;EACE,cAAA;Adk1CR;Ac/0CM;EACE,yBAAA;Adi1CR;Ac/0CQ;EACE,yBAAA;Adi1CV;Ac/0CU;EACE,oCAAA;Adi1CZ;Ac70CQ;EACE,yBAAA;Ad+0CV;Ac70CU;EACE,cAAA;Ad+0CZ;Acx0CM;EACE,uBAAA;EACA,yBAAA;Ad00CR;Acx0CQ;EACE,yBAAA;Ad00CV;Acx0CU;EACE,oCAAA;Ad00CZ;Act0CQ;EACE,yBAAA;Adw0CV;Acn0CI;EACE,kBAAA;EACA,yBAAA;EACA,wDAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,WAAA;Adq0CN;Acl0CQ;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;Ado0CV;Acj0CY;EACE,0BAAA;Adm0Cd;Ac/zCc;EACE,cAAA;Adi0ChB;Ac5zCU;EACE,6BAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;Ad8zCZ;Ac5zCY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;Ad8zCd;Ac5zCc;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;Ad8zChB;AcxzCc;EACE,aAAA;Ad0zChB;AcvzCc;EACE,aAAA;AdyzChB;AcpzCU;EACE,WAAA;AdszCZ;AcnzCU;EACE,UAAA;AdqzCZ;AclzCU;EACE,UAAA;AdozCZ;AcjzCU;EACE,UAAA;AdmzCZ;AchzCU;EACE,UAAA;AdkzCZ;Ac/yCU;EACE,UAAA;AdizCZ;Ac7yCQ;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;Ad+yCV;Ac7yCU;EACE,mBAAA;EACA,6BAAA;Ad+yCZ;Ac7yCY;EACE,mBAAA;Ad+yCd;Ac7yCc;;EAEE,cAAA;Ad+yChB;Ac1yCc;EACE,cAAA;Ad4yChB;AczyCc;EACE,yBAAA;Ad2yChB;AcvyCgB;EACE,cAAA;AdyyClB;AclyCU;EACE,mBAAA;EACA,6BAAA;AdoyCZ;AclyCY;EACE,mBAAA;AdoyCd;AclyCc;;EAEE,cAAA;AdoyChB;Ac/xCc;EACE,cAAA;AdiyChB;Ac7xCgB;EACE,cAAA;Ad+xClB;AczxCU;EACE,mBAAA;EACA,6BAAA;Ad2xCZ;AczxCY;EACE,mBAAA;Ad2xCd;AczxCc;;EAEE,cAAA;Ad2xChB;ActxCc;EACE,cAAA;AdwxChB;AcpxCgB;EACE,cAAA;AdsxClB;AchxCU;EACE,mBAAA;EACA,6BAAA;AdkxCZ;AchxCY;EACE,mBAAA;AdkxCd;AchxCc;;EAEE,cAAA;AdkxChB;Ac7wCc;EACE,cAAA;Ad+wChB;Ac3wCgB;EACE,cAAA;Ad6wClB;ActwCY;EACE,yBAAA;AdwwCd;AcpwCU;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AdswCZ;AcpwCY;EACE,eAAA;EACA,gBAAA;AdswCd;AcnwCY;EACE,eAAA;EACA,gBAAA;AdqwCd;AcjwCU;EACE,2BAAA;EACA,YAAA;AdmwCZ;AchwCU;EACE,gBAAA;EACA,oBAAA;AdkwCZ;AchwCY;EACE,eAAA;EACA,gBAAA;AdkwCd;Ac/vCY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AdiwCd;Ac9vCY;EACE,YAAA;AdgwCd;Ac9vCc;EACE,eAAA;EACA,gBAAA;AdgwChB;Ac5vCY;EACE,YAAA;EACA,iBAAA;Ad8vCd;Ac1vCc;EACE,oBAAA;EACA,gBAAA;Ad4vChB;Ac1vCgB;EACE,YAAA;EACA,sBAAA;EACA,yBAAA;Ad4vClB;Ac1vCkB;EACE,eAAA;Ad4vCpB;ActvCY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AdwvCd;ActvCc;EACE,kBAAA;EACA,eAAA;AdwvChB;AcrvCc;EACE,kBAAA;EACA,gBAAA;AduvChB;AcpvCc;EACE,2BAAA;AdsvChB;AcnvCc;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AdqvChB;AclvCc;EACE,yBAAA;AdovChB;AclvCgB;;;EAGE,cAAA;AdovClB;AchvCc;EAEE,mBAAA;AdivChB;Ac/uCgB;;;;;EAGE,cAAA;AdmvClB;Ac/uCc;EACE,mBAAA;AdivChB;Ac/uCgB;;;EAGE,cAAA;AdivClB;;AervDA;EACE,kBAAA;AfwvDF;AetvDE;EAME,yBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;AfmvDJ;Ae3vDI;EACE,gBAAA;EACA,+BAAA;Af6vDN;AepvDE;EACE,uBAAA;EACA,WAAA;EAEA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;AfovDJ;AelvDI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AfovDN;AelvDM;EACE,eAAA;EAEA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AfmvDR;Ae9uDE;EACE,aAAA;AfgvDJ;Ae7uDE;EACE,iBAAA;Af+uDJ;Ae7uDI;EACE,mBAAA;Af+uDN;Ae9uDM;EACE,kBAAA;AfgvDR;;Ae1uDA;EACE,eAAA;EAEA,sBAAA;EACA,YAAA;EACA,yBAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;EAEA,mBAAA;EACA,0CAAA;EACA,oCAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AfyuDF;AevuDE;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AfyuDJ;;AeruDA;EACE,eAAA;EAEA,iBAAA;EACA,oBAAA;EAEA,aAAA;EACA,mBAAA;EAEA,oCAAA;EAEA,kBAAA;AfouDF;AeluDE;EACE,iBAAA;EAEA,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EAEA,mBAAA;AfkuDJ;Ae/tDE;EACE,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;AfiuDJ;Ae9tDE;EACE,mBAAA;AfguDJ;Ae/tDI;EACE,cAAA;AfiuDN;;Ae5tDA;EACE,eAAA;EAEA,sBAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,SAAA;EAEA,kBAAA;EAEA,mBAAA;EACA,0CAAA;EACA,8BAAA;Af2tDF;AeztDE;EACE,SAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;Af2tDJ;AeztDI;EACE,WAAA;Af2tDN;AextDI;EACE,WAAA;Af0tDN;AettDI;EACE,cAAA;EACA,iBAAA;EACA,qBAAA;AfwtDN;AeptDE;EACE,qBAAA;EAEA,mBAAA;EACA,wCAAA;EAEA,gBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;AfmtDJ;Ae/sDI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EAEA,kBAAA;AfgtDN;Ae7sDI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;Af+sDN;Ae1sDI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EAEA,kBAAA;Af2sDN;AexsDI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;Af0sDN;AevsDM;EACE,gBAAA;EACA,uBAAA;EACA,YAAA;AfysDR;AepsDE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AfssDJ;AepsDI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AfssDN;AensDM;EACE,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AfqsDR;AelsDM;EACE,cAAA;AfosDR;AehsDI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EAEA,oBAAA;AfisDN;Ae9rDI;EACE,aAAA;EACA,QAAA;AfgsDN;Ae9rDM;EACE,sBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EAEA,iBAAA;EAEA,yBAAA;EACA,2BAAA;Af8rDR;Ae5rDQ;EACE,yBAAA;EACA,aAAA;Af8rDV;Ae3rDQ;EACE,yBAAA;EACA,aAAA;Af6rDV;AevrDE;EACE,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,mBAAA;EAEA,oBAAA;AfurDJ;AeprDE;EACE,mBAAA;EACA,yCAAA;EACA,8BAAA;EACA,kDAAA;AfsrDJ;AenrDM;EACE,yBAAA;AfqrDR;AenrDM;EACE,yBAAA;AfqrDR;AehrDM;EACE,yBAAA;AfkrDR;AehrDM;EACE,8BAAA;AfkrDR;Ae7qDM;EACE,yBAAA;Af+qDR;Ae3qDI;EACE,yBAAA;EACA,gBAAA;Af6qDN;Ae3qDM;EACE,yBAAA;EACA,gBAAA;Af6qDR;;AgBriEA;EACE,eAAA;EACA,kCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AhBwiEF;AgBtiEE;EACE,kBAAA;EACA,wBAAA,EAAA,oCAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;AhBwiEJ;AgBriEE;EACE;IACE,yCAAA;EhBuiEJ;EgBriEE;IACE,wBAAA;EhBuiEJ;AACF;AgBpiEE;EACE,UAAA;EACA,YAAA;EACA,oCAAA;EACA,gBAAA;EACA,YAAA;AhBsiEJ;AgBpiEI;EAGE,oCAAA;EACA,gBAAA;EACA,YAAA;AhBoiEN;;AiB9kEA;EACE,kBAAA;AjBilEF;AiB/kEI;EACE,cfuBc;EetBd,eAAA;EACA,gBAAA;EACA,QAAA;AjBilEN;AiB/kEM;EACE,YAAA;AjBilER;AiBhlEQ;EACE,eAAA;AjBklEV;AiB7kEE;;EAEE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AjB+kEJ;AiB7kEE;;EAEE,YAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AjB+kEJ;AiB7kEE;EACE,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,WAAA;EACA,SAAA;AjB+kEJ;AiB9kEI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;AjBglEN;AiB7kEE;EACE,QAAA;AjB+kEJ;AiB7kEE;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;AjB+kEJ;AiB9kEI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AjBglEN;AiB9kEI;EACE,WAAA;EACA,gBAAA;AjBglEN;AiB/kEM;EACE,aAAA;EACA,qCAAA;EACA,kBAAA;AjBilER;AiBhlEQ;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AjBklEV;AiB/kEQ;EACE,aAAA;EACA,8BAAA;AjBilEV;AiBhlEU;EACE,UAAA;AjBklEZ;AiBjlEY;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AjBmlEd;AiB5kEM;EACE,eAAA;AjB8kER;AiB3kEM;EACE,sBAAA;EACA,uBAAA;AjB6kER;AiBzkEI;EACE,WAAA;AjB2kEN;AiBxkEI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AjB0kEN;AiBzkEM;EACE,gBAAA;AjB2kER;AiBxkEI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AjB0kEN;AiBxkEI;;EAEE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AjB0kEN;AiBxkEI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AjB0kEN;AiBxkEI;;EAEE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AjB0kEN;AiBzkEM;;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AjB4kER;AiBzkEI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AjB2kEN;AiB1kEM;EACE,WAAA;EACA,gBAAA;AjB4kER;AiBzkEI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AjB2kEN;AiB1kEM;EACE,cAAA;AjB4kER;AiBvkEE;EACE,kBAAA;AjBykEJ;AiBtkEM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,uBAAA;EACA,kBAAA;AjBwkER;AiBpkEI;EACE,kBAAA;EACA,QAAA;EACA,WAAA;AjBskEN;AiBpkEM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AjBskER;AiBlkEI;EACE,aAAA;EACA,8BAAA;AjBokEN;AiBjkEI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;AjBmkEN;AiBhkEI;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;AjBkkEN;AiB9jEM;EACE,eAAA;AjBgkER;AiB9jEM;EACE,eAAA;EACA,gBAAA;AjBgkER;;AkBr0EA;EACE,kBAAA;EAEA,gBAAA;AlBu0EF;AkBr0EE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,mBAAA;EACA,gCAAA;EACA,mBAAA;AlBs0EJ;AkBp0EI;EACE,kBAAA;AlBs0EN;AkBp0EM;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EACA,yBAAA;AlBs0ER;AkBn0EM;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AlBq0ER;AkBj0EI;EACE,eAAA;EAEA,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EACA,yBAAA;AlBk0EN;AkB9zEE;EACE,aAAA;EACA,8BAAA;EAEA,gCAAA;EACA,mBAAA;AlB+zEJ;AkB7zEI;EACE,SAAA;AlB+zEN;AkB7zEQ;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AlB+zEV;AkB5zEQ;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AlB8zEV;AkB5zEU;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AlB8zEZ;AkBzzEM;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AlB2zER;AkBxzEM;EACE,mBAAA;AlB0zER;AkBxzEQ;EACE,aAAA;EACA,mBAAA;AlB0zEV;AkBxzEU;EACE,SAAA;EACA,iBAAA;AlB0zEZ;AkBvzEU;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,kBAAA;EAEA,YAAA;AlBuzEZ;AkBlzEM;EACE,kBAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AlBmzER;AkBjzEQ;EACE,eAAA;EAEA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AlBkzEV;AkB9yEM;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AlBgzER;AkB/yEQ;EACE,cAAA;EACA,gBAAA;AlBizEV;AkB/yEQ;EACE,0BAAA;AlBizEV;AkB3yEI;EACE,SAAA;AlB6yEN;AkB1yEI;EACE,SAAA;AlB4yEN;AkBxyEE;EACE,aAAA;AlB0yEJ;AkBxyEI;EACE,SAAA;EACA,sBAAA;AlB0yEN;AkBvyEI;EACE,mBAAA;AlByyEN;AkBvyEM;EACE,mBAAA;AlByyER;AkBvyEQ;EACE,kBAAA;AlByyEV;AkBryEM;EACE,aAAA;EACA,8BAAA;AlBuyER;AkBryEQ;EACE,SAAA;EAEA,mBAAA;EACA,0CAAA;EAEA,kBAAA;EAEA,kBAAA;AlBoyEV;AkBlyEU;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,mBAAA;AlBmyEZ;AkBhyEU;EACE,YAAA;EAEA,mBAAA;EACA,wCAAA;EACA,8BAAA;EAEA,kBAAA;AlBgyEZ;AkB9xEY;EACE,0CAAA;EACA,oCAAA;AlBgyEd;AkB9xEc;EACE,yBAAA;EACA,gCAAA;AlBgyEhB;AkB7xEc;EACE,+BAAA;AlB+xEhB;AkB3xEY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,iBAAA;EAEA,gCAAA;EAEA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;AlB0xEd;AkBvxEY;EACE,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AlBuxEd;AkBnxEU;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;AlBqxEZ;AkBnxEY;EACE,gBAAA;EACA,cAAA;AlBqxEd;AkBhxEQ;EACE,SAAA;AlBkxEV;AkB7wEI;EACE,kBAAA;AlB+wEN;AkB5wEQ;EACE,kBAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AlB6wEV;AkB1wEQ;EACE,aAAA;EACA,mBAAA;AlB4wEV;AkBzwEQ;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AlB2wEV;AkBzwEU;EACE,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EAMA,iBAAA;EAEA,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AlBowEZ;AkBlxEY;EACE,kBAAA;AlBoxEd;AkBnwEQ;EACE,mBAAA;AlBqwEV;AkBjwEM;EACE,qCAAA;EACA,+BAAA;EACA,kBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,mBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AlBiwER;AkB/vEQ;EACE,oCAAA;EACA,gCAAA;EAEA,yBAAA;AlBgwEV;AkB3vEQ;EACE,kBAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AlB4vEV;AkBzvEQ;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AlB2vEV;AkBzvEU;EACE,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EAMA,iBAAA;EAEA,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AlBovEZ;AkBlwEY;EACE,kBAAA;AlBowEd;AkB9uEM;EACE,iBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,0CAAA;EACA,oCAAA;EAEA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AlB8uER;;AkBvuEE;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,kBAAA;EAEA,kBAAA;AlBwuEJ;AkBruEE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,oCAAA;AlBuuEJ;;AkBnuEA;EACE,mBAAA;EACA,0CAAA;EAEA,kBAAA;AlBquEF;AkBnuEE;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,mBAAA;AlBouEJ;AkBjuEE;EACE,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AlBmuEJ;AkBjuEI;EACE,kBAAA;AlBmuEN;AkBjuEM;EACE,kBAAA;AlBmuER;AkB/tEI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;AlBguEN;AkB7tEQ;EACE,+BAAA;AlB+tEV;AkB5tEQ;EACE,eAAA;EAEA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AlB6tEV;AkBztEM;EACE,eAAA;EACA,kBAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AlB0tER;AkBxtEQ;EACE,+BAAA;AlB0tEV;AkBptEE;EACE,YAAA;AlBstEJ;AkBptEI;EACE,uBAAA;AlBstEN;AkBntEI;EACE,wBAAA;AlBqtEN;AkBltEI;EACE,uBAAA;EACA,4BAAA;EACA,4BAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AlBotEN;AkBltEM;EACE,iBAAA;AlBotER;AkBjtEM;EACE,kBAAA;AlBmtER;;AmBzxFA;EACE,eAAA;EAEA,aAAA;EACA,sBAAA;EAEA,mBAAA;EACA,0CAAA;EACA,8BAAA;EAmNA,mBAAA;AnBwkFF;AmBzxFE;EAKE,mBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,aAAA;EACA,mBAAA;EAEA,QAAA;AnBqxFJ;AmBhyFI;EACE,iBAAA;AnBkyFN;AmBtxFI;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,yBjBQ0B;EiBP1B,cjBIe;EiBHf,yBAAA;AnBwxFN;AmBtxFM;EACE,eAAA;EACA,gBAAA;AnBwxFR;AmBtxFM;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AnBwxFR;AmBtxFM;EACE,YAAA;EACA,YAAA;AnBwxFR;AmBvxFQ;EACE,0BAAA;EACA,cjBbW;EiBcX,eAAA;AnByxFV;AmBvxFQ;EACE,WAAA;EACA,YAAA;AnByxFV;AmBvxFQ;EACE,wBAAA;AnByxFV;AmBpxFQ;EACE,gBAAA;EACA,qBAAA;AnBsxFV;AmB/wFE;EACE,mBAAA;EACA,0CAAA;EACA,mBAAA;EACA,+CAAA;AnBixFJ;AmB/wFI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AnBixFN;AmB7wFM;EACE,eAAA;AnB+wFR;AmB3wFI;EACE,8BAAA;EACA,0BAAA;AnB6wFN;AmBzwFE;EACE,mBAAA;EACA,oCAAA;EACA,8BAAA;EACA,+CAAA;AnB2wFJ;AmBzwFI;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AnB2wFN;AmBvwFM;EACE,0BAAA;AnBywFR;AmBrwFI;EACE,mBAAA;EACA,0BAAA;AnBuwFN;AmBnwFE;EACE,mBAAA;EACA,oCAAA;EACA,8BAAA;EACA,+CAAA;AnBqwFJ;AmBnwFI;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AnBqwFN;AmBjwFM;EACE,0BAAA;AnBmwFR;AmB/vFI;EACE,mBAAA;EACA,0BAAA;AnBiwFN;AmB7vFE;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,+CAAA;AnB+vFJ;AmB7vFI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AnB+vFN;AmB3vFM;EACE,eAAA;AnB6vFR;AmBzvFI;EACE,mBAAA;EACA,0BAAA;AnB2vFN;AmBpvFQ;EACE,eAAA;AnBsvFV;AmBjvFQ;EACE,eAAA;AnBmvFV;AmB9uFI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AnBgvFN;AmB7uFI;EACE,8BAAA;EACA,0BAAA;AnB+uFN;AmB3uFE;EACE,YAAA;EACA,WAAA;EAEA,iBAAA;AnB4uFJ;AmB1uFI;EACE,iBAAA;AnB4uFN;AmBtuFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AnBwuFJ;AmBtuFI;EACE,YAAA;EACA,YAAA;AnBwuFN;AmBpuFE;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,sBAAA;EACA,yBAAA;AnBsuFJ;AmBpuFI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AnBsuFN;AmBpuFM;EACE,yBAAA;AnBsuFR;AmBnuFM;EACE,yBAAA;AnBquFR;AmBhuFE;EACE,aAAA;EACA,kBAAA;AnBkuFJ;AmB/tFM;EACE,YAAA;EACA,YAAA;AnBiuFR;AmB7tFQ;EACE,aAAA;AnB+tFV;AmB3tFU;EACE,eAAA;AnB6tFZ;AmBttFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,cAAA;AnBwtFJ;AmBttFI;EACE,YAAA;EACA,aAAA;EACA,oBAAA;AnBwtFN;AmBntFE;EACE,WAAA;AnBqtFJ;;AoBngGA;EACE,aAAA;EACA,sBAAA;EAEA,mBAAA;EACA,oCAAA;EACA,aAAA;EACA,iBAAA;ApBqgGF;AoBngGE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EAGA,kBAAA;EACA,WAAA;ApBmgGJ;AoBjgGI;EACE,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EAEA,kBAAA;ApBkgGN;AoB//FI;EACE,gBAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;ApBigGN;AoB9/FI;EACE,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ApBggGN;AoB5/FE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,kBAAA;ApB4/FJ;AoBz/FE;EACE,WAAA;ApB2/FJ;AoBz/FI;EACE,iBAAA;ApB2/FN;AoBx/FI;EACE,WAAA;EACA,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,YAAA;EACA,gBAAA;EAEA,kBAAA;EACA,qCAAA;EACA,+BAAA;ApBs/FN;AoBp/FM;EACE,qCAAA;ApBs/FR;AoBl/FI;EACE,0BAAA;EACA,gBAAA;ApBo/FN;;AqB5lGA;EAEE,aAAA;EACA,sBAAA;EAEA,kBAAA;EAEA,mBAAA;EACA,0CAAA;EACA,8BAAA;EACA,mBAAA;ArB4lGF;AqB1lGE;EACE,aAAA;EACA,mBAAA;ArB4lGJ;AqB1lGI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;ArB4lGN;AqB1lGM;EACE,eAAA;ArB4lGR;AqBxlGI;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;ArB0lGN;AqBvlGI;EACE,aAAA;EACA,WAAA;EACA,cAAA;EACA,QAAA;ArBylGN;AqBvlGM;EACE,eAAA;ArBylGR;AqBrlGI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,UAAA;ArBulGN;AqBrlGM;EACE,YAAA;EACA,aAAA;EACA,oBAAA;ArBulGR;AqBnlGI;EACE,WAAA;ArBqlGN;AqBjlGE;EACE,YAAA;EACA,WAAA;EAEA,iBAAA;ArBklGJ;AqBhlGI;EACE,iBAAA;ArBklGN;AqB9kGM;EACE,eAAA;ArBglGR;AqB3kGE;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ArB6kGJ;AqB1kGE;EACE,8BAAA;ArB4kGJ;AqB3kGI;EACE,0BAAA;ArB6kGN;AqBvkGM;EACE,eAAA;ArBykGR;AqBrkGI;EACE,oCAAA;EACA,8BAAA;ArBukGN;AqBtkGM;EACE,0BAAA;ArBwkGR;AqBnkGE;EACE,oCAAA;EACA,8BAAA;ArBqkGJ;AqBnkGI;EACE,yBAAA;ArBqkGN;AqBjkGM;EACE,eAAA;ArBmkGR;AqB/jGI;EACE,8BAAA;ArBikGN;AqBhkGM;EACE,0BAAA;ArBkkGR;AqB7jGM;EACE,yBAAA;ArB+jGR;AqB5jGM;EACE,cAAA;ArB8jGR;AqB1jGI;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBnBpH0B;EmBqH1B,cnBxHe;EmByHf,yBAAA;ArB4jGN;AqB3jGM;EACE,eAAA;EACA,gBAAA;ArB6jGR;AqB3jGM;EACE,eAAA;EACA,gBAAA;ArB6jGR;AqB3jGM;EACE,YAAA;EACA,YAAA;ArB6jGR;AqB5jGQ;EACE,0BAAA;EACA,cnBvIW;EmBwIX,eAAA;ArB8jGV;AqB5jGQ;EACE,WAAA;EACA,YAAA;ArB8jGV;AqB5jGQ;EACE,wBAAA;ArB8jGV;AqBzjGQ;EACE,gBAAA;EACA,qBAAA;ArB2jGV;AqBrjGE;EACE,oCAAA;EACA,8BAAA;ArBujGJ;AqBrjGI;EACE,yBAAA;ArBujGN;AqBnjGM;EACE,eAAA;ArBqjGR;AqBjjGI;EACE,8BAAA;ArBmjGN;AqBljGM;EACE,0BAAA;ArBojGR;AqB/iGE;EACE,oCAAA;EACA,8BAAA;ArBijGJ;AqB/iGI;EACE,yBAAA;ArBijGN;AqB7iGM;EACE,eAAA;ArB+iGR;AqB3iGI;EACE,8BAAA;ArB6iGN;AqB5iGM;EACE,0BAAA;ArB8iGR;AqBziGE;EACE,gBAAA;EACA,iBAAA;ArB2iGJ;AqBziGI;EACE,gBAAA;EACA,eAAA;ArB2iGN;AqBxiGI;EACE,gBAAA;EACA,eAAA;ArB0iGN;;AsBhyGA;EACE,WAAA;AtBmyGF;;AsBhyGA;EACE,eAAA;EACA,kCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AtBmyGF;AsBjyGE;EACE,gBAAA;AtBmyGJ;AsBhyGE;EACE,UAAA;EACA,sBAAA;EACA,YAAA;AtBkyGJ;AsBhyGE;EACE,UAAA;EACA,YAAA;EACA,oCAAA;EACA,gBAAA;EACA,YAAA;AtBkyGJ;AsBjyGI;EAGE,oCAAA;EACA,gBAAA;EACA,YAAA;AtBiyGN;AsB7xGE;EAEE,iBAAA;AtB8xGJ;AsB7xGI;EACE,WAAA;EACA,aAAA;EACA,iBAAA;AtB+xGN;AsB9xGM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gCAAA;AtBgyGR;AsB9xGM;;;;EAIE,6BAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,yBAAA;AtBgyGR;AsB9xGM;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;AtBgyGR;AsB7xGI;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;AtB+xGN;AsB9xGM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,QAAA;AtBgyGR;AsB/xGQ;EACE,UAAA;EACA,2BAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AtBiyGV;AsBhyGU;EACE,yBAAA;EACA,mBAAA;AtBkyGZ;AsBhyGU;EACE,YAAA;EACA,WAAA;EACA,0BAAA;AtBkyGZ;AsBhyGU;EACE,YAAA;EACA,WAAA;EACA,0BAAA;EACA,mBpB1Ec;AF42G1B;AsB9xGM;EACE,gBAAA;EACA,qBAAA;AtBgyGR;AsB/xGQ;EACE,YAAA;EACA,yBAAA;EACA,yBAAA;AtBiyGV;AsBhyGU;EACE,kBAAA;EACA,iBAAA;AtBkyGZ;AsB9xGM;EACE,eAAA;AtBgyGR;AsB/xGQ;EACE,gBAAA;AtBiyGV;AsBhyGU;EACE,cpBvHC;AFy5Gb;AsB7xGM;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EA2DA,UAAA;EAKA,WAAA;EAMA,oBAAA;AtB4tGR;AsBjyGQ;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AtBmyGV;AsBjyGQ;EACE,gBAAA;EACA,WAAA;EACA,oBAAA;AtBmyGV;AsBhyGQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AtBkyGV;AsBjyGU;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AtBmyGZ;AsBlyGY;EACE,cAAA;AtBoyGd;AsBhyGQ;EACE,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AtBkyGV;AsBhyGU;EACE,cAAA;AtBkyGZ;AsB/xGQ;EACE,gBAAA;EACA,sBAAA;EACA,yBAAA;AtBiyGV;AsB/xGQ;EACE,cAAA;AtBiyGV;AsB/xGQ;EACE,UAAA;EACA,kBAAA;AtBiyGV;AsB7xGQ;EACE,mBAAA;AtB+xGV;AsB3xGQ;EACE,gBAAA;EACA,kBAAA;AtB6xGV;AsBzxGQ;EACE,gBAAA;AtB2xGV;AsBtxGE;EACE,6BAAA;EACA,aAAA;AtBwxGJ;AsBtxGM;EACE,cAAA;AtBwxGR;AsBvxGQ;EACE,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AtByxGV;AsBpxGM;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AtBsxGR;AsBnxGI;EACE,cAAA;AtBqxGN;AsBnxGI;EAIE,mBAAA;AtBkxGN;AsBrxGM;EACE,cAAA;AtBuxGR;AsBpxGM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AtBsxGR;AsBrxGQ;EACE,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AtBuxGV;AsBnxGI;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;AtBqxGN;AsBpxGM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AtBsxGR;AsBpxGQ;EACE,cAAA;EACA,mBAAA;AtBsxGV;AsBrxGU;EACE,cAAA;AtBuxGZ;AsBpxGQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AtBsxGV;AsBrxGU;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AtBuxGZ;AsBtxGY;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AtBwxGd;AsBvxGc;EACE,yBAAA;EACA,mBAAA;AtByxGhB;AsBxxGgB;EACE,aAAA;AtB0xGlB;;AuBjlHA;EACE,UAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,4BAAA;AvBolHF;AuBllHE;EACE,6BAAA;EACA,2BAAA;EACA,6BAAA;AvBolHJ;AuBjlHE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AvBmlHJ;AuBjlHI;EACE,uBAAA;AvBmlHN;;AwBxmHA;EACE,mBAAA;EACA,4CAAA;EACA,sCAAA;EACA,+CAAA;EACA,UAAA;EACA,uBAAA;EACA,qBAAA;AxB2mHF;AwBzmHI;EACE,oCAAA;EACA,gCAAA;AxB2mHN;AwBxmHE;EACE,eAAA;EACA,YAAA;AxB0mHJ;AwBxmHE;EACE,WAAA;EACA,eAAA;AxB0mHJ;AwBxmHE;EACE,6BAAA;EACA,aAAA;AxB0mHJ;AwBzmHI;EACE,gBAAA;EACA,kBAAA;AxB2mHN;AwBzmHI;EACE,cAAA;AxB2mHN;AwBzmHI;EACE,6BAAA;EACA,iBAAA;EACA,gBAAA;AxB2mHN;AwBzmHI;EACE,gBAAA;AxB2mHN;AwBzmHI;EACE,gBAAA;EACA,uBAAA;AxB2mHN;AwBzmHI;EACE,aAAA;AxB2mHN;AwBxmHE;EACE,cAAA;AxB0mHJ;AwBxmHE;EACE,gBAAA;AxB0mHJ;AwBzmHI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AxB2mHN;AwBxmHE;EACE,gBAAA;EACA,kBAAA;AxB0mHJ;AwBzmHI;EACE,cAAA;AxB2mHN;AwBxmHM;EACE,cAAA;AxB0mHR;AwBxmHM;EACE,cAAA;AxB0mHR;AwBvmHQ;EACE,oCAAA;EACA,8BAAA;EACA,yBAAA;AxBymHV;AwBvmHQ;EACE,oCAAA;EACA,2BAAA;EACA,yBAAA;AxBymHV;AwBxmHU;EACE,2BAAA;EACA,yBAAA;AxB0mHZ;AwBvmHQ;EACE,oCAAA;EACA,8BAAA;EACA,yBAAA;EACA,2BAAA;AxBymHV;;AyBtsHE;EACE,cAAA;AzBysHJ;AyBvsHE;EACE,mBAAA;AzBysHJ;AyBtsHE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AzBwsHJ;AyBtsHI;EACE,aAAA;EACA,sBAAA;AzBwsHN;AyBrsHI;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,+CAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AzBusHN;AyBtsHM;EACE,yBAAA;AzBwsHR;AyBtsHM;EACE,2BAAA;AzBwsHR;AyBtsHM;EACE,aAAA;AzBwsHR;AyBtsHM;EAYE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kDAAA;AzB6rHR;AyB3sHQ;EACE,aAAA;EACA,QAAA;EACA,uBAAA;AzB6sHV;AyB5sHU;EACE,eAAA;AzB8sHZ;AyB5sHU;EACE,gBAAA;AzB8sHZ;AyBvsHQ;EACE,yBAAA;AzBysHV;AyBvsHQ;EACE,cAAA;AzBysHV;AyBvsHQ;EACE,gBAAA;AzBysHV;AyBnsHI;EACE,WAAA;AzBqsHN;AyBpsHM;EACE,YAAA;AzBssHR;AyBrsHQ;EACE,yBAAA;AzBusHV;AyBnsHI;EACE,yBAAA;AzBqsHN;AyBnsHI;EACE,yBAAA;EACA,eAAA;EACA,eAAA;AzBqsHN;AyBlsHE;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AzBosHJ;AyBnsHI;EACE,cAAA;EACA,iBAAA;AzBqsHN;;A0B7yHA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA,EAAA,0BAAA;A1BgzHF;;A0B7yHA;EACE,kBAAA;A1BgzHF;;A0B7yHA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;A1BgzHF;;A0B7yHA,0CAAA;AACA;EAA4B,wCAAA;A1BizH5B;;A0BhzHA;EAA4B,wCAAA;A1BozH5B;;A0BnzHA;EAA4B,wCAAA;A1BuzH5B;;A0BtzHA;EAA4B,yCAAA;A1B0zH5B;;A0BzzHA;EAA4B,yCAAA;A1B6zH5B;;A0B5zHA;EAA4B,yCAAA;A1Bg0H5B;;A0B/zHA;EAA4B,yCAAA;A1Bm0H5B;;A0Bl0HA;EAA4B,yCAAA;A1Bs0H5B;;A0Br0HA;EAA4B,yCAAA;A1By0H5B;;A0Bx0HA;EAA6B,yCAAA;A1B40H7B;;A0B30HA;EAA6B,yCAAA;A1B+0H7B;;A0B90HA;EAA6B,uCAAA;A1Bk1H7B;;A0Bh1HA,oDAAA;AACA;EACE;IACE,yBAAA;E1Bm1HF;E0Bj1HA;IACE,yBAAA;E1Bm1HF;AACF;A0Bh1HA,sCAAA;AACA;EAA4B,sBAAA;A1Bm1H5B;;A0Bl1HA;EAA4B,oBAAA;A1Bs1H5B;;A0Br1HA;EAA4B,sBAAA;A1By1H5B;;A0Bx1HA;EAA4B,sBAAA;A1B41H5B;;A0B31HA;EAA4B,sBAAA;A1B+1H5B;;A0B91HA;EAA4B,sBAAA;A1Bk2H5B;;A0Bj2HA;EAA4B,sBAAA;A1Bq2H5B;;A0Bp2HA;EAA4B,sBAAA;A1Bw2H5B;;A0Bv2HA;EAA4B,sBAAA;A1B22H5B;;A0B12HA;EAA6B,sBAAA;A1B82H7B;;A0B72HA;EAA6B,sBAAA;A1Bi3H7B;;A0Bh3HA;EAA6B,mBAAA;A1Bo3H7B;;A2B/6HA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;A3Bk7HF;A2Bj7HE;EACE,oBAAA;EACA,mBzBSe;EyBRf,czBCS;EyBAT,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;A3Bm7HJ;A2Bl7HI;EACE,gBAAA;EACA,gBAAA;A3Bo7HN;A2Bl7HI;EACE,8BAAA;EACA,uBAAA;A3Bo7HN;A2Bl7HI;EACE,yBlB1BY;EkB2BZ,czBXE;AF+7HR;A2Bn7HM;EACE,yBlB7BU;EkB8BV,yBAAA;A3Bq7HR;;A4Bp9HA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kDAAA;EACA,kBAAA;A5Bu9HF;A4Bt9HE;EACE,cAAA;EACA,kBAAA;A5Bw9HJ;A4Bt9HE;EACE,cAAA;EACA,mBAAA;A5Bw9HJ;;A6Bp+HA;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;A7Bu+HF;A6Bt+HE;EACE,mBAAA;A7Bw+HJ;A6Bt+HE;EACE,cAAA;EACA,kBAAA;A7Bw+HJ;A6Bt+HE;EACE,cAAA;EACA,kBAAA;A7Bw+HJ;A6Bt+HE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;A7Bw+HJ;A6Bv+HI;EACE,UAAA;A7By+HN;A6Bt+HE;EACE,mBAAA;A7Bw+HJ;A6Bv+HI;EACE,gCAAA;EACA,oBAAA;A7By+HN;;A8BrgIA;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,+CAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;A9BwgIF;A8BtgIE;EACE,c5BLS;E4BMT,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A9BwgIJ;A8BvgII;EACE,gBAAA;A9BygIN;A8BrgIE;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A9BugIJ;A8BrgIE;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A9BugIJ;A8BpgII;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;A9BsgIN;A8BrgIM;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,mBAAA;A9BugIR;A8BtgIQ;EACE,YAAA;EACA,WAAA;EACA,UAAA;A9BwgIV;A8BrgIU;EACE,eAAA;A9BugIZ;A8BtgIY;EACE,aAAA;A9BwgId;A8BngIU;EACE,eAAA;EACA,aAAA;A9BqgIZ;A8BhgII;EACE,kBAAA;A9BkgIN;A8BhgII;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;A9BkgIN;A8BhgII;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;A9BkgIN;A8B9/HE;EACE,gBAAA;A9BggIJ;A8B5/HI;EACE,cAAA;EACA,kBAAA;A9B8/HN;A8B3/HM;EACE,cAAA;A9B6/HR;A8Bx/HE;EACE,SAAA;EACA,aAAA;EACA,8BAAA;A9B0/HJ;A8Bv/HE;EACE,qBAAA;A9By/HJ;A8Bx/HI;EACE,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A9B0/HN;A8Bz/HM;EACE,iBAAA;A9B2/HR;A8Bz/HM;EACE,cAAA;A9B2/HR;A8Bx/HI;EACE,cAAA;A9B0/HN;A8Bx/HI;EACE,yBAAA;EACA,cAAA;A9B0/HN;A8Bt/HQ;EACE,eAAA;A9Bw/HV;A8Bv/HU;EACE,aAAA;A9By/HZ;A8Bp/HQ;EACE,eAAA;EACA,aAAA;A9Bs/HV;A8Bn/HM;EACE,cAAA;A9Bq/HR;A8Bl/HI;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,+CAAA;A9Bo/HN;A8Bh/HE;EACE,qBAAA;EACA,mBAAA;A9Bk/HJ;A8Bh/HI;EACE,cAAA;EACA,mBAAA;A9Bk/HN;A8B/+HI;EACE,yBAAA;A9Bi/HN;A8B9+HI;EACE,cAAA;A9Bg/HN;A8B7+HI;EACE,eAAA;EACA,aAAA;A9B++HN;A8B7+HI;EACE,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;A9B++HN;A8B9+HM;EACE,cAAA;A9Bg/HR;A8B7+HI;EACE,cAAA;A9B++HN;A8B7+HI;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gDAAA;A9B++HN;A8B3+HE;EACE,qBAAA;A9B6+HJ;A8B5+HI;EACE,cAAA;A9B8+HN;A8B3+HI;EACE,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;A9B6+HN;A8B5+HM;EACE,cAAA;A9B8+HR;A8Bz+HE;EACE,qBAAA;A9B2+HJ;A8B1+HI;EACE,cAAA;A9B4+HN;A8B1+HI;EACE,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;A9B4+HN;A8B3+HM;EACE,cAAA;A9B6+HR;A8B1+HI;;EAEE,cAAA;A9B4+HN;A8B3+HM;;EACE,cAAA;A9B8+HR;A8B3+HI;EACE,qBAAA;A9B6+HN;A8B1+HM;;EAEE,cAAA;A9B4+HR;A8Bv+HQ;EACE,eAAA;A9By+HV;A8Bx+HU;EACE,aAAA;A9B0+HZ;A8Br+HQ;EACE,eAAA;EACA,aAAA;A9Bu+HV;A8Bp+HM;EACE,cAAA;A9Bs+HR;A8Bj+HI;EACE,sBAAA;A9Bm+HN;;A+BvwIA;EACE,gBAAA;EACA,WAAA;A/B0wIF;A+BzwIE;EACE,6BAAA;EACA,uBAAA;EACA,2BAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A/B2wIJ;A+B1wII;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A/B4wIN;A+BzwIE;EACE,WAAA;EACA,mBAAA;A/B2wIJ;A+BzwIE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;A/B2wIJ;A+B1wII;EACE,WAAA;A/B4wIN;;AgC5yIA;EACC,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AhC+yID;AgC7yIC;EACC,mBAAA;AhC+yIF;AgC7yIE;EACC,WAAA;EACA,gBAAA;AhC+yIH;AgC5yIE;EACC,UAAA;AhC8yIH;AgC1yIC;EACC,aAAA;EACA,8BAAA;EACA,kBAAA;AhC4yIF;AgC1yIE;EACC,aAAA;EACA,mBAAA;EACG,sBAAA;EACA,yBAAA;AhC4yIN;AgCzyIE;EACC,UAAA;EACA,yBAAA;EACA,eAAA;AhC2yIH;AgCzyIG;EACC,0BAAA;AhC2yIJ;AgCxyIG;EACC,yBAAA;AhC0yIJ;AgCryIC;EACC,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AhCuyIF;AgCryII;EACE,eAAA;EACA,0BAAA;EACH,cAAA;AhCuyIH;AgCryIM;EACE,cAAA;AhCuyIR;AgClyIC;EACC,yBAAA;EACA,yB9B9B8B;AFk0IhC;AgClyIE;EACC,yBAAA;AhCoyIH;AgCjyIE;EACC,yBAAA;AhCmyIH;AgChyIE;EACC,yBAAA;AhCkyIH;AgC9xIC;EACC,yBAAA;EACA,uB9BrCgC;AFq0IlC;AgC9xIE;EACC,yBAAA;AhCgyIH;AgC7xIE;EACC,yBAAA;AhC+xIH;AgC5xIE;EACC,yBAAA;AhC8xIH;AgC1xIC;EACC,yBAAA;EACA,yB9B7C6B;AFy0I/B;AgC1xIE;EACC,yBAAA;AhC4xIH;AgCzxIE;EACC,yBAAA;AhC2xIH;AgCxxIE;EACC,yBAAA;AhC0xIH;;AiC34IA;EACI,YAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AjC84IJ;AiC54II;EACI,oCAAA;EACA,uBAAA;AjC84IR;AiC54IQ;EACI,qCAAA;AjC84IZ;AiC14II;EACI,kCAAA;EACA,yBAAA;AjC44IR;AiC14IQ;EACI,0CAAA;AjC44IZ;AiCx4II;EACI,yBAAA;EACA,mBAAA;AjC04IR;AiCx4IQ;EACI,YAAA;AjC04IZ;AiCt4IY;EACI,oCAAA;AjCw4IhB;AiCt4IgB;EACI,cxBpCF;EwBqCE,gBAAA;AjCw4IpB;AiCn4IQ;EACI,cxB5CE;EwB6CF,gBAAA;AjCq4IZ;AiCn4IY;EACI,cxB/CE;EwBgDF,gBAAA;AjCq4IhB;;AkCt7IA;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AlCy7IF;AkCx7IE;EACE,cAAA;AlC07IJ;AkCx7IE;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AlC07IJ;AkCz7II;EACE,cAAA;AlC27IN;AkC17IM;EACE,aAAA;AlC47IR;AkCx7IM;EACE,cAAA;EACA,aAAA;AlC07IR;AkCz7IQ;EACE,cAAA;EACA,cAAA;AlC27IV;AkCt7IE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AlCw7IJ;AkCv7II;EACE,cAAA;AlCy7IN;AkCv7II;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AlCy7IN;AkCv7II;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AlCy7IN;;AmCz+IE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AnC4+IJ;AmC1+IE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AnC4+IJ;AmC1+IE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AnC4+IJ;AmC3+II;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AnC6+IN;AmC1+IE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AnC4+IJ;AmC1+IE;EACE,SAAA;EACA,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,gBAAA;EACA,8BAAA;EACA,qBAAA;AnC4+IJ;AmC1+IM;EACE,eAAA;AnC4+IR;AmCv+IE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;AnCy+IJ;AmCv+II;EACE,gBAAA;EACA,cjCtDO;AF+hJb;AmCt+II;EACE,gBAAA;EACA,cjC3CU;AFmhJhB;AmCr+II;EACE,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;AnCu+IN;AmCp+IE;EACE,gCAAA;AnCs+IJ;AmCr+II;EAEE,qBAAA;AnCu+IN;AmCt+IM;EAEE,wBAAA;EACA,SAAA;AnCu+IR;AmCn+IE;EACE,gCAAA;AnCq+IJ;;AoC/jJE;EACE,cAAA;ApCkkJJ;AoCjkJI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;ApCmkJN;AoClkJM;EACE,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;ApCokJR;AoClkJQ;EACE,oCAAA;EACA,8BAAA;ApCokJV;AoCjkJQ;EACE,oCAAA;EACA,8BAAA;ApCmkJV;AoClkJU;;EAEE,yBAAA;ApCokJZ;AoCjkJQ;EACE,oCAAA;EACA,8BAAA;ApCmkJV;AoClkJU;;EAEE,yBAAA;ApCokJZ;AoC/jJM;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;ApCikJR;AoChkJQ;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;ApCkkJV;AoChkJQ;EACE,eAAA;ApCkkJV;AoC/jJM;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;ApCikJR;AoChkJQ;EACE,eAAA;ApCkkJV;AoC/jJM;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;ApCikJR;AoChkJQ;EACE,QAAA;ApCkkJV;AoC/jJM;EACE,gBAAA;ApCikJR;AoC/jJM;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;ApCikJR;AoC/jJM;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,OAAA;EACA,uBAAA;EACA,mBAAA;ApCikJR;AoChkJQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;ApCkkJV;;AqCpqJA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;ArCuqJF;AqCtqJE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;ArCwqJJ;AqCvqJI;EACE,WAAA;EACA,wBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,yBnCFa;AF2qJnB;AqCtqJM;EACE,cAAA;ArCwqJR;AqCtqJM;EACE,yBnCFW;AF0qJnB;AqCnqJQ;EACE,yBnCtBG;AF2rJb;;AqC7pJI;EACE,UAAA;ArCgqJN;AqC9pJI;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;ArCgqJN;AqC/pJM;EACE,cAAA;ArCiqJR;AqChqJQ;EACE,kBAAA;ArCkqJV;AqC/pJM;EACE,WAAA;EACA,WAAA;EACA,aAAA;ArCiqJR;AqC/pJM;EACE,aAAA;EACA,QAAA;EACA,mBAAA;ArCiqJR;AqC/pJM;;EAEE,aAAA;EACA,WAAA;EACA,WAAA;ArCiqJR;AqC/pJM;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;ArCiqJR;AqC/pJQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;ArCiqJV;AqChqJU;EACE,iBAAA;ArCkqJZ;AqC/pJQ;EACE,6BAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;ArCiqJV;AqChqJU;EACE,gBAAA;EACA,WAAA;ArCkqJZ;AqC9pJM;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;ArCgqJR;AqC/pJQ;EACE,WAAA;EACA,YAAA;EACA,UAAA;ArCiqJV;AqC/pJQ;EACE,gBAAA;EACA,cnCxFI;EmCyFJ,+BAAA;ArCiqJV;AqC9pJM;EAEE,yBAAA;ArC+pJR;AqC9pJQ;EACE,yBAAA;ArCgqJV;AqC9pJQ;EACE,cAAA;ArCgqJV;AqC7pJU;EAGE,cAAA;ArC6pJZ;AqC1pJQ;EACE,YAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;ArC4pJV;AqCzpJM;EACE,yBnCtIK;EmCuIL,YAAA;ArC2pJR;AqC1pJQ;EACE,aAAA;ArC4pJV;AqC3pJU;EACE,cAAA;ArC6pJZ;AqC1pJY;EACE,eAAA;ArC4pJd;AqCxpJQ;EACE,YAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;ArC0pJV;AqCvpJM;EACE,yBAAA;EACA,YAAA;ArCypJR;AqCxpJQ;EACE,cnC5JF;AFszJR;AqCxpJQ;EACE,aAAA;ArC0pJV;AqCvpJU;EACE,enCjKE;AF0zJd;AqCrpJU;EAGE,cnC1KJ;AF+zJR;AqClpJQ;EACE,yBAAA;ArCopJV;AqClpJQ;EACE,cAAA;ArCopJV;AqClpJQ;EACE,YAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;ArCopJV;AqChpJQ;EACE,cAAA;ArCkpJV;;AsCt2JE;EACE,WAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;AtCy2JJ;AsCx2JI;EACE,8BAAA;EACA,2BAAA;AtC02JN;AsCx2JI;EACE,+BAAA;EACA,4BAAA;AtC02JN;AsCx2JI;EACE,WAAA;AtC02JN;AsCv2JE;EACE,yBAAA;EACA,oBAAA;AtCy2JJ;;AuC73JE;EACE,cAAA;EACA,gBAAA;AvCg4JJ;AuC93JE;EACE,WAAA;AvCg4JJ;;AwCt4JA;EACI,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AxCy4JJ;AwCv4JI;EACI,iBAAA;AxCy4JR;AwCt4JI;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;AxCw4JR;AwCr4JI;EACI,qBtCyBoB;EsCxBpB,mBtCwBoB;AF+2J5B;AwCr4JQ;EACI,yBAAA;AxCu4JZ;AwCn4JI;EACI,qBtCMkB;EsCLlB,mBtCKkB;AFg4J1B;AwCn4JQ;EACI,yBAAA;AxCq4JZ;AwCj4JI;EACI,qBtCgBiB;EsCfjB,mBtCeiB;AFo3JzB;AwCj4JQ;EACI,yBAAA;AxCm4JZ;AwC93JQ;EACI,yBAAA;AxCg4JZ;;AyCl7JA;EACE,kBAAA;AzCq7JF;AyCp7JE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AzCs7JJ;AyCp7JE;EACE,YAAA;EACA,WAAA;EACA,0BAAA;AzCs7JJ;AyCr7JI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AzCu7JN;AyCt7JM;EACE,eAAA;EACA,cAAA;AzCw7JR;AyCp7JE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AzCs7JJ;AyCr7JI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AzCu7JN;AyCt7JM;EACE,yBvCLc;EuCMd,qBvCRO;AFg8Jf;AyCt7JM;EACE,yBvCOoB;EuCNpB,qBAAA;AzCw7JR;AyCp7JE;EACE,WAAA;EACA,mBAAA;AzCs7JJ;AyCp7JE;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AzCs7JJ;AyCr7JI;EACE,6BAAA;EACA,uBAAA;EACA,2BAAA;AzCu7JN;AyCn7JI;EACE,cAAA;AzCq7JN;AyCl7JE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AzCo7JJ;AyCl7JE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AzCo7JJ;AyCn7JI;EACE,eAAA;AzCq7JN;AyCl7JE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AzCo7JJ;AyCj7JE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,kCAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AzCm7JJ;AyCl7JI;EACE,sBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;AzCo7JN;AyCl7JI;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,oCAAA;EAEA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,eAAA;AzCm7JN;AyCj7JI;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AzCm7JN;AyCl7JM;EACE,YAAA;AzCo7JR;AyCj7JI;EACE,+BAAA;EACA,kDAAA;EACA,iBAAA;AzCm7JN;AyCj7JI;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AzCm7JN;AyCh7JE;EACE,uBAAA;EACA,SAAA;AzCk7JJ;AyCj7JI;;EAEE,qBAAA;AzCm7JN;;A0C/kKE;EACE,WAAA;EACA,YAAA;A1CklKJ;A0ChlKI;EACE,qBxCmCiB;EwClCjB,yBxCwCsB;AF0iK5B;A0ChlKM;EACE,yBxCgCqB;AFkjK7B;A0C9kKI;EACE,yBxCgBgB;EwCfhB,qBxCaS;AFmkKf;A0C9kKM;EACE,yBxCgBa;AFgkKrB;A0C5kKI;EACE,yBxCgCmB;EwC/BnB,qBxC0Be;AFojKrB;A0C5kKM;EACE,yBxCuBa;AFujKrB;;A2C1mKA;EACE,oBAAA;A3C6mKF;A2C5mKE;EACE,yBAAA;A3C8mKJ;A2C5mKE;EACE,iBAAA;A3C8mKJ;A2C5mKE;EACE,yBAAA;EACA,kBAAA;A3C8mKJ;A2C5mKE;EACE,yBAAA;A3C8mKJ;;A4C3nKA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;A5C8nKF;A4C5nKE;EACE,oBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;A5C8nKJ;A4C7nKI;EACE,gBAAA;A5C+nKN;A4C5nKE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,WAAA;A5C8nKJ;A4C3nKE;EAUE,uBAAA;A5ConKJ;A4C7nKI;EACE,kBAAA;A5C+nKN;A4C7nKI;EACE,mBAAA;A5C+nKN;A4C7nKI;EACE,wBAAA;A5C+nKN;A4CznKU;EACE,wBAAA;A5C2nKZ;A4CnnKU;EACE,wBAAA;A5CqnKZ;A4C/mKE;EACE,6BAAA;EACA,gBAAA;A5CinKJ;A4C/mKE;EACE,mBAAA;EACA,yBAAA;A5CinKJ;A4ChnKI;EACE,mBAAA;A5CknKN;A4CjnKM;EACE,cAAA;A5CmnKR;A4C/mKM;EACE,cAAA;A5CinKR;A4ChnKQ;EACE,cAAA;A5CknKV;A4C/mKM;EACE,cAAA;A5CinKR;A4C3mKU;EACE,yBAAA;A5C6mKZ;A4C3mKU;EACE,yBAAA;A5C6mKZ;A4CvmKE;EACE,yBAAA;A5CymKJ;A4CvmKI;EACE,mBAAA;A5CymKN;A4CxmKM;EACE,eAAA;A5C0mKR;A4CxmKM;EACE,cAAA;A5C0mKR;A4CtmKM;EACE,0BAAA;A5CwmKR;A4CrmKI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;A5CumKN;A4CtmKM;EACE,UAAA;A5CwmKR;A4CvmKQ;EACE,kBAAA;A5CymKV;A4CrmKI;EACE,gBAAA;EACA,6BAAA;EACA,gBAAA;A5CumKN;A4CpmKE;EACE,yBAAA;A5CsmKJ;A4CpmKI;EACE,mBAAA;A5CsmKN;A4CrmKM;EACE,eAAA;A5CumKR;A4CrmKM;EACE,cAAA;A5CumKR;A4CnmKM;EACE,0BAAA;A5CqmKR;A4ClmKI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;A5ComKN;A4CnmKM;EACE,UAAA;A5CqmKR;A4CpmKQ;EACE,kBAAA;A5CsmKV;A4ClmKI;EACE,gBAAA;EACA,6BAAA;EACA,gBAAA;A5ComKN;A4ChmKQ;EACE,oCAAA;EACA,oCAAA;A5CkmKV;A4CjmKU;EACE,yBAAA;A5CmmKZ;A4CjmKU;EACE,yBAAA;A5CmmKZ;A4C3lKI;EACE,WAAA;A5C6lKN;A4CxlKM;EACE,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,8BAAA;EACA,6BAAA;A5C0lKR;A4CxlKM;EACE,aAAA;A5C0lKR;;A6C5xKA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;A7C+xKF;A6C5xKI;EACE,YAAA;A7C8xKN;A6C1xKE;EACE,gBAAA;A7C4xKJ;A6C1xKI;EACE,oBAAA,EAAA,sDAAA;EACA,4BAAA,EAAA,yBAAA;EACA,qBAAA,EAAA,4BAAA;EACA,gBAAA,EAAA,sCAAA;A7C4xKN;A6CxxKE;EACE,kBAAA;A7C0xKJ;A6CxxKE;EACE,cAAA;A7C0xKJ;A6CxxKE;EACE,cAAA;A7C0xKJ;A6CxxKE;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;A7C0xKJ;A6CxxKI;EACE,0BAAA;A7C0xKN;A6CxxKM;EACE,cAAA;A7C0xKR;A6CtxKI;EACE,cAAA;EACA,eAAA;A7CwxKN;;A8Cz0KE;;EAEE,kBAAA;EACA,cAAA;EACA,iBAAA;A9C40KJ;A8C10KE;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;A9C40KJ;A8Cz0KE;EACE,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A9C20KJ;;A8Cv0KA;EACE,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;A9C00KF;A8Cx0KI;EACE,kBAAA;A9C00KN;A8Cv0KE;EACE,2BAAA;A9Cy0KJ;A8Cx0KI;EACE,YAAA;A9C00KN;A8Cr0KI;EACE,YAAA;A9Cu0KN;A8Cp0KE;EACE,yBAAA;A9Cs0KJ;A8Cp0KE;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;A9Cs0KJ;A8Cr0KI;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;A9Cu0KN;A8Cp0KM;EACE,aAAA;A9Cs0KR;A8Cl0KE;EACE,mBAAA;EACA,kBAAA;A9Co0KJ;A8Cl0KI;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;A9Co0KN;A8Cj0KE;EACE,6BAAA;A9Cm0KJ;;A+C/4KI;EACE,eAAA;EACA,mBAAA;A/Ck5KN;A+Cj5KM;EACE,cAAA;EACA,gBAAA;EACA,+BAAA;EAEA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;A/Ck5KR;A+C/4KI;EACE,YAAA;EACA,WAAA;EACA,eAAA;A/Ci5KN;A+Ch5KM;EACE,cAAA;A/Ck5KR;A+C/4KI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A/Ci5KN;A+C/4KI;EACE,gBAAA;A/Ci5KN;A+C94KM;EACE,aAAA;EACA,WAAA;A/Cg5KR;A+C/4KQ;EACE,WAAA;A/Ci5KV;A+C/4KQ;EACE,SAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;A/Ci5KV;A+C54KE;EACE,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;A/C84KJ;A+C54KI;EACE,aAAA;EACA,yBAAA;EACA,SAAA;A/C84KN;A+C54KM;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;A/C84KR;A+C34KM;EACE,UAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kCAAA;EACA,8BAAA;A/C64KR;A+Cz4KI;EACE,UAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;A/C24KN;A+Cz4KM;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;A/C24KR;A+Cv4KQ;EACE,yBAAA;A/Cy4KV;;AgDl/KA;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;AhDq/KF;AgDn/KI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AhDq/KN;AgDp/KM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AhDs/KR;AgDr/KQ;EACE,yBAAA;AhDu/KV;AgDl/KE;EACE,yBAAA;EACF,yB9Ce8B;AFq+KhC;AgDj/KE;EACE,yBAAA;EACA,uB9CoB8B;AF+9KlC;AgDj/KI;EACE,yBAAA;AhDm/KN;AgDh/KI;EACE,yBAAA;AhDk/KN;AgD/+KI;EACE,yBAAA;AhDi/KN;AgD7+KE;EACE,yBAAA;EACA,yB9CY2B;AFm+K/B;AgD7+KI;EACE,yBAAA;AhD++KN;AgD5+KI;EACE,yBAAA;AhD8+KN;AgD3+KI;EACE,yBAAA;AhD6+KN;;AiDriLA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;AjDwiLF;AiDviLE;EACE,cAAA;AjDyiLJ;AiDviLE;EACE,6BAAA;AjDyiLJ;AiDviLE;EACE,yBAAA;EACF,yB/C0B8B;AF+gLhC;AiDtiLE;EACE,yBAAA;EACA,uB/C+B8B;AFygLlC;AiDtiLI;EACE,yBAAA;AjDwiLN;AiDriLI;EACE,yBAAA;AjDuiLN;AiDpiLI;EACE,yBAAA;AjDsiLN;AiDliLE;EACE,yBAAA;EACA,yB/CuB2B;AF6gL/B;AiDliLI;EACE,yBAAA;AjDoiLN;AiDjiLI;EACE,yBAAA;AjDmiLN;AiDhiLI;EACE,yBAAA;AjDkiLN;AiD9hLE;EACE,UAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AjDgiLJ;AiD9hLI;EACE,UAAA;EACA,aAAA;EACA,qBAAA;EACA,QAAA;EACA,gBAAA;AjDgiLN;AiD9hLM;EACE,2BAAA;EACA,yBAAA;AjDgiLR;AiD5hLI;EACE,aAAA;EACA,qBAAA;EACA,kBAAA;AjD8hLN;AiD3hLI;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AjD6hLN;AiD1hLI;EACE,sBAAA;AjD4hLN;;AkDpnLA;EAEE,yBAAA;EACA,kBAAA;AlDsnLF;AkDrnLE;EACE,cAAA;AlDunLJ;AkDrnLE;EACE,8BAAA;AlDunLJ;;AmD7nLI;EAME,YAAA;EACA,cAAA;EACA,qBAAA;AnD2nLN;AmDloLM;EACE,gBAAA;EACA,+BAAA;AnDooLR;AmD5nLI;EAME,yBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;AnDynLN;AmDjoLM;EACE,gBAAA;EACA,+BAAA;AnDmoLR;AmD1nLI;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AnD4nLN;AmD1nLM;EACE,aAAA;EACA,gBAAA;EACA,SAAA;AnD4nLR;AmDznLM;EACE,WAAA;EACA,YAAA;AnD2nLR;AmDxnLM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AnD0nLR;;AoDvqLA;EACE,kBAAA;EACA,mBAAA;ApD0qLF;AoDxqLE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;ApD0qLJ;AoDtqLI;EACE,mBAAA;ApDwqLN;AoDpqLE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;ApDsqLJ;AoDnqLM;EACE,oCAAA;ApDqqLR;AoDjqLI;EACE,0BAAA;ApDmqLN;AoD9pLQ;EACE,YAAA;ApDgqLV;AoD3pLI;EACE,yBAAA;EACA,yBlDlB0B;AF+qLhC;AoD3pLM;EACE,yBAAA;ApD6pLR;AoD1pLM;EACE,yBAAA;ApD4pLR;AoDzpLM;EACE,yBAAA;ApD2pLR;AoDvpLQ;EACE,yBAAA;ApDypLV;AoDrpLM;EACE,yBAAA;ApDupLR;AoDppLM;EACE,yBAAA;ApDspLR;AoDppLQ;EACE,gBAAA;ApDspLV;AoDjpLI;EACE,yBAAA;EACA,uBlD3C4B;AF8rLlC;AoDjpLM;EACE,yBAAA;ApDmpLR;AoDhpLM;EACE,yBAAA;ApDkpLR;AoD/oLM;EACE,yBAAA;ApDipLR;AoD7oLQ;EACE,yBAAA;ApD+oLV;AoD3oLM;EACE,yBAAA;ApD6oLR;AoD1oLM;EACE,yBAAA;ApD4oLR;AoD1oLQ;EACE,gBAAA;ApD4oLV;AoDxoLM;EACE,yBAAA;ApD0oLR;AoDtoLI;EACE,yBAAA;EACA,uBAAA;ApDwoLN;AoDtoLM;EACE,yBAAA;ApDwoLR;AoDroLM;EACE,yBAAA;ApDuoLR;AoDpoLM;EACE,yBAAA;ApDsoLR;AoDloLQ;EACE,yBAAA;ApDooLV;AoDhoLM;EACE,yBAAA;ApDkoLR;AoD/nLM;EACE,yBAAA;ApDioLR;AoD/nLQ;EACE,gBAAA;ApDioLV;AoD7nLM;EACE,yBAAA;ApD+nLR;AoD3nLI;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;ApD6nLN;AoD3nLM;EACE,aAAA;EACA,UAAA;EACA,sBAAA;ApD6nLR;AoD3nLQ;EACE,aAAA;EACA,SAAA;ApD6nLV;AoD3nLU;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,QAAA;ApD6nLZ;AoD3nLY;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;ApD6nLd;AoD1nLY;EACE,eAAA;ApD4nLd;AoDrnLU;EACE,clDxLY;AF+yLxB;AoDpnLU;EACE,clD7JO;AFmxLnB;AoDnnLU;EACE,clD5MG;AFi0Lf;AoDnnLY;EACE,wBAAA;ApDqnLd;AoDlnLY;EACE,clDnNC;AFu0Lf;AoDhnLU;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ApDknLZ;AoD7mLM;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;ApD+mLR;AoD5mLU;EACE,gBAAA;EACA,2BAAA;ApD8mLZ;AoD1mLQ;EACE,YAAA;EACA,eAAA;EACA,8BAAA;ApD4mLV;AoDzmLQ;EACE,eAAA;EACA,eAAA;EACA,cAAA;ApD2mLV;AoDxmLQ;EACE,sBAAA;EACA,YAAA;ApD0mLV;AoDpmLI;EACE,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,aAAA;EACA,kCAAA;EACA,6JACE;ApDmmLR;AoD7lLM;EACE,clD1OW;AFy0LnB;AoD5lLM;EACE,cAAA;ApD8lLR;AoD3lLM;EACE,iBAAA;EACA,YAAA;ApD6lLR;AoD3lLQ;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,clDtSK;AFm4Lf;AoDzlLM;EACE,gBAAA;ApD2lLR;AoDxlLM;EACE,mBAAA;ApD0lLR;AoDvlLM;EACE,cAAA;ApDylLR;AoDtlLM;EACE,oBAAA;ApDwlLR;AoDplLY;EACE,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;ApDslLd;AoDnlLY;EACE,YAAA;ApDqlLd;AoD/kLM;EACE,mBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,eAAA;ApDilLR;AoD9kLM;EACE,gBAAA;ApDglLR;AoD7kLM;EACE,gBAAA;ApD+kLR;AoD5kLM;EACE,kBAAA;ApD8kLR;AoD3kLM;EACE,yBAAA;ApD6kLR;AoD3kLQ;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ApD6kLV;AoDzkLM;EACE,iBAAA;ApD2kLR;;AqDl8LE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;ArDq8LJ;AqDl8LE;EACE,cnDwBgB;AF46LpB;AqDj8LE;EACE,cnDgCkB;AFm6LtB;AqDh8LE;EACE,cnDoCe;AF85LnB;AqD/7LE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ArDi8LJ;AqD97LE;EACE,aAAA;EACA,8BAAA;EAEA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ArD+7LJ;AqD77LI;EACE,UAAA;ArD+7LN;AqD57LI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;ArD87LN;AqD37LI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;ArD67LN;;AsD9+LA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;AtDi/LF;AsD/+LE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,WAAA;AtDi/LJ;AsD9+LE;EACE,eAAA;AtDg/LJ;;AuD7/LQ;EAMI,YAAA;EACA,cAAA;EACA,qBAAA;AvD2/LZ;AuDlgMY;EACI,gBAAA;EACA,+BAAA;AvDogMhB;AuD5/LQ;EAMI,yBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;AvDy/LZ;AuDjgMY;EACI,gBAAA;EACA,+BAAA;AvDmgMhB;AuD1/LQ;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;AvD4/LZ;AuD1/LY;EACI,aAAA;EACA,gBAAA;EACA,SAAA;AvD4/LhB;AuDz/LY;EACI,WAAA;EACA,YAAA;AvD2/LhB;AuDz/LgB;EACI,yBrDMQ;EqDLR,qBrDDG;AF4/LvB;AuDx/LgB;EACI,yBrDfE;EqDgBF,qBrDlBL;AF4gMf;AuDv/LgB;EACI,yBrDKK;EqDJL,qBrDDC;AF0/LrB;;AwD1iMQ;EACI,0BAAA;AxD6iMZ;AwDziMI;EACI,cAAA;EACA,YAAA;AxD2iMR;AwDxiMI;EAKI,yBAAA;EACA,cAAA;EACA,qBAAA;AxDsiMR;AwD5iMQ;EACI,+BAAA;AxD8iMZ;AwDtiMI;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AxDwiMR;AwDtiMQ;EACI,WAAA;AxDwiMZ;;AyDlkMI;EACE,yBAAA;EACF,yBvDiC4B;AFoiMhC;AyDlkMI;EACE,yBAAA;EACF,yBvD+C2B;AFqhM/B;AyDjkMI;EACE,yBAAA;EACF,uBvDiC8B;AFkiMlC;AyD/jMM;;EAEE,YAAA;AzDikMR;AyD3jMI;EACE,yBvDGgB;EuDFhB,gCAAA;AzD6jMN;AyD1jMI;EACE,oCAAA;EACF,yBvDawB;AF+iM5B;;A0D5lME;;EAEE,wBAAA;EACA,SAAA;A1D+lMJ;A0D5lME;EACE,2BAAA;A1D8lMJ;A0DzlMI;;EAEE,YAAA;A1D2lMN;A0DxlMQ;;EACE,cAAA;A1D2lMV;A0DnlMM;EACE,cAAA;A1DqlMR;A0DjlMI;EACE,mBAAA;A1DmlMN;A0D/kME;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;A1DilMJ;A0D/kMI;EACE,YAAA;EACA,gBAAA;A1DilMN;;A2DloMA;EACE,mBAAA;EACA,yBAAA;EACA,+CAAA;EACA,sBAAA;EAcA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A3DwnMF;A2DxoME;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,iCAAA;EACA,kHAAA;A3D0oMJ;A2D9nME;EACE,yBAAA;EACA,yBzDY4B;AFonMhC;A2D9nMI;EACE,yBAAA;A3DgoMN;A2D7nMI;EACE,yBAAA;A3D+nMN;A2D5nMI;EACE,yBAAA;A3D8nMN;A2D1nME;EACE,yBAAA;EACA,uBzDK8B;AFunMlC;A2D1nMI;EACE,yBAAA;A3D4nMN;A2DznMI;EACE,yBAAA;A3D2nMN;A2DxnMI;EACE,yBAAA;A3D0nMN;A2DtnME;EACE,yBAAA;EACA,yBzDH2B;AF2nM/B;A2DtnMI;EACE,yBAAA;A3DwnMN;A2DrnMI;EACE,yBAAA;A3DunMN;A2DpnMI;EACE,yBAAA;A3DsnMN;A2DlnME;EACE,cAAA;A3DonMJ;A2DjnME;EACE,iBAAA;EACA,YAAA;A3DmnMJ;A2DjnMI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,czD/ES;AFksMf;A2D/mME;EACE,gBAAA;A3DinMJ;A2D9mME;EACE,mBAAA;A3DgnMJ;A2D7mME;EAKE,uBAAA;A3D2mMJ;A2D/mMI;EACE,0BAAA;A3DinMN;A2D3mME;EACE,eAAA;A3D6mMJ;A2D1mME;EACE,gBAAA;A3D4mMJ;A2DzmME;EACE,gBAAA;A3D2mMJ;A2DxmME;EACE,iBAAA;A3D0mMJ;A2DxmMI;EACE,kBAAA;A3D0mMN;;A4DtuMI;EACI,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;A5DyuMR;A4DtuMI;EACI,oCAAA;A5DwuMR;;A6DlvMI;EACI,cAAA;EACA,qBAAA;EACA,uBAAA;A7DqvMR;A6DpvMQ;EACI,kCAAA;EACA,yBAAA;EACA,qBAAA;A7DsvMZ;A6DlvMI;EACI,yBAAA;A7DovMR;;A8DhwMI;EACI,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;A9DmwMR;A8DhwMI;EACI,oCAAA;A9DkwMR;;A+D7wMA;EACE,kBAAA;A/DgxMF;A+D9wME;EACE,uBAAA;EACA,WAAA;EAEA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;A/D8wMJ;A+D5wMI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A/D8wMN;A+D5wMM;EACE,eAAA;EAEA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;A/D6wMR;A+DxwME;EACE,iBAAA;A/D0wMJ;A+DxwMI;EACE,mBAAA;A/D0wMN;A+DzwMM;EACE,kBAAA;A/D2wMR;A+DtwME;EACE,eAAA;EAEA,sBAAA;EACA,YAAA;EACA,yBAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;EAEA,mBAAA;EACA,0CAAA;EACA,oCAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;A/DowMJ;A+DlwMI;EACE,UAAA;EACA,WAAA;EACA,gBAAA;A/DowMN;;AgE50MA;EACI;IAAK,wBAAA;EhEg1MP;EgE/0ME;IAAM,2BAAA;EhEk1MR;EgEj1ME;IAAM,0BAAA;EhEo1MR;EgEn1ME;IAAM,2BAAA;EhEs1MR;EgEr1ME;IAAO,0BAAA;EhEw1MT;AACF;AiE91MA;EACE,aAAA;EACA,8BAAA;EACA,8BAAA;AjEg2MF;AiE/1ME;;EAEE,UAAA;AjEi2MJ;AiE/1ME;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AjEi2MJ;AiEh2MI;EACE,mBAAA;AjEk2MN;AiEh2MI;EACE,mBAAA;AjEk2MN;AiEh2MI;EACE,WAAA;AjEk2MN;AiEh2MI;EACE,gBAAA;EACA,c/DNQ;AFw2Md;AiEh2MI;EACE,gBAAA;AjEk2MN;AiE/1MM;EACE,cAAA;AjEi2MR;AiE/1MM;EACE,0BAAA;AjEi2MR;AiE91MI;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;AjEg2MN;AiE/1MM;EACE,0BAAA;AjEi2MR;AiE51ME;EACE,iBAAA;EACA,UAAA;EAEA,yBAAA;EAEA,kBAAA;AjE41MJ;AiE11MI;EACE,kBAAA;EACA,kBAAA;AjE41MN;AiEz1MI;EACE,mBAAA;AjE21MN;AiEx1MI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EAEA,mBAAA;AjEy1MN;AiEt1MI;EAIE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AjEq1MN;AiE71MM;EACE,gBAAA;AjE+1MR;AiEr1MI;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EAEA,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,+BAAA;AjEs1MN;AiEl1ME;EACE,mBAAA;EACA,2BAAA;AjEo1MJ;AiEl1MI;EACE,WAAA;EACA,kBAAA;EAEA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AjEm1MN;AiEj1MM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,cAAA;EACA,kBAAA;EACA,kBAAA;AjEk1MR;AiE90MI;EACE,WAAA;EAEA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AjE+0MN;AiE70MM;EACE,gBAAA;AjE+0MR;AiE30MI;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;EAEA,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,+BAAA;AjE40MN;AiEx0ME;EACE;IACE,aAAA;EjE00MJ;EiEz0MI;IACE,YAAA;EjE20MN;AACF","sourcesContent":["@charset \"UTF-8\";\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n.container {\n  max-width: 1300px;\n  width: 100%;\n}\n\n.disabled {\n  opacity: 0.6;\n  cursor: not-allowed !important;\n}\n.disabled label {\n  cursor: not-allowed !important;\n}\n\n.cards-step-2 .body-card {\n  color: #6e7889;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-bottom: 4px;\n}\n.cards-step-2 iframe {\n  width: 100%;\n  height: 120px;\n  border: none;\n  background-color: transparent;\n}\n.cards-step-2 .UploadDocs .input-content {\n  height: 78px;\n}\n.cards-step-2 .UploadDocs .input-content input {\n  height: 78px;\n}\n\n.card__generic {\n  border-radius: 10px;\n  border: 1px solid #929fb0;\n  box-shadow: 0px 0px 3px 0px rgba(11, 19, 26, 0.18);\n  width: 100%;\n  padding: 16px;\n}\n\n.form-item__input,\n.form-item .ant-input {\n  padding: 12px 0;\n  border: 0;\n  border-bottom: 1px solid #404859;\n  border-radius: 0;\n}\n.form-item__input::placeholder,\n.form-item .ant-input::placeholder {\n  color: #929fb0;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.card-upload {\n  border-radius: 10px;\n  border: 1px solid #2a2f3c;\n  padding: 12px 16px;\n  box-shadow: 0px 0px 3px 0px rgba(11, 19, 26, 0.18);\n}\n.card-upload .link {\n  color: #6e7889;\n  text-align: right;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-decoration-line: underline;\n}\n.card-upload p {\n  margin: 10px 0;\n}\n\n.flex-btw {\n  display: flex;\n  justify-content: space-between;\n}\n\n.flex-end {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.flex-start {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.flex-col {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n}\n\n.mt-20 {\n  margin-top: 20px;\n}\n.mt-25 {\n  margin-top: 25px;\n}\n.mt-30 {\n  margin-top: 30px;\n}\n.mt-40 {\n  margin-top: 40px;\n}\n.mt-50 {\n  margin-top: 50px;\n}\n.mt-60 {\n  margin-top: 60px;\n}\n.mt-12 {\n  margin-top: 12px;\n}\n.mt-6 {\n  margin-top: 6px;\n}\n.mt-5 {\n  margin-top: 5px;\n}\n.mt-10 {\n  margin-top: 10px;\n}\n.mt-15 {\n  margin-top: 15px;\n}\n\n.divider-top {\n  border-top: 1px solid #afbdcc;\n}\n\n.input-transparent {\n  background-color: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 0;\n}\n.input-number {\n  width: 100%;\n  height: 48px;\n  border-radius: 10px;\n  border: 1px solid #2a2f3c;\n  background: #fff;\n}\n.input-number .ant-input-number-input-wrap {\n  height: 45px;\n}\n.input-number .ant-input-number-input-wrap .ant-input-number-input {\n  height: 45px;\n}\n.input-number .ant-input-prefix {\n  color: #404859;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 400;\n}\n.input-number input::placeholder {\n  color: #929fb0;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 400;\n}\n.input-placeholder-bold::placeholder {\n  color: #9bbceb;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.body-placeholder::placeholder {\n  color: #929fb0;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 600;\n  line-height: normal;\n}\n.body-placeholder-w4::placeholder {\n  font-weight: 400;\n}\n\n.fz-14 {\n  font-size: 14px;\n}\n\n.fz-12 {\n  font-size: 12px;\n}\n\n.children {\n  padding-bottom: 20px;\n}\n\n/* http://meyerweb.com/eric/tools/css/reset/\n   v2.0-modified | 20110126\n   License: none (public domain)\n*/\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  margin: 0;\n  height: 100%;\n}\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n\n/* make sure to set some focus styles for accessibility */\n:focus {\n  outline: 0;\n}\n\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\nbody {\n  line-height: 1;\n}\n\nol,\nul {\n  list-style: none;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\ninput[type=search]::-webkit-search-cancel-button,\ninput[type=search]::-webkit-search-decoration,\ninput[type=search]::-webkit-search-results-button,\ninput[type=search]::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\ninput[type=search] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\ntextarea {\n  overflow: auto;\n  vertical-align: top;\n  resize: vertical;\n}\n\n/**\n   * Correct `inline-block` display not defined in IE 6/7/8/9 and Firefox 3.\n   */\naudio,\ncanvas,\nvideo {\n  display: inline-block;\n  *display: inline;\n  *zoom: 1;\n  max-width: 100%;\n}\n\n/**\n   * Prevent modern browsers from displaying `audio` without controls.\n   * Remove excess height in iOS 5 devices.\n   */\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n   * Address styling not present in IE 7/8/9, Firefox 3, and Safari 4.\n   * Known issue: no IE 6 support.\n   */\n[hidden] {\n  display: none;\n}\n\n/**\n   * 1. Correct text resizing oddly in IE 6/7 when body `font-size` is set using\n   *    `em` units.\n   * 2. Prevent iOS text size adjust after orientation change, without disabling\n   *    user zoom.\n   */\nhtml {\n  font-size: 100%; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n  -ms-text-size-adjust: 100%; /* 2 */\n}\n\n/**\n   * Address `outline` inconsistency between Chrome and other browsers.\n   */\na:focus {\n  outline: thin dotted;\n}\n\n/**\n   * Improve readability when focused and also mouse hovered in all browsers.\n   */\na:active,\na:hover {\n  outline: 0;\n}\n\n/**\n   * 1. Remove border when inside `a` element in IE 6/7/8/9 and Firefox 3.\n   * 2. Improve image quality when scaled in IE 7.\n   */\nimg {\n  border: 0; /* 1 */\n  -ms-interpolation-mode: bicubic; /* 2 */\n}\n\n/**\n   * Address margin not present in IE 6/7/8/9, Safari 5, and Opera 11.\n   */\nfigure {\n  margin: 0;\n}\n\n/**\n   * Correct margin displayed oddly in IE 6/7.\n   */\nform {\n  margin: 0;\n}\n\n/**\n   * Define consistent border, margin, and padding.\n   */\nfieldset {\n  border: 0px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n/**\n   * 1. Correct color not being inherited in IE 6/7/8/9.\n   * 2. Correct text not wrapping in Firefox 3.\n   * 3. Correct alignment displayed oddly in IE 6/7.\n   */\nlegend {\n  border: 0; /* 1 */\n  padding: 0;\n  white-space: normal; /* 2 */\n  *margin-left: -7px; /* 3 */\n}\n\n/**\n   * 1. Correct font size not being inherited in all browsers.\n   * 2. Address margins set differently in IE 6/7, Firefox 3+, Safari 5,\n   *    and Chrome.\n   * 3. Improve appearance and consistency in all browsers.\n   */\nbutton,\ninput,\nselect,\ntextarea {\n  font-size: 100%; /* 1 */\n  margin: 0; /* 2 */\n  vertical-align: baseline; /* 3 */\n  *vertical-align: middle; /* 3 */\n}\n\n/**\n   * Address Firefox 3+ setting `line-height` on `input` using `!important` in\n   * the UA stylesheet.\n   */\nbutton,\ninput {\n  line-height: normal;\n}\n\n/**\n   * Address inconsistent `text-transform` inheritance for `button` and `select`.\n   * All other form control elements do not inherit `text-transform` values.\n   * Correct `button` style inheritance in Chrome, Safari 5+, and IE 6+.\n   * Correct `select` style inheritance in Firefox 4+ and Opera.\n   */\nbutton,\nselect {\n  text-transform: none;\n}\n\n/**\n   * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n   *    and `video` controls.\n   * 2. Correct inability to style clickable `input` types in iOS.\n   * 3. Improve usability and consistency of cursor style between image-type\n   *    `input` and others.\n   * 4. Remove inner spacing in IE 7 without affecting normal text inputs.\n   *    Known issue: inner spacing remains in IE 6.\n   */\nbutton,\nhtml input[type=button],\ninput[type=reset],\ninput[type=submit] {\n  -webkit-appearance: button; /* 2 */\n  cursor: pointer; /* 3 */\n  *overflow: visible; /* 4 */\n}\n\n/**\n   * Re-set default cursor for disabled elements.\n   */\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n\n/**\n   * 1. Address box sizing set to content-box in IE 8/9.\n   * 2. Remove excess padding in IE 8/9.\n   * 3. Remove excess padding in IE 7.\n   *    Known issue: excess padding remains in IE 6.\n   */\ninput[type=checkbox],\ninput[type=radio] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n  *height: 13px; /* 3 */\n  *width: 13px; /* 3 */\n}\n\n/**\n   * 1. Address `appearance` set to `searchfield` in Safari 5 and Chrome.\n   * 2. Address `box-sizing` set to `border-box` in Safari 5 and Chrome\n   *    (include `-moz` to future-proof).\n   */\ninput[type=search] {\n  -webkit-appearance: textfield; /* 1 */\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box; /* 2 */\n  box-sizing: content-box;\n}\n\n/**\n   * Remove inner padding and search cancel button in Safari 5 and Chrome\n   * on OS X.\n   */\ninput[type=search]::-webkit-search-cancel-button,\ninput[type=search]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n   * Remove inner padding and border in Firefox 3+.\n   */\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n/**\n   * 1. Remove default vertical scrollbar in IE 6/7/8/9.\n   * 2. Improve readability and alignment in all browsers.\n   */\ntextarea {\n  overflow: auto; /* 1 */\n  vertical-align: top; /* 2 */\n}\n\n/**\n   * Remove most spacing between table cells.\n   */\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\nhtml,\nbutton,\ninput,\nselect,\ntextarea {\n  color: #222;\n}\n\n::-moz-selection {\n  background: #b3d4fc;\n  text-shadow: none;\n}\n\n::selection {\n  background: #b3d4fc;\n  text-shadow: none;\n}\n\nimg {\n  vertical-align: middle;\n}\n\nfieldset {\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\ntextarea {\n  resize: vertical;\n}\n\n.chromeframe {\n  margin: 0.2em 0;\n  background: #ccc;\n  color: #000;\n  padding: 0.2em 0;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n.h1 {\n  color: #404859;\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.h2 {\n  color: #2a2f3c;\n  font-family: Inter;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 120%;\n}\n.h2-w8 {\n  font-weight: 800;\n}\n\n.h3 {\n  color: #2a2f3c;\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 135%;\n}\n\n.h4 {\n  color: #2a2f3c;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 115%;\n}\n.h4-cp {\n  text-transform: capitalize;\n}\n.h4-w4 {\n  font-weight: 400;\n}\n.h4-w5 {\n  font-weight: 500;\n}\n\n.title-blue-bold {\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  color: #355c7d;\n}\n\n.body-regular {\n  color: #404859;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.body-regular-italic {\n  font-style: italic;\n}\n.body-regular-up {\n  text-transform: uppercase;\n}\n.body-regular-bold, .body-regular-w6 {\n  font-weight: 600;\n}\n.body-regular-w5 {\n  font-weight: 500;\n}\n\n.placeholder {\n  color: #929fb0;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.placeholder-w6 {\n  font-weight: 600;\n}\n\n.button-txt-big {\n  color: #f5faff;\n  text-align: center;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.24px;\n}\n\n.body-small {\n  color: #404859;\n  font-family: Inter;\n  font-size: 10px !important;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.body-small-w4 {\n  font-weight: 400;\n}\n.body-small-w6 {\n  font-weight: 600;\n}\n.body-small-up {\n  text-transform: uppercase;\n}\n\n.small-detail {\n  color: #6e7889;\n  font-family: Inter;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.body-card {\n  color: #404859;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n}\n.body-card-bold-line {\n  font-weight: 700;\n  text-decoration-line: underline;\n}\n.body-card-w6 {\n  font-weight: 600;\n}\n.body-card-w7 {\n  font-weight: 700;\n}\n.body-card-w5 {\n  font-weight: 500;\n}\n\n.blue-bold {\n  color: #5e8eb7;\n  cursor: pointer;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 145%;\n}\n.blue-bold img {\n  height: 10px;\n  margin-left: 5px;\n}\n\n.bold {\n  font-weight: 600;\n}\n\n.bold-little {\n  font-weight: 500;\n}\n\n.cursor {\n  cursor: pointer;\n}\n\n.disabled {\n  color: #2A2F3C !important;\n}\n.disabled div {\n  border-color: #AFBDCC !important;\n}\n\n.button {\n  height: 32px;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.button-empty {\n  background-color: transparent;\n  padding: 0;\n  border: none;\n  box-shadow: none;\n}\n.button-empty span {\n  color: #404859 !important;\n  font-family: Inter;\n  font-size: 10px !important;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n  letter-spacing: 0.2px;\n}\n.button-modal-ok {\n  width: 100%;\n  border-radius: 6px;\n  border: 1px solid #ffc857 !important;\n  background: #ffc857 !important;\n  height: 40px;\n  color: #66564d !important;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.21px;\n}\n.button-modal-cancel {\n  width: 100%;\n  border-radius: 6px;\n  border: 1px solid #ddaa42 !important;\n  background: #fff9ee !important;\n  height: 40px;\n  color: #3c302a !important;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 0.21px;\n}\n.button-primary {\n  width: 100%;\n  height: 48px;\n  flex-shrink: 0;\n  border-radius: 6px;\n  border: 1px solid #162e43;\n  background: #162e43;\n  border: none;\n}\n.button-primary:hover {\n  border: none;\n  color: #f5faff !important;\n}\n.button-secondary {\n  width: 179px;\n  border-radius: 6px;\n  border: 1px solid #355c7d;\n  color: #355c7d;\n}\n.button-secondary:hover {\n  color: #355c7d !important;\n  border: 1px solid #355c7d !important;\n}\n.button-grey {\n  color: #6e7889 !important;\n  text-align: center;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.18px;\n  border-radius: 6px;\n  border: 1px solid #eff3f5 !important;\n  background: #eff3f5;\n  width: 100%;\n}\n.button-transparent {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  color: #48759a;\n}\n.button-transparent .anticon {\n  color: #48759a;\n}\n.button-transparent:hover {\n  color: #48759a !important;\n}\n.button-gray {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  color: #afbdcc;\n}\n.button-gray .anticon {\n  color: #afbdcc;\n}\n.button-gray:hover {\n  color: #afbdcc !important;\n}\n.button-card {\n  width: 100%;\n  color: #000000;\n  border: 1px solid #ccd3db;\n}\n.button-card:hover {\n  color: #000000 !important;\n  border: 1px solid #ccd3db !important;\n}\n.button-submit {\n  border-radius: 6px;\n  border: 1px solid #122536 !important;\n  background: #122536 !important;\n  color: #fff !important;\n  text-align: center;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.18px;\n  width: 100%;\n}\n.button-submit-delete {\n  all: unset;\n  border: none !important;\n  background-color: transparent !important;\n}\n.button-submit-delete:hover {\n  background: none !important;\n  border-color: transparent !important;\n}\n.button-submit:disabled {\n  background-color: #DFE4EB !important;\n  border-color: #DFE4EB !important;\n}\n.button-submit:disabled span {\n  color: #929FB0 !important;\n}\n.button-submit:disabled:hover {\n  background-color: #DFE4EB !important;\n  border-color: #DFE4EB !important;\n}\n.button-submit:disabled:hover span {\n  color: #929FB0 !important;\n}\n.button-submit:not(.button-submit-delete):hover {\n  background-color: #EBF6FF !important;\n  border-color: #EBF6FF !important;\n}\n.button-submit:not(.button-submit-delete):hover span {\n  color: #355D7D !important;\n}\n.button-link {\n  width: 100%;\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  font-weight: 400;\n  color: #000000;\n}\n.button-link:hover {\n  color: #000000 !important;\n}\n.button-link-REVIEW {\n  color: #161616 !important;\n}\n.button-link-border {\n  width: 100%;\n  border-radius: 6px;\n  border: 1px solid #162E43 !important;\n  background: none;\n  color: #3c302a !important;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 0.21px;\n}\n.button-link-border:disabled {\n  background-color: #DFE4EB !important;\n  border-color: #DFE4EB !important;\n  color: #929FB0 !important;\n}\n.button-link-blue {\n  color: #5E8EB7;\n}\n.button-link-blue span {\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  text-decoration-line: underline;\n}\n.button-link-blue:hover {\n  color: #5E8EB7 !important;\n}\n.button-blue {\n  color: #5E8EB7;\n}\n.button-blue span {\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.button-blue:hover {\n  color: #5E8EB7 !important;\n}\n.button-open-modal {\n  width: 100%;\n}\n.button-open-modal:hover {\n  border-color: #ccd3db !important;\n  color: #000000 !important;\n}\n.button-open-modal-REVIEW {\n  border-color: #AC78B3;\n  color: #161616;\n}\n.button-open-modal-REVIEW:hover {\n  border-color: #AC78B3 !important;\n  background-color: #693B6F !important;\n  color: white !important;\n}\n\n.select-primary {\n  width: 100%;\n  height: 40px;\n}\n.select-primary .ant-select-selector {\n  height: 40px !important;\n  padding: 2px 11px !important;\n  border-radius: 10px !important;\n  border: 1px solid #5e8eb7 !important;\n}\n.select-primary .ant-select-selector .ant-select-selection-search-input {\n  height: 40px !important;\n}\n\n.circle {\n  background-color: #fff;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1px solid #2a2f3c;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.circle .upload {\n  width: auto;\n  height: 18px;\n  object-fit: cover;\n}\n\n.circles-tags {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 8px;\n}\n\n.circle-state-tooltip {\n  padding: 6px 7px !important;\n  opacity: 1 !important;\n}\n.circle-state-tooltip b {\n  font-weight: 600;\n}\n.circle-state-tooltip span {\n  margin-top: 10px;\n}\n.circle-state-tooltip-APPROVED {\n  background-color: #549358 !important;\n}\n.circle-state-tooltip-DRAFT {\n  background-color: #404859 !important;\n}\n.circle-state-tooltip-REQUEST_ERROR {\n  background-color: #c94f4a !important;\n}\n.circle-state-tooltip-REVIEW {\n  background-color: #855791 !important;\n}\n\n.error-box {\n  width: 100%;\n  min-height: 43px;\n  top: 615px;\n  left: 126px;\n  border-width: 1px;\n  border-radius: 6px;\n  border: 1px solid #DDAA42;\n  background: #FCF8F7;\n  padding: 10px 16px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.error-box span {\n  font-family: Inter;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 145%;\n  color: #775614;\n  flex: 1;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n.error-box img {\n  padding-left: 6px;\n  flex-shrink: 0;\n}\n\n.DrodownBasic {\n  height: 40px;\n  padding: 1px 3px !important;\n  display: flex;\n  align-items: center;\n  border: 1px solid #6E7889;\n  width: 100%;\n}\n.DrodownBasic span {\n  color: #6E7889;\n  padding-left: 16px;\n}\n.DrodownBasic-blue {\n  border: 1px solid #9BBCEB;\n  border-radius: 10px;\n}\n.DrodownBasic-blue .ant-dropdown-menu {\n  padding: 0px;\n  width: 160px;\n}\n.DrodownBasic-blue .ant-dropdown-menu-item:hover {\n  background-color: #EBF6FF !important;\n}\n.DrodownBasic-blue .ant-dropdown-menu-item:hover .ant-dropdown-menu-title-content {\n  color: #355c7d;\n  font-weight: 600;\n}\n.DrodownBasic-blue .ant-dropdown-menu-title-content {\n  color: #5E8EB7;\n  font-weight: 400;\n}\n.DrodownBasic-blue .ant-dropdown-menu-title-content:hover {\n  color: #355c7d;\n  font-weight: 600;\n}\n\n.checkbox-basic .ant-checkbox-wrapper {\n  color: #244560;\n}\n.checkbox-basic .ant-checkbox-wrapper:hover .ant-checkbox-inner {\n  border: 1px solid #5E8EB7 !important;\n}\n.checkbox-basic .ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #5E8EB7 !important;\n}\n.checkbox-basic .ant-checkbox,\n.checkbox-basic .ant-checkbox-input {\n  border: none;\n}\n.checkbox-basic .ant-checkbox:hover .ant-checkbox-inner,\n.checkbox-basic .ant-checkbox-input:hover .ant-checkbox-inner {\n  border: 1px solid #5E8EB7 !important;\n}\n.checkbox-basic .ant-checkbox:hover .ant-checkbox-checked .ant-checkbox-inner,\n.checkbox-basic .ant-checkbox-input:hover .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #5E8EB7 !important;\n}\n.checkbox-basic .ant-checkbox-inner {\n  width: 18px;\n  height: 18px;\n  border: 1px solid #5E8EB7;\n}\n.checkbox-basic .ant-checkbox-disabled .ant-checkbox-inner {\n  border-radius: 2px;\n  background: #DFE4EB !important;\n  border: 1px solid #DFE4EB;\n}\n.checkbox-basic .ant-checkbox-checked:hover .ant-checkbox-inner {\n  background-color: #5E8EB7 !important;\n}\n.checkbox-basic .ant-checkbox-checked .ant-checkbox-inner {\n  border-radius: 2px;\n  background: #5E8EB7;\n}\n\n.Layout {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n.Layout .content {\n  width: 100%;\n}\n.Layout .BarLogin {\n  padding: 16px;\n  background-color: #eff3f5;\n  width: 64px;\n  height: 100vh;\n  border-right: 1px solid #dfe4eb;\n}\n.Layout .BarLogin .logo {\n  width: 32px;\n}\n\n.select-section-selected .ant-select-selector {\n  background: #F5FAFF !important;\n  border: 1px solid #5E8EB7 !important;\n  padding-left: 10px !important;\n}\n.select-section-selected .ant-select-selector .ant-select-selection-item {\n  color: #355C7D !important;\n}\n.select-section-selected .ant-select-selector .ant-select-selection-item-content {\n  color: #5E8EB7 !important;\n}\n.select-section .ant-select {\n  display: block;\n  height: 40px;\n  margin-top: 6px;\n}\n.select-section .ant-select .ant-select-selection-placeholder {\n  margin-bottom: 0;\n  color: #6E7889 !important;\n}\n\n.ant-select-dropdown div {\n  color: #6E7889;\n}\n.ant-select-dropdown .anticon {\n  display: none;\n}\n.ant-select-dropdown .circle {\n  width: 14px !important;\n  height: 14px !important;\n  border-color: #CCD3DB;\n}\n\n.ant-select-outlined.ant-select-multiple .ant-select-selection-item {\n  background: none;\n  border: none;\n}\n.ant-select-outlined.ant-select-multiple .ant-select-selection-item span {\n  color: rgb(53, 92, 125) !important;\n}\n\n.ant-select-item-option-selected .ant-select-item-option-content div {\n  color: #48759A !important;\n}\n\n.task-item-list .circle-state-tooltip {\n  padding: 6px 7px;\n  opacity: 1;\n}\n.task-item-list .circle-state-tooltip b {\n  font-weight: 600;\n}\n.task-item-list .circle-state-tooltip span {\n  margin-top: 10px;\n}\n.task-item-list .circle-state-tooltip-APPROVED {\n  background-color: #549358;\n}\n.task-item-list .circle-state-tooltip-DRAFT {\n  background-color: #c0cad7;\n}\n.task-item-list .circle-state-tooltip-REQUEST_ERROR {\n  background-color: #c94f4a;\n}\n.task-item-list .circle-state-tooltip-REVIEW {\n  background-color: #855791;\n}\n.task-item-list .circles-tags {\n  display: flex;\n  align-items: end;\n  gap: 20px;\n  margin-top: 5px;\n}\n.task-item-list .circle {\n  width: 16px;\n  height: 16px;\n}\n.task-item-list .circle-APPROVED {\n  background-color: #6eac72;\n  border-color: #587e5b;\n}\n.task-item-list .circle-APPROVED:hover {\n  background-color: #549358;\n}\n.task-item-list .circle-APPROVED-active {\n  background-color: #549358;\n}\n.task-item-list .circle-REVIEW {\n  background-color: #AC78B3;\n  border-color: #AC78B3;\n}\n.task-item-list .circle-REVIEW:hover {\n  background-color: #855791;\n}\n.task-item-list .circle-REVIEW-active {\n  background-color: #855791;\n}\n.task-item-list .circle-REQUEST_ERROR {\n  background-color: #FFD4CF;\n  border-color: #c94f4a;\n}\n.task-item-list .circle-REQUEST_ERROR:hover {\n  background-color: #c94f4a;\n}\n.task-item-list .circle-REQUEST_ERROR-active {\n  background-color: #c94f4a;\n}\n.task-item-list .circle-DRAFT {\n  background-color: #DFE4EB;\n  border: 1px solid #CCD3DB;\n}\n.task-item-list .circle-DRAFT:hover {\n  background-color: #cfd7e1;\n}\n.task-item-list .circle-DRAFT-active {\n  background-color: #cfd7e1;\n}\n.task-item-list .circle-INCOMPLETE {\n  background-color: #2a2f3c;\n  border: 1px solid #2a2f3c;\n}\n.task-item-list .circle-INCOMPLETE:hover {\n  background-color: #20232d;\n}\n.task-item-list .circle-INCOMPLETE-active {\n  background-color: #20232d;\n}\n\n.LoanProgress {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n}\n.LoanProgress .tab {\n  margin: 0 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.LoanProgress .tab .popover-label {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n.LoanProgress .tab .bar-status {\n  cursor: pointer;\n  width: 100%;\n  width: calc(100% + 20px);\n  height: 8px;\n  border-radius: 16px;\n  margin-top: 6px;\n  background-color: #dfe4eb;\n}\n.LoanProgress .tab-complete .text-status {\n  color: #141F15;\n}\n.LoanProgress .tab-complete .body-small {\n  color: #2D7032;\n}\n.LoanProgress .tab-complete .bar-status {\n  background-color: #4CA852;\n}\n.LoanProgress .tab-complete .bar-status-selected {\n  background-color: #2D7032;\n}\n.LoanProgress .tab-complete .bar-status-selected:hover {\n  background-color: #2D7032 !important;\n}\n.LoanProgress .tab-complete .bar-status:hover {\n  background-color: #3F9545;\n}\n.LoanProgress .tab-complete .bar-status:hover .body-small {\n  color: #2D7032;\n}\n.LoanProgress .tab-blocked .body-small {\n  color: #8A130F;\n}\n.LoanProgress .tab-blocked .text-status {\n  color: #610805;\n}\n.LoanProgress .tab-blocked .bar-status {\n  background-color: #C13934;\n}\n.LoanProgress .tab-blocked .bar-status-selected {\n  background-color: #8A130F;\n}\n.LoanProgress .tab-blocked .bar-status-selected:hover {\n  background-color: #8A130F !important;\n}\n.LoanProgress .tab-blocked .bar-status:hover {\n  background-color: #A31C17;\n}\n.LoanProgress .tab-blocked .bar-status:hover .body-small {\n  color: #8A130F;\n}\n.LoanProgress .tab-error .body-small {\n  color: #8A130F;\n}\n.LoanProgress .tab-error .text-status {\n  color: #610805;\n}\n.LoanProgress .tab-error .bar-status {\n  background-color: #FFDAD6;\n}\n.LoanProgress .tab-error .bar-status-selected {\n  background-color: #8A130F;\n}\n.LoanProgress .tab-error .bar-status-selected:hover {\n  background-color: #8A130F !important;\n}\n.LoanProgress .tab-error .bar-status:hover {\n  background-color: #C13934;\n}\n.LoanProgress .tab-error .bar-status:hover .body-small {\n  color: #8A130F;\n}\n.LoanProgress .tab-progress .text-status {\n  color: #122536;\n}\n.LoanProgress .tab-progress .body-small {\n  color: #404859;\n}\n.LoanProgress .tab-progress .bar-status {\n  background-color: #5E8EB7;\n}\n.LoanProgress .tab-progress .bar-status-selected {\n  background-color: #355C7D;\n}\n.LoanProgress .tab-progress .bar-status-selected:hover {\n  background-color: #355C7D !important;\n}\n.LoanProgress .tab-progress .bar-status:hover {\n  background-color: #48759A;\n}\n.LoanProgress .tab-progress .bar-status:hover .body-small {\n  color: #404859;\n}\n.LoanProgress .tab-not-started .bar-status {\n  background-color: white;\n  border: 1px solid #404859;\n}\n.LoanProgress .tab-not-started .bar-status-selected {\n  background-color: #404859;\n}\n.LoanProgress .tab-not-started .bar-status-selected:hover {\n  background-color: #404859 !important;\n}\n.LoanProgress .tab-not-started .bar-status:hover {\n  background-color: #929FB0;\n}\n.LoanProgress .tab-open-content {\n  position: absolute;\n  border: 1px solid #929FB0;\n  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.1019607843);\n  height: auto;\n  min-height: 253px;\n  width: 825px;\n  background: white;\n  top: 150px;\n  border-radius: 10px;\n  z-index: 99;\n}\n.LoanProgress .tab-open-content .content-bar-status {\n  width: 823px;\n  height: 68px;\n  background: white;\n  border-radius: 10px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: start;\n  gap: 8px;\n  padding-left: 8px;\n  padding-top: 3px;\n}\n.LoanProgress .tab-open-content .content-bar-status .tab .body-small {\n  font-size: 12px !important;\n}\n.LoanProgress .tab-open-content .content-bar-status .tab-error span {\n  color: #610805;\n}\n.LoanProgress .tab-open-content .content-bar-status .bar-status {\n  width: -webkit-fill-available;\n  height: 16px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.LoanProgress .tab-open-content .content-bar-status .bar-status .text-status {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n}\n.LoanProgress .tab-open-content .content-bar-status .bar-status .text-status span {\n  font-family: Inter;\n  font-size: 10px;\n  font-weight: 600;\n}\n.LoanProgress .tab-open-content .content-bar-status .bar-status:hover span {\n  display: none;\n}\n.LoanProgress .tab-open-content .content-bar-status .bar-status:hover .text-status {\n  display: none;\n}\n.LoanProgress .tab-open-content .content-bar-status .tab {\n  margin: 0 0;\n}\n.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(1) {\n  width: 10%;\n}\n.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(2) {\n  width: 22%;\n}\n.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(3) {\n  width: 38%;\n}\n.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(4) {\n  width: 14%;\n}\n.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(5) {\n  width: 11%;\n}\n.LoanProgress .tab-open-content .content-phase-select {\n  width: 823px;\n  height: auto;\n  min-height: 183px;\n  border-radius: 10px;\n  background: #F9FAFB;\n  border-top: 1px solid #DFE4EB;\n}\n.LoanProgress .tab-open-content .content-phase-select-complete {\n  background: #F8FFF8;\n  border-top: 1px solid #C2F0C5;\n}\n.LoanProgress .tab-open-content .content-phase-select-complete .tag-state {\n  background: #C2F0C5;\n}\n.LoanProgress .tab-open-content .content-phase-select-complete .tag-state b,\n.LoanProgress .tab-open-content .content-phase-select-complete .tag-state span {\n  color: #141F15;\n}\n.LoanProgress .tab-open-content .content-phase-select-complete .content-phase b {\n  color: #1F4222;\n}\n.LoanProgress .tab-open-content .content-phase-select-complete .content-phase p {\n  color: #1F4222 !important;\n}\n.LoanProgress .tab-open-content .content-phase-select-complete .content-phase-first b {\n  color: #2D7032;\n}\n.LoanProgress .tab-open-content .content-phase-select-blocked {\n  background: #FCF8F7;\n  border-top: 1px solid #FFC6BF;\n}\n.LoanProgress .tab-open-content .content-phase-select-blocked .tag-state {\n  background: #FFD4CF;\n}\n.LoanProgress .tab-open-content .content-phase-select-blocked .tag-state b,\n.LoanProgress .tab-open-content .content-phase-select-blocked .tag-state span {\n  color: #610805;\n}\n.LoanProgress .tab-open-content .content-phase-select-blocked .content-phase b {\n  color: #2A2F3C;\n}\n.LoanProgress .tab-open-content .content-phase-select-blocked .content-phase-first b {\n  color: #610805;\n}\n.LoanProgress .tab-open-content .content-phase-select-error {\n  background: #FCF8F7;\n  border-top: 1px solid #FFC6BF;\n}\n.LoanProgress .tab-open-content .content-phase-select-error .tag-state {\n  background: #FFD4CF;\n}\n.LoanProgress .tab-open-content .content-phase-select-error .tag-state b,\n.LoanProgress .tab-open-content .content-phase-select-error .tag-state span {\n  color: #610805;\n}\n.LoanProgress .tab-open-content .content-phase-select-error .content-phase b {\n  color: #2A2F3C;\n}\n.LoanProgress .tab-open-content .content-phase-select-error .content-phase-first b {\n  color: #610805;\n}\n.LoanProgress .tab-open-content .content-phase-select-progress {\n  background: #F5FAFF;\n  border-top: 1px solid #B6DCFC;\n}\n.LoanProgress .tab-open-content .content-phase-select-progress .tag-state {\n  background: #B6DCFC;\n}\n.LoanProgress .tab-open-content .content-phase-select-progress .tag-state b,\n.LoanProgress .tab-open-content .content-phase-select-progress .tag-state span {\n  color: #122536;\n}\n.LoanProgress .tab-open-content .content-phase-select-progress .content-phase b {\n  color: #2A2F3C;\n}\n.LoanProgress .tab-open-content .content-phase-select-progress .content-phase-first b {\n  color: #244560;\n}\n.LoanProgress .tab-open-content .content-phase-select-not-started .tag-state {\n  border: 1px solid #404859;\n}\n.LoanProgress .tab-open-content .content-phase-select .tag-state {\n  height: 16px;\n  width: max-content;\n  display: flex;\n  align-items: center;\n  gap: 3.5px;\n  border-radius: 10px;\n  padding: 3px 7px;\n  margin: 16px 23px;\n}\n.LoanProgress .tab-open-content .content-phase-select .tag-state b {\n  font-size: 10px;\n  font-weight: 600;\n}\n.LoanProgress .tab-open-content .content-phase-select .tag-state span {\n  font-size: 10px;\n  font-weight: 400;\n}\n.LoanProgress .tab-open-content .content-phase-select .divider {\n  border: 0.7px solid #929FB0;\n  height: auto;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase {\n  margin: 0px 24px;\n  padding-bottom: 23px;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase b {\n  font-size: 12px;\n  font-weight: 600;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase p {\n  font-size: 12px;\n  font-weight: 400;\n  color: #2A2F3C;\n  margin-top: 6px;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase-first {\n  width: 270px;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase-first b {\n  font-size: 16px;\n  font-weight: 600;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase-second {\n  width: 240px;\n  margin-left: 20px;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase-third .task-item {\n  display: inline-flex;\n  max-width: 335px;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase-third .task-item .task-label {\n  min-width: 0;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase-third .task-item .task-label b {\n  display: inline;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-top: 4px;\n  width: max-content;\n  border-radius: 4px;\n  padding: 2px 3px;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item span {\n  font-family: Inter;\n  font-size: 12px;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item b {\n  font-family: Inter;\n  font-weight: 500;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item .bold {\n  font-weight: 600 !important;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item .circle {\n  width: 12px;\n  height: 12px;\n  border: 1px solid #6E7889;\n  border-radius: 50%;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED {\n  background-color: #D5F7E2;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED span,\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED b,\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED strong {\n  color: #2D7032;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR, .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED {\n  background: #FFC6BF;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR span,\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR b,\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR strong, .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED span,\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED b,\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED strong {\n  color: #610805;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW {\n  background: #F7EDFC;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW span,\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW b,\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW strong {\n  color: #855791;\n}\n\n.borrowers {\n  padding: 24px 25px;\n}\n.borrowers .dropdown-review-bold {\n  color: #AC78B3 !important;\n  height: 26px;\n  display: unset;\n  padding: 0 !important;\n}\n.borrowers .dropdown-review-bold span {\n  font-weight: 600;\n  text-decoration-line: underline;\n}\n.borrowers .top-container {\n  box-sizing: content-box;\n  width: 100%;\n  margin-bottom: 33px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: space-between;\n}\n.borrowers .top-container .title {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.borrowers .top-container .title > span {\n  cursor: pointer;\n  color: var(--blue60, #5E8EB7);\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-decoration-line: underline;\n}\n.borrowers .badges-container {\n  display: flex;\n}\n.borrowers-container {\n  padding: 16px 0px;\n}\n.borrowers-container > * {\n  margin-bottom: 16px;\n}\n.borrowers-container > *:last-child {\n  margin-bottom: 0px;\n}\n\n.search-box {\n  cursor: pointer;\n  box-sizing: border-box;\n  width: 384px;\n  padding: 5px 18px 5px 8px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-radius: 10px;\n  border: 1px solid var(--400-grey, #CCD3DB);\n  background: var(--gray-100, #F9FAFB);\n  color: var(--700-grey, #6E7889);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 120%;\n}\n.search-box > input {\n  all: unset;\n  width: 100%;\n  margin-left: 8px;\n}\n\n.status-badge {\n  cursor: pointer;\n  padding: 4px 12px;\n  border-radius: 100px;\n  display: flex;\n  align-items: center;\n  background: var(--300-grey, #DFE4EB);\n  margin-right: 12px;\n}\n.status-badge .title {\n  margin-right: 4px;\n  color: var(--800-grey, #404859);\n  text-align: right;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px; /* 133.333% */\n  white-space: nowrap;\n}\n.status-badge .count {\n  color: var(--800-grey, #404859);\n  text-align: right;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px; /* 133.333% */\n}\n.status-badge.selected {\n  background: #355C7D;\n}\n.status-badge.selected .title, .status-badge.selected .count {\n  color: #FFFFFF;\n}\n\n.borrower-list-item {\n  cursor: pointer;\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 10px 24px;\n  border-radius: 10px;\n  border: 1px solid var(--600-grey, #929FB0);\n  background: var(--white, #FFF);\n}\n.borrower-list-item > * {\n  flex: 1 1 0;\n  min-width: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.borrower-list-item > *.loan-status-badge-container {\n  flex: 0.8 1 0;\n}\n.borrower-list-item > *.borrower-summary-container {\n  flex: 0.7 1 0;\n}\n.borrower-list-item > *:last-child {\n  flex: 0 0 auto;\n  overflow: visible;\n  align-items: flex-end;\n}\n.borrower-list-item .loan-status-badge {\n  display: inline-block;\n  border-radius: 76px;\n  border: 1px solid var(--blue60, #5E8EB7);\n  padding: 4px 7px;\n  color: var(--70, #48759A);\n  text-align: center;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.2px;\n  text-transform: uppercase;\n}\n.borrower-list-item .borrower-summary .caption {\n  color: var(--700-grey, #6E7889);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 115%;\n  text-transform: capitalize;\n  margin-bottom: 2px;\n}\n.borrower-list-item .borrower-summary .borrower-name {\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 115%;\n  text-transform: capitalize;\n}\n.borrower-list-item .entities-summary .caption {\n  color: var(--700-grey, #6E7889);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 115%;\n  text-transform: capitalize;\n  margin-bottom: 2px;\n}\n.borrower-list-item .entities-summary .content {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 115%;\n  text-transform: capitalize;\n  white-space: nowrap;\n  display: flex;\n  gap: 3px;\n  align-items: center;\n  min-width: 0;\n  max-width: 100%;\n}\n.borrower-list-item .entities-summary .content > span:first-child {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n.borrower-list-item .task-summary {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.borrower-list-item .task-summary .address {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.borrower-list-item .task-summary .address > *:first-child {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n  flex: 0 1 auto;\n}\n.borrower-list-item .task-summary .address > *:not(:first-child) {\n  flex: 0 0 auto;\n}\n.borrower-list-item .task-summary .caption {\n  color: var(--700-grey, #6E7889);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 115%;\n  text-transform: capitalize;\n  margin-bottom: 2.5px;\n}\n.borrower-list-item .task-summary .task-item-container {\n  display: flex;\n  gap: 9px;\n}\n.borrower-list-item .task-summary .task-item-container .task-item {\n  box-sizing: border-box;\n  height: 15px;\n  width: 15px;\n  border-radius: 100px;\n  margin-right: 8px;\n  background-color: #DFE4EB;\n  border: 1.5px solid #CCD3DB;\n}\n.borrower-list-item .task-summary .task-item-container .task-item.completed {\n  background-color: #4CA852;\n  border: unset;\n}\n.borrower-list-item .task-summary .task-item-container .task-item.review {\n  background-color: #855791;\n  border: unset;\n}\n.borrower-list-item .action-container {\n  color: var(--blue60, #5E8EB7);\n  text-align: right;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  white-space: nowrap;\n  align-self: flex-end;\n}\n.borrower-list-item:hover {\n  border-radius: 10px;\n  border: 1px solid var(--blue-40, #97BCF0);\n  background: var(--10, #F5FAFF);\n  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);\n}\n.borrower-list-item:hover .borrower-summary .caption {\n  color: var(--70, #48759A);\n}\n.borrower-list-item:hover .borrower-summary .borrower-name {\n  color: var(--90, #244560);\n}\n.borrower-list-item:hover .address-summary .caption {\n  color: var(--70, #48759A);\n}\n.borrower-list-item:hover .address-summary .address {\n  color: var(--blue-80, #355C7D);\n}\n.borrower-list-item:hover .task-summary .caption {\n  color: var(--70, #48759A);\n}\n.borrower-list-item:hover .action-container {\n  color: var(--70, #48759A);\n  font-weight: 600;\n}\n.borrower-list-item:hover .action-container:hover {\n  color: var(--90, #244560);\n  font-weight: 700;\n}\n\n.right-scenes {\n  position: fixed;\n  background: rgba(42, 47, 60, 0.55);\n  backdrop-filter: blur(2px);\n  top: 0;\n  left: 70px;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.right-scenes-content {\n  position: relative;\n  width: calc(100% - 70px); /* Ancho de la pantalla menos 70px */\n  background-color: #fff;\n  height: 100%;\n  animation: slideIn 1s forwards;\n}\n@keyframes slideIn {\n  from {\n    transform: translateX(calc(-100% + 70px));\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n.right-scenes .button-close-mask {\n  width: 30%;\n  height: 100%;\n  background-color: rgba(255, 0, 0, 0);\n  box-shadow: none;\n  border: none;\n}\n.right-scenes .button-close-mask:hover, .right-scenes .button-close-mask:active, .right-scenes .button-close-mask:focus {\n  background-color: rgba(255, 0, 0, 0);\n  box-shadow: none;\n  border: none;\n}\n\n.view-borrower-detail {\n  padding: 50px 15px;\n}\n.view-borrower-detail-header .title {\n  color: #404859;\n  font-size: 32px;\n  font-weight: 600;\n  gap: 5px;\n}\n.view-borrower-detail-header .title button {\n  height: 32px;\n}\n.view-borrower-detail-header .title button span {\n  font-size: 32px;\n}\n.view-borrower-detail .button-r,\n.view-borrower-detail .button-r:hover {\n  width: 58px;\n  height: 20px;\n  border: 1px solid #bb8d2f;\n  color: #bb8d2f;\n  border-radius: 76px;\n  padding: 0;\n  font-family: Inter;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 12.1px;\n  margin: 0 15px;\n}\n.view-borrower-detail .button-delete,\n.view-borrower-detail .button-delete:hover {\n  height: 20px;\n  border: none;\n  color: #c94f4a;\n  padding: 0;\n  font-family: Inter;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 12.1px;\n  margin: 0 15px;\n}\n.view-borrower-detail .flex-2-col {\n  display: flex;\n  margin-top: 20px;\n  justify-content: space-between;\n  width: 100%;\n  gap: 30px;\n}\n.view-borrower-detail .flex-2-col .box {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 50%;\n}\n.view-borrower-detail .gap-3 {\n  gap: 6px;\n}\n.view-borrower-detail .card-profile-generic {\n  border: 1px solid #afbdcc;\n  border-radius: 10px;\n  padding: 15px;\n  width: 100%;\n}\n.view-borrower-detail .card-profile-generic .card-title {\n  font-family: Inter;\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 29.05px;\n  text-align: left;\n}\n.view-borrower-detail .card-profile-generic .table {\n  width: 100%;\n  margin-top: 10px;\n}\n.view-borrower-detail .card-profile-generic .table-row {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  margin-bottom: 7px;\n}\n.view-borrower-detail .card-profile-generic .table-row .title {\n  font-family: Inter;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14.52px;\n  text-align: left;\n  color: #6e7889;\n}\n.view-borrower-detail .card-profile-generic .table-row .flex {\n  display: flex;\n  justify-content: space-between;\n}\n.view-borrower-detail .card-profile-generic .table-row .flex .col {\n  width: 50%;\n}\n.view-borrower-detail .card-profile-generic .table-row .flex .col .italic {\n  font-family: Inter;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 400;\n  line-height: 16.94px;\n  text-align: left;\n  color: #929fb0;\n}\n.view-borrower-detail .card-profile-generic .avatar .ant-avatar-string {\n  font-size: 25px;\n}\n.view-borrower-detail .card-profile-generic .avatar .ant-upload {\n  width: 68px !important;\n  height: 68px !important;\n}\n.view-borrower-detail .card-profile-generic .ant-upload-wrapper.ant-upload-picture-circle-wrapper {\n  width: auto;\n}\n.view-borrower-detail .card-profile-generic .title-bold {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 16.94px;\n  text-align: left;\n  color: #404859;\n}\n.view-borrower-detail .card-profile-generic .title-bold .bold {\n  font-weight: 600;\n}\n.view-borrower-detail .card-profile-generic .body-bold {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 16.94px;\n  text-align: right;\n}\n.view-borrower-detail .card-profile-generic .button-transparent,\n.view-borrower-detail .card-profile-generic .button-transparent:hover {\n  padding: 0;\n  height: 20px;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 16.94px;\n  text-align: left;\n  color: #8a130f;\n}\n.view-borrower-detail .card-profile-generic .button-round {\n  width: 75px;\n  height: 20px;\n  padding: 0;\n  border-radius: 76px;\n  border: 2px solid #404859;\n  font-family: Inter;\n  font-size: 10px;\n  font-weight: 600;\n}\n.view-borrower-detail .card-profile-generic .button-edit,\n.view-borrower-detail .card-profile-generic .button-edit:hover {\n  font-family: Inter;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  text-align: left;\n  color: #5e8eb7;\n}\n.view-borrower-detail .card-profile-generic .button-edit .edit,\n.view-borrower-detail .card-profile-generic .button-edit:hover .edit {\n  width: 10px;\n  height: 10px;\n  margin-right: 3px;\n}\n.view-borrower-detail .card-profile-generic .link {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 16.94px;\n  text-align: left;\n  color: #5e8eb7;\n  text-decoration: none;\n}\n.view-borrower-detail .card-profile-generic .link .arrow {\n  width: 15px;\n  margin-left: 5px;\n}\n.view-borrower-detail .card-profile-generic .text-footer {\n  font-family: Inter;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14.52px;\n  text-align: left;\n  color: #6e7889;\n  margin-top: 14px;\n}\n.view-borrower-detail .card-profile-generic .text-footer span {\n  color: #4e8aff;\n}\n.view-borrower-detail .card-report {\n  position: relative;\n}\n.view-borrower-detail .card-report .button span {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 19.36px;\n  letter-spacing: 0.015em;\n  text-align: center;\n}\n.view-borrower-detail .card-report .button-edit {\n  position: absolute;\n  top: 8px;\n  right: 15px;\n}\n.view-borrower-detail .card-report .button-edit span {\n  font-family: Inter;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  text-align: left;\n  color: #5e8eb7;\n}\n.view-borrower-detail .card-report-head {\n  display: flex;\n  justify-content: space-between;\n}\n.view-borrower-detail .card-report .date-expires {\n  font-family: Inter;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 400;\n  line-height: 16.94px;\n  text-align: right;\n  color: #6E7889;\n}\n.view-borrower-detail .card-report .upload-report-span {\n  cursor: pointer;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 16.94px;\n  text-align: right;\n  color: #5E8EB7;\n  text-decoration: underline;\n}\n.view-borrower-detail .card-report .credit-score-input input {\n  text-align: end;\n}\n.view-borrower-detail .card-report .credit-score-input-text {\n  text-align: end;\n  padding: 5px 0px;\n}\n\n.loan-details {\n  padding: 43px 40px;\n  overflow: hidden;\n}\n.loan-details .loan-details-top-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #929FB0;\n  margin-bottom: 22px;\n}\n.loan-details .loan-details-top-bar .loan-info {\n  margin-bottom: 2px;\n}\n.loan-details .loan-details-top-bar .loan-info .loan-borrower-name {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px; /* 133.333% */\n  letter-spacing: 0.24px;\n  text-transform: uppercase;\n}\n.loan-details .loan-details-top-bar .loan-info .loan-address {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 16px;\n  letter-spacing: 0.24px;\n  text-transform: uppercase;\n}\n.loan-details .loan-details-top-bar .close-button-container {\n  cursor: pointer;\n  color: var(--800-grey, #404859);\n  text-align: right;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px; /* 133.333% */\n  letter-spacing: 0.24px;\n  text-transform: uppercase;\n}\n.loan-details .loan-details-first-row {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: solid 1px #CCD3DB;\n  margin-bottom: 16px;\n}\n.loan-details .loan-details-first-row .loan-progress {\n  flex: 6;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-info .loan-status {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n  letter-spacing: 0.36px;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-info .loan-closing-date {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n  letter-spacing: 0.36px;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-info .loan-closing-date b {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.36px;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-address {\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 40px;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-progress-section {\n  margin-bottom: 20px;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container {\n  display: flex;\n  flex-direction: row;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container > * {\n  flex: 1;\n  margin-right: 8px;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container .loan-progress-item-caption {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  white-space: nowrap;\n  margin-bottom: 6px;\n  flex: 0.13;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-values-summary {\n  margin-bottom: 8px;\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 115%;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-values-summary span {\n  cursor: pointer;\n  color: var(--blue60, #5E8EB7);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 115%;\n}\n.loan-details .loan-details-first-row .loan-progress .closed-loan {\n  display: flex;\n  align-items: center;\n  border: 1px solid #5E8EB7;\n}\n.loan-details .loan-details-first-row .loan-progress .closed-loan span, .loan-details .loan-details-first-row .loan-progress .closed-loan a {\n  color: #122536;\n  font-weight: 600;\n}\n.loan-details .loan-details-first-row .loan-progress .closed-loan a {\n  text-decoration: underline;\n}\n.loan-details .loan-details-first-row .placeholder {\n  flex: 3;\n}\n.loan-details .loan-details-first-row .borrower-card {\n  flex: 1;\n}\n.loan-details .loan-details-main {\n  display: flex;\n}\n.loan-details .loan-details-main > * {\n  flex: 1;\n  box-sizing: border-box;\n}\n.loan-details .loan-details-main .left-column {\n  padding-right: 15px;\n}\n.loan-details .loan-details-main .left-column > * {\n  margin-bottom: 16px;\n}\n.loan-details .loan-details-main .left-column > *:last-of-type {\n  margin-bottom: 0px;\n}\n.loan-details .loan-details-main .left-column .loan-summary {\n  display: flex;\n  justify-content: space-between;\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing {\n  flex: 1;\n  border-radius: 10px;\n  border: 1px solid var(--500-grey, #AFBDCC);\n  padding: 16px 20px;\n  margin-right: 16px;\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .label {\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-bottom: 18px;\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .calendar {\n  width: 128px;\n  border-radius: 10px;\n  border: 1px solid var(--blue60, #5E8EB7);\n  background: var(--10, #F5FAFF);\n  margin-bottom: 8px;\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled {\n  border: 1px solid var(--600-grey, #929FB0);\n  background: var(--200-grey, #EFF3F5);\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled .date {\n  color: var(--70, #48759A);\n  border-bottom: 1px solid #929FB0;\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled .day {\n  color: var(--300-grey, #DFE4EB);\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .calendar .date {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 26px;\n  border-bottom: 1px solid #5E8EB7;\n  color: var(--70, #48759A);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px; /* 114.286% */\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .calendar .day {\n  height: 68px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--blue-80, #355C7D);\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .caption {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .caption b {\n  font-weight: 600;\n  color: #404859;\n}\n.loan-details .loan-details-main .left-column .loan-summary .content-box {\n  flex: 5;\n}\n.loan-details .loan-details-main .right-column {\n  padding-left: 15px;\n}\n.loan-details .loan-details-main .right-column .borrower-tasks > .title {\n  margin-bottom: 8px;\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 40px;\n}\n.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-status-container {\n  display: flex;\n  margin-bottom: 16px;\n}\n.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-bottom: 7px;\n}\n.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions > div {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  margin-left: 16px;\n  color: var(--700-grey, #6E7889);\n  text-align: right;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.24px;\n  text-transform: uppercase;\n}\n.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions > div svg {\n  position: relative;\n}\n.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-list {\n  margin-bottom: 17px;\n}\n.loan-details .loan-details-main .right-column .action-button {\n  border: 1px solid var(--100, #162E43);\n  background: var(--100, #162E43);\n  text-align: center;\n  border-radius: 6px;\n  padding: 14px 0px;\n  margin-bottom: 30px;\n  color: var(--10, #F5FAFF);\n  text-align: center;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.24px;\n  cursor: pointer;\n}\n.loan-details .loan-details-main .right-column .action-button:hover {\n  background-color: #EBF6FF !important;\n  border-color: #EBF6FF !important;\n  color: #355D7D !important;\n}\n.loan-details .loan-details-main .right-column .loan-documents > .title {\n  margin-bottom: 8px;\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 40px;\n}\n.loan-details .loan-details-main .right-column .loan-documents .loan-documents-docs-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-bottom: 7px;\n}\n.loan-details .loan-details-main .right-column .loan-documents .loan-documents-docs-actions > div {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  margin-left: 16px;\n  color: var(--700-grey, #6E7889);\n  text-align: right;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.24px;\n  text-transform: uppercase;\n}\n.loan-details .loan-details-main .right-column .loan-documents .loan-documents-docs-actions > div svg {\n  position: relative;\n}\n.loan-details .loan-details-main .right-column .approve-loan {\n  padding: 14px 0px;\n  text-align: center;\n  border-radius: 6px;\n  border: 1px solid var(--300-grey, #DFE4EB);\n  background: var(--300-grey, #DFE4EB);\n  color: var(--600-grey, #929FB0);\n  text-align: center;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.24px;\n}\n\n.loan-progress-item .caption {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  white-space: nowrap;\n  text-align: center;\n  margin-bottom: 4px;\n}\n.loan-progress-item .loan-progress-bar {\n  width: 100%;\n  height: 6px;\n  border-radius: 16px;\n  background: var(--300-grey, #DFE4EB);\n}\n\n.content-box {\n  border-radius: 10px;\n  border: 1px solid var(--500-grey, #AFBDCC);\n  padding: 16px 20px;\n}\n.content-box .label {\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-bottom: 10px;\n}\n.content-box .content {\n  border-left: 1px solid #97BCF0;\n  padding: 2px 0px;\n  padding-left: 12px;\n  min-width: 0;\n  overflow: hidden;\n}\n.content-box .content .item {\n  margin-bottom: 8px;\n}\n.content-box .content .item:last-of-type {\n  margin-bottom: 0px;\n}\n.content-box .content .item-row {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.content-box .content .item-row .value i {\n  color: var(--700-grey, #6E7889);\n}\n.content-box .content .item-row .value span {\n  cursor: pointer;\n  color: var(--blue60, #5E8EB7);\n  text-align: right;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.content-box .content .item-row.extra {\n  margin-top: 8px;\n  padding-left: 16px;\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 400;\n  line-height: normal;\n}\n.content-box .content .item-row.extra .value {\n  color: var(--700-grey, #6E7889);\n}\n.content-box .quill {\n  height: auto;\n}\n.content-box .quill .ql-container {\n  height: auto !important;\n}\n.content-box .quill .ql-tooltip.ql-hidden {\n  display: none !important;\n}\n.content-box .quill .ql-editor {\n  height: auto !important;\n  min-height: unset !important;\n  overflow: visible !important;\n  padding: 0 !important;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n  white-space: pre-wrap;\n}\n.content-box .quill .ql-editor strong {\n  font-weight: bold;\n}\n.content-box .quill .ql-editor em {\n  font-style: italic;\n}\n\n.document-item {\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  border-radius: 10px;\n  border: 1px solid var(--400-grey, #CCD3DB);\n  background: var(--white, #FFF);\n  margin-bottom: 12px;\n}\n.document-item .row {\n  padding-right: 16px;\n  padding-bottom: 11px;\n  padding-left: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.document-item .row:first-child {\n  padding-top: 11px;\n}\n.document-item .row .box-message-state-review {\n  width: 100%;\n  margin-left: 45px;\n  margin-right: 13px;\n  padding: 5px 8px;\n  padding-bottom: 10px;\n  background-color: #FDFCFF;\n  color: #855791;\n  border: 1px solid #D7B8E5;\n}\n.document-item .row .box-message-state-review span {\n  font-size: 12px;\n  font-weight: 400;\n}\n.document-item .row .box-message-state-review b {\n  font-size: 12px;\n  font-weight: 700;\n  text-decoration: underline;\n}\n.document-item .row .box-message-state-review button {\n  height: auto;\n  padding: 0px;\n}\n.document-item .row .box-message-state-review button span {\n  text-decoration: underline;\n  color: #855791;\n  font-size: 12px;\n}\n.document-item .row .box-message-state-review button svg {\n  width: 12px;\n  height: 12px;\n}\n.document-item .row .box-message-state-review button .anticon {\n  margin-inline-start: 5px;\n}\n.document-item .row .box-message-state-review .button-bold span {\n  font-weight: 600;\n  text-decoration: none;\n}\n.document-item-COMPLETE {\n  border-radius: 10px;\n  border: 1px solid var(--green-60, #4CA852);\n  background: #FAFCFC;\n  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n}\n.document-item-COMPLETE .label {\n  color: var(--green-90, #1F4222);\n  font-family: Inter;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.document-item-COMPLETE svg:not(.trash) path {\n  stroke: #1F4222;\n}\n.document-item-COMPLETE .status-badge {\n  background: var(--30, #C2F0C5);\n  color: var(--100, #141F15);\n}\n.document-item-VERIFY\\/UPDATE {\n  border-radius: 10px;\n  border: 1px solid var(--60, #C59ED5);\n  background: var(--10, #FAF9FC);\n  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n}\n.document-item-VERIFY\\/UPDATE .label {\n  color: var(--90, #653B6F);\n  font-family: Inter;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.document-item-VERIFY\\/UPDATE svg:not(.trash) path {\n  stroke: var(--90, #653B6F);\n}\n.document-item-VERIFY\\/UPDATE .status-badge {\n  background: #EAD6FF;\n  color: var(--100, #141F15);\n}\n.document-item-MANUAL {\n  border-radius: 10px;\n  border: 1px solid var(--60, #C59ED5);\n  background: var(--10, #FAF9FC);\n  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n}\n.document-item-MANUAL .label {\n  color: var(--90, #653B6F);\n  font-family: Inter;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.document-item-MANUAL svg:not(.trash) path {\n  stroke: var(--90, #653B6F);\n}\n.document-item-MANUAL .status-badge {\n  background: #EAD6FF;\n  color: var(--100, #141F15);\n}\n.document-item-UPLOAD {\n  border-radius: 10px;\n  border: 1px solid #C13934;\n  background: #FAFCFC;\n  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n}\n.document-item-UPLOAD .label {\n  color: #610805;\n  font-family: Inter;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.document-item-UPLOAD svg:not(.trash) path {\n  stroke: #610805;\n}\n.document-item-UPLOAD .status-badge {\n  background: #FFC6BF;\n  color: var(--100, #141F15);\n}\n.document-item-DRAFT svg:not(.trash) path {\n  stroke: #929FB0;\n}\n.document-item-DRAFT svg.trash path {\n  stroke: #FFC6BF;\n}\n.document-item-DRAFT .label {\n  color: var(--600-grey, #929FB0);\n  font-family: Inter;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.document-item-DRAFT .status-badge {\n  background: var(--30, #EFF3F5);\n  color: var(--100, #404859);\n}\n.document-item svg {\n  height: 16px;\n  width: 16px;\n  margin-right: 8px;\n}\n.document-item svg:last-of-type {\n  margin-right: 0px;\n}\n.document-item .actions-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 40px;\n}\n.document-item .actions-container .disabled {\n  opacity: 0.3;\n  cursor: auto;\n}\n.document-item .label {\n  flex: 1;\n  min-width: 0;\n  font-size: 22px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  column-gap: 24px;\n  row-gap: 0;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n.document-item .label .expires-label {\n  font-family: Inter;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 400;\n  text-align: left;\n}\n.document-item .label .expires-label-error {\n  color: #E56A5C !important;\n}\n.document-item .label .expires-label-approved {\n  color: #3F9545 !important;\n}\n.document-item .feedback-actions-container {\n  display: flex;\n  align-items: start;\n}\n.document-item .feedback-actions-container .action-blocked-disabled {\n  opacity: 0.3;\n  cursor: auto;\n}\n.document-item .feedback-actions-container .action-blocked-blocked svg {\n  fill: #FFC6BF;\n}\n.document-item .feedback-actions-container .action-blocked-blocked svg:not(.trash) path {\n  stroke: #610805;\n}\n.document-item .content-right {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  justify-content: end;\n  flex-shrink: 0;\n}\n.document-item .content-right .document-state {\n  width: 200px;\n  display: flex;\n  justify-content: end;\n}\n.document-item .expand {\n  flex: 0.2;\n}\n\n.borrower-card {\n  display: flex;\n  flex-direction: column;\n  border-radius: 10px;\n  background: var(--gray-100, #F9FAFB);\n  height: 112px;\n  padding: 7px 14px;\n}\n.borrower-card .borrower-summary {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 256px;\n  position: relative;\n  bottom: 8px;\n}\n.borrower-card .borrower-summary .photo-container {\n  position: absolute;\n  top: -8px;\n  border-radius: 24px;\n  background: lightgray 50%;\n  margin-bottom: 4px;\n}\n.borrower-card .borrower-summary .borrower-caption {\n  margin-top: 22px;\n  color: var(--700-grey, #6E7889);\n  text-align: center;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-transform: uppercase;\n}\n.borrower-card .borrower-summary .borrower-name {\n  color: var(--900-grey, #2A2F3C);\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.borrower-card .contact-info-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-bottom: 8px;\n}\n.borrower-card .buttons-container {\n  width: 100%;\n}\n.borrower-card .buttons-container > *:first-child {\n  margin-right: 8px;\n}\n.borrower-card .buttons-container .button-blue {\n  width: 100%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--100, #122536);\n  text-align: center;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.15px;\n  height: 24px;\n  padding: 0px 6px;\n  border-radius: 6px;\n  border: 1px solid var(--100, #162E43);\n  background: var(--100, #122536);\n}\n.borrower-card .buttons-container .button-blue:hover {\n  color: var(--100, #122536) !important;\n}\n.borrower-card .buttons-container .button-blue.outlined {\n  color: var(--100, #122536);\n  background: #FFF;\n}\n\n.borrower-task-item {\n  display: flex;\n  flex-direction: column;\n  padding: 11px 16px;\n  border-radius: 10px;\n  border: 1px solid var(--400-grey, #CCD3DB);\n  background: var(--white, #FFF);\n  margin-bottom: 12px;\n}\n.borrower-task-item .row-1 {\n  display: flex;\n  align-items: center;\n}\n.borrower-task-item .row-1 .actions-container {\n  display: flex;\n  align-items: center;\n  width: 40px;\n  gap: 8px;\n}\n.borrower-task-item .row-1 .actions-container img, .borrower-task-item .row-1 .actions-container svg {\n  cursor: pointer;\n}\n.borrower-task-item .row-1 .label {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  margin-left: 10px;\n  width: 20em;\n}\n.borrower-task-item .row-1 .feedback-actions-container {\n  display: flex;\n  width: 50px;\n  max-width: 5em;\n  gap: 8px;\n}\n.borrower-task-item .row-1 .feedback-actions-container svg {\n  cursor: pointer;\n}\n.borrower-task-item .row-1 .content-right {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  justify-content: end;\n  width: 50%;\n}\n.borrower-task-item .row-1 .content-right .content-status {\n  width: 150px;\n  display: flex;\n  justify-content: end;\n}\n.borrower-task-item .row-1 .expand {\n  width: 20px;\n}\n.borrower-task-item svg {\n  height: 16px;\n  width: 16px;\n  margin-right: 8px;\n}\n.borrower-task-item svg:last-of-type {\n  margin-right: 0px;\n}\n.borrower-task-item svg:not(.trash) path {\n  stroke: #2A2F3C;\n}\n.borrower-task-item .label {\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.borrower-task-item .status-badge {\n  background: var(--30, #404859);\n}\n.borrower-task-item .status-badge .title {\n  color: var(--100, #FFFFFF);\n}\n.borrower-task-item.DRAFT svg:not(.trash) path {\n  stroke: #404859;\n}\n.borrower-task-item.DRAFT .status-badge {\n  border: 1px solid var(--60, #404859);\n  background: var(--30, #FFFFFF);\n}\n.borrower-task-item.DRAFT .status-badge .title {\n  color: var(--100, #404859);\n}\n.borrower-task-item.REVIEW {\n  border: 1px solid var(--60, #C59ED5);\n  background: var(--10, #FAF9FC);\n}\n.borrower-task-item.REVIEW .label {\n  color: var(--90, #653B6F);\n}\n.borrower-task-item.REVIEW svg:not(.trash) path {\n  stroke: #653B6F;\n}\n.borrower-task-item.REVIEW .status-badge {\n  background: var(--30, #EAD6FF);\n}\n.borrower-task-item.REVIEW .status-badge .title {\n  color: var(--100, #241226);\n}\n.borrower-task-item.REVIEW .liquidity-info .title {\n  color: #653B6F !important;\n}\n.borrower-task-item.REVIEW .liquidity-info .max {\n  color: #653B6F;\n}\n.borrower-task-item.REVIEW .box-message-state-review {\n  margin-top: 10px;\n  margin-left: 45px;\n  margin-right: 28px;\n  padding: 5px 8px;\n  background-color: #FDFCFF;\n  color: #855791;\n  border: 1px solid #D7B8E5;\n}\n.borrower-task-item.REVIEW .box-message-state-review span {\n  font-size: 12px;\n  font-weight: 400;\n}\n.borrower-task-item.REVIEW .box-message-state-review b {\n  font-size: 12px;\n  font-weight: 700;\n}\n.borrower-task-item.REVIEW .box-message-state-review button {\n  height: auto;\n  padding: 0px;\n}\n.borrower-task-item.REVIEW .box-message-state-review button span {\n  text-decoration: underline;\n  color: #855791;\n  font-size: 12px;\n}\n.borrower-task-item.REVIEW .box-message-state-review button svg {\n  width: 12px;\n  height: 12px;\n}\n.borrower-task-item.REVIEW .box-message-state-review button .anticon {\n  margin-inline-start: 5px;\n}\n.borrower-task-item.REVIEW .box-message-state-review .button-bold span {\n  font-weight: 600;\n  text-decoration: none;\n}\n.borrower-task-item.REQUEST_ERROR {\n  border: 1px solid var(--60, #C13934);\n  background: var(--10, #FFFFFF);\n}\n.borrower-task-item.REQUEST_ERROR .label {\n  color: var(--90, #610805);\n}\n.borrower-task-item.REQUEST_ERROR svg:not(.trash) path {\n  stroke: #610805;\n}\n.borrower-task-item.REQUEST_ERROR .status-badge {\n  background: var(--30, #FFC6BF);\n}\n.borrower-task-item.REQUEST_ERROR .status-badge .title {\n  color: var(--100, #241226);\n}\n.borrower-task-item.APPROVED {\n  border: 1px solid var(--60, #4CA852);\n  background: var(--10, #FAFCFC);\n}\n.borrower-task-item.APPROVED .label {\n  color: var(--90, #1F4222);\n}\n.borrower-task-item.APPROVED svg:not(.trash) path {\n  stroke: #1F4222;\n}\n.borrower-task-item.APPROVED .status-badge {\n  background: var(--30, #C2F0C5);\n}\n.borrower-task-item.APPROVED .status-badge .title {\n  color: var(--100, #241226);\n}\n.borrower-task-item .liquidity-info {\n  margin-top: 10px;\n  margin-left: 55px;\n}\n.borrower-task-item .liquidity-info .label {\n  font-weight: 500;\n  font-size: 12px;\n}\n.borrower-task-item .liquidity-info .max {\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.cont-modal {\n  width: 100%;\n}\n\n.ModalTask {\n  position: fixed;\n  background: rgba(42, 47, 60, 0.55);\n  backdrop-filter: blur(2px);\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 300;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.ModalTask .content-add {\n  margin-top: 50px;\n}\n.ModalTask-content {\n  width: 70%;\n  background-color: #fff;\n  height: 100%;\n}\n.ModalTask .button-close-mask {\n  width: 30%;\n  height: 100%;\n  background-color: rgba(255, 0, 0, 0);\n  box-shadow: none;\n  border: none;\n}\n.ModalTask .button-close-mask:hover, .ModalTask .button-close-mask:active, .ModalTask .button-close-mask:focus {\n  background-color: rgba(255, 0, 0, 0);\n  box-shadow: none;\n  border: none;\n}\n.ModalTask .content-modal {\n  padding-bottom: 0;\n}\n.ModalTask .content-modal .modal-title {\n  width: 100%;\n  padding: 40px;\n  padding-bottom: 0;\n}\n.ModalTask .content-modal .modal-title .flex-btw {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  border-bottom: 1px solid #929fb0;\n}\n.ModalTask .content-modal .modal-title button,\n.ModalTask .content-modal .modal-title button:hover,\n.ModalTask .content-modal .modal-title button:active,\n.ModalTask .content-modal .modal-title button:focus {\n  background-color: transparent;\n  border: none !important;\n  padding: 0 !important;\n  box-shadow: none !important;\n  color: #404859 !important;\n}\n.ModalTask .content-modal .modal-title .body-card {\n  color: #404859;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px; /* 133.333% */\n  letter-spacing: 0.24px;\n}\n.ModalTask .content-modal .modal-container {\n  position: relative;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  height: calc(100vh - 180px);\n}\n.ModalTask .content-modal .modal-container .dots {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 45%;\n  left: 30px;\n  gap: 9px;\n}\n.ModalTask .content-modal .modal-container .dots-button {\n  padding: 0;\n  border: 1.5px solid #6e7889;\n  background: #fff;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n.ModalTask .content-modal .modal-container .dots-button-success {\n  border: 1px solid #6EAC72;\n  background: #C5F0C8;\n}\n.ModalTask .content-modal .modal-container .dots-button-active {\n  height: 25px;\n  width: 25px;\n  border: 2px dotted #ddaa42;\n}\n.ModalTask .content-modal .modal-container .dots-button-review-active {\n  height: 25px;\n  width: 25px;\n  border: 2px dotted #ddaa42;\n  background: #e3ddf0;\n}\n.ModalTask .content-modal .modal-container .modal-title {\n  border-bottom: 0;\n  align-items: flex-end;\n}\n.ModalTask .content-modal .modal-container .modal-title button {\n  height: 18px;\n  text-transform: uppercase;\n  color: #8a5791 !important;\n}\n.ModalTask .content-modal .modal-container .modal-title button img {\n  margin-top: -0.9px;\n  margin-right: 3px;\n}\n.ModalTask .content-modal .modal-container .text {\n  margin-top: 5px;\n}\n.ModalTask .content-modal .modal-container .text a {\n  margin-left: 6px;\n}\n.ModalTask .content-modal .modal-container .text a:hover {\n  color: #2a2f3c;\n}\n.ModalTask .content-modal .modal-container .modal-cards {\n  width: 100%;\n  height: 100%;\n  padding-bottom: 20px;\n  padding-top: 64px;\n  overflow: auto;\n  padding-right: 10px;\n  max-width: 576px;\n  /* Track */\n  /* Handle */\n  /* Handle on hover */\n}\n.ModalTask .content-modal .modal-container .modal-cards--full {\n  max-width: none;\n  display: flex;\n  justify-content: center;\n}\n.ModalTask .content-modal .modal-container .modal-cards-mx-w {\n  max-width: 576px;\n  width: 100%;\n  padding-bottom: 20px;\n}\n.ModalTask .content-modal .modal-container .modal-cards .flex-btw {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 12px;\n}\n.ModalTask .content-modal .modal-container .modal-cards .flex-btw .button {\n  text-transform: uppercase;\n  color: #404859;\n  text-align: right;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 120%;\n  text-transform: uppercase;\n}\n.ModalTask .content-modal .modal-container .modal-cards .flex-btw .button .anticon {\n  color: #404859;\n}\n.ModalTask .content-modal .modal-container .modal-cards .title {\n  background: #e3ddf0;\n  border-radius: 140px;\n  display: flex;\n  padding: 5px 12px 5px 10px;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n.ModalTask .content-modal .modal-container .modal-cards .title .body-regular {\n  color: #48244d;\n}\n.ModalTask .content-modal .modal-container .modal-cards .h2 {\n  margin-top: 12px;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n.ModalTask .content-modal .modal-container .modal-cards .h2-w8 {\n  color: #ac78b3;\n}\n.ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar {\n  width: 8px;\n  border-radius: 5px;\n}\n.ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n.ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 5px;\n}\n.ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n.ModalTask .modal-review-task__footer {\n  border-top: 1px solid #dfe4eb;\n  height: 180px;\n}\n.ModalTask .modal-review-task__footer .text-footer .placeholder {\n  color: #6e7889;\n}\n.ModalTask .modal-review-task__footer .text-footer .placeholder span {\n  color: #f5faff;\n  font-weight: 600;\n  background-color: #5e8eb7;\n  padding: 0 5px;\n  border-radius: 3px;\n}\n.ModalTask .modal-review-task__footer .footer-grey .h4 {\n  color: #6e7889;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 170%;\n}\n.ModalTask .modal-review-task__footer .body-regular {\n  color: #6e7889;\n}\n.ModalTask .modal-review-task__footer .footer_dost {\n  align-items: center;\n}\n.ModalTask .modal-review-task__footer .footer_dost .body-regular {\n  color: #404859;\n}\n.ModalTask .modal-review-task__footer .footer_dost .circles {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n}\n.ModalTask .modal-review-task__footer .footer_dost .circles .circle {\n  border-radius: 64px;\n  border: 1px solid #404859;\n  width: 20px;\n  height: 20px;\n}\n.ModalTask .modal-review-task__footer .modal-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  height: 100%;\n  padding-right: 15px;\n}\n.ModalTask .modal-review-task__footer .modal-container .modal-cards {\n  width: 100%;\n  height: 100%;\n  max-width: 576px;\n  padding: 14px 0;\n}\n.ModalTask .modal-review-task__footer .modal-container .modal-cards .h4-w4 {\n  color: #ac78b3;\n  margin-bottom: 10px;\n}\n.ModalTask .modal-review-task__footer .modal-container .modal-cards .h4-w4 .h4 {\n  color: #6e7889;\n}\n.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n}\n.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles .circle {\n  border-radius: 100%;\n  border: 1px solid #8a5791;\n  background: #dfb8e5;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles .circle-active {\n  border: 1px solid #587e5b;\n  background: #6eac72;\n}\n.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles .circle-active img {\n  display: none;\n}\n\n.ModalTask-content-right {\n  width: 35%;\n  background-color: #fff;\n  height: 100%;\n  border-left: 1px solid #ccd3db;\n  overflow: scroll;\n  padding: 60px 45px 25px 30px;\n}\n.ModalTask-content-right .w-md-editor .title {\n  line-height: unset !important;\n  font-size: unset !important;\n  font-weight: unset !important;\n}\n.ModalTask-content-right .button-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  color: black;\n}\n.ModalTask-content-right .button-close:hover {\n  color: black !important;\n}\n\n.modal-end-submit {\n  border-radius: 10px;\n  border: 1px solid var(--yellow-400, #ffd47d);\n  background: var(--yellow-100, #fff9ee);\n  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);\n  padding: 0;\n  width: 556px !important;\n  top: 202px !important;\n}\n.modal-end-submit .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #162e43 !important;\n  border-color: #162e43 !important;\n}\n.modal-end-submit .coin {\n  width: 49.334px;\n  height: 34px;\n}\n.modal-end-submit .tag {\n  width: 53px;\n  height: 47.06px;\n}\n.modal-end-submit .ant-modal-content {\n  background-color: transparent;\n  padding: 32px;\n}\n.modal-end-submit .ant-modal-content .h2 {\n  margin-top: 15px;\n  margin-bottom: 5px;\n}\n.modal-end-submit .ant-modal-content .h4 {\n  color: #66564d;\n}\n.modal-end-submit .ant-modal-content .divider {\n  border-top: 1px solid #ddaa42;\n  padding-top: 20px;\n  margin-top: 26px;\n}\n.modal-end-submit .ant-modal-content .buttons {\n  margin-top: 35px;\n}\n.modal-end-submit .ant-modal-content .button {\n  margin-top: 16px;\n  height: 40px !important;\n}\n.modal-end-submit .ant-modal-content .ant-modal-footer {\n  display: none;\n}\n.modal-end-submit .anticon {\n  color: #997120;\n}\n.modal-end-submit .ant-checkbox-wrapper {\n  margin-top: 10px;\n}\n.modal-end-submit .ant-checkbox-wrapper span {\n  color: #244560;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.18px;\n}\n.modal-end-submit--white {\n  background: #fff;\n  border-color: #fff;\n}\n.modal-end-submit--white .anticon {\n  color: #6e7889;\n}\n.modal-end-submit--white .ant-modal-content .h2 {\n  color: #162e43;\n}\n.modal-end-submit--white .ant-modal-content .h4 {\n  color: #48759a;\n}\n.modal-end-submit--white .ant-modal-content .buttons .button-modal-ok {\n  border: 1px solid #162e43 !important;\n  background: #162e43 !important;\n  color: #ffffff !important;\n}\n.modal-end-submit--white .ant-modal-content .buttons .button-modal-cancel {\n  border: 1px solid #162e43 !important;\n  background: #fff !important;\n  color: #162e43 !important;\n}\n.modal-end-submit--white .ant-modal-content .buttons .button-modal-cancel-delete {\n  font-weight: 600 !important;\n  color: #122536 !important;\n}\n.modal-end-submit--white .ant-modal-content .buttons .button-modal-delete {\n  border: 1px solid #A31C17 !important;\n  background: #A31C17 !important;\n  color: #F5FAFF !important;\n  font-weight: 600 !important;\n}\n\n.QuestionBasic .body-regular {\n  color: #6e7889;\n}\n.QuestionBasic .h3 {\n  margin-bottom: 40px;\n}\n.QuestionBasic .options {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 18px;\n  margin-top: 25px;\n}\n.QuestionBasic .options .content-left {\n  display: flex;\n  flex-direction: column;\n}\n.QuestionBasic .options .Button-option {\n  cursor: pointer;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex-direction: column;\n  border-radius: 10px;\n  border: 1px solid #ccd3db;\n  background: #f9fafb;\n  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);\n  min-height: 56px;\n  height: auto;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  padding: 19px 24px;\n}\n.QuestionBasic .options .Button-option-text {\n  color: #2a2f3c !important;\n}\n.QuestionBasic .options .Button-option .flex-btw {\n  margin-bottom: 0 !important;\n}\n.QuestionBasic .options .Button-option .flex-start {\n  display: none;\n}\n.QuestionBasic .options .Button-option-active {\n  border-radius: 10px;\n  border: 1px solid #9bbceb;\n  background: #ebf6ff;\n  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);\n}\n.QuestionBasic .options .Button-option-active .flex-start {\n  display: flex;\n  gap: 6px;\n  align-items: flex-start;\n}\n.QuestionBasic .options .Button-option-active .flex-start img {\n  margin-top: 3px;\n}\n.QuestionBasic .options .Button-option-active .flex-start .body-regular {\n  max-width: 300px;\n}\n.QuestionBasic .options .Button-option-active-text {\n  color: #355c7d !important;\n}\n.QuestionBasic .options .Button-option-active .body-regular {\n  color: #5e8eb7;\n}\n.QuestionBasic .options .Button-option-active .sub-title {\n  font-weight: 500;\n}\n.QuestionBasic .Button-option-active .ModalEndSubmit {\n  width: 100%;\n}\n.QuestionBasic .Button-option-active .ModalEndSubmit .button {\n  height: 36px;\n}\n.QuestionBasic .Button-option-active .ModalEndSubmit .button span {\n  color: #f5faff !important;\n}\n.QuestionBasic .Button-option-active .Button-option-text {\n  color: #355c7d !important;\n}\n.QuestionBasic .Button-option-active-description {\n  color: #5E8EB7 !important;\n  font-size: 14px;\n  margin-top: 5px;\n}\n.QuestionBasic .list {\n  list-style-type: disc;\n  list-style: disc;\n  padding-left: 25px;\n  margin-top: 15px;\n}\n.QuestionBasic .list .h4 {\n  color: #404859;\n  line-height: 145%;\n}\n\n.spinner-container {\n  position: relative;\n  width: auto;\n  height: 120px;\n  display: flex;\n  justify-content: center;\n  align-items: end;\n  overflow: hidden; /* Evita desbordamientos */\n}\n\n.spinner {\n  position: relative;\n}\n\n.spinner div {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  background-color: #c4cdd5;\n  border-radius: 50%;\n  animation: spin 1.2s linear infinite;\n}\n\n/* Colocación inicial de los 12 círculos */\n.spinner div:nth-child(1) {\n  transform: rotate(30deg) translate(40px);\n}\n\n.spinner div:nth-child(2) {\n  transform: rotate(60deg) translate(40px);\n}\n\n.spinner div:nth-child(3) {\n  transform: rotate(90deg) translate(40px);\n}\n\n.spinner div:nth-child(4) {\n  transform: rotate(120deg) translate(40px);\n}\n\n.spinner div:nth-child(5) {\n  transform: rotate(150deg) translate(40px);\n}\n\n.spinner div:nth-child(6) {\n  transform: rotate(180deg) translate(40px);\n}\n\n.spinner div:nth-child(7) {\n  transform: rotate(210deg) translate(40px);\n}\n\n.spinner div:nth-child(8) {\n  transform: rotate(240deg) translate(40px);\n}\n\n.spinner div:nth-child(9) {\n  transform: rotate(270deg) translate(40px);\n}\n\n.spinner div:nth-child(10) {\n  transform: rotate(300deg) translate(40px);\n}\n\n.spinner div:nth-child(11) {\n  transform: rotate(330deg) translate(40px);\n}\n\n.spinner div:nth-child(12) {\n  transform: rotate(0deg) translate(40px);\n}\n\n/* Animación para cambiar el color de los círculos */\n@keyframes spin {\n  0%, 100% {\n    background-color: #c4cdd5;\n  }\n  8.3% {\n    background-color: #4e8de6;\n  }\n}\n/* Cambia el retardo de cada círculo */\n.spinner div:nth-child(1) {\n  animation-delay: -1.1s;\n}\n\n.spinner div:nth-child(2) {\n  animation-delay: -1s;\n}\n\n.spinner div:nth-child(3) {\n  animation-delay: -0.9s;\n}\n\n.spinner div:nth-child(4) {\n  animation-delay: -0.8s;\n}\n\n.spinner div:nth-child(5) {\n  animation-delay: -0.7s;\n}\n\n.spinner div:nth-child(6) {\n  animation-delay: -0.6s;\n}\n\n.spinner div:nth-child(7) {\n  animation-delay: -0.5s;\n}\n\n.spinner div:nth-child(8) {\n  animation-delay: -0.4s;\n}\n\n.spinner div:nth-child(9) {\n  animation-delay: -0.3s;\n}\n\n.spinner div:nth-child(10) {\n  animation-delay: -0.2s;\n}\n\n.spinner div:nth-child(11) {\n  animation-delay: -0.1s;\n}\n\n.spinner div:nth-child(12) {\n  animation-delay: 0s;\n}\n\n.ButtonTabsFilters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n}\n.ButtonTabsFilters .tab {\n  border-radius: 100px;\n  background: #dfe4eb;\n  color: #404859;\n  text-align: right;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n  border: none;\n  box-shadow: none;\n  height: 24px;\n}\n.ButtonTabsFilters .tab .number {\n  font-weight: 400;\n  margin-left: 3px;\n}\n.ButtonTabsFilters .tab:hover {\n  background: #5E8EB7 !important;\n  color: white !important;\n}\n.ButtonTabsFilters .tab-active {\n  background-color: #355c7d;\n  color: #ffffff;\n}\n.ButtonTabsFilters .tab-active:hover {\n  background-color: #355c7d;\n  color: #ffffff !important;\n}\n\n.CardAlertError {\n  border-radius: 10px;\n  border: 1px solid #d7b8e5;\n  background: #f7edfc;\n  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);\n  padding: 18px 24px;\n}\n.CardAlertError .h4-w5 {\n  color: #241226;\n  margin-bottom: 5px;\n}\n.CardAlertError .h4-w4 {\n  color: #653b6f;\n  margin-bottom: 30px;\n}\n\n.CardDetailInformationBank {\n  border-radius: 10px;\n  border: 1px solid #929fb0;\n  background: #fff;\n  padding: 20px 16px;\n}\n.CardDetailInformationBank .h4 {\n  margin-bottom: 24px;\n}\n.CardDetailInformationBank .label {\n  color: #6e7889;\n  margin-bottom: 4px;\n}\n.CardDetailInformationBank .info {\n  color: #929fb0;\n  font-style: italic;\n}\n.CardDetailInformationBank .row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.CardDetailInformationBank .row .column {\n  width: 50%;\n}\n.CardDetailInformationBank .column {\n  margin-bottom: 20px;\n}\n.CardDetailInformationBank .column-line {\n  border-bottom: 1px solid #dfe4eb;\n  padding-bottom: 16px;\n}\n\n.CardLoanTasks {\n  width: 396px;\n  height: 192px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  border: 1px solid #6e7889;\n  background: #fafcfc;\n  padding: 12px 19px;\n  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.CardLoanTasks .state-name {\n  color: #404859;\n  font-family: Inter;\n  font-size: 10px !important;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.CardLoanTasks .state-name-w6 {\n  font-weight: 600;\n}\n.CardLoanTasks .withBorder {\n  width: 100%;\n  border-radius: 10px;\n  border: 1px solid #ccd3db;\n  background: #fff;\n  color: #000;\n  text-align: center;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.CardLoanTasks .withOutBorder {\n  width: 100%;\n  border-radius: 10px;\n  border: none;\n  background: none;\n  box-shadow: none;\n  color: #000;\n  text-align: center;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.CardLoanTasks__top__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 5px;\n}\n.CardLoanTasks__top__head .flex-end {\n  display: flex;\n  justify-content: flex-end;\n  gap: 4px;\n  align-items: center;\n}\n.CardLoanTasks__top__head .flex-end .svg-grid {\n  height: 12px;\n  width: 12px;\n  fill: none;\n}\n.CardLoanTasks__top__head .flex-end .quick-task path {\n  stroke: #6e7889;\n}\n.CardLoanTasks__top__head .flex-end .quick-task path:first-child {\n  fill: #6e7889;\n}\n.CardLoanTasks__top__head .flex-end .major-task path {\n  stroke: #6e7889;\n  fill: #6e7889;\n}\n.CardLoanTasks__top .h4 {\n  margin-bottom: 4px;\n}\n.CardLoanTasks__top .text {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.CardLoanTasks__top .body-card-full {\n  margin-left: 5px;\n  padding: 0 5px;\n  font-weight: 700;\n  border-radius: 2px;\n}\n.CardLoanTasks .TaskProgress {\n  margin-top: 10px;\n}\n.CardLoanTasks__bottom .body-small-up {\n  color: #587e5b;\n  margin-bottom: 8px;\n}\n.CardLoanTasks__bottom .flex-betwen .body-card {\n  color: #587e5b;\n}\n.CardLoanTasks-buttons-actions {\n  gap: 10px;\n  display: flex;\n  justify-content: space-between;\n}\n.CardLoanTasks-APPROVED {\n  border-color: #6eac72;\n}\n.CardLoanTasks-APPROVED .state {\n  border-radius: 76px;\n  background: #c5f0c8;\n  padding: 4px 8px 4px 7px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.CardLoanTasks-APPROVED .state .check {\n  margin-right: 2px;\n}\n.CardLoanTasks-APPROVED .state .state-name {\n  color: #355137;\n}\n.CardLoanTasks-APPROVED .h4 {\n  color: #466849;\n}\n.CardLoanTasks-APPROVED .body-card-full {\n  background-color: #c5f0c8;\n  color: #466849;\n}\n.CardLoanTasks-APPROVED .flex-end .svg-grid path {\n  stroke: #6eac72;\n}\n.CardLoanTasks-APPROVED .flex-end .svg-grid path:first-child {\n  fill: #6eac72;\n}\n.CardLoanTasks-APPROVED .flex-end .major-task path {\n  stroke: #6eac72;\n  fill: #6eac72;\n}\n.CardLoanTasks-APPROVED .flex-end .state-name {\n  color: #6eac72;\n}\n.CardLoanTasks-APPROVED .button-card {\n  border: 1px solid #6eac72;\n  background: #fafcfc;\n  color: #466849;\n  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n}\n.CardLoanTasks-REVIEW {\n  border-color: #ac78b3;\n  background: #FEFAFF;\n}\n.CardLoanTasks-REVIEW .body-card-full {\n  color: #48244d;\n  background: #e3ddf0;\n}\n.CardLoanTasks-REVIEW .body-card--green {\n  background-color: #e3ddf0;\n}\n.CardLoanTasks-REVIEW .state-name {\n  color: #8a5791;\n}\n.CardLoanTasks-REVIEW .CardLoanTasks__top__head .flex-end .major-task path {\n  stroke: #ac78b3;\n  fill: #ac78b3;\n}\n.CardLoanTasks-REVIEW .state {\n  border-radius: 76px;\n  background: #e3ddf0;\n  padding: 4px 8px 4px 7px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n.CardLoanTasks-REVIEW .state .state-name {\n  color: #48244d;\n}\n.CardLoanTasks-REVIEW .body-card {\n  color: #48244d;\n}\n.CardLoanTasks-REVIEW .button-card {\n  color: #693b6f;\n  border-radius: 6px;\n  border: 1px solid #ac78b3;\n  background: #fdfcff;\n  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.03);\n}\n.CardLoanTasks-DRAFT {\n  border-color: #929fb0;\n}\n.CardLoanTasks-DRAFT .body-card-w5 {\n  color: #48244d;\n}\n.CardLoanTasks-DRAFT .state {\n  border-radius: 76px;\n  background: #404859;\n  padding: 4px 8px 4px 7px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n.CardLoanTasks-DRAFT .state .state-name {\n  color: #f9fafb;\n}\n.CardLoanTasks-REQUEST_ERROR {\n  border-color: #c94f4a;\n}\n.CardLoanTasks-REQUEST_ERROR .body-card-w5 {\n  color: #ac3e3a;\n}\n.CardLoanTasks-REQUEST_ERROR .state {\n  border-radius: 76px;\n  background: #ffd4cf;\n  padding: 4px 8px 4px 7px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n.CardLoanTasks-REQUEST_ERROR .state .state-name {\n  color: #712220;\n}\n.CardLoanTasks-REQUEST_ERROR .h4,\n.CardLoanTasks-REQUEST_ERROR .body-card {\n  color: #712220;\n}\n.CardLoanTasks-REQUEST_ERROR .h4-text-2,\n.CardLoanTasks-REQUEST_ERROR .body-card-text-2 {\n  color: #ac3e3a;\n}\n.CardLoanTasks-REQUEST_ERROR .button-card {\n  border-color: #c94f4a;\n}\n.CardLoanTasks-REQUEST_ERROR .flex-betwen .button,\n.CardLoanTasks-REQUEST_ERROR .flex-betwen .button-link {\n  color: #712220;\n}\n.CardLoanTasks-REQUEST_ERROR .flex-end .svg-grid path {\n  stroke: #c94f4a;\n}\n.CardLoanTasks-REQUEST_ERROR .flex-end .svg-grid path:first-child {\n  fill: #c94f4a;\n}\n.CardLoanTasks-REQUEST_ERROR .flex-end .major-task path {\n  stroke: #c94f4a;\n  fill: #c94f4a;\n}\n.CardLoanTasks-REQUEST_ERROR .flex-end .state-name {\n  color: #c94f4a;\n}\n.CardLoanTasks-beginTask .ModalCardState {\n  width: 100% !important;\n}\n\n.CardSomeoneElse {\n  margin-top: 10px;\n  width: 100%;\n}\n.CardSomeoneElse input {\n  background-color: transparent;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 0;\n  color: #48759a;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.CardSomeoneElse input::placeholder {\n  color: #9bbceb;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 500;\n  line-height: normal;\n}\n.CardSomeoneElse .ant-form-item {\n  width: 100%;\n  margin-bottom: 15px;\n}\n.CardSomeoneElse .row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.CardSomeoneElse .row .ant-form-item {\n  width: 100%;\n}\n\n.card-upload-response {\n  position: relative;\n  border-radius: 10px;\n  border: 1px solid #2A2F3C;\n  padding: 10px 16px;\n}\n.card-upload-response .template {\n  margin-bottom: 10px;\n}\n.card-upload-response .template .arrow-right {\n  width: 14px;\n  margin-left: 5px;\n}\n.card-upload-response .template button {\n  padding: 0;\n}\n.card-upload-response .header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n.card-upload-response .header .h4 {\n  display: flex;\n  align-items: center;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n.card-upload-response .header .link {\n  padding: 0;\n  color: rgb(110, 120, 137);\n  font-size: 12px;\n}\n.card-upload-response .header .link span {\n  text-decoration: underline;\n}\n.card-upload-response .header .link:hover {\n  color: rgb(110, 120, 137);\n}\n.card-upload-response .description {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0em;\n  text-align: left;\n  margin-bottom: 12px;\n}\n.card-upload-response .description .description-button-link {\n  padding-left: 0;\n  text-decoration: underline;\n  color: #5e8eb7;\n}\n.card-upload-response .description .description-button-link:hover {\n  color: #5e8eb7;\n}\n.card-upload-response-REVIEW {\n  border: 1px solid #AC78B3;\n  background-color: #FDFCFF;\n}\n.card-upload-response-REVIEW .h4 {\n  color: #161616 !important;\n}\n.card-upload-response-REVIEW .description {\n  color: #161616 !important;\n}\n.card-upload-response-REVIEW .link {\n  color: #161616 !important;\n}\n.card-upload-response-APPROVED {\n  border: 1px solid #92c295;\n  background-color: white;\n}\n.card-upload-response-APPROVED .h4 {\n  color: #404859 !important;\n}\n.card-upload-response-APPROVED .description {\n  color: #404859 !important;\n}\n.card-upload-response-APPROVED .link {\n  color: #404859 !important;\n}\n.card-upload-response-REQUEST_ERROR {\n  border: 1px solid #c94f4a;\n  background-color: #FFFFFF;\n}\n.card-upload-response-REQUEST_ERROR .h4 {\n  color: #404859 !important;\n}\n.card-upload-response-REQUEST_ERROR .description {\n  color: #404859 !important;\n}\n.card-upload-response-REQUEST_ERROR .link {\n  color: #404859 !important;\n}\n\n.DrodownBlue {\n  height: 20px;\n  padding: 1px 3px !important;\n  display: flex;\n  align-items: center;\n}\n.DrodownBlue:hover {\n  background-color: #5E8EB7 !important;\n  color: white !important;\n}\n.DrodownBlue:hover span {\n  text-decoration-line: none !important;\n}\n.DrodownBlue:disabled {\n  background-color: white !important;\n  color: #5E8EB7 !important;\n}\n.DrodownBlue:disabled span {\n  text-decoration-line: underline !important;\n}\n.DrodownBlue-blue {\n  border: 1px solid #9BBCEB;\n  border-radius: 10px;\n}\n.DrodownBlue-blue .ant-dropdown-menu {\n  padding: 0px;\n}\n.DrodownBlue-blue .ant-dropdown-menu-item:hover {\n  background-color: #EBF6FF !important;\n}\n.DrodownBlue-blue .ant-dropdown-menu-item:hover .ant-dropdown-menu-title-content {\n  color: #355c7d;\n  font-weight: 600;\n}\n.DrodownBlue-blue .ant-dropdown-menu-title-content {\n  color: #5E8EB7;\n  font-weight: 400;\n}\n.DrodownBlue-blue .ant-dropdown-menu-title-content:hover {\n  color: #355c7d;\n  font-weight: 600;\n}\n\n.InputAmount {\n  border-radius: 10px;\n  border: 1px solid #929fb0;\n  background: #fff;\n  padding: 13px 16px;\n}\n.InputAmount .h4 {\n  color: #404859;\n}\n.InputAmount .button-operation {\n  padding: 0;\n  height: 23px;\n  border: 0;\n  background: none;\n  box-shadow: none;\n}\n.InputAmount .button-operation .anticon {\n  color: #5e8eb7;\n}\n.InputAmount .button-operation .anticon-full {\n  display: none;\n}\n.InputAmount .button-operation:hover .anticon {\n  color: #5e8eb7;\n  display: none;\n}\n.InputAmount .button-operation:hover .anticon-full {\n  display: block;\n  margin-left: 0;\n}\n.InputAmount .flex {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n}\n.InputAmount .flex .h4 {\n  color: #929fb0;\n}\n.InputAmount .flex span {\n  color: #929fb0;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 400;\n  line-height: normal;\n}\n.InputAmount .flex .text-bold {\n  color: #5e8eb7;\n  font-weight: 600;\n  font-style: normal;\n}\n\n.InputBorderNone .input {\n  color: #775614;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  word-break: break-word;\n}\n.InputBorderNone .body-placeholder-w4 {\n  color: #775614;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  word-break: break-word;\n}\n.InputBorderNone .bold-lith {\n  color: #2a2f3c;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 400;\n}\n.InputBorderNone .bold-lith::placeholder {\n  color: #929fb0;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 400;\n  line-height: 145%;\n}\n.InputBorderNone .bold {\n  color: #2a2f3c;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n}\n.InputBorderNone .percentage-bottom {\n  border: 0;\n  display: flex;\n  justify-content: space-between;\n  border-top: 1px solid #afbdcc;\n  padding-top: 1px;\n  margin-bottom: 10px !important;\n  width: 90% !important;\n}\n.InputBorderNone .percentage-bottom .body-regular span {\n  font-size: 12px;\n}\n.InputBorderNone .ant-input-number-input {\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  line-height: normal;\n  padding: 5px 0px !important;\n}\n.InputBorderNone .ant-input-number-input .default {\n  font-weight: 400;\n  color: #404859;\n}\n.InputBorderNone .ant-input-number-input .warning {\n  font-weight: 600;\n  color: #775614;\n}\n.InputBorderNone .ant-input-number-input::placeholder {\n  color: #929fb0;\n  font-family: Inter;\n  font-style: italic !important;\n  font-weight: 400;\n}\n.InputBorderNone-edit-number {\n  border-bottom: 1px solid #afbdcc;\n}\n.InputBorderNone-edit-number input[type=number] {\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n.InputBorderNone-edit-number input[type=number]::-webkit-inner-spin-button, .InputBorderNone-edit-number input[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.InputBorderNone-edit-date {\n  border-bottom: 1px solid #afbdcc;\n}\n\n.InputUploadedFile .file-ok {\n  margin: 10px 0;\n}\n.InputUploadedFile .file-ok .file {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f9fafb;\n  position: relative;\n}\n.InputUploadedFile .file-ok .file-content {\n  height: 28px;\n  border-radius: 10px;\n  border: 1px solid #2a2f3c;\n  background-color: #f9fafb;\n  width: 100%;\n  padding: 0 20px;\n  padding-right: 12px;\n}\n.InputUploadedFile .file-ok .file-content-approved {\n  border: 1px solid #92c295 !important;\n  background: #f5faf7 !important;\n}\n.InputUploadedFile .file-ok .file-content-request_error {\n  border: 1px solid #c94f4a !important;\n  background: #fff4f3 !important;\n}\n.InputUploadedFile .file-ok .file-content-request_error .name,\n.InputUploadedFile .file-ok .file-content-request_error .anticon {\n  color: #712220 !important;\n}\n.InputUploadedFile .file-ok .file-content-review {\n  border: 1px solid #AC78B3 !important;\n  background: #e3ddf0 !important;\n}\n.InputUploadedFile .file-ok .file-content-review .name,\n.InputUploadedFile .file-ok .file-content-review .anticon {\n  color: #693B6F !important;\n}\n.InputUploadedFile .file-ok .file .file-name {\n  width: 80%;\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  gap: 7px;\n}\n.InputUploadedFile .file-ok .file .file-name .name {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.InputUploadedFile .file-ok .file .file-name .anticon {\n  font-size: 15px;\n}\n.InputUploadedFile .file-ok .file .content-buttons {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  gap: 7px;\n}\n.InputUploadedFile .file-ok .file .content-buttons .anticon {\n  font-size: 15px;\n}\n.InputUploadedFile .file-ok .file .flex {\n  width: 80%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  gap: 12px;\n}\n.InputUploadedFile .file-ok .file .flex:first-child {\n  gap: 4px;\n}\n.InputUploadedFile .file-ok .file .upload {\n  margin-bottom: 0;\n}\n.InputUploadedFile .file-ok .file .flex-btw {\n  margin-bottom: 0;\n  height: 100%;\n  border-bottom: none;\n}\n.InputUploadedFile .file-ok .file .circle-input {\n  background-color: #fff;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1px solid #2a2f3c;\n  display: flex;\n  position: absolute;\n  left: 0;\n  justify-content: center;\n  align-items: center;\n}\n.InputUploadedFile .file-ok .file .circle-input .upload {\n  width: auto;\n  height: 18px;\n  object-fit: cover;\n}\n\n.ProgressSteps {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n}\n.ProgressSteps .tab {\n  margin: 0 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.ProgressSteps .tab .bar-status {\n  width: 100%;\n  width: calc(100% + 20px);\n  height: 6px;\n  border-radius: 16px;\n  margin-top: 6px;\n  background-color: #dfe4eb;\n}\n.ProgressSteps .tab-complete .body-small {\n  color: #587e5b;\n}\n.ProgressSteps .tab-complete .bar-status {\n  background-color: #6eac72;\n}\n.ProgressSteps .tab-started:hover .bar-status {\n  background-color: #404859;\n}\n\n.ant-popover-content .ant-popover-inner {\n  padding: 0;\n}\n.ant-popover-content .popover-content {\n  padding: 10px 8px;\n  border-radius: 10px;\n  width: 240px;\n  position: relative;\n}\n.ant-popover-content .popover-content .body-small {\n  color: #fafcfa;\n}\n.ant-popover-content .popover-content .body-small-w6 {\n  margin-bottom: 6px;\n}\n.ant-popover-content .popover-content .divider {\n  height: 1px;\n  width: 100%;\n  margin: 8px 0;\n}\n.ant-popover-content .popover-content .button {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n.ant-popover-content .popover-content .flecha-darck,\n.ant-popover-content .popover-content .flecha {\n  display: none;\n  width: 16px;\n  height: 8px;\n}\n.ant-popover-content .popover-content .felx-between {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n}\n.ant-popover-content .popover-content .felx-between .flex {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.ant-popover-content .popover-content .felx-between .flex img {\n  margin-right: 5px;\n}\n.ant-popover-content .popover-content .felx-between .button {\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  height: 20px;\n  box-shadow: none;\n}\n.ant-popover-content .popover-content .felx-between .button .flecha {\n  margin-left: 5px;\n  width: 12px;\n}\n.ant-popover-content .popover-content .warning {\n  display: none;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 5px;\n  margin-top: 10px;\n}\n.ant-popover-content .popover-content .warning svg {\n  width: 10px;\n  height: 11px;\n  fill: none;\n}\n.ant-popover-content .popover-content .warning .body-small {\n  margin-bottom: 0;\n  color: #8f2f2c;\n  text-decoration-line: underline;\n}\n.ant-popover-content .popover-content-complete, .ant-popover-content .popover-content-started {\n  background-color: #587e5b;\n}\n.ant-popover-content .popover-content-complete .divider, .ant-popover-content .popover-content-started .divider {\n  background-color: #fafcfa;\n}\n.ant-popover-content .popover-content-complete .flecha, .ant-popover-content .popover-content-started .flecha {\n  display: block;\n}\n.ant-popover-content .popover-content-complete .button:hover, .ant-popover-content .popover-content-complete .button:active, .ant-popover-content .popover-content-complete .button:focus, .ant-popover-content .popover-content-started .button:hover, .ant-popover-content .popover-content-started .button:active, .ant-popover-content .popover-content-started .button:focus {\n  color: #fafcfa;\n}\n.ant-popover-content .popover-content-complete::after, .ant-popover-content .popover-content-started::after {\n  content: \"*\";\n  font-size: 0;\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 11px solid #587e5b;\n  position: absolute;\n  left: 46%;\n  top: -10px;\n  z-index: 3;\n}\n.ant-popover-content .popover-content-started {\n  background-color: #404859;\n  width: 270px;\n}\n.ant-popover-content .popover-content-started .warning {\n  display: flex;\n}\n.ant-popover-content .popover-content-started .warning .body-small {\n  color: #ffd4cf;\n}\n.ant-popover-content .popover-content-started .warning svg path {\n  stroke: #ffd4cf;\n}\n.ant-popover-content .popover-content-started::after {\n  content: \"*\";\n  font-size: 0;\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 11px solid #404859;\n  position: absolute;\n  left: 46%;\n  top: -10px;\n  z-index: 3;\n}\n.ant-popover-content .popover-content-not-started {\n  background-color: #ccd3db;\n  width: 270px;\n}\n.ant-popover-content .popover-content-not-started .body-small {\n  color: #000000;\n}\n.ant-popover-content .popover-content-not-started .warning {\n  display: flex;\n}\n.ant-popover-content .popover-content-not-started svg path {\n  stroke: #8f2f2c;\n}\n.ant-popover-content .popover-content-not-started .button:hover, .ant-popover-content .popover-content-not-started .button:active, .ant-popover-content .popover-content-not-started .button:focus {\n  color: #000000;\n}\n.ant-popover-content .popover-content-not-started .divider {\n  background-color: #404859;\n}\n.ant-popover-content .popover-content-not-started .flecha-darck {\n  display: block;\n}\n.ant-popover-content .popover-content-not-started::after {\n  content: \"*\";\n  font-size: 0;\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 11px solid #ccd3db;\n  position: absolute;\n  left: 46%;\n  top: -10px;\n  z-index: 3;\n}\n.ant-popover-content .popover-content .green-all .body-small {\n  color: #c5f0c8;\n}\n\n.TaskProgress .bar {\n  width: 100%;\n  background-color: #dfe4eb;\n  height: 8px;\n  border-radius: 8px;\n  display: flex;\n}\n.TaskProgress .bar :first-child {\n  border-bottom-left-radius: 8px;\n  border-top-left-radius: 8px;\n}\n.TaskProgress .bar :last-child {\n  border-bottom-right-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.TaskProgress .bar-percentage {\n  height: 8px;\n}\n.TaskProgress .h4 {\n  color: #404859 !important;\n  text-transform: none;\n}\n\n.SelectPrimary .body-regular {\n  color: #2a2f3c;\n  font-weight: 500;\n}\n.SelectPrimary .ant-space-item {\n  width: 100%;\n}\n\n.state-tag {\n  width: max-content;\n  border-radius: 76px;\n  padding: 4px 8px 4px 7px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n.state-tag .check {\n  margin-right: 2px;\n}\n.state-tag .state-name {\n  font-weight: 600;\n  font-family: Inter;\n  line-height: 11px;\n  letter-spacing: 0.02em;\n  font-size: 10px;\n}\n.state-tag-APPROVED {\n  border-color: #C2F0C5;\n  background: #C2F0C5;\n}\n.state-tag-APPROVED .state-name {\n  color: #404859 !important;\n}\n.state-tag-REVIEW {\n  border-color: #e3ddf0;\n  background: #e3ddf0;\n}\n.state-tag-REVIEW .state-name {\n  color: #161616 !important;\n}\n.state-tag-REQUEST_ERROR {\n  border-color: #FFD4CF;\n  background: #FFD4CF;\n}\n.state-tag-REQUEST_ERROR .state-name {\n  color: #404859 !important;\n}\n.state-tag-DRAFT .state-name {\n  color: #2a2f3c !important;\n}\n\n.UploadDocs {\n  position: relative;\n}\n.UploadDocs .modal-see-file {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: red;\n}\n.UploadDocs .button-upload {\n  height: 78px;\n  width: 100%;\n  border: 1px dashed #6e7889;\n}\n.UploadDocs .button-upload p {\n  color: #2a2f3c;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.UploadDocs .button-upload p span {\n  font-size: 10px;\n  color: #4e8aff;\n}\n.UploadDocs .circles {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n}\n.UploadDocs .circles .circle {\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n  border: 1px solid #404859;\n}\n.UploadDocs .circles .circle-review {\n  background-color: #AC78B3;\n  border-color: #AC78B3;\n}\n.UploadDocs .circles .circle-approved {\n  background-color: #C2F0C5;\n  border-color: #92c295;\n}\n.UploadDocs .ant-upload {\n  width: 100%;\n  margin-bottom: 12px;\n}\n.UploadDocs .button {\n  border-radius: 6px;\n  border: #122536;\n  background: #122536;\n  width: 100%;\n  height: 32px;\n  color: #fff;\n  text-align: center;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.18px;\n}\n.UploadDocs .button-transparent {\n  background-color: transparent;\n  border: none !important;\n  box-shadow: none !important;\n}\n.UploadDocs .body-small .blue {\n  color: #4e8aff;\n}\n.UploadDocs .upload {\n  width: 20px;\n  height: 20px;\n  margin-bottom: 7px;\n}\n.UploadDocs .empty-input {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.UploadDocs .empty-input .small-detail {\n  margin-top: 4px;\n}\n.UploadDocs--container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 12px;\n}\n.UploadDocs .input-content {\n  position: relative;\n  height: 128px;\n  width: 100%;\n  border-radius: 10px;\n  background: var(--colors-gradient);\n  padding: 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px dashed #6e7889;\n}\n.UploadDocs .input-content .white {\n  background-color: #fff;\n  height: 10px;\n  width: 20px;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  border-top-left-radius: 5px;\n  z-index: 200;\n}\n.UploadDocs .input-content input {\n  height: 126px;\n  width: 100%;\n  border-radius: 10px;\n  background-color: rgba(255, 0, 0, 0);\n  font-size: 0 !important;\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  cursor: pointer;\n}\n.UploadDocs .input-content .cont-img {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fff;\n}\n.UploadDocs .input-content .cont-img img {\n  width: 100px;\n}\n.UploadDocs .input-content-wh {\n  background: var(--colors-white);\n  box-shadow: -3px 1px 10px -7px var(--colors-black);\n  margin: 30px 40px;\n}\n.UploadDocs .input-content .edit {\n  position: absolute;\n  bottom: 0;\n  height: auto;\n  width: 99px;\n  border-radius: 0;\n}\n.UploadDocs .content-flex {\n  align-items: flex-start;\n  gap: 16px;\n}\n.UploadDocs .content-flex .input-content,\n.UploadDocs .content-flex .file-ok {\n  width: 50% !important;\n}\n\n.circle-tag .circle {\n  width: 20px;\n  height: 20px;\n}\n.circle-tag .circle-APPROVED {\n  border-color: #92c295;\n  background-color: #C2F0C5;\n}\n.circle-tag .circle-APPROVED:hover {\n  background-color: #549358;\n}\n.circle-tag .circle-REVIEW {\n  background-color: #AC78B3;\n  border-color: #AC78B3;\n}\n.circle-tag .circle-REVIEW:hover {\n  background-color: #855791;\n}\n.circle-tag .circle-REQUEST_ERROR {\n  background-color: #FFD4CF;\n  border-color: #c94f4a;\n}\n.circle-tag .circle-REQUEST_ERROR:hover {\n  background-color: #c94f4a;\n}\n\n.MinimumLiquidity {\n  padding-bottom: 30px;\n}\n.MinimumLiquidity .h4 {\n  color: #404859 !important;\n}\n.MinimumLiquidity .divider-top {\n  padding-top: 10px;\n}\n.MinimumLiquidity .h4-error {\n  color: #712220 !important;\n  margin-bottom: 7px;\n}\n.MinimumLiquidity .h2-w8 {\n  color: #2a2f3c !important;\n}\n\n.CardStateAccount {\n  border-radius: 10px;\n  border: 1px solid #7b7b7b;\n  padding: 12px 16px;\n  position: relative;\n}\n.CardStateAccount .label {\n  border-radius: 100px;\n  min-width: 81px;\n  width: auto;\n  max-width: 95px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 3px 4px;\n  gap: 4px;\n  margin-bottom: 8px;\n  background: #969696;\n}\n.CardStateAccount .label .body-small {\n  margin-bottom: 0;\n}\n.CardStateAccount_head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n}\n.CardStateAccount .box {\n  width: 300px !important;\n}\n.CardStateAccount .box .body-card {\n  margin-bottom: 6px;\n}\n.CardStateAccount .box .body-regular {\n  margin-bottom: 16px;\n}\n.CardStateAccount .box .file-ok {\n  margin-top: 0 !important;\n}\n.CardStateAccount .box-error .flex .button:last-child {\n  display: none !important;\n}\n.CardStateAccount .box-success .flex .button:last-child {\n  display: none !important;\n}\n.CardStateAccount .divider {\n  border-top: 1px solid #afbdcc;\n  margin-top: 20px;\n}\n.CardStateAccount--inReview {\n  background: #fdfcff;\n  border: 1px solid #ac78b3;\n}\n.CardStateAccount--inReview .label {\n  background: #e3ddf0;\n}\n.CardStateAccount--inReview .label .body-small {\n  color: #48244d;\n}\n.CardStateAccount--inReview .box .body-card {\n  color: #48244d;\n}\n.CardStateAccount--inReview .box .body-card-dark {\n  color: #2a2f3c;\n}\n.CardStateAccount--inReview .box .body-regular {\n  color: #48244d;\n}\n.CardStateAccount--inReview .file-ok .file-content .name {\n  color: #693b6f !important;\n}\n.CardStateAccount--inReview .file-ok .file-content .anticon {\n  color: #693b6f !important;\n}\n.CardStateAccount--error {\n  border: 1px solid #c94f4a;\n}\n.CardStateAccount--error .label {\n  background: #ffd4cf;\n}\n.CardStateAccount--error .label img {\n  margin-top: 1px;\n}\n.CardStateAccount--error .label .body-small {\n  color: #712220;\n}\n.CardStateAccount--error .UploadDocs .input-content {\n  border: 1px dashed #e67f73;\n}\n.CardStateAccount--error .row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n.CardStateAccount--error .row .box {\n  width: 40%;\n}\n.CardStateAccount--error .row .box .body-card {\n  margin-bottom: 4px;\n}\n.CardStateAccount--error .divider {\n  margin-top: 20px;\n  border-top: 1px solid #ffd4cf;\n  padding-top: 8px;\n}\n.CardStateAccount--approved {\n  border: 1px solid #3F9545;\n}\n.CardStateAccount--approved .label {\n  background: #C5F0C8;\n}\n.CardStateAccount--approved .label img {\n  margin-top: 1px;\n}\n.CardStateAccount--approved .label .body-small {\n  color: #355137;\n}\n.CardStateAccount--approved .UploadDocs .input-content {\n  border: 1px dashed #C5F0C8;\n}\n.CardStateAccount--approved .row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n.CardStateAccount--approved .row .box {\n  width: 40%;\n}\n.CardStateAccount--approved .row .box .body-card {\n  margin-bottom: 4px;\n}\n.CardStateAccount--approved .divider {\n  margin-top: 20px;\n  border-top: 1px solid #C5F0C8;\n  padding-top: 8px;\n}\n.CardStateAccount--approved .file-ok .file-content {\n  border: 1px solid #75C27A !important;\n  background-color: #C5F0C8 !important;\n}\n.CardStateAccount--approved .file-ok .file-content .name {\n  color: #355137 !important;\n}\n.CardStateAccount--approved .file-ok .file-content .anticon {\n  color: #355137 !important;\n}\n.CardStateAccount .row-btw .box {\n  width: 100%;\n}\n.CardStateAccount .section-upload .UploadDocs .file-content {\n  height: 28px !important;\n  border-radius: 10px;\n  border: 1px solid #eff3f5 !important;\n  background: #eff3f5 !important;\n  padding-left: 12px !important;\n}\n.CardStateAccount .section-upload .UploadDocs .InputUploadedFile .file-ok .file .circle {\n  display: none;\n}\n\n.SectionError {\n  border-radius: 10px;\n  border: 1px solid #c94f4a;\n  padding: 12px 15px;\n}\n.SectionError .flex-end button {\n  height: 30px;\n}\n.SectionError .description {\n  overflow: hidden;\n}\n.SectionError .description .body-regular {\n  display: -webkit-box; /* Utiliza el modelo de caja flexible de tipo webkit */\n  -webkit-box-orient: vertical; /* Orientación vertical */\n  -webkit-line-clamp: 2; /* Número máximo de líneas */\n  overflow: hidden; /* Oculta el contenido que sobresale */\n}\n.SectionError .flex-btw {\n  margin-bottom: 5px;\n}\n.SectionError .body-regular {\n  color: #c94f4a;\n}\n.SectionError .body-regular-w6 {\n  color: #712220;\n}\n.SectionError .button {\n  color: #712220;\n  text-align: right;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 140%;\n}\n.SectionError .button span {\n  text-decoration: underline;\n}\n.SectionError .button span:hover {\n  color: #712220;\n}\n.SectionError .button .anticon {\n  color: #712220;\n  margin-top: 2px;\n}\n\n.SectionNewBank .h4,\n.SectionNewBank .body-regular {\n  margin-bottom: 8px;\n  color: #2a2f3c;\n  line-height: 145%;\n}\n.SectionNewBank .button {\n  width: auto !important;\n  font-size: 20px;\n  font-weight: 600;\n}\n.SectionNewBank .button-block {\n  width: 100% !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.card-add-account {\n  border-radius: 10px;\n  border: 1px solid #2a2f3c;\n  padding: 16px;\n  margin-top: 16px;\n}\n.card-add-account .ModalEndSubmit .button {\n  margin-bottom: 5px;\n}\n.card-add-account .flex-btw {\n  margin-bottom: 0 !important;\n}\n.card-add-account .flex-btw .box {\n  height: 100%;\n}\n.card-add-account .UploadDocs .flex-btw {\n  border: none;\n}\n.card-add-account .body-card {\n  color: #404859 !important;\n}\n.card-add-account .box {\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.card-add-account .box .h4 {\n  color: #929fb0;\n  font-style: italic;\n  margin-bottom: 16px;\n}\n.card-add-account .box .ModalEndSubmit .button {\n  display: none;\n}\n.card-add-account .button-submit {\n  margin-bottom: 20px;\n  border-radius: 6px;\n}\n.card-add-account .button-submit span {\n  color: #fff;\n  text-align: center;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.18px;\n}\n.card-add-account .top-InfoExpand {\n  border-top: 1px solid #afbdcc;\n}\n\n.DscrQuestionsAgreements .Step3 .h2 {\n  margin-top: 4px;\n  margin-bottom: 10px;\n}\n.DscrQuestionsAgreements .Step3 .h2 .blue-bold {\n  color: #5e8eb7;\n  font-weight: 800;\n  text-decoration-line: underline;\n  color: #2A2F3C;\n  font-family: Inter;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 135%;\n  text-decoration-line: unset;\n}\n.DscrQuestionsAgreements .Step3 .rent-input {\n  border: none;\n  width: auto;\n  display: inline;\n}\n.DscrQuestionsAgreements .Step3 .rent-input.touched {\n  color: #404859;\n}\n.DscrQuestionsAgreements .Step3 .month {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.DscrQuestionsAgreements .Step3 #rent-button {\n  margin-top: 16px;\n}\n.DscrQuestionsAgreements .Step3 .UploadDocs .contenedor-flex {\n  display: flex;\n  width: 100%;\n}\n.DscrQuestionsAgreements .Step3 .UploadDocs .contenedor-flex .cont-files {\n  width: 100%;\n}\n.DscrQuestionsAgreements .Step3 .UploadDocs .contenedor-flex .UploadDocs--container {\n  gap: 20px;\n  justify-content: center;\n  align-items: flex-start;\n  flex-direction: row;\n  width: 100%;\n}\n.DscrQuestionsAgreements .InputAmount-edit {\n  margin-bottom: 0px !important;\n  border: none !important;\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n}\n.DscrQuestionsAgreements .InputAmount-edit .flex {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n}\n.DscrQuestionsAgreements .InputAmount-edit .flex .text-bold {\n  color: #5e8eb7;\n  font-weight: 600;\n  font-style: normal;\n}\n.DscrQuestionsAgreements .InputAmount-edit .flex .input-edit {\n  all: unset;\n  color: #6E7889;\n  animation: none;\n  cursor: pointer;\n  font-style: italic;\n  font-weight: 400;\n  line-height: 19.36px;\n  text-align: right;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n.DscrQuestionsAgreements .InputAmount-edit .button-edit {\n  all: unset;\n  border: none;\n  color: #5E8EB7;\n  animation: none;\n  cursor: pointer;\n  margin-left: 10px;\n}\n.DscrQuestionsAgreements .InputAmount-edit .button-edit span {\n  margin-left: 5px;\n  font-weight: 500;\n  color: #5E8EB7;\n  font-family: Inter;\n  font-style: normal;\n}\n.DscrQuestionsAgreements .InputAmount-edit .button-edit-disabled span {\n  color: #6E7889 !important;\n}\n\n.CardLeaseAgreements {\n  padding: 16px;\n  border-radius: 4px;\n  border: 1px solid #929fb0;\n}\n.CardLeaseAgreements .flex-btw .flex {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 28px;\n}\n.CardLeaseAgreements .flex-btw .flex .circle {\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n  border: 1px solid #404859;\n}\n.CardLeaseAgreements .flex-btw .flex .circle--active {\n  background-color: #404859;\n}\n.CardLeaseAgreements-REVIEW {\n  border: 1px solid #AC78B3;\n  background-color: #FDFCFF;\n}\n.CardLeaseAgreements-APPROVED {\n  border: 1px solid #92c295;\n  background-color: white;\n}\n.CardLeaseAgreements-APPROVED .h4 {\n  color: #404859 !important;\n}\n.CardLeaseAgreements-APPROVED .description {\n  color: #404859 !important;\n}\n.CardLeaseAgreements-APPROVED .link {\n  color: #404859 !important;\n}\n.CardLeaseAgreements-REQUEST_ERROR {\n  border: 1px solid #c94f4a;\n  background-color: #FFFFFF;\n}\n.CardLeaseAgreements-REQUEST_ERROR .h4 {\n  color: #404859 !important;\n}\n.CardLeaseAgreements-REQUEST_ERROR .description {\n  color: #404859 !important;\n}\n.CardLeaseAgreements-REQUEST_ERROR .link {\n  color: #404859 !important;\n}\n\n.CardMarketRent {\n  border-radius: 4px;\n  border: 1px solid #929fb0;\n  padding: 12px 16px;\n}\n.CardMarketRent .body-regular-italic {\n  color: #929fb0;\n}\n.CardMarketRent .flex-btw {\n  margin-bottom: 9px !important;\n}\n.CardMarketRent-REVIEW {\n  border: 1px solid #AC78B3;\n  background-color: #FDFCFF;\n}\n.CardMarketRent-APPROVED {\n  border: 1px solid #92c295;\n  background-color: white;\n}\n.CardMarketRent-APPROVED .h4 {\n  color: #404859 !important;\n}\n.CardMarketRent-APPROVED .description {\n  color: #404859 !important;\n}\n.CardMarketRent-APPROVED .link {\n  color: #404859 !important;\n}\n.CardMarketRent-REQUEST_ERROR {\n  border: 1px solid #c94f4a;\n  background-color: #FFFFFF;\n}\n.CardMarketRent-REQUEST_ERROR .h4 {\n  color: #404859 !important;\n}\n.CardMarketRent-REQUEST_ERROR .description {\n  color: #404859 !important;\n}\n.CardMarketRent-REQUEST_ERROR .link {\n  color: #404859 !important;\n}\n.CardMarketRent .ant-form {\n  all: unset;\n  margin-top: 10px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.CardMarketRent .ant-form .form-row {\n  all: unset;\n  display: flex;\n  align-items: baseline;\n  gap: 5px;\n  max-height: 35px;\n}\n.CardMarketRent .ant-form .form-row .bold {\n  font-weight: 600 !important;\n  color: #404859 !important;\n}\n.CardMarketRent .ant-form .rent-container {\n  display: flex;\n  align-items: baseline;\n  position: relative;\n}\n.CardMarketRent .ant-form .rent-input {\n  width: auto;\n  min-width: 56px;\n  max-width: 58px;\n  text-align: right;\n  font-weight: 600;\n  color: #404859;\n  border: none;\n  outline: none;\n  background: transparent;\n}\n.CardMarketRent .ant-form .unit-input {\n  width: 25px !important;\n}\n\n.CardTotalUnits {\n  border: 1px solid #929fb0;\n  padding: 12px 16px;\n}\n.CardTotalUnits .body-regular-italic {\n  color: #929fb0;\n}\n.CardTotalUnits .flex-btw {\n  margin-bottom: 16px !important;\n}\n\n.EntityGuarantorCreation .task-footer .dropdown-blue-bold {\n  height: 26px;\n  display: unset;\n  padding: 0 !important;\n}\n.EntityGuarantorCreation .task-footer .dropdown-blue-bold span {\n  font-weight: 600;\n  text-decoration-line: underline;\n}\n.EntityGuarantorCreation .task-footer .dropdown-review-bold {\n  color: #AC78B3 !important;\n  height: 26px;\n  display: unset;\n  padding: 0 !important;\n}\n.EntityGuarantorCreation .task-footer .dropdown-review-bold span {\n  font-weight: 600;\n  text-decoration-line: underline;\n}\n.EntityGuarantorCreation .task-footer .owners-tags {\n  display: flex;\n  justify-content: space-between;\n  align-items: end;\n}\n.EntityGuarantorCreation .task-footer .owners-tags .circles-tags {\n  display: flex;\n  align-items: end;\n  gap: 10px;\n}\n.EntityGuarantorCreation .task-footer .owners-tags .circle {\n  width: 20px;\n  height: 20px;\n}\n.EntityGuarantorCreation .task-footer .owners-tags .circle-step3 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n}\n\n.main {\n  position: relative;\n  border-radius: 10px;\n}\n.main .icon-delete {\n  font-size: 20px;\n  position: absolute;\n  top: 50%;\n  right: -9.5px;\n  transform: translateY(-50%);\n  color: #5E8EB7;\n  cursor: pointer;\n  visibility: hidden;\n}\n.main:hover .icon-delete {\n  visibility: visible;\n}\n.main .content-card {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  border-radius: 10px;\n  border: 1px solid #ccd3db;\n  min-height: 56px;\n  height: auto;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  padding: 10px 18px 5px 16px;\n}\n.main .content-card-hover-removed:hover {\n  border: 1px solid #ccd3db !important;\n}\n.main .content-card:hover {\n  border: 1px dashed #929fb0;\n}\n.main .content-card .input-disabled-color input:disabled {\n  color: black;\n}\n.main .content-card-REVIEW {\n  border: 1px solid #AC78B3;\n  background-color: #FDFCFF;\n}\n.main .content-card-REVIEW .body-regular {\n  color: #161616 !important;\n}\n.main .content-card-REVIEW .bold-lith {\n  color: #161616 !important;\n}\n.main .content-card-REVIEW .ant-input-number-suffix {\n  color: #161616 !important;\n}\n.main .content-card-REVIEW .ant-picker-input input {\n  color: #161616 !important;\n}\n.main .content-card-REVIEW .ant-form-item-no-colon {\n  color: #161616 !important;\n}\n.main .content-card-REVIEW .ant-input-number-input-wrap {\n  color: #161616 !important;\n}\n.main .content-card-REVIEW .ant-input-number-input-wrap input {\n  font-weight: 500;\n}\n.main .content-card-APPROVED {\n  border: 1px solid #92c295;\n  background-color: white;\n}\n.main .content-card-APPROVED .body-regular {\n  color: #404859 !important;\n}\n.main .content-card-APPROVED .bold-lith {\n  color: #404859 !important;\n}\n.main .content-card-APPROVED .ant-input-number-suffix {\n  color: #404859 !important;\n}\n.main .content-card-APPROVED .ant-picker-input input {\n  color: #404859 !important;\n}\n.main .content-card-APPROVED .ant-form-item-no-colon {\n  color: #404859 !important;\n}\n.main .content-card-APPROVED .ant-input-number-input-wrap {\n  color: #404859 !important;\n}\n.main .content-card-APPROVED .ant-input-number-input-wrap input {\n  font-weight: 500;\n}\n.main .content-card-APPROVED .file-name {\n  color: #404859 !important;\n}\n.main .content-card-REQUEST_ERROR {\n  border: 1px solid #c94f4a;\n  background-color: white;\n}\n.main .content-card-REQUEST_ERROR .body-regular {\n  color: #712220 !important;\n}\n.main .content-card-REQUEST_ERROR .bold-lith {\n  color: #712220 !important;\n}\n.main .content-card-REQUEST_ERROR .ant-form-item-no-colon {\n  color: #712220 !important;\n}\n.main .content-card-REQUEST_ERROR .ant-picker-input input {\n  color: #712220 !important;\n}\n.main .content-card-REQUEST_ERROR .ant-input-number-suffix {\n  color: #712220 !important;\n}\n.main .content-card-REQUEST_ERROR .ant-input-number-input-wrap {\n  color: #712220 !important;\n}\n.main .content-card-REQUEST_ERROR .ant-input-number-input-wrap input {\n  font-weight: 500;\n}\n.main .content-card-REQUEST_ERROR .file-name {\n  color: #712220 !important;\n}\n.main .content-card .card-ownership {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n.main .content-card .card-ownership .section-1 {\n  display: flex;\n  width: 70%;\n  flex-direction: column;\n}\n.main .content-card .card-ownership .section-1 .names {\n  display: flex;\n  gap: 30px;\n}\n.main .content-card .card-ownership .section-1 .names .name {\n  display: flex;\n  flex-direction: column;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: auto;\n  gap: 5px;\n}\n.main .content-card .card-ownership .section-1 .names .name span {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-size: 16px;\n}\n.main .content-card .card-ownership .section-1 .names .name label {\n  font-size: 12px;\n}\n.main .content-card .card-ownership .section-1 .footer .approved {\n  color: #587e5b;\n}\n.main .content-card .card-ownership .section-1 .footer .error {\n  color: #404859;\n}\n.main .content-card .card-ownership .section-1 .footer button {\n  color: #6e7889;\n}\n.main .content-card .card-ownership .section-1 .footer button .anticon {\n  margin-inline-start: 4px;\n}\n.main .content-card .card-ownership .section-1 .footer button:hover {\n  color: #6e7889;\n}\n.main .content-card .card-ownership .section-1 .footer span {\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 15px;\n}\n.main .content-card .card-ownership .section-2 {\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n}\n.main .content-card .card-ownership .section-2 .suffix-null input {\n  margin-top: 18px;\n  padding-right: 0 !important;\n}\n.main .content-card .card-ownership .section-2 input {\n  width: 100px;\n  text-align: end;\n  padding-right: 13px !important;\n}\n.main .content-card .card-ownership .section-2 .guarantor {\n  margin-top: 7px;\n  font-size: 10px;\n  color: #5E8EB7;\n}\n.main .content-card .card-ownership .section-2 .ant-input-number-suffix {\n  margin-inline-end: 0px;\n  color: black;\n}\n.main .content-card .form-edit {\n  width: 100%;\n  height: auto;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  display: grid;\n  grid-template-columns: 45% 35% 20%;\n  grid-template-areas: \"ssn datebirth textedit\" \"phone email .\" \"address address address\" \"identification identification identification\" \"submit submit submit\";\n}\n.main .content-card .form-edit .ant-input-status-error {\n  color: #404859;\n}\n.main .content-card .form-edit .ant-form-item-row {\n  display: block;\n}\n.main .content-card .form-edit .ant-form-item-label {\n  text-align: start;\n  height: 27px;\n}\n.main .content-card .form-edit .ant-form-item-label label {\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14.52px;\n  color: #6e7889;\n}\n.main .content-card .form-edit .ant-form-item-control-input {\n  min-height: 20px;\n}\n.main .content-card .form-edit .ant-form-item {\n  margin-bottom: 15px;\n}\n.main .content-card .form-edit .ssn {\n  grid-area: ssn;\n}\n.main .content-card .form-edit .datebirth {\n  grid-area: datebirth;\n}\n.main .content-card .form-edit .datebirth .ant-picker-input input::placeholder {\n  color: #929fb0;\n  font-family: Inter;\n  font-style: italic !important;\n  font-weight: 400;\n}\n.main .content-card .form-edit .datebirth .ant-picker-input input:disabled {\n  color: black;\n}\n.main .content-card .form-edit .textedit {\n  grid-area: textedit;\n  font-size: 11px;\n  text-align: end;\n  color: #5E8EB7;\n  display: flex;\n  align-items: start;\n  gap: 6px;\n  justify-content: end;\n  margin-top: 5px;\n}\n.main .content-card .form-edit .phone {\n  grid-area: phone;\n}\n.main .content-card .form-edit .email {\n  grid-area: email;\n}\n.main .content-card .form-edit .address {\n  grid-area: address;\n}\n.main .content-card .form-edit .identification {\n  grid-area: identification;\n}\n.main .content-card .form-edit .identification label {\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 15px;\n}\n.main .content-card .form-edit .submit {\n  grid-area: submit;\n}\n\n.step-3 .blue-bold {\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 800;\n  text-decoration: underline;\n}\n.step-3 .owner-REVIEW {\n  color: #161616;\n}\n.step-3 .owner-APPROVED {\n  color: #404859;\n}\n.step-3 .owner-REQUEST_ERROR {\n  color: #404859;\n}\n.step-3 .content-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.step-3 .content-owner-new {\n  display: flex;\n  justify-content: space-between;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.step-3 .content-owner-new button {\n  padding: 0;\n}\n.step-3 .content-owner-new .text-add {\n  display: flex;\n  gap: 5px;\n  align-items: center;\n}\n.step-3 .content-owner-new .total {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n}\n\n.action-accept-reject {\n  position: absolute;\n  top: -10px;\n  right: 15px;\n  width: 60px;\n  z-index: 99;\n}\n.action-accept-reject .content-actions {\n  display: flex;\n  justify-content: end;\n  gap: 15px;\n  width: 60px;\n}\n.action-accept-reject .circle-input {\n  cursor: pointer;\n}\n\n.EntityDocs .task-footer .dropdown-blue-bold {\n  height: 26px;\n  display: unset;\n  padding: 0 !important;\n}\n.EntityDocs .task-footer .dropdown-blue-bold span {\n  font-weight: 600;\n  text-decoration-line: underline;\n}\n.EntityDocs .task-footer .dropdown-review-bold {\n  color: #AC78B3 !important;\n  height: 26px;\n  display: unset;\n  padding: 0 !important;\n}\n.EntityDocs .task-footer .dropdown-review-bold span {\n  font-weight: 600;\n  text-decoration-line: underline;\n}\n.EntityDocs .task-footer .owners-tags {\n  display: flex;\n  justify-content: space-between;\n  align-items: end;\n}\n.EntityDocs .task-footer .owners-tags .circles-tags {\n  display: flex;\n  align-items: end;\n  gap: 10px;\n}\n.EntityDocs .task-footer .owners-tags .circle {\n  width: 20px;\n  height: 20px;\n}\n.EntityDocs .task-footer .owners-tags .circle-APPROVED {\n  background-color: #C2F0C5;\n  border-color: #92c295;\n}\n.EntityDocs .task-footer .owners-tags .circle-REVIEW {\n  background-color: #AC78B3;\n  border-color: #AC78B3;\n}\n.EntityDocs .task-footer .owners-tags .circle-REQUEST_ERROR {\n  background-color: #FFD4CF;\n  border-color: #c94f4a;\n}\n\n.entity-docs-step-2 .section-1 span {\n  font-size: 20px !important;\n}\n.entity-docs-step-2 .dropdown-blue-bold {\n  display: unset;\n  height: auto;\n}\n.entity-docs-step-2 .dropdown-review-bold {\n  color: #AC78B3 !important;\n  display: unset;\n  padding: 0 !important;\n}\n.entity-docs-step-2 .dropdown-review-bold span {\n  text-decoration-line: underline;\n}\n.entity-docs-step-2 .submits {\n  display: flex;\n  justify-content: space-between;\n  gap: 15px;\n}\n.entity-docs-step-2 .submits section {\n  width: 100%;\n}\n\n.InvestmentExperienceVerification .card__generic-REVIEW {\n  border: 1px solid #AC78B3;\n  background-color: #FDFCFF;\n}\n.InvestmentExperienceVerification .card__generic-REQUEST_ERROR {\n  border: 1px solid #c94f4a;\n  background-color: #FFFFFF;\n}\n.InvestmentExperienceVerification .card__generic-APPROVED {\n  border: 1px solid #92c295;\n  background-color: white;\n}\n.InvestmentExperienceVerification .card__generic .UploadDocs .input-content,\n.InvestmentExperienceVerification .card__generic .UploadDocs .input-content input {\n  height: 79px;\n}\n.InvestmentExperienceVerification .circle-review {\n  background-color: #AC78B3;\n  border-color: #AC78B3 !important;\n}\n.InvestmentExperienceVerification .circle-approved {\n  border: 1px solid #92c295 !important;\n  background-color: #C2F0C5;\n}\n\n.ConstructionBudget input::-webkit-outer-spin-button,\n.ConstructionBudget input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.ConstructionBudget .h2 {\n  margin-top: 30px !important;\n}\n.ConstructionBudget .UploadDocs .input-content,\n.ConstructionBudget .UploadDocs .input-content input {\n  height: 78px;\n}\n.ConstructionBudget .UploadDocs .input-content .empty-input .body-small,\n.ConstructionBudget .UploadDocs .input-content input .empty-input .body-small {\n  color: #2a2f3c;\n}\n.ConstructionBudget .card__generic .s-title .h4 {\n  color: #404859;\n}\n.ConstructionBudget .card__generic .body-regular {\n  margin-bottom: 20px;\n}\n.ConstructionBudget .link {\n  color: #5e8eb7;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  text-decoration: none;\n  line-height: 145%;\n}\n.ConstructionBudget .link .arrow {\n  height: 10px;\n  margin-left: 5px;\n}\n\n.title-company-step-1 {\n  border-radius: 10px;\n  border: 1px solid #ccd3db;\n  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);\n  padding: 16px 24px 5px;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.title-company-step-1 .ant-form {\n  margin-top: 15px;\n  width: 100%;\n  height: auto;\n  display: grid;\n  grid-template-columns: 50% 5% 45%;\n  grid-template-areas: \"titleCompany titleCompany titleCompany\" \"name name .\" \"phone . email\" \"submit submit submit\";\n}\n.title-company-step-1-REVIEW {\n  border: 1px solid #AC78B3;\n  background-color: #FDFCFF;\n}\n.title-company-step-1-REVIEW .h4 {\n  color: #161616 !important;\n}\n.title-company-step-1-REVIEW .description {\n  color: #161616 !important;\n}\n.title-company-step-1-REVIEW .link {\n  color: #161616 !important;\n}\n.title-company-step-1-APPROVED {\n  border: 1px solid #92c295;\n  background-color: white;\n}\n.title-company-step-1-APPROVED .h4 {\n  color: #404859 !important;\n}\n.title-company-step-1-APPROVED .description {\n  color: #404859 !important;\n}\n.title-company-step-1-APPROVED .link {\n  color: #404859 !important;\n}\n.title-company-step-1-REQUEST_ERROR {\n  border: 1px solid #c94f4a;\n  background-color: #FFFFFF;\n}\n.title-company-step-1-REQUEST_ERROR .h4 {\n  color: #404859 !important;\n}\n.title-company-step-1-REQUEST_ERROR .description {\n  color: #404859 !important;\n}\n.title-company-step-1-REQUEST_ERROR .link {\n  color: #404859 !important;\n}\n.title-company-step-1 .ant-form-item-row {\n  display: block;\n}\n.title-company-step-1 .ant-form-item-label {\n  text-align: start;\n  height: 27px;\n}\n.title-company-step-1 .ant-form-item-label label {\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14.52px;\n  color: #6e7889;\n}\n.title-company-step-1 .ant-form-item-control-input {\n  min-height: 20px;\n}\n.title-company-step-1 .ant-form-item {\n  margin-bottom: 15px;\n}\n.title-company-step-1 .titleCompany {\n  grid-area: titleCompany;\n}\n.title-company-step-1 .titleCompany input {\n  font-size: 16px !important;\n}\n.title-company-step-1 .name {\n  grid-area: name;\n}\n.title-company-step-1 .phone {\n  grid-area: phone;\n}\n.title-company-step-1 .email {\n  grid-area: email;\n}\n.title-company-step-1 .submit {\n  grid-area: submit;\n}\n.title-company-step-1 .submit button {\n  border-radius: 6px;\n}\n\n.insurance-step-2 .ant-collapse-header-text {\n  max-width: 335px;\n  margin-inline-end: unset !important;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n}\n.insurance-step-2 .ant-collapse-expand-icon {\n  padding-inline-start: 0px !important;\n}\n\n.payoff-footer .dropdown-blue-bold {\n  display: unset;\n  padding: 0 !important;\n  border: none !important;\n}\n.payoff-footer .dropdown-blue-bold span {\n  background-color: white !important;\n  color: #5E8EB7 !important;\n  padding: 0 !important;\n}\n.payoff-footer .is-review {\n  color: #AC78B3 !important;\n}\n\n.insurance-step-2 .ant-collapse-header-text {\n  max-width: 335px;\n  margin-inline-end: unset !important;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n}\n.insurance-step-2 .ant-collapse-expand-icon {\n  padding-inline-start: 0px !important;\n}\n\n.entities-list {\n  padding: 24px 25px;\n}\n.entities-list .top-container {\n  box-sizing: content-box;\n  width: 100%;\n  margin-bottom: 33px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: space-between;\n}\n.entities-list .top-container .title {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.entities-list .top-container .title > span {\n  cursor: pointer;\n  color: var(--blue60, #5E8EB7);\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-decoration-line: underline;\n}\n.entities-list .entities-container {\n  padding: 16px 0px;\n}\n.entities-list .entities-container > * {\n  margin-bottom: 16px;\n}\n.entities-list .entities-container > *:last-child {\n  margin-bottom: 0px;\n}\n.entities-list .search-box {\n  cursor: pointer;\n  box-sizing: border-box;\n  width: 384px;\n  padding: 5px 18px 5px 8px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-radius: 10px;\n  border: 1px solid var(--400-grey, #CCD3DB);\n  background: var(--gray-100, #F9FAFB);\n  color: var(--700-grey, #6E7889);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 120%;\n}\n.entities-list .search-box > input {\n  all: unset;\n  width: 100%;\n  margin-left: 8px;\n}\n\n@keyframes horizontal-shaking {\n  0% {\n    transform: translateX(0);\n  }\n  25% {\n    transform: translateX(-3px);\n  }\n  50% {\n    transform: translateX(3px);\n  }\n  75% {\n    transform: translateX(-1px);\n  }\n  100% {\n    transform: translateX(1px);\n  }\n}\n.Login {\n  display: flex;\n  justify-content: space-between;\n  min-height: calc(100vh - 56px);\n}\n.Login-form,\n.Login .rigth {\n  width: 50%;\n}\n.Login-form {\n  padding: 32px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: flex-start;\n  position: relative;\n}\n.Login-form .coin {\n  margin-bottom: 13px;\n}\n.Login-form .h1 {\n  margin-bottom: 24px;\n}\n.Login-form .ant-form {\n  width: 100%;\n}\n.Login-form .error-message {\n  margin-top: 50px;\n  color: #8f2f2c;\n}\n.Login-form .button {\n  margin-top: 10px;\n}\n.Login-form .link:hover {\n  color: #404859;\n}\n.Login-form .link .body-regular-bold {\n  text-decoration: underline;\n}\n.Login-form .link-absolute {\n  position: absolute;\n  bottom: 30px;\n  left: 32px;\n  text-decoration: none;\n}\n.Login-form .link-absolute .body-regular-bold {\n  text-decoration: underline;\n}\n.Login .right {\n  padding-top: 48px;\n  width: 55%;\n  background-color: #F9FAFB;\n  position: relative;\n}\n.Login .right .content {\n  padding-left: 72px;\n  padding-right: 0px;\n}\n.Login .right .star {\n  margin-bottom: 16px;\n}\n.Login .right .phrase {\n  margin: 0px;\n  color: #2A2F3C;\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 120%; /* 24px */\n  margin-bottom: 12px;\n}\n.Login .right .author {\n  color: #355C7D;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 300;\n  line-height: 140%; /* 22.4px */\n}\n.Login .right .author b {\n  font-weight: 600;\n}\n.Login .right .home {\n  height: 70vh;\n  position: absolute;\n  bottom: -90px;\n  left: 48px;\n  border-color: #355C7D;\n  border-width: 2px 0px 0px 2px;\n  border-style: solid;\n  border-radius: 10px 0px 0px 0px;\n}\n.Login > .right-column {\n  background: #F9FAFB;\n  padding: 64px 64px 0px 56px;\n}\n.Login > .right-column .testimonial {\n  margin: 0px;\n  margin-bottom: 4px;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 28.8px;\n  color: #2A2F3C;\n}\n.Login > .right-column .testimonial.description {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 125%;\n  color: #777b83;\n  margin-bottom: 6px;\n  margin-right: 16px;\n}\n.Login > .right-column .caption {\n  margin: 0px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 19.6px;\n  color: #404859;\n}\n.Login > .right-column .caption > b {\n  font-weight: 600;\n}\n.Login > .right-column .welcome-image {\n  position: absolute;\n  bottom: -40px;\n  right: 0px;\n  max-height: 65vh;\n  width: 91%;\n  border-color: #355C7D;\n  border-width: 8px 0px 0px 8px;\n  border-style: solid;\n  border-radius: 10px 0px 0px 0px;\n}\n@media (min-height: 735px) {\n  .Login .bottom-flex {\n    height: 470px;\n  }\n  .Login .bottom-flex img {\n    height: 100%;\n  }\n}",".container {\n  max-width: 1300px;\n  width: 100%;\n}\n\n.disabled {\n  opacity: 0.6;\n  cursor: not-allowed !important;\n\n  label {\n    cursor: not-allowed !important;\n  }\n}\n\n.cards-step-2 {\n  .body-card {\n    color: #6e7889;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    margin-bottom: 4px;\n  }\n  iframe {\n    width: 100%;\n    height: 120px;\n    border: none;\n    background-color: transparent;\n  }\n  .UploadDocs .input-content {\n    height: 78px;\n\n    input {\n      height: 78px;\n    }\n  }\n}\n.card {\n  &__generic {\n    border-radius: 10px;\n    border: 1px solid #929fb0;\n    box-shadow: 0px 0px 3px 0px rgba(11, 19, 26, 0.18);\n    width: 100%;\n    padding: 16px;\n  }\n}\n.form {\n  &-item {\n    &__input,\n    .ant-input {\n      padding: 12px 0;\n      border: 0;\n      border-bottom: 1px solid $grey-title;\n      border-radius: 0;\n      &::placeholder {\n        color: $grey-placeholder;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n      }\n    }\n  }\n}\n.card-upload {\n  border-radius: 10px;\n  border: 1px solid #2a2f3c;\n  padding: 12px 16px;\n  box-shadow: 0px 0px 3px 0px rgba(11, 19, 26, 0.18);\n  .link {\n    color: #6e7889;\n    text-align: right;\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    text-decoration-line: underline;\n  }\n  p {\n    margin: 10px 0;\n  }\n}\n.flex-btw {\n  display: flex;\n  justify-content: space-between;\n}\n.flex-end {\n  display: flex;\n  justify-content: flex-end;\n}\n.flex-start {\n  display: flex;\n  justify-content: flex-start;\n}\n.flex-col {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n}\n.mt {\n  &-20 {\n    margin-top: 20px;\n  }\n  &-25 {\n    margin-top: 25px;\n  }\n  &-30 {\n    margin-top: 30px;\n  }\n  &-40 {\n    margin-top: 40px;\n  }\n  &-50 {\n    margin-top: 50px;\n  }\n  &-60 {\n    margin-top: 60px;\n  }\n  &-12 {\n    margin-top: 12px;\n  }\n  &-6 {\n    margin-top: 6px;\n  }\n  &-5 {\n    margin-top: 5px;\n  }\n  &-10 {\n    margin-top: 10px;\n  }\n  &-15 {\n    margin-top: 15px;\n  }\n}\n.divider-top {\n  border-top: 1px solid #afbdcc;\n}\n\n// inputs ******************************************** inputs\n.input {\n  &-transparent {\n    background-color: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n    padding: 0;\n  }\n  &-number {\n    width: 100%;\n    height: 48px;\n    border-radius: 10px;\n    border: 1px solid #2a2f3c;\n    background: #fff;\n    .ant-input-number-input-wrap {\n      height: 45px;\n      .ant-input-number-input {\n        height: 45px;\n      }\n    }\n    .ant-input-prefix {\n      color: #404859;\n      font-family: Inter;\n      font-size: 16px;\n      font-weight: 400;\n    }\n    input {\n      &::placeholder {\n        color: #929fb0;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: italic;\n        font-weight: 400;\n      }\n    }\n  }\n  &-placeholder-bold {\n    &::placeholder {\n      color: #9bbceb;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: italic;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n}\n.body-placeholder {\n  &::placeholder {\n    color: #929fb0;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: italic;\n    font-weight: 600;\n    line-height: normal;\n  }\n  &-w4 {\n    &::placeholder {\n      font-weight: 400;\n    }\n  }\n}\n.fz-14 {\n  font-size: 14px;\n}\n.fz-12 {\n  font-size: 12px;\n}\n\n.children {\n  padding-bottom: 20px;\n}\n","//sizes\n$small: 440px;\n$s-medium: 570px;\n$medium: 761px;\n$large: 960px;\n$x-large: 1060px;\n$xx-large: 1250px;\n\n//colors\n$grey-title: #404859;\n$grey-text-op: #6e7889;\n$grey-placeholder: #929fb0;\n$color-primary-button: #162e43;\n$white-button-txt: #f5faff;\n$black-text: #2a2f3c;\n$blue-button-tab: #355c7d;\n$white-button-tab: #dfe4eb;\n$white: #ffffff;\n$black: #000000;\n$red-title: #c94f4a;\n$red-warning: #8f2f2c;\n$grey-border: #ccd3db;\n$green-tab-active-text: #587e5b;\n$green-tab-active: #6eac72;\n\n$state-warning: #775614;\n\n$state-draft-hover: #404859;\n\n$state-review: #AC78B3;\n$state-review-dark: #693B6F;\n$state-review-border: #AC78B3;\n$state-review-border-2: #D7B8E5;\n$state-review-text: #161616;\n$state-review-text-dark: #241226;\n$state-review-label: #855791;\n$state-review-tag: #48244D;\n$state-review-background: #e3ddf0;\n$state-review-background-ligth: #FDFCFF;\n\n$state-approved: #f5faf7;\n$state-approved-border:#92c295;\n$state-approved-border-dark: darken($green-tab-active, 10%); \n$state-approved-title-dark: #3F9545; \n$state-approved-icon: #466849; \n$state-approved-text: #404859;\n$state-approved-text-dark: #1F4222;\n$state-approved-background: #C2F0C5;\n$state-approved-background-ligth: white;\n\n$state-error: #fff4f3;\n$state-error-border: #c94f4a;\n$state-error-icon: #712220;\n$state-error-text: #404859;\n$state-error-text-dark: #8A130F;\n$state-error-dark: #C13934;\n$state-error-background: #FFD4CF;\n$state-error-background-ligth: #FFFFFF;\n\n$state-tag-incomplete: #404859;\n\n$button-disbaled-background: #DFE4EB;\n$button-disbaled-border: #DFE4EB;\n$button-color: #929FB0;\n$button-blue: #5E8EB7;\n","/* http://meyerweb.com/eric/tools/css/reset/\n   v2.0-modified | 20110126\n   License: none (public domain)\n*/\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  margin: 0;\n  height: 100%;\n}\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n\n/* make sure to set some focus styles for accessibility */\n:focus {\n  outline: 0;\n}\n\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\nbody {\n  line-height: 1;\n}\n\nol,\nul {\n  list-style: none;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration,\ninput[type=\"search\"]::-webkit-search-results-button,\ninput[type=\"search\"]::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\ninput[type=\"search\"] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\ntextarea {\n  overflow: auto;\n  vertical-align: top;\n  resize: vertical;\n}\n\n/**\n   * Correct `inline-block` display not defined in IE 6/7/8/9 and Firefox 3.\n   */\n\naudio,\ncanvas,\nvideo {\n  display: inline-block;\n  *display: inline;\n  *zoom: 1;\n  max-width: 100%;\n}\n\n/**\n   * Prevent modern browsers from displaying `audio` without controls.\n   * Remove excess height in iOS 5 devices.\n   */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n   * Address styling not present in IE 7/8/9, Firefox 3, and Safari 4.\n   * Known issue: no IE 6 support.\n   */\n\n[hidden] {\n  display: none;\n}\n\n/**\n   * 1. Correct text resizing oddly in IE 6/7 when body `font-size` is set using\n   *    `em` units.\n   * 2. Prevent iOS text size adjust after orientation change, without disabling\n   *    user zoom.\n   */\n\nhtml {\n  font-size: 100%; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n  -ms-text-size-adjust: 100%; /* 2 */\n}\n\n/**\n   * Address `outline` inconsistency between Chrome and other browsers.\n   */\n\na:focus {\n  outline: thin dotted;\n}\n\n/**\n   * Improve readability when focused and also mouse hovered in all browsers.\n   */\n\na:active,\na:hover {\n  outline: 0;\n}\n\n/**\n   * 1. Remove border when inside `a` element in IE 6/7/8/9 and Firefox 3.\n   * 2. Improve image quality when scaled in IE 7.\n   */\n\nimg {\n  border: 0; /* 1 */\n  -ms-interpolation-mode: bicubic; /* 2 */\n}\n\n/**\n   * Address margin not present in IE 6/7/8/9, Safari 5, and Opera 11.\n   */\n\nfigure {\n  margin: 0;\n}\n\n/**\n   * Correct margin displayed oddly in IE 6/7.\n   */\n\nform {\n  margin: 0;\n}\n\n/**\n   * Define consistent border, margin, and padding.\n   */\n\nfieldset {\n  border: 0px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n/**\n   * 1. Correct color not being inherited in IE 6/7/8/9.\n   * 2. Correct text not wrapping in Firefox 3.\n   * 3. Correct alignment displayed oddly in IE 6/7.\n   */\n\nlegend {\n  border: 0; /* 1 */\n  padding: 0;\n  white-space: normal; /* 2 */\n  *margin-left: -7px; /* 3 */\n}\n\n/**\n   * 1. Correct font size not being inherited in all browsers.\n   * 2. Address margins set differently in IE 6/7, Firefox 3+, Safari 5,\n   *    and Chrome.\n   * 3. Improve appearance and consistency in all browsers.\n   */\n\nbutton,\ninput,\nselect,\ntextarea {\n  font-size: 100%; /* 1 */\n  margin: 0; /* 2 */\n  vertical-align: baseline; /* 3 */\n  *vertical-align: middle; /* 3 */\n}\n\n/**\n   * Address Firefox 3+ setting `line-height` on `input` using `!important` in\n   * the UA stylesheet.\n   */\n\nbutton,\ninput {\n  line-height: normal;\n}\n\n/**\n   * Address inconsistent `text-transform` inheritance for `button` and `select`.\n   * All other form control elements do not inherit `text-transform` values.\n   * Correct `button` style inheritance in Chrome, Safari 5+, and IE 6+.\n   * Correct `select` style inheritance in Firefox 4+ and Opera.\n   */\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n/**\n   * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n   *    and `video` controls.\n   * 2. Correct inability to style clickable `input` types in iOS.\n   * 3. Improve usability and consistency of cursor style between image-type\n   *    `input` and others.\n   * 4. Remove inner spacing in IE 7 without affecting normal text inputs.\n   *    Known issue: inner spacing remains in IE 6.\n   */\n\nbutton,\n  html input[type=\"button\"], /* 1 */\n  input[type=\"reset\"],\n  input[type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n  cursor: pointer; /* 3 */\n  *overflow: visible; /* 4 */\n}\n\n/**\n   * Re-set default cursor for disabled elements.\n   */\n\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n\n/**\n   * 1. Address box sizing set to content-box in IE 8/9.\n   * 2. Remove excess padding in IE 8/9.\n   * 3. Remove excess padding in IE 7.\n   *    Known issue: excess padding remains in IE 6.\n   */\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n  *height: 13px; /* 3 */\n  *width: 13px; /* 3 */\n}\n\n/**\n   * 1. Address `appearance` set to `searchfield` in Safari 5 and Chrome.\n   * 2. Address `box-sizing` set to `border-box` in Safari 5 and Chrome\n   *    (include `-moz` to future-proof).\n   */\n\ninput[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box; /* 2 */\n  box-sizing: content-box;\n}\n\n/**\n   * Remove inner padding and search cancel button in Safari 5 and Chrome\n   * on OS X.\n   */\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n   * Remove inner padding and border in Firefox 3+.\n   */\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n/**\n   * 1. Remove default vertical scrollbar in IE 6/7/8/9.\n   * 2. Improve readability and alignment in all browsers.\n   */\n\ntextarea {\n  overflow: auto; /* 1 */\n  vertical-align: top; /* 2 */\n}\n\n/**\n   * Remove most spacing between table cells.\n   */\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\nhtml,\nbutton,\ninput,\nselect,\ntextarea {\n  color: #222;\n}\n\n::-moz-selection {\n  background: #b3d4fc;\n  text-shadow: none;\n}\n\n::selection {\n  background: #b3d4fc;\n  text-shadow: none;\n}\n\nimg {\n  vertical-align: middle;\n}\n\nfieldset {\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\ntextarea {\n  resize: vertical;\n}\n\n.chromeframe {\n  margin: 0.2em 0;\n  background: #ccc;\n  color: #000;\n  padding: 0.2em 0;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\",\n    \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n",".h1 {\n  color: $grey-title;\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.h2 {\n  color: $black-text;\n  font-family: Inter;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 120%;\n  &-w8 {\n    font-weight: 800;\n  }\n}\n.h3 {\n  color: #2a2f3c;\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 135%;\n}\n.h4 {\n  color: $black-text;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 115%;\n  &-cp {\n    text-transform: capitalize;\n  }\n  &-w4 {\n    font-weight: 400;\n  }\n  &-w5 {\n    font-weight: 500;\n  }\n}\n.title-blue-bold {\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  color: $blue-button-tab;\n}\n.body-regular {\n  color: $grey-title;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  &-italic {\n    font-style: italic;\n  }\n  &-up {\n    text-transform: uppercase;\n  }\n  &-bold,\n  &-w6 {\n    font-weight: 600;\n  }\n  &-w5 {\n    font-weight: 500;\n  }\n}\n\n.placeholder {\n  color: $grey-placeholder;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  &-w6 {\n    font-weight: 600;\n  }\n}\n.button-txt-big {\n  color: $white-button-txt;\n  text-align: center;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.24px;\n}\n.body-small {\n  color: $grey-title;\n  font-family: Inter;\n  font-size: 10px !important;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  &-w4 {\n    font-weight: 400;\n  }\n  &-w6 {\n    font-weight: 600;\n  }\n  &-up {\n    text-transform: uppercase;\n  }\n}\n.small-detail {\n  color: #6e7889;\n  font-family: Inter;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.body-card {\n  color: $grey-title;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  &-bold-line {\n    font-weight: 700;\n    text-decoration-line: underline;\n  }\n  &-w6 {\n    font-weight: 600;\n  }\n  &-w7 {\n    font-weight: 700;\n  }\n  &-w5 {\n    font-weight: 500;\n  }\n}\n.blue-bold {\n  color: #5e8eb7;\n  cursor: pointer;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 145%;\n  img {\n    height: 10px;\n    margin-left: 5px;\n  }\n}\n\n.bold {\n  font-weight: 600;\n}\n\n.bold-little {\n  font-weight: 500;\n}\n\n.cursor {\n  cursor: pointer;\n}\n\n.disabled {\n  color: #2A2F3C !important;\n\n  div {\n    border-color: #AFBDCC !important;\n  }\n}\n",".button {\n  height: 32px;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  &-empty {\n    background-color: transparent;\n    padding: 0;\n    border: none;\n    box-shadow: none;\n    span {\n      color: #404859 !important;\n      font-family: Inter;\n      font-size: 10px !important;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 16px;\n      letter-spacing: 0.2px;\n    }\n  }\n  &-modal-ok {\n    width: 100%;\n    border-radius: 6px;\n    border: 1px solid #ffc857 !important;\n    background: #ffc857 !important;\n    height: 40px;\n    color: #66564d !important;\n    text-align: center;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.21px;\n  }\n  &-modal-cancel {\n    width: 100%;\n    border-radius: 6px;\n    border: 1px solid #ddaa42 !important;\n    background: #fff9ee !important;\n    height: 40px;\n    color: #3c302a !important;\n    text-align: center;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    letter-spacing: 0.21px;\n  }\n  &-primary {\n    width: 100%;\n    height: 48px;\n    flex-shrink: 0;\n    border-radius: 6px;\n    border: 1px solid $color-primary-button;\n    background: $color-primary-button;\n    border: none;\n    &:hover {\n      border: none;\n      color: $white-button-txt !important;\n    }\n  }\n  &-secondary {\n    width: 179px;\n    border-radius: 6px;\n    border: 1px solid $blue-button-tab;\n    color: $blue-button-tab;\n\n    &:hover {\n      color: $blue-button-tab !important;\n      border: 1px solid $blue-button-tab !important;\n    }\n  }\n  &-grey {\n    color: #6e7889 !important;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.18px;\n    border-radius: 6px;\n    border: 1px solid #eff3f5 !important;\n    background: #eff3f5;\n    width: 100%;\n  }\n  &-transparent {\n    padding: 0;\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    color: #48759a;\n    .anticon {\n      color: #48759a;\n    }\n    &:hover {\n      color: #48759a !important;\n    }\n  }\n  &-gray {\n    padding: 0;\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    color: #afbdcc;\n    .anticon {\n      color: #afbdcc;\n    }\n    &:hover {\n      color: #afbdcc !important;\n    }\n  }\n  &-card {\n    width: 100%;\n    color: $black;\n    border: 1px solid $grey-border;\n    &:hover {\n      color: $black !important;\n      border: 1px solid $grey-border !important;\n    }\n  }\n  &-submit {\n    border-radius: 6px;\n    border: 1px solid #122536 !important;\n    background: #122536 !important;\n    color: #fff !important;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.18px;\n    width: 100%;\n\n    &-delete {\n      all: unset;\n      border: none !important;\n      background-color: transparent !important;\n      &:hover {\n        background: none !important;\n        border-color: transparent !important;\n      }\n    }\n\n    &:disabled {\n      background-color: $button-disbaled-background !important;\n      border-color: $button-disbaled-border !important;\n\n      span {\n        color: $button-color !important;\n      }\n\n      &:hover {\n        background-color: $button-disbaled-background !important;\n        border-color: $button-disbaled-border !important;\n        span {\n          color: $button-color !important;\n        }\n      }\n    }\n\n    &:not(&-delete):hover {\n      background-color: #EBF6FF !important;\n      border-color: #EBF6FF !important;\n      span {\n        color: #355D7D !important;\n      }\n    }\n  }\n\n  &-link {\n    width: 100%;\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    font-weight: 400;\n    color: $black;\n\n    &:hover {\n      color: $black !important;\n    }\n\n    &-REVIEW {\n      color: $state-review-text !important;\n    }\n  }\n\n  &-link-border {\n    width: 100%;\n    border-radius: 6px;\n    border: 1px solid #162E43 !important;\n    background: none;\n    color: #3c302a !important;\n    text-align: center;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    letter-spacing: 0.21px;\n\n    &:disabled {\n      background-color: $button-disbaled-background !important;\n      border-color: $button-disbaled-border !important;\n      color: $button-color !important;\n    }\n  }\n\n  &-link-blue {\n    color: #5E8EB7;\n    span {\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      text-decoration-line: underline;\n    }\n\n    &:hover {\n      color: #5E8EB7 !important;\n    }\n  }\n\n  &-blue {\n    color: #5E8EB7;\n    span {\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n    }\n\n    &:hover {\n      color: #5E8EB7 !important;\n    }\n  }\n\n  &-open-modal {\n    width: 100%;\n\n    &:hover {\n      border-color: $grey-border !important;\n      color: $black !important;\n    }\n\n    &-REVIEW {\n      border-color: $state-review-border;\n      color: $state-review-text;\n  \n      &:hover {\n        border-color: $state-review-border !important;\n        background-color: $state-review-dark !important;\n        color: white !important;\n      }\n    }\n  }\n}\n",".select {\n  &-primary {\n    width: 100%;\n    height: 40px;\n    .ant-select-selector {\n      height: 40px !important;\n      padding: 2px 11px !important;\n      border-radius: 10px !important;\n      border: 1px solid #5e8eb7 !important;\n      .ant-select-selection-search-input {\n        height: 40px !important;\n      }\n    }\n  }\n}\n",".circle {\n    background-color: #fff;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    border: 1px solid #2a2f3c;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .upload {\n        width: auto;\n        height: 18px;\n        object-fit: cover;\n    }\n}\n\n.circles-tags {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 8px;\n}\n\n.circle-state-tooltip {\n    padding: 6px 7px !important;\n    opacity: 1 !important;\n\n    b {\n        font-weight: 600;\n    }\n\n    span {\n        margin-top: 10px;\n    }\n\n    &-APPROVED {\n        background-color: $state-approved-border-dark !important;\n    }\n\n    &-DRAFT {\n        background-color: $state-draft-hover !important;\n    }\n\n    &-REQUEST_ERROR {\n        background-color: $state-error-border !important;\n    }\n\n    &-REVIEW {\n        background-color: $state-review-label !important;\n    }\n}",".error-box {\n  width: 100%;\n  min-height: 43px;\n  top: 615px;\n  left: 126px;\n  border-width: 1px;\n  border-radius: 6px;\n  border: 1px solid #DDAA42;\n  background: #FCF8F7;\n  padding: 10px 16px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  span {\n    font-family: Inter;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 145%;\n    color: #775614;\n    flex: 1;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n  img {\n    padding-left: 6px;\n    flex-shrink: 0;\n  }\n}","$button-blue: #5E8EB7;\n$blue-button-tab: #355c7d;\n\n.DrodownBasic {\n    height: 40px;\n    padding: 1px 3px !important;\n    display: flex;\n    align-items: center;\n    border: 1px solid #6E7889;\n    width: 100%;\n\n    span {\n        color: #6E7889;\n        padding-left: 16px;\n    }\n\n\n    &-blue {\n        border: 1px solid #9BBCEB;\n        border-radius: 10px;\n\n        .ant-dropdown-menu {\n            padding: 0px;\n            width: 160px;\n        }\n\n        .ant-dropdown-menu-item {\n            &:hover {\n                background-color: #EBF6FF !important;\n\n                .ant-dropdown-menu-title-content {\n                    color: $blue-button-tab;\n                    font-weight: 600;\n                }\n            }\n        }\n\n        .ant-dropdown-menu-title-content {\n            color: $button-blue;\n            font-weight: 400;\n\n            &:hover {\n                color: $blue-button-tab;\n                font-weight: 600;\n            }\n        }\n    }\n}",".checkbox-basic {\n\n  .ant-checkbox-wrapper {\n    color: #244560;\n    \n    &:hover {\n      .ant-checkbox-inner {\n        border: 1px solid #5E8EB7 !important;\n      }\n\n      .ant-checkbox-checked {\n        .ant-checkbox-inner {\n          background-color: #5E8EB7 !important;\n        }\n      }\n    }\n  }\n\n  .ant-checkbox,\n  .ant-checkbox-input {\n    border: none;\n\n    &:hover {\n      .ant-checkbox-inner {\n        border: 1px solid #5E8EB7 !important;\n      }\n\n      .ant-checkbox-checked {\n        .ant-checkbox-inner {\n          background-color: #5E8EB7 !important;\n        }\n      }\n    }\n  }\n\n  .ant-checkbox-inner {\n    width: 18px;\n    height: 18px;\n    border: 1px solid #5E8EB7;\n  }\n\n  .ant-checkbox-disabled {\n    .ant-checkbox-inner {\n      border-radius: 2px;\n      background: #DFE4EB !important;\n      border: 1px solid #DFE4EB;\n    }\n  }\n\n  .ant-checkbox-checked {\n    &:hover {\n      .ant-checkbox-inner {\n        background-color: #5E8EB7 !important;\n      }\n    }\n\n    .ant-checkbox-inner {\n      border-radius: 2px;\n      background: #5E8EB7;\n    }\n  }\n}",".Layout {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  .content {\n    width: 100%;\n  }\n  .BarLogin {\n    padding: 16px;\n    background-color: #eff3f5;\n    width: 64px;\n    height: 100vh;\n    border-right: 1px solid #dfe4eb;\n    .logo {\n      width: 32px;\n    }\n  }\n}\n",".select-section {\n\n  &-selected {\n    .ant-select-selector {\n      background: #F5FAFF !important;\n      border: 1px solid #5E8EB7 !important;\n      padding-left: 10px !important;\n\n      .ant-select-selection-item {\n        color: #355C7D !important;\n      }\n\n      .ant-select-selection-item-content {\n        color: #5E8EB7 !important;\n      }\n    }\n  }\n\n  .ant-select {\n    display: block;\n    height: 40px;\n    margin-top: 6px;\n\n    .ant-select-selection-placeholder {\n      margin-bottom: 0;\n      color: #6E7889 !important;\n    }\n  }\n}\n\n.ant-select-dropdown {\n\n  div {\n    color: #6E7889;\n  }\n\n  .anticon {\n    display: none;\n  }\n\n  .circle {\n    width: 14px !important;\n    height: 14px !important;\n    border-color: #CCD3DB;\n  }\n}\n\n.ant-select-outlined.ant-select-multiple .ant-select-selection-item {\n  background: none;\n  border: none;\n  \n  span {\n    color: rgb(53, 92, 125) !important;\n  }\n}\n\n.ant-select-item-option-selected {\n  .ant-select-item-option-content {\n    div {\n      color: #48759A !important;\n    }\n\n  }\n}",".task-item-list {\n  .circle-state-tooltip {\n    padding: 6px 7px;\n    opacity: 1;\n\n    b {\n      font-weight: 600;\n    }\n\n    span {\n      margin-top: 10px;\n    }\n\n    &-APPROVED {\n      background-color: $state-approved-border-dark;\n    }\n\n    &-DRAFT {\n      background-color: darken(#DFE4EB, 10%);\n    }\n\n    &-REQUEST_ERROR {\n      background-color: $state-error-border;\n    }\n\n    &-REVIEW {\n      background-color: $state-review-label;\n    }\n  }\n\n  .circles-tags {\n    display: flex;\n    align-items: end;\n    gap: 20px;\n    margin-top: 5px;\n  }\n\n  .circle {\n    width: 16px;\n    height: 16px;\n\n    &-APPROVED {\n      background-color: $green-tab-active;\n      border-color: $green-tab-active-text;\n\n      &:hover {\n        background-color: $state-approved-border-dark;\n      }\n\n      &-active {\n        background-color: $state-approved-border-dark;\n      }\n    }\n\n    &-REVIEW {\n      background-color: $state-review-border;\n      border-color: $state-review;\n\n      &:hover {\n        background-color: $state-review-label;\n      }\n\n      &-active {\n        background-color: $state-review-label;\n      }\n    }\n\n    &-REQUEST_ERROR {\n      background-color: $state-error-background;\n      border-color: $state-error-border;\n\n      &:hover {\n        background-color: $state-error-border;\n      }\n\n      &-active {\n        background-color: $state-error-border;\n      }\n    }\n\n    &-DRAFT {\n      background-color: #DFE4EB;\n      border: 1px solid #CCD3DB;\n\n      &:hover {\n        background-color: darken(#DFE4EB, 5%);\n      }\n\n      &-active {\n        background-color: darken(#DFE4EB, 5%);\n      }\n    }\n\n    &-INCOMPLETE {\n      background-color: $black-text;\n      border: 1px solid $black-text;\n\n      &:hover {\n        background-color: darken($black-text, 5%);\n      }\n\n      &-active {\n        background-color: darken($black-text, 5%);\n      }\n    }\n  }\n}",".LoanProgress {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n\n  .tab {\n    margin: 0 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    .popover-label {\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n    }\n\n    .bar-status {\n      cursor: pointer;\n      width: 100%;\n      width: calc(100% + 20px);\n      height: 8px;\n      border-radius: 16px;\n      margin-top: 6px;\n      background-color: $white-button-tab;\n    }\n\n    &-complete {\n      .text-status {\n        color: #141F15;\n      }\n\n      .body-small {\n        color: #2D7032;\n      }\n\n      .bar-status {\n        background-color: #4CA852;\n\n        &-selected {\n          background-color: #2D7032;\n\n          &:hover {\n            background-color: #2D7032 !important;\n          }\n        }\n\n        &:hover {\n          background-color: #3F9545;\n\n          .body-small {\n            color: #2D7032;\n          }\n        }\n      }\n    }\n\n    &-blocked {\n      .body-small {\n        color: #8A130F;\n      }\n\n      .text-status {\n        color: #610805;\n      }\n\n      .bar-status {\n        background-color: #C13934;\n\n        &-selected {\n          background-color: #8A130F;\n\n          &:hover {\n            background-color: #8A130F !important;\n          }\n        }\n\n        &:hover {\n          background-color: #A31C17;\n\n          .body-small {\n            color: #8A130F;\n          }\n        }\n      }\n    }\n\n    &-error {\n      .body-small {\n        color: #8A130F;\n      }\n\n      .text-status {\n        color: #610805;\n      }\n\n      .bar-status {\n        background-color: #FFDAD6;\n\n        &-selected {\n          background-color: #8A130F;\n\n          &:hover {\n            background-color: #8A130F !important;\n          }\n        }\n\n        &:hover {\n          background-color: #C13934;\n\n          .body-small {\n            color: #8A130F;\n          }\n        }\n      }\n    }\n\n    &-progress {\n\n      .text-status {\n        color: #122536;\n      }\n\n      .body-small {\n        color: #404859;\n      }\n\n      .bar-status {\n        background-color: #5E8EB7;\n\n        &-selected {\n          background-color: #355C7D;\n\n          &:hover {\n            background-color: #355C7D !important;\n          }\n        }\n\n        &:hover {\n          background-color: #48759A;\n\n          .body-small {\n            color: #404859;\n          }\n        }\n      }\n    }\n\n    &-not-started {\n      .bar-status {\n        background-color: white;\n        border: 1px solid #404859;\n\n        &-selected {\n          background-color: #404859;\n\n          &:hover {\n            background-color: #404859 !important;\n          }\n        }\n\n        &:hover {\n          background-color: #929FB0;\n        }\n      }\n    }\n\n    &-open-content {\n      position: absolute;\n      border: 1px solid #929FB0;\n      box-shadow: 2px 2px 10px 0px #0000001A;\n      height: auto;\n      min-height: 253px;\n      width: 825px;\n      background: white;\n      top: 150px;\n      border-radius: 10px;\n      z-index: 99;\n\n      .content {\n        &-bar-status {\n          width: 823px;\n          height: 68px;\n          background: white;\n          border-radius: 10px;\n          display: flex;\n          justify-content: flex-start;\n          align-items: start;\n          gap: 8px;\n          padding-left: 8px;\n          padding-top: 3px;\n\n          .tab {\n            .body-small {\n              font-size: 12px !important;\n            }\n\n            &-error {\n              span {\n                color: #610805;\n              }\n            }\n          }\n\n          .bar-status {\n            width: -webkit-fill-available;\n            height: 16px;\n            border-radius: 16px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            .text-status {\n              display: flex;\n              align-items: center;\n              gap: 3px;\n\n              span {\n                font-family: Inter;\n                font-size: 10px;\n                font-weight: 600;\n              }\n            }\n\n\n            &:hover {\n              span {\n                display: none;\n              }\n\n              .text-status {\n                display: none;\n              }\n            }\n          }\n\n          .tab {\n            margin: 0 0;\n          }\n\n          .tab:nth-child(1) {\n            width: 10%;\n          }\n\n          .tab:nth-child(2) {\n            width: 22%;\n          }\n\n          .tab:nth-child(3) {\n            width: 38%;\n          }\n\n          .tab:nth-child(4) {\n            width: 14%;\n          }\n\n          .tab:nth-child(5) {\n            width: 11%;\n          }\n        }\n\n        &-phase-select {\n          width: 823px;\n          height: auto;\n          min-height: 183px;\n          border-radius: 10px;\n          background: #F9FAFB;\n          border-top: 1px solid #DFE4EB;\n\n          &-complete {\n            background: #F8FFF8;\n            border-top: 1px solid #C2F0C5;\n\n            .tag-state {\n              background: #C2F0C5;\n\n              b,\n              span {\n                color: #141F15;\n              }\n            }\n\n            .content-phase {\n              b {\n                color: #1F4222;\n              }\n\n              p {\n                color: #1F4222 !important;\n              }\n\n              &-first {\n                b {\n                  color: #2D7032;\n                }\n              }\n\n            }\n          }\n\n          &-blocked {\n            background: #FCF8F7;\n            border-top: 1px solid #FFC6BF;\n\n            .tag-state {\n              background: #FFD4CF;\n\n              b,\n              span {\n                color: #610805;\n              }\n            }\n\n            .content-phase {\n              b {\n                color: #2A2F3C;\n              }\n\n              &-first {\n                b {\n                  color: #610805;\n                }\n              }\n            }\n          }\n\n          &-error {\n            background: #FCF8F7;\n            border-top: 1px solid #FFC6BF;\n\n            .tag-state {\n              background: #FFD4CF;\n\n              b,\n              span {\n                color: #610805;\n              }\n            }\n\n            .content-phase {\n              b {\n                color: #2A2F3C;\n              }\n\n              &-first {\n                b {\n                  color: #610805;\n                }\n              }\n            }\n          }\n\n          &-progress {\n            background: #F5FAFF;\n            border-top: 1px solid #B6DCFC;\n\n            .tag-state {\n              background: #B6DCFC;\n\n              b,\n              span {\n                color: #122536;\n              }\n            }\n\n            .content-phase {\n              b {\n                color: #2A2F3C;\n              }\n\n              &-first {\n                b {\n                  color: #244560;\n                }\n              }\n            }\n          }\n\n          &-not-started {\n            .tag-state {\n              border: 1px solid #404859;\n            }\n          }\n\n          .tag-state {\n            height: 16px;\n            width: max-content;\n            display: flex;\n            align-items: center;\n            gap: 3.5px;\n            border-radius: 10px;\n            padding: 3px 7px;\n            margin: 16px 23px;\n\n            b {\n              font-size: 10px;\n              font-weight: 600;\n            }\n\n            span {\n              font-size: 10px;\n              font-weight: 400;\n            }\n          }\n\n          .divider {\n            border: 0.7px solid #929FB0;\n            height: auto;\n          }\n\n          .content-phase {\n            margin: 0px 24px;\n            padding-bottom: 23px;\n\n            b {\n              font-size: 12px;\n              font-weight: 600;\n            }\n\n            p {\n              font-size: 12px;\n              font-weight: 400;\n              color: #2A2F3C;\n              margin-top: 6px;\n            }\n\n            &-first {\n              width: 270px;\n\n              b {\n                font-size: 16px;\n                font-weight: 600;\n              }\n            }\n\n            &-second {\n              width: 240px;\n              margin-left: 20px;\n            }\n\n            &-third {\n              .task-item {\n                display: inline-flex;\n                max-width: 335px;\n\n                .task-label {\n                  min-width: 0;\n                  word-break: break-word;\n                  overflow-wrap: break-word;\n\n                  b {\n                    display: inline;\n                  }\n                }\n              }\n            }\n\n            .task-item {\n              display: flex;\n              align-items: center;\n              gap: 5px;\n              margin-top: 4px;\n              width: max-content;\n              border-radius: 4px;\n              padding: 2px 3px;\n\n              span {\n                font-family: Inter;\n                font-size: 12px;\n              }\n\n              b {\n                font-family: Inter;\n                font-weight: 500;\n              }\n\n              .bold {\n                font-weight: 600 !important;\n              }\n\n              .circle {\n                width: 12px;\n                height: 12px;\n                border: 1px solid #6E7889;\n                border-radius: 50%;\n              }\n\n              &-APPROVED {\n                background-color: #D5F7E2;\n\n                span,\n                b,\n                strong {\n                  color: #2D7032;\n                }\n              }\n\n              &-REQUEST_ERROR,\n              &-BLOCKED {\n                background: #FFC6BF;\n\n                span,\n                b,\n                strong {\n                  color: #610805;\n                }\n              }\n\n              &-REVIEW {\n                background: #F7EDFC;\n\n                span,\n                b,\n                strong  {\n                  color: #855791;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}",".borrowers {\n  padding: 24px 25px;\n\n  .dropdown-review-bold {\n    span {\n      font-weight: 600;\n      text-decoration-line: underline;\n    }\n\n    color: $state-review !important;\n    height: 26px;\n    display: unset;\n    padding: 0 !important;\n  }\n\n  .top-container {\n    box-sizing: content-box;\n    width: 100%;\n\n    margin-bottom: 33px;\n\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    justify-content: space-between;\n\n    .title {\n      color: var(--800-grey, #404859);\n      font-family: Inter;\n      font-size: 32px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n\n      >span {\n        cursor: pointer;\n\n        color: var(--blue60, #5E8EB7);\n        font-family: Inter;\n        font-size: 32px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        text-decoration-line: underline;\n      }\n    }\n  }\n\n  .badges-container {\n    display: flex;\n  }\n\n  &-container {\n    padding: 16px 0px;\n\n    >* {\n      margin-bottom: 16px;\n      &:last-child {\n        margin-bottom: 0px;\n      }\n    }\n  }\n}\n\n.search-box {\n  cursor: pointer;\n\n  box-sizing: border-box;\n  width: 384px;\n  padding: 5px 18px 5px 8px;\n\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  border-radius: 10px;\n  border: 1px solid var(--400-grey, #CCD3DB);\n  background: var(--gray-100, #F9FAFB);\n\n  color: var(--700-grey, #6E7889);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 120%;\n\n  >input {\n    all: unset;\n    width: 100%;\n    margin-left: 8px;\n  }\n}\n\n.status-badge {\n  cursor: pointer;\n\n  padding: 4px 12px;\n  border-radius: 100px;\n\n  display: flex;\n  align-items: center;\n\n  background: var(--300-grey, #DFE4EB);\n\n  margin-right: 12px;\n\n  .title {\n    margin-right: 4px;\n\n    color: var(--800-grey, #404859);\n    text-align: right;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 16px; /* 133.333% */\n\n    white-space: nowrap;\n  }\n\n  .count {\n    color: var(--800-grey, #404859);\n    text-align: right;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px; /* 133.333% */\n  }\n\n  &.selected {\n    background: #355C7D;\n    .title, .count {\n      color: #FFFFFF;\n    }\n  }\n}\n\n.borrower-list-item {\n  cursor: pointer;\n\n  box-sizing: border-box;\n  width: 100%;\n\n  display: flex;\n  align-items: center;\n  gap: 20px;\n\n  padding: 10px 24px;\n\n  border-radius: 10px;\n  border: 1px solid var(--600-grey, #929FB0);\n  background: var(--white, #FFF);\n\n  >* {\n    flex: 1 1 0;\n    min-width: 0;        // clave: deja que la columna se encoja y el texto haga ellipsis\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n\n    &.loan-status-badge-container {\n      flex: 0.8 1 0;\n    }\n\n    &.borrower-summary-container {\n      flex: 0.7 1 0;\n    }\n\n    // Columna de acción (\"View borrower details\"): solo su ancho, alineada a la derecha\n    &:last-child {\n      flex: 0 0 auto;\n      overflow: visible;\n      align-items: flex-end;\n    }\n  }\n\n  .loan-status-badge {\n    display: inline-block;\n\n    border-radius: 76px;\n    border: 1px solid var(--blue60, #5E8EB7);\n\n    padding: 4px 7px;\n\n    color: var(--70, #48759A);\n    text-align: center;\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.2px;\n    text-transform: uppercase;\n  }\n\n  .borrower-summary {\n    .caption {\n      color: var(--700-grey, #6E7889);\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 115%;\n      text-transform: capitalize;\n\n      margin-bottom: 2px;\n    }\n\n    .borrower-name {\n      color: var(--900-grey, #2A2F3C);\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 115%;\n      text-transform: capitalize;\n    }\n  }\n\n  .entities-summary {\n    .caption {\n      color: var(--700-grey, #6E7889);\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 115%;\n      text-transform: capitalize;\n\n      margin-bottom: 2px;\n    }\n\n    .content {\n      color: var(--800-grey, #404859);\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 115%;\n      text-transform: capitalize;\n      white-space: nowrap;\n      display: flex;\n      gap: 3px;\n      align-items: center;\n      min-width: 0;\n      max-width: 100%;\n\n      // el primer nombre se trunca; el \"& X more\" queda visible\n      > span:first-child {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        min-width: 0;\n      }\n    }\n  }\n\n  .task-summary {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n\n    .address {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      min-width: 0;\n      max-width: 100%;\n      white-space: nowrap;\n      overflow: hidden;\n\n      // el primer loan (nombre o dropdown) se trunca; \"& X more\" queda visible\n      > *:first-child {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        min-width: 0;\n        flex: 0 1 auto;\n      }\n\n      > *:not(:first-child) {\n        flex: 0 0 auto;\n      }\n    }\n\n    .caption {\n      color: var(--700-grey, #6E7889);\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 115%;\n      text-transform: capitalize;\n\n      margin-bottom: 2.5px;\n    }\n\n    .task-item-container {\n      display: flex;\n      gap: 9px;\n\n      .task-item {\n        box-sizing: border-box;\n        height: 15px;\n        width: 15px;\n        border-radius: 100px;\n        \n        margin-right: 8px;\n\n        background-color: #DFE4EB;\n        border: 1.5px solid #CCD3DB;\n\n        &.completed {\n          background-color: #4CA852;\n          border: unset;\n        }\n\n        &.review {\n          background-color: #855791;\n          border: unset;\n        }\n      }\n    }\n  }\n\n  .action-container {\n    color: var(--blue60, #5E8EB7);\n    text-align: right;\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n\n    white-space: nowrap;\n\n    align-self: flex-end;\n  }\n\n  &:hover {\n    border-radius: 10px;\n    border: 1px solid var(--blue-40, #97BCF0);\n    background: var(--10, #F5FAFF);\n    box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.10);\n\n    .borrower-summary {\n      .caption {\n        color: var(--70, #48759A);\n      }\n      .borrower-name {\n        color: var(--90, #244560);\n      }\n    }\n\n    .address-summary {\n      .caption {\n        color: var(--70, #48759A);\n      }\n      .address {\n        color: var(--blue-80, #355C7D);\n      }\n    }\n\n    .task-summary {\n      .caption {\n        color: var(--70, #48759A);\n      }\n    }\n\n    .action-container {\n      color: var(--70, #48759A);\n      font-weight: 600;\n\n      &:hover {\n        color: var(--90, #244560);\n        font-weight: 700;\n      }\n    }\n  }\n}",".right-scenes{\n  position: fixed;\n  background: rgba(42, 47, 60, 0.55);\n  backdrop-filter: blur(2px);\n  top: 0;\n  left: 70px;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &-content {\n    position: relative;\n    width: calc(100% - 70px); /* Ancho de la pantalla menos 70px */\n    background-color: #fff;\n    height: 100%;\n    animation: slideIn 1s forwards;\n  }\n\n  @keyframes slideIn {\n    from {\n      transform: translateX(calc(-100% + 70px));\n    }\n    to {\n      transform: translateX(0);\n    }\n  }\n\n  .button-close-mask {\n    width: 30%;\n    height: 100%;\n    background-color: rgba(255, 0, 0, 0);\n    box-shadow: none;\n    border: none;\n\n    &:hover,\n    &:active,\n    &:focus {\n      background-color: rgba(255, 0, 0, 0);\n      box-shadow: none;\n      border: none;\n    }\n  }\n}",".view-borrower-detail {\n  padding: 50px 15px;\n  &-header {\n    .title {\n      color: $state-draft-hover;\n      font-size: 32px;\n      font-weight: 600;\n      gap: 5px;\n\n      button {\n        height: 32px;\n        span {\n          font-size: 32px;\n        }\n      }\n    }\n  }\n  .button-r,\n  .button-r:hover {\n    width: 58px;\n    height: 20px;\n    border: 1px solid #bb8d2f;\n    color: #bb8d2f;\n    border-radius: 76px;\n    padding: 0;\n    font-family: Inter;\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 12.1px;\n    margin: 0 15px;\n  }\n  .button-delete,\n  .button-delete:hover {\n    height: 20px;\n    border: none;\n    color: #c94f4a;\n    padding: 0;\n    font-family: Inter;\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 12.1px;\n    margin: 0 15px;\n  }\n  .flex-2-col {\n    display: flex;\n    margin-top: 20px;\n    justify-content: space-between;\n    width: 100%;\n    gap: 30px;\n    .box {\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n      width: 50%;\n    }\n  }\n  .gap-3 {\n    gap: 6px;\n  }\n  .card-profile-generic {\n    border: 1px solid #afbdcc;\n    border-radius: 10px;\n    padding: 15px;\n    width: 100%;\n    .card-title {\n      font-family: Inter;\n      font-size: 24px;\n      font-weight: 400;\n      line-height: 29.05px;\n      text-align: left;\n    }\n    .table {\n      width: 100%;\n      margin-top: 10px;\n      &-row {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        margin-bottom: 7px;\n        .title {\n          font-family: Inter;\n          font-size: 12px;\n          font-weight: 400;\n          line-height: 14.52px;\n          text-align: left;\n          color: #6e7889;\n        }\n\n        .flex {\n          display: flex;\n          justify-content: space-between;\n          .col {\n            width: 50%;\n            .italic {\n              font-family: Inter;\n              font-size: 14px;\n              font-style: italic;\n              font-weight: 400;\n              line-height: 16.94px;\n              text-align: left;\n              color: #929fb0;\n            }\n          }\n        }\n      }\n    }\n    .avatar {\n      .ant-avatar-string {\n        font-size: 25px;\n      }\n\n      .ant-upload {\n        width: 68px !important;\n        height: 68px !important;\n      }\n    }\n\n    .ant-upload-wrapper.ant-upload-picture-circle-wrapper {\n      width: auto;\n    }\n\n    .title-bold {\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 16.94px;\n      text-align: left;\n      color: #404859;\n      .bold {\n        font-weight: 600;\n      }\n    }\n    .body-bold {\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 16.94px;\n      text-align: right;\n    }\n    .button-transparent,\n    .button-transparent:hover {\n      padding: 0;\n      height: 20px;\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 16.94px;\n      text-align: left;\n      color: #8a130f;\n    }\n    .button-round {\n      width: 75px;\n      height: 20px;\n      padding: 0;\n      border-radius: 76px;\n      border: 2px solid #404859;\n      font-family: Inter;\n      font-size: 10px;\n      font-weight: 600;\n    }\n    .button-edit,\n    .button-edit:hover {\n      font-family: Inter;\n      font-size: 10px;\n      font-weight: 500;\n      line-height: 12px;\n      text-align: left;\n      color: #5e8eb7;\n      .edit {\n        width: 10px;\n        height: 10px;\n        margin-right: 3px;\n      }\n    }\n    .link {\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 16.94px;\n      text-align: left;\n      color: #5e8eb7;\n      text-decoration: none;\n      .arrow {\n        width: 15px;\n        margin-left: 5px;\n      }\n    }\n    .text-footer {\n      font-family: Inter;\n      font-size: 12px;\n      font-weight: 400;\n      line-height: 14.52px;\n      text-align: left;\n      color: #6e7889;\n      margin-top: 14px;\n      span {\n        color: #4e8aff;\n      }\n    }\n  }\n  \n  .card-report {\n    position: relative;\n\n    .button {\n      span {\n        font-family: Inter;\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 19.36px;\n        letter-spacing: 0.015em;\n        text-align: center;\n      }\n    }\n\n    .button-edit {\n      position: absolute;\n      top: 8px;\n      right: 15px;\n\n      span {\n        font-family: Inter;\n        font-size: 10px;\n        font-weight: 500;\n        line-height: 12px;\n        text-align: left;\n        color: #5e8eb7;\n      }\n    }\n\n    &-head {\n      display: flex;\n      justify-content: space-between;\n    }\n\n    .date-expires {\n      font-family: Inter;\n      font-size: 14px;\n      font-style: italic;\n      font-weight: 400;\n      line-height: 16.94px;\n      text-align: right;\n      color: #6E7889;\n    }\n\n    .upload-report-span {\n      cursor: pointer;\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 16.94px;\n      text-align: right;\n      color: #5E8EB7;\n      text-decoration: underline;\n    }\n\n    .credit-score-input {\n      input {\n        text-align: end;\n      }\n      &-text {\n        text-align: end;\n        padding: 5px 0px;\n      }\n    }\n  }\n}\n",".loan-details {\n  padding: 43px 40px;\n\n  overflow: hidden;\n\n  .loan-details-top-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    padding-bottom: 8px;\n    border-bottom: 1px solid #929FB0;\n    margin-bottom: 22px;\n\n    .loan-info {\n      margin-bottom: 2px;\n      \n      .loan-borrower-name {\n        color: var(--800-grey, #404859);\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 16px; /* 133.333% */\n        letter-spacing: 0.24px;\n        text-transform: uppercase;\n      }\n\n      .loan-address {\n        color: var(--800-grey, #404859);\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 16px;\n        letter-spacing: 0.24px;\n        text-transform: uppercase;\n      }\n    }\n\n    .close-button-container {\n      cursor: pointer;\n\n      color: var(--800-grey, #404859);\n      text-align: right;\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 16px; /* 133.333% */\n      letter-spacing: 0.24px;\n      text-transform: uppercase;\n    }\n  }\n\n  .loan-details-first-row {\n    display: flex;\n    justify-content: space-between;\n\n    border-bottom: solid 1px #CCD3DB;\n    margin-bottom: 16px;\n\n    .loan-progress {\n      flex: 6;\n      .loan-info {\n        .loan-status {\n          color: var(--800-grey, #404859);\n          font-family: Inter;\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 16px;\n          letter-spacing: 0.36px;\n        }\n\n        .loan-closing-date {\n          color: var(--800-grey, #404859);\n          font-family: Inter;\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 16px;\n          letter-spacing: 0.36px;\n\n          b {\n            color: var(--800-grey, #404859);\n            font-family: Inter;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: 16px;\n            letter-spacing: 0.36px;\n          }\n        }\n      }\n\n      .loan-address {\n        color: var(--900-grey, #2A2F3C);\n        font-family: Inter;\n        font-size: 32px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 40px;\n      }\n\n      .loan-progress-section {\n        margin-bottom: 20px;\n\n        .loan-progress-items-container {\n          display: flex;\n          flex-direction: row;\n\n          >* {\n            flex: 1;\n            margin-right: 8px;\n          }\n\n          .loan-progress-item-caption {\n            color: var(--800-grey, #404859);\n            font-family: Inter;\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: normal;\n\n            white-space: nowrap;\n            margin-bottom: 6px;\n\n            flex: 0.13;\n          }\n        }\n      }\n\n      .loan-values-summary {\n        margin-bottom: 8px;\n\n        color: var(--800-grey, #404859);\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 115%;\n\n        span {\n          cursor: pointer;\n\n          color: var(--blue60, #5E8EB7);\n          font-family: Inter;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 115%;\n        }\n      }\n\n      .closed-loan {\n        display: flex;\n        align-items: center;\n        border: 1px solid #5E8EB7;\n        span, a {\n          color: #122536;\n          font-weight: 600;\n        }\n        a {\n          text-decoration: underline;\n        }\n      }\n  \n    }\n\n    .placeholder {\n      flex: 3;\n    }\n\n    .borrower-card {\n      flex: 1;\n    }\n  }\n\n  .loan-details-main {\n    display: flex;\n\n    >* {\n      flex: 1;\n      box-sizing: border-box;\n    }\n\n    .left-column {\n      padding-right: 15px;\n\n      >* {\n        margin-bottom: 16px;\n\n        &:last-of-type {\n          margin-bottom: 0px;\n        }\n      }\n\n      .loan-summary {\n        display: flex;\n        justify-content: space-between;\n\n        .closing {\n          flex: 1;\n\n          border-radius: 10px;\n          border: 1px solid var(--500-grey, #AFBDCC);\n          \n          padding: 16px 20px;\n\n          margin-right: 16px;\n\n          .label {\n            color: var(--900-grey, #2A2F3C);\n            font-family: Inter;\n            font-size: 22px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: normal;\n\n            margin-bottom: 18px;\n          }\n\n          .calendar {\n            width: 128px;\n\n            border-radius: 10px;\n            border: 1px solid var(--blue60, #5E8EB7);\n            background: var(--10, #F5FAFF);\n\n            margin-bottom: 8px;\n\n            &.disabled {\n              border: 1px solid var(--600-grey, #929FB0);\n              background: var(--200-grey, #EFF3F5);\n\n              .date {\n                color: var(--70, #48759A);\n                border-bottom: 1px solid #929FB0;\n              }\n\n              .day {\n                color: var(--300-grey, #DFE4EB);\n              }\n            }\n\n            .date {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n\n              padding: 6px 26px;\n\n              border-bottom: 1px solid #5E8EB7;\n\n              color: var(--70, #48759A);\n              font-family: Inter;\n              font-size: 14px;\n              font-style: normal;\n              font-weight: 600;\n              line-height: 16px; /* 114.286% */\n            }\n\n            .day {\n              height: 68px;\n\n              display: flex;\n              align-items: center;\n              justify-content: center;\n\n              color: var(--blue-80, #355C7D);\n              font-family: Inter;\n              font-size: 32px;\n              font-style: normal;\n              font-weight: 600;\n              line-height: normal;\n            }\n          }\n          \n          .caption {\n            color: var(--800-grey, #404859);\n            font-family: Inter;\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 18px; /* 128.571% */\n\n            b {\n              font-weight: 600;\n              color: #404859;\n            }\n          }\n        }\n\n        .content-box {\n          flex: 5;\n        }\n      }\n    }\n\n    .right-column {\n      padding-left: 15px;\n\n      .borrower-tasks {\n        >.title {\n          margin-bottom: 8px;\n\n          color: var(--900-grey, #2A2F3C);\n          font-family: Inter;\n          font-size: 32px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 40px;\n        }\n\n        .borrower-tasks-status-container {\n          display: flex;\n          margin-bottom: 16px;\n        }\n\n        .borrower-tasks-actions {\n          display: flex;\n          align-items: center;\n          justify-content: flex-end;\n          margin-bottom: 7px;\n\n          >div {\n            cursor: pointer;\n\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 3px;\n\n            svg {\n              position: relative;\n            }\n\n            margin-left: 16px;\n\n            color: var(--700-grey, #6E7889);\n            text-align: right;\n            font-family: Inter;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            letter-spacing: 0.24px;\n            text-transform: uppercase;\n          }\n        }\n\n        .borrower-tasks-list {\n          margin-bottom: 17px;\n        }\n      }\n\n      .action-button {\n        border: 1px solid var(--100, #162E43);\n        background: var(--100, #162E43);\n        text-align: center;\n\n        border-radius: 6px;\n        padding: 14px 0px;\n        margin-bottom: 30px;\n\n        color: var(--10, #F5FAFF);\n        text-align: center;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        letter-spacing: 0.24px;\n        cursor: pointer;\n\n        &:hover {\n          background-color: #EBF6FF !important;\n          border-color: #EBF6FF !important;\n    \n          color: #355D7D !important;\n        }\n      }\n\n      .loan-documents {\n        >.title {\n          margin-bottom: 8px;\n\n          color: var(--900-grey, #2A2F3C);\n          font-family: Inter;\n          font-size: 32px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 40px;\n        }\n\n        .loan-documents-docs-actions {\n          display: flex;\n          align-items: center;\n          justify-content: flex-end;\n          margin-bottom: 7px;\n\n          >div {\n            cursor: pointer;\n\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 3px;\n\n            svg {\n              position: relative;\n            }\n\n            margin-left: 16px;\n\n            color: var(--700-grey, #6E7889);\n            text-align: right;\n            font-family: Inter;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            letter-spacing: 0.24px;\n            text-transform: uppercase;\n          }\n        }\n\n        .loan-documents-list {\n          \n        }\n      }\n\n      .approve-loan {\n        padding: 14px 0px;\n        text-align: center;\n        \n        border-radius: 6px;\n        border: 1px solid var(--300-grey, #DFE4EB);\n        background: var(--300-grey, #DFE4EB);\n\n        color: var(--600-grey, #929FB0);\n        text-align: center;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        letter-spacing: 0.24px;\n      }\n    }\n  }\n}\n\n.loan-progress-item {\n  .caption {\n    color: var(--800-grey, #404859);\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n\n    white-space: nowrap;\n    text-align: center;\n\n    margin-bottom: 4px;\n  }\n\n  .loan-progress-bar {\n    width: 100%;\n    height: 6px;\n    border-radius: 16px;\n    background: var(--300-grey, #DFE4EB);\n  }\n}\n\n.content-box {\n  border-radius: 10px;\n  border: 1px solid var(--500-grey, #AFBDCC);\n\n  padding: 16px 20px;\n\n  .label {\n    color: var(--900-grey, #2A2F3C);\n    font-family: Inter;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n\n    margin-bottom: 10px;\n  }\n\n  .content {\n    border-left: 1px solid #97BCF0;\n    padding: 2px 0px;\n    padding-left: 12px;\n    min-width: 0;\n    overflow: hidden;\n\n    .item {\n      margin-bottom: 8px;\n      \n      &:last-of-type {\n        margin-bottom: 0px;\n      }\n    }\n\n    .item-row {\n      color: var(--800-grey, #404859);\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    \n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      .value {\n        i {\n          color: var(--700-grey, #6E7889);\n        }\n\n        span {\n          cursor: pointer;\n          \n          color: var(--blue60, #5E8EB7);\n          text-align: right;\n          font-family: Inter;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: normal;\n        }\n      }\n\n      &.extra {\n        margin-top: 8px;\n        padding-left: 16px;\n\n        color: var(--900-grey, #2A2F3C);\n        font-family: Inter;\n        font-size: 14px;\n        font-style: italic;\n        font-weight: 400;\n        line-height: normal;\n\n        .value {\n          color: var(--700-grey, #6E7889);\n        }\n      }\n    }\n  }\n\n  .quill {\n    height: auto;\n\n    .ql-container {\n      height: auto !important;\n    }\n\n    .ql-tooltip.ql-hidden {\n      display: none !important;\n    }\n\n    .ql-editor {\n      height: auto !important;\n      min-height: unset !important;\n      overflow: visible !important;\n      padding: 0 !important;\n      word-break: break-word;\n      overflow-wrap: anywhere;\n      white-space: pre-wrap;\n\n      strong {\n        font-weight: bold;\n      }\n\n      em {\n        font-style: italic;\n      }\n    }\n  }\n}\n\n\n",".document-item {\n  cursor: pointer;\n\n  display: flex;\n  flex-direction: column;\n\n  border-radius: 10px;\n  border: 1px solid var(--400-grey, #CCD3DB);\n  background: var(--white, #FFF);\n\n  .row {\n    &:first-child {\n      padding-top: 11px;\n    }\n    \n    padding-right: 16px;\n    padding-bottom: 11px;\n    padding-left: 16px;\n\n    display: flex;\n    align-items: center;\n\n    gap: 8px;\n\n    .box-message-state-review {\n      width: 100%;\n      margin-left: 45px;\n      margin-right: 13px;\n      padding: 5px 8px;\n      padding-bottom: 10px;\n      background-color: $state-review-background-ligth;\n      color: $state-review-label;\n      border: 1px solid $state-review-border-2;\n\n      span {\n        font-size: 12px;\n        font-weight: 400;\n      }\n      b {\n        font-size: 12px;\n        font-weight: 700;\n        text-decoration: underline;\n      }\n      button {\n        height: auto;\n        padding: 0px;\n        span {\n          text-decoration: underline;\n          color: $state-review-label;\n          font-size: 12px;\n        }\n        svg {\n          width: 12px;\n          height: 12px;\n        }\n        .anticon {\n          margin-inline-start: 5px;\n        }\n      }\n\n      .button-bold {\n        span {\n          font-weight: 600;\n          text-decoration: none;\n        }\n      }\n    }\n  }\n\n\n  &-COMPLETE {\n    border-radius: 10px;\n    border: 1px solid var(--green-60, #4CA852);\n    background: #FAFCFC;\n    box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n\n    .label {\n      color: var(--green-90, #1F4222);\n      font-family: Inter;\n      font-size: 22px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n\n    svg:not(.trash) {\n      path {\n        stroke: #1F4222;\n      }\n    }\n\n    .status-badge {\n      background: var(--30, #C2F0C5);\n      color: var(--100, #141F15);\n    }\n  }\n\n  &-VERIFY\\/UPDATE {\n    border-radius: 10px;\n    border: 1px solid var(--60, #C59ED5);\n    background: var(--10, #FAF9FC);\n    box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n\n    .label {\n      color: var(--90, #653B6F);\n      font-family: Inter;\n      font-size: 22px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n\n    svg:not(.trash) {\n      path {\n        stroke: var(--90, #653B6F);\n      }\n    }\n\n    .status-badge {\n      background: #EAD6FF;\n      color: var(--100, #141F15);\n    }\n  }\n\n  &-MANUAL {\n    border-radius: 10px;\n    border: 1px solid var(--60, #C59ED5);\n    background: var(--10, #FAF9FC);\n    box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n\n    .label {\n      color: var(--90, #653B6F);\n      font-family: Inter;\n      font-size: 22px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n\n    svg:not(.trash) {\n      path {\n        stroke: var(--90, #653B6F);\n      }\n    }\n\n    .status-badge {\n      background: #EAD6FF;\n      color: var(--100, #141F15);\n    }\n  }\n\n  &-UPLOAD {\n    border-radius: 10px;\n    border: 1px solid #C13934;\n    background: #FAFCFC;\n    box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n\n    .label {\n      color: #610805;\n      font-family: Inter;\n      font-size: 22px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n\n    svg:not(.trash) {\n      path {\n        stroke: #610805;\n      }\n    }\n\n    .status-badge {\n      background: #FFC6BF;\n      color: var(--100, #141F15);\n    }\n  }\n\n  &-DRAFT {\n    svg {\n      &:not(.trash) {\n        path {\n          stroke: #929FB0;\n        }\n      }\n\n      &.trash {\n        path {\n          stroke: #FFC6BF;\n        }\n      }\n    }\n\n    .label {\n      color: var(--600-grey, #929FB0);\n      font-family: Inter;\n      font-size: 22px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n\n    .status-badge {\n      background: var(--30, #EFF3F5);\n      color: var(--100, #404859);\n    }\n  }\n\n  svg {\n    height: 16px;\n    width: 16px;\n\n    margin-right: 8px;\n\n    &:last-of-type {\n      margin-right: 0px;\n    }\n  }\n\n  margin-bottom: 12px;\n\n  .actions-container {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 40px;\n\n    .disabled {\n      opacity: 0.3;\n      cursor: auto;\n    }\n  }\n\n  .label {\n    flex: 1;\n    min-width: 0;\n    font-size: 22px;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    column-gap: 24px;\n    row-gap: 0;\n    word-break: break-word;\n    overflow-wrap: break-word;\n\n    .expires-label {\n      font-family: Inter;\n      font-size: 14px;\n      font-style: italic;\n      font-weight: 400;\n      text-align: left;\n\n      &-error {\n        color: #E56A5C !important;\n      }\n\n      &-approved {\n        color: #3F9545 !important;\n      }\n    }\n  }\n\n  .feedback-actions-container {\n    display: flex;\n    align-items: start;\n\n    .action-blocked {\n      &-disabled {\n        opacity: 0.3;\n        cursor: auto;\n      }\n\n      &-blocked {\n        svg {\n          fill: #FFC6BF;\n        }\n\n        svg:not(.trash) {\n          path {\n            stroke: #610805;\n          }\n        }\n      }\n    }\n  }\n\n  .content-right {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    justify-content: end;\n    flex-shrink: 0;\n\n    .document-state {\n      width: 200px;\n      display: flex;\n      justify-content: end;\n    }\n  }\n\n\n  .expand {\n    flex: 0.2;\n  }\n}",".borrower-card {\n  display: flex;\n  flex-direction: column;\n\n  border-radius: 10px;\n  background: var(--gray-100, #F9FAFB);\n  height: 112px;\n  padding: 7px 14px;\n\n  .borrower-summary {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 256px;\n    \n\n    position: relative;\n    bottom: 8px;\n\n    .photo-container {\n      position: absolute; \n      top: -8px;\n      border-radius: 24px;\n      background: lightgray 50%;\n\n      margin-bottom: 4px;\n    }\n\n    .borrower-caption {\n      margin-top: 22px;\n      color: var(--700-grey, #6E7889);\n      text-align: center;\n      font-family: Inter;\n      font-size: 10px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      text-transform: uppercase;\n    }\n\n    .borrower-name {\n      color: var(--900-grey, #2A2F3C);\n      text-align: center;\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n    }\n  }\n\n  .contact-info-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    color: var(--800-grey, #404859);\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n\n    margin-bottom: 8px;\n  }\n\n  .buttons-container {\n    width: 100%;\n\n    >*:first-child {\n      margin-right: 8px;\n    }\n\n    .button-blue {\n      width: 100%;\n      cursor: pointer;\n\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      color: var(--100, #122536);\n      text-align: center;\n      font-family: Inter;\n      font-size: 10px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n      letter-spacing: 0.15px;\n\n      height: 24px;\n      padding: 0px 6px;\n\n      border-radius: 6px;\n      border: 1px solid var(--100, #162E43);\n      background: var(--100, #122536);\n\n      &:hover {\n        color: var(--100, #122536) !important;\n      }\n    }\n\n    .button-blue.outlined {\n      color: var(--100, #122536);\n      background: #FFF;\n    }\n  }\n}",".borrower-task-item {\n  \n  display: flex;\n  flex-direction: column;\n  \n  padding: 11px 16px;\n  \n  border-radius: 10px;\n  border: 1px solid var(--400-grey, #CCD3DB);\n  background: var(--white, #FFF);\n  margin-bottom: 12px;\n  \n  .row-1 {\n    display: flex;\n    align-items: center;\n  \n    .actions-container {\n      display: flex;\n      align-items: center;\n      width: 40px;\n      gap: 8px;\n\n      img,svg {\n        cursor: pointer;\n      }\n    }\n  \n    .label {\n      flex: 1;\n      min-width: 0;\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n      word-break: break-word;\n      overflow-wrap: break-word;\n      margin-left: 10px;\n      width: 20em;\n    }\n  \n    .feedback-actions-container {\n      display: flex;\n      width: 50px;\n      max-width: 5em;\n      gap: 8px;\n\n      svg {\n        cursor: pointer;\n      }\n    }\n\n    .content-right {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      justify-content: end;\n      width: 50%;\n\n      .content-status {\n        width: 150px;\n        display: flex;\n        justify-content: end;\n      }\n    }\n\n    .expand { \n      width: 20px;\n    }\n  }\n\n  svg {\n    height: 16px;\n    width: 16px;\n\n    margin-right: 8px;\n\n    &:last-of-type {\n      margin-right: 0px;\n    }\n\n    &:not(.trash) {\n      path {\n        stroke: #2A2F3C;\n      }\n    }\n  }\n\n  .label {\n    color: var(--900-grey, #2A2F3C);\n    font-family: Inter;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n\n  .status-badge {\n    background: var(--30, #404859);\n    .title {\n      color: var(--100, #FFFFFF);\n    }\n  } \n\n  &.DRAFT {\n    svg:not(.trash) {\n      path {\n        stroke: #404859;\n      }\n    }\n\n    .status-badge {\n      border: 1px solid var(--60, #404859);\n      background: var(--30, #FFFFFF);\n      .title {\n        color: var(--100, #404859);\n      }\n    }\n  }\n\n  &.REVIEW {\n    border: 1px solid var(--60, #C59ED5);\n    background: var(--10, #FAF9FC);\n\n    .label {\n      color: var(--90, #653B6F);\n    }\n\n    svg:not(.trash) {\n      path {\n        stroke: #653B6F;\n      }\n    }\n\n    .status-badge {\n      background: var(--30, #EAD6FF);\n      .title {\n        color: var(--100, #241226);\n      }\n    }\n\n    .liquidity-info {\n      .title {\n        color: #653B6F !important;\n      }\n\n      .max {\n        color: #653B6F;\n      }\n    }\n\n    .box-message-state-review {\n      margin-top: 10px;\n      margin-left: 45px;\n      margin-right: 28px;\n      padding: 5px 8px;\n      background-color: $state-review-background-ligth;\n      color: $state-review-label;\n      border: 1px solid $state-review-border-2;\n      span {\n        font-size: 12px;\n        font-weight: 400;\n      }\n      b {\n        font-size: 12px;\n        font-weight: 700;\n      }\n      button {\n        height: auto;\n        padding: 0px;\n        span {\n          text-decoration: underline;\n          color: $state-review-label;\n          font-size: 12px;\n        }\n        svg {\n          width: 12px;\n          height: 12px;\n        }\n        .anticon {\n          margin-inline-start: 5px;\n        }\n      }\n\n      .button-bold {\n        span {\n          font-weight: 600;\n          text-decoration: none;\n        }\n      }\n    }\n  }\n  \n  &.REQUEST_ERROR {\n    border: 1px solid var(--60, #C13934);\n    background: var(--10, #FFFFFF);\n\n    .label {\n      color: var(--90, #610805);\n    }\n\n    svg:not(.trash) {\n      path {\n        stroke: #610805;\n      }\n    }\n\n    .status-badge {\n      background: var(--30, #FFC6BF);\n      .title {\n        color: var(--100, #241226);\n      }\n    }\n  }\n\n  &.APPROVED {\n    border: 1px solid var(--60, #4CA852);\n    background: var(--10, #FAFCFC);\n\n    .label {\n      color: var(--90, #1F4222);\n    }\n\n    svg:not(.trash) {\n      path {\n        stroke: #1F4222;\n      }\n    }\n\n    .status-badge {\n      background: var(--30, #C2F0C5);\n      .title {\n        color: var(--100, #241226);\n      }\n    }\n  }\n\n  .liquidity-info {\n    margin-top: 10px;\n    margin-left: 55px;\n\n    .label {\n      font-weight: 500;\n      font-size: 12px;\n    }\n\n    .max {\n      font-weight: 600;\n      font-size: 12px;\n    }\n  }\n\n}",".cont-modal {\n  width: 100%;\n}\n\n.ModalTask {\n  position: fixed;\n  background: rgba(42, 47, 60, 0.55);\n  backdrop-filter: blur(2px);\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 300;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .content-add {\n    margin-top: 50px;\n  }\n  \n  &-content {\n    width: 70%;\n    background-color: #fff;\n    height: 100%;\n  }\n  .button-close-mask {\n    width: 30%;\n    height: 100%;\n    background-color: rgba(255, 0, 0, 0);\n    box-shadow: none;\n    border: none;\n    &:hover,\n    &:active,\n    &:focus {\n      background-color: rgba(255, 0, 0, 0);\n      box-shadow: none;\n      border: none;\n    }\n  }\n\n  .content-modal {\n    // padding: 40px;\n    padding-bottom: 0;\n    .modal-title {\n      width: 100%;\n      padding: 40px;\n      padding-bottom: 0;\n      .flex-btw {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n        border-bottom: 1px solid $grey-placeholder;\n      }\n      button,\n      button:hover,\n      button:active,\n      button:focus {\n        background-color: transparent;\n        border: none !important;\n        padding: 0 !important;\n        box-shadow: none !important;\n        color: $grey-title !important;\n      }\n      .body-card {\n        color: #404859;\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 16px; /* 133.333% */\n        letter-spacing: 0.24px;\n      }\n    }\n    .modal-container {\n      position: relative;\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: flex-start;\n      height: calc(100vh - 180px);\n      .dots {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        position: absolute;\n        top: 45%;\n        left: 30px;\n        gap: 9px;\n        &-button {\n          padding: 0;\n          border: 1.5px solid #6e7889;\n          background: #fff;\n          width: 8px;\n          height: 8px;\n          border-radius: 50%;\n          &-success {\n            border: 1px solid #6EAC72;\n            background: #C5F0C8;\n          }\n          &-active {\n            height: 25px;\n            width: 25px;\n            border: 2px dotted #ddaa42;\n          }\n          &-review-active {\n            height: 25px;\n            width: 25px;\n            border: 2px dotted #ddaa42;\n            background: $state-review-background;\n          }\n        }\n      }\n      .modal-title {\n        border-bottom: 0;\n        align-items: flex-end;\n        button {\n          height: 18px;\n          text-transform: uppercase;\n          color: #8a5791 !important;\n          img {\n            margin-top: -0.9px;\n            margin-right: 3px;\n          }\n        }\n      }\n      .text {\n        margin-top: 5px;\n        a {\n          margin-left: 6px;\n          &:hover {\n            color: $black-text;\n          }\n        }\n      }\n\n      .modal-cards {\n        width: 100%;\n        height: 100%;\n        padding-bottom: 20px;\n        padding-top: 64px;\n        overflow: auto;\n        padding-right: 10px;\n        max-width: 576px;\n        &--full {\n          max-width: none;\n          display: flex;\n          justify-content: center;\n        }\n        &-mx-w {\n          max-width: 576px;\n          width: 100%;\n          padding-bottom: 20px;\n        }\n\n        .flex-btw {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          width: 100%;\n          margin-bottom: 12px;\n          .button {\n            text-transform: uppercase;\n            color: #404859;\n            text-align: right;\n            font-family: Inter;\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 120%;\n            text-transform: uppercase;\n            .anticon {\n              color: #404859;\n            }\n          }\n        }\n        .title {\n          background: #e3ddf0;\n          border-radius: 140px;\n          display: flex;\n          padding: 5px 12px 5px 10px;\n          justify-content: center;\n          align-items: center;\n          gap: 4px;\n\n          .body-regular {\n            color: #48244d;\n          }\n        }\n        .h2 {\n          margin-top: 12px;\n          word-break: break-word;\n          overflow-wrap: break-word;\n        }\n        .h2-w8 {\n          color: #ac78b3;\n        }\n        &::-webkit-scrollbar {\n          width: 8px;\n          border-radius: 5px;\n        }\n\n        /* Track */\n        &::-webkit-scrollbar-track {\n          background: #f1f1f1;\n        }\n\n        /* Handle */\n        &::-webkit-scrollbar-thumb {\n          background: #888;\n          border-radius: 5px;\n        }\n\n        /* Handle on hover */\n        &::-webkit-scrollbar-thumb:hover {\n          background: #555;\n        }\n      }\n    }\n  }\n  .modal-review-task__footer {\n    border-top: 1px solid #dfe4eb;\n    height: 180px;\n    .text-footer {\n      .placeholder {\n        color: #6e7889;\n        span {\n          color: #f5faff;\n          font-weight: 600;\n          background-color: #5e8eb7;\n          padding: 0 5px;\n          border-radius: 3px;\n        }\n      }\n    }\n    .footer-grey {\n      .h4 {\n        color: #6e7889;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 170%;\n      }\n    }\n    .body-regular {\n      color: #6e7889;\n    }\n    .footer_dost {\n      .body-regular {\n        color: #404859;\n      }\n      align-items: center;\n      .circles {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 24px;\n        .circle {\n          border-radius: 64px;\n          border: 1px solid #404859;\n          width: 20px;\n          height: 20px;\n        }\n      }\n    }\n    .modal-container {\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: flex-start;\n      height: 100%;\n      padding-right: 15px;\n      .modal-cards {\n        width: 100%;\n        height: 100%;\n        max-width: 576px;\n        padding: 14px 0;\n\n        .h4-w4 {\n          color: #ac78b3;\n          margin-bottom: 10px;\n          .h4 {\n            color: #6e7889;\n          }\n        }\n        .flex {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          width: 100%;\n          .circles {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            gap: 24px;\n            .circle {\n              border-radius: 100%;\n              border: 1px solid #8a5791;\n              background: #dfb8e5;\n              width: 20px;\n              height: 20px;\n              display: flex;\n              justify-content: center;\n              align-items: center;\n              &-active {\n                border: 1px solid #587e5b;\n                background: #6eac72;\n                img {\n                  display: none;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",".ModalTask-content-right {\n  width: 35%;\n  background-color: #fff;\n  height: 100%;\n  border-left: 1px solid #ccd3db;\n  overflow: scroll;\n  padding: 60px 45px 25px 30px;\n\n  .w-md-editor .title {\n    line-height: unset !important;\n    font-size: unset !important;\n    font-weight: unset !important;\n  }\n\n  .button-close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    color: black;\n\n    &:hover {\n      color: black !important;\n    }\n  }\n}",".modal-end-submit {\n  border-radius: 10px;\n  border: 1px solid var(--yellow-400, #ffd47d);\n  background: var(--yellow-100, #fff9ee);\n  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);\n  padding: 0;\n  width: 556px !important;\n  top: 202px !important;\n  .ant-checkbox-checked {\n    .ant-checkbox-inner {\n      background-color: #162e43 !important;\n      border-color: #162e43 !important;\n    }\n  }\n  .coin {\n    width: 49.334px;\n    height: 34px;\n  }\n  .tag {\n    width: 53px;\n    height: 47.06px;\n  }\n  .ant-modal-content {\n    background-color: transparent;\n    padding: 32px;\n    .h2 {\n      margin-top: 15px;\n      margin-bottom: 5px;\n    }\n    .h4 {\n      color: #66564d;\n    }\n    .divider {\n      border-top: 1px solid #ddaa42;\n      padding-top: 20px;\n      margin-top: 26px;\n    }\n    .buttons {\n      margin-top: 35px;\n    }\n    .button {\n      margin-top: 16px;\n      height: 40px !important;\n    }\n    .ant-modal-footer {\n      display: none;\n    }\n  }\n  .anticon {\n    color: #997120;\n  }\n  .ant-checkbox-wrapper {\n    margin-top: 10px;\n    span {\n      color: #244560;\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      letter-spacing: 0.18px;\n    }\n  }\n  &--white {\n    background: #fff;\n    border-color: #fff;\n    .anticon {\n      color: #6e7889;\n    }\n    .ant-modal-content {\n      .h2 {\n        color: #162e43;\n      }\n      .h4 {\n        color: #48759a;\n      }\n      .buttons {\n        .button-modal-ok {\n          border: 1px solid #162e43 !important;\n          background: #162e43 !important;\n          color: #ffffff !important;\n        }\n        .button-modal-cancel {\n          border: 1px solid #162e43 !important;\n          background: #fff !important;\n          color: #162e43 !important;\n          &-delete {\n            font-weight: 600 !important;\n            color: #122536 !important;\n          }\n        }\n        .button-modal-delete {\n          border: 1px solid #A31C17 !important;\n          background: #A31C17 !important;\n          color: #F5FAFF !important;\n          font-weight: 600 !important;\n        }\n      }\n    }\n  }\n}\n",".QuestionBasic {\n\n  .body-regular {\n    color: #6e7889;\n  }\n  .h3 {\n    margin-bottom: 40px;\n  }\n  \n  .options {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 18px;\n    margin-top: 25px;\n\n    .content-left {\n      display: flex;\n      flex-direction: column;\n    }\n\n    .Button-option {\n      cursor: pointer;\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: flex-start;\n      flex-direction: column;\n      border-radius: 10px;\n      border: 1px solid #ccd3db;\n      background: #f9fafb;\n      box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);\n      min-height: 56px;\n      height: auto;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      padding: 19px 24px;\n      &-text {\n        color: #2a2f3c !important;\n      }\n      .flex-btw {\n        margin-bottom: 0 !important;\n      }\n      .flex-start {\n        display: none;\n      }\n      &-active {\n        .flex-start {\n          display: flex;\n          gap: 6px;\n          align-items: flex-start;\n          img {\n            margin-top: 3px;\n          }\n          .body-regular {\n            max-width: 300px;\n          }\n        }\n        border-radius: 10px;\n        border: 1px solid #9bbceb;\n        background: #ebf6ff;\n        box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);\n        &-text {\n          color: #355c7d !important;\n        }\n        .body-regular {\n          color: #5e8eb7;\n        }\n        .sub-title {\n          font-weight: 500;\n        }\n      }\n    }\n  }\n  .Button-option-active {\n    .ModalEndSubmit {\n      width: 100%;\n      .button {\n        height: 36px;\n        span {\n          color: #f5faff !important;\n        }\n      }\n    }\n    .Button-option-text {\n      color: $blue-button-tab !important;\n    }\n    &-description {\n      color: #5E8EB7 !important;\n      font-size: 14px;\n      margin-top: 5px;\n    }\n  }\n  .list {\n    list-style-type: disc;\n    list-style: disc;\n    padding-left: 25px;\n    margin-top: 15px;\n    .h4 {\n      color: #404859;\n      line-height: 145%;\n    }\n  }\n}\n",".spinner-container {\n  position: relative;\n  width: auto;\n  height: 120px;\n  display: flex;\n  justify-content: center;\n  align-items: end;\n  overflow: hidden; /* Evita desbordamientos */\n}\n\n.spinner {\n  position: relative;\n}\n\n.spinner div {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  background-color: #c4cdd5;\n  border-radius: 50%;\n  animation: spin 1.2s linear infinite;\n}\n\n/* Colocación inicial de los 12 círculos */\n.spinner div:nth-child(1) { transform: rotate(30deg) translate(40px); }\n.spinner div:nth-child(2) { transform: rotate(60deg) translate(40px); }\n.spinner div:nth-child(3) { transform: rotate(90deg) translate(40px); }\n.spinner div:nth-child(4) { transform: rotate(120deg) translate(40px); }\n.spinner div:nth-child(5) { transform: rotate(150deg) translate(40px); }\n.spinner div:nth-child(6) { transform: rotate(180deg) translate(40px); }\n.spinner div:nth-child(7) { transform: rotate(210deg) translate(40px); }\n.spinner div:nth-child(8) { transform: rotate(240deg) translate(40px); }\n.spinner div:nth-child(9) { transform: rotate(270deg) translate(40px); }\n.spinner div:nth-child(10) { transform: rotate(300deg) translate(40px); }\n.spinner div:nth-child(11) { transform: rotate(330deg) translate(40px); }\n.spinner div:nth-child(12) { transform: rotate(0deg) translate(40px); }\n\n/* Animación para cambiar el color de los círculos */\n@keyframes spin {\n  0%, 100% {\n    background-color: #c4cdd5;\n  }\n  8.3% {\n    background-color: #4e8de6;\n  }\n}\n\n/* Cambia el retardo de cada círculo */\n.spinner div:nth-child(1) { animation-delay: -1.1s; }\n.spinner div:nth-child(2) { animation-delay: -1s; }\n.spinner div:nth-child(3) { animation-delay: -0.9s; }\n.spinner div:nth-child(4) { animation-delay: -0.8s; }\n.spinner div:nth-child(5) { animation-delay: -0.7s; }\n.spinner div:nth-child(6) { animation-delay: -0.6s; }\n.spinner div:nth-child(7) { animation-delay: -0.5s; }\n.spinner div:nth-child(8) { animation-delay: -0.4s; }\n.spinner div:nth-child(9) { animation-delay: -0.3s; }\n.spinner div:nth-child(10) { animation-delay: -0.2s; }\n.spinner div:nth-child(11) { animation-delay: -0.1s; }\n.spinner div:nth-child(12) { animation-delay: 0s; }",".ButtonTabsFilters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  .tab {\n    border-radius: 100px;\n    background: $white-button-tab;\n    color: $grey-title;\n    text-align: right;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 16px;\n    border: none;\n    box-shadow: none;\n    height: 24px;\n    .number {\n      font-weight: 400;\n      margin-left: 3px;\n    }\n    &:hover {\n      background: #5E8EB7 !important;\n      color: white !important;\n    }\n    &-active {\n      background-color: $blue-button-tab;\n      color: $white;\n      &:hover {\n        background-color: $blue-button-tab;\n        color: $white !important;\n      }\n    }\n  }\n}\n",".CardAlertError {\n  border-radius: 10px;\n  border: 1px solid #d7b8e5;\n  background: #f7edfc;\n  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);\n  padding: 18px 24px;\n  .h4-w5 {\n    color: #241226;\n    margin-bottom: 5px;\n  }\n  .h4-w4 {\n    color: #653b6f;\n    margin-bottom: 30px;\n  }\n}\n",".CardDetailInformationBank {\n  border-radius: 10px;\n  border: 1px solid #929fb0;\n  background: #fff;\n  padding: 20px 16px;\n  .h4 {\n    margin-bottom: 24px;\n  }\n  .label {\n    color: #6e7889;\n    margin-bottom: 4px;\n  }\n  .info {\n    color: #929fb0;\n    font-style: italic;\n  }\n  .row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    .column {\n      width: 50%;\n    }\n  }\n  .column {\n    margin-bottom: 20px;\n    &-line {\n      border-bottom: 1px solid #dfe4eb;\n      padding-bottom: 16px;\n    }\n  }\n}\n",".CardLoanTasks {\n  width: 396px;\n  height: 192px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  border: 1px solid #6e7889;\n  background: #fafcfc;\n  padding: 12px 19px;\n  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  .state-name {\n    color: $grey-title;\n    font-family: Inter;\n    font-size: 10px !important;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    &-w6 {\n      font-weight: 600;\n    }\n  }\n\n  .withBorder {\n    width: 100%;\n    border-radius: 10px;\n    border: 1px solid #ccd3db;\n    background: #fff;\n    color: #000;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n  .withOutBorder {\n    width: 100%;\n    border-radius: 10px;\n    border: none;\n    background: none;\n    box-shadow: none;\n    color: #000;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n  &__top {\n    &__head {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 5px;\n      .flex-end {\n        display: flex;\n        justify-content: flex-end;\n        gap: 4px;\n        align-items: center;\n        .svg-grid {\n          height: 12px;\n          width: 12px;\n          fill: none;\n        }\n        .quick-task {\n          path {\n            stroke: #6e7889;\n            &:first-child {\n              fill: #6e7889;\n            }\n          }\n        }\n        .major-task {\n          path {\n            stroke: #6e7889;\n            fill: #6e7889;\n          }\n        }\n      }\n    }\n    .h4 {\n      margin-bottom: 4px;\n    }\n    .text {\n      display: flex;\n      justify-content: flex-start;\n      align-items: flex-start;\n    }\n    .body-card-full {\n      margin-left: 5px;\n      padding: 0 5px;\n      font-weight: 700;\n      border-radius: 2px;\n    }\n  }\n\n  .TaskProgress {\n    margin-top: 10px;\n  }\n  \n  &__bottom {\n    .body-small-up {\n      color: #587e5b;\n      margin-bottom: 8px;\n    }\n    .flex-betwen {\n      .body-card {\n        color: #587e5b;\n      }\n    }\n  }\n\n  &-buttons-actions {\n    gap: 10px;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  &-APPROVED {\n    border-color: #6eac72;\n    .state {\n      border-radius: 76px;\n      background: #c5f0c8;\n      padding: 4px 8px 4px 7px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      .check {\n        margin-right: 2px;\n      }\n      .state-name {\n        color: #355137;\n      }\n    }\n    .h4 {\n      color: #466849;\n    }\n    .body-card-full {\n      background-color: #c5f0c8;\n      color: #466849;\n    }\n    .flex-end {\n      .svg-grid {\n        path {\n          stroke: #6eac72;\n          &:first-child {\n            fill: #6eac72;\n          }\n        }\n      }\n      .major-task {\n        path {\n          stroke: #6eac72;\n          fill: #6eac72;\n        }\n      }\n      .state-name {\n        color: #6eac72;\n      }\n    }\n    .button-card {\n      border: 1px solid #6eac72;\n      background: #fafcfc;\n      color: #466849;\n      box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n    }\n  }\n\n  &-REVIEW {\n    border-color: #ac78b3;\n    background: #FEFAFF;\n\n    .body-card-full {\n      color: #48244d;\n      background: #e3ddf0;\n    }\n\n    .body-card--green {\n      background-color: #e3ddf0;\n    }\n\n    .state-name {\n      color: #8a5791;\n    }\n\n    .CardLoanTasks__top__head .flex-end .major-task path {\n      stroke: #ac78b3;\n      fill: #ac78b3;\n    }\n    .state {\n      border-radius: 76px;\n      background: #e3ddf0;\n      padding: 4px 8px 4px 7px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n      .state-name {\n        color: #48244d;\n      }\n    }\n    .body-card {\n      color: #48244d;\n    }\n    .button-card {\n      color: #693b6f;\n      border-radius: 6px;\n      border: 1px solid #ac78b3;\n      background: #fdfcff;\n      box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.03);\n    }\n  }\n\n  &-DRAFT {\n    border-color: #929fb0;\n    .body-card-w5 {\n      color: #48244d;\n    }\n\n    .state {\n      border-radius: 76px;\n      background: #404859;\n      padding: 4px 8px 4px 7px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n      .state-name {\n        color: #f9fafb;\n      }\n    }\n  }\n\n  &-REQUEST_ERROR {\n    border-color: #c94f4a;\n    .body-card-w5 {\n      color: #ac3e3a;\n    }\n    .state {\n      border-radius: 76px;\n      background: #ffd4cf;\n      padding: 4px 8px 4px 7px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n      .state-name {\n        color: #712220;\n      }\n    }\n    .h4,\n    .body-card {\n      color: #712220;\n      &-text-2 {\n        color: #ac3e3a;\n      }\n    }\n    .button-card {\n      border-color: #c94f4a;\n    }\n    .flex-betwen {\n      .button,\n      .button-link {\n        color: #712220;\n      }\n    }\n    .flex-end {\n      .svg-grid {\n        path {\n          stroke: #c94f4a;\n          &:first-child {\n            fill: #c94f4a;\n          }\n        }\n      }\n      .major-task {\n        path {\n          stroke: #c94f4a;\n          fill: #c94f4a;\n        }\n      }\n      .state-name {\n        color: #c94f4a;\n      }\n    }\n  }\n  &-beginTask {\n    .ModalCardState {\n      width: 100% !important;\n    }\n  }\n}\n",".CardSomeoneElse {\n  margin-top: 10px;\n  width: 100%;\n  input {\n    background-color: transparent;\n    border: none !important;\n    box-shadow: none !important;\n    padding: 0;\n    color: #48759a;\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    &::placeholder {\n      color: #9bbceb;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: italic;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n  .ant-form-item {\n    width: 100%;\n    margin-bottom: 15px;\n  }\n  .row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    .ant-form-item {\n      width: 100%;\n    }\n  }\n}\n",".card-upload-response {\n\tposition: relative;\n\tborder-radius: 10px;\n\tborder: 1px solid #2A2F3C;\n\tpadding: 10px 16px;\n\n\t.template {\n\t\tmargin-bottom: 10px;\n\n\t\t.arrow-right {\n\t\t\twidth: 14px;\n\t\t\tmargin-left: 5px;\n\t\t}\n\n\t\tbutton {\n\t\t\tpadding: 0;\n\t\t}\n\t}\n\n\t.header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-bottom: 6px;\n\n\t\t.h4 {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n      word-break: break-word;\n      overflow-wrap: break-word;\n\t\t}\n\n\t\t.link {\n\t\t\tpadding: 0;\n\t\t\tcolor: rgba(110, 120, 137, 1);\n\t\t\tfont-size: 12px;\n\n\t\t\tspan {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tcolor: rgba(110, 120, 137, 1);\n\t\t\t}\n\t\t}\n\t}\n\n\t.description {\n\t\tfont-family: Inter;\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tline-height: 20px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\t\tmargin-bottom: 12px;\n\n    .description-button-link {\n      padding-left: 0;\n      text-decoration: underline;\n\t\t\tcolor:#5e8eb7;\n\n      &:hover {\n        color:#5e8eb7;\n      }\n    }\n\t}\n\n\t&-REVIEW {\n\t\tborder: 1px solid $state-review-border;\n\t\tbackground-color: $state-review-background-ligth;\n\n\t\t.h4 {\n\t\t\tcolor: $state-review-text !important;\n\t\t}\n\n\t\t.description {\n\t\t\tcolor: $state-review-text !important;\n\t\t}\n\n\t\t.link {\n\t\t\tcolor: $state-review-text !important;\n\t\t}\n\t}\n\n\t&-APPROVED {\n\t\tborder: 1px solid $state-approved-border;\n\t\tbackground-color: $state-approved-background-ligth;\n\n\t\t.h4 {\n\t\t\tcolor: $state-approved-text !important;\n\t\t}\n\n\t\t.description {\n\t\t\tcolor: $state-approved-text !important;\n\t\t}\n\n\t\t.link {\n\t\t\tcolor: $state-approved-text !important;\n\t\t}\n\t}\n\n\t&-REQUEST_ERROR {\n\t\tborder: 1px solid $state-error-border;\n\t\tbackground-color: $state-error-background-ligth;\n\n\t\t.h4 {\n\t\t\tcolor: $state-error-text !important;\n\t\t}\n\n\t\t.description {\n\t\t\tcolor: $state-error-text !important;\n\t\t}\n\n\t\t.link {\n\t\t\tcolor: $state-error-text !important;\n\t\t}\n\t}\n}",".DrodownBlue {\n    height: 20px;\n    padding: 1px 3px !important;\n    display: flex;\n    align-items: center;\n\n    &:hover {\n        background-color: $button-blue !important;\n        color: white !important;\n\n        span {\n            text-decoration-line: none !important;\n        }\n    }\n\n    &:disabled {\n        background-color: white !important;\n        color: $button-blue !important;\n\n        span {\n            text-decoration-line: underline !important;\n        }\n    }\n\n    &-blue {\n        border: 1px solid #9BBCEB;\n        border-radius: 10px;\n\n        .ant-dropdown-menu {\n            padding: 0px;\n        }\n\n        .ant-dropdown-menu-item {\n            &:hover {\n                background-color: #EBF6FF !important;\n\n                .ant-dropdown-menu-title-content {\n                    color: $blue-button-tab;\n                    font-weight: 600;\n                }\n            }\n        }\n\n        .ant-dropdown-menu-title-content {\n            color: $button-blue;\n            font-weight: 400;\n\n            &:hover {\n                color: $blue-button-tab;\n                font-weight: 600;\n            }\n        }\n    }\n}",".InputAmount {\n  border-radius: 10px;\n  border: 1px solid #929fb0;\n  background: #fff;\n  padding: 13px 16px;\n  .h4 {\n    color: #404859;\n  }\n  .button-operation {\n    padding: 0;\n    height: 23px;\n    border: 0;\n    background: none;\n    box-shadow: none;\n    .anticon {\n      color: #5e8eb7;\n      &-full {\n        display: none;\n      }\n    }\n    &:hover {\n      .anticon {\n        color: #5e8eb7;\n        display: none;\n        &-full {\n          display: block;\n          margin-left: 0;\n        }\n      }\n    }\n  }\n  .flex {\n    display: flex;\n    justify-content: flex-end;\n    gap: 16px;\n    .h4 {\n      color: #929fb0;\n    }\n    span {\n      color: #929fb0;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: italic;\n      font-weight: 400;\n      line-height: normal;\n    }\n    .text-bold {\n      color: #5e8eb7;\n      font-weight: 600;\n      font-style: normal;\n    }\n  }\n}\n",".InputBorderNone {\n  .input {\n    color: #775614;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    word-break: break-word;\n  }\n  .body-placeholder-w4 {\n    color: #775614;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    word-break: break-word;\n  }\n  .bold-lith {\n    color: #2a2f3c;\n    font-family: Inter;\n    font-size: 14px;\n    font-weight: 400;\n    &::placeholder {\n      color: #929fb0;\n      font-family: Inter;\n      font-size: 14px;\n      font-style: italic;\n      font-weight: 400;\n      line-height: 145%;\n    }\n  }\n  .bold {\n    color: #2a2f3c;\n    font-family: Inter;\n    font-size: 16px;\n    font-weight: 600;\n  }\n  .percentage-bottom {\n    border: 0;\n    display: flex;\n    justify-content: space-between;\n    border-top: 1px solid #afbdcc;\n    padding-top: 1px;\n    margin-bottom: 10px !important;\n    width: 90% !important;\n    .body-regular {\n      span {\n        font-size: 12px;\n      }\n    }\n  }\n\n  .ant-input-number-input {\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    line-height: normal;\n    padding: 5px 0px !important;\n\n    .default {\n      font-weight: 400;\n      color: $grey-title;\n    }\n\n    .warning {\n      font-weight: 600;\n      color: $state-warning;\n    }\n\n    &::placeholder {\n      color: #929fb0;\n      font-family: Inter;\n      font-style: italic !important;\n      font-weight: 400;\n    }\n  }\n  &-edit-number {\n    border-bottom: 1px solid #afbdcc;\n    input[type='number'] {\n      -moz-appearance: textfield;\n      appearance: textfield;\n      &::-webkit-inner-spin-button,\n      &::-webkit-outer-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n      }\n    }\n  }\n  &-edit-date {\n    border-bottom: 1px solid #afbdcc;\n  }\n}\n",".InputUploadedFile {\n  .file-ok {\n    margin: 10px 0;\n    .file {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: #f9fafb;\n      position: relative;\n      &-content {\n        height: 28px;\n        border-radius: 10px;\n        border: 1px solid #2a2f3c;\n        background-color: #f9fafb;\n        width: 100%;\n        padding: 0 20px;\n        padding-right: 12px;\n\n        &-approved {\n          border: 1px solid $state-approved-border !important;\n          background: $state-approved !important;\n        }\n\n        &-request_error {\n          border: 1px solid $state-error-border !important;\n          background: $state-error !important;\n          .name,\n          .anticon {\n            color: $state-error-icon !important;\n          }\n        }\n        &-review {\n          border: 1px solid $state-review-border !important;\n          background: $state-review-background !important;\n          .name,\n          .anticon {\n            color: $state-review-dark !important;\n          }\n        }\n      }\n      \n      .file-name {\n        width: 80%;\n        display: flex;\n        justify-content: start;\n        align-items: center;\n        gap: 7px;\n        .name {\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          overflow: hidden;\n        }\n        .anticon {\n          font-size: 15px;\n        }\n      }\n      .content-buttons {\n        display: flex;\n        justify-content: end;\n        align-items: center;\n        gap: 7px;\n        .anticon {\n          font-size: 15px;\n        }\n      }\n      .flex {\n        width: 80%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 100%;\n        gap: 12px;\n        &:first-child {\n          gap: 4px;\n        }\n      }\n      .upload {\n        margin-bottom: 0;\n      }\n      .flex-btw {\n        margin-bottom: 0;\n        height: 100%;\n        border-bottom: none;\n      }\n      .circle-input {\n        background-color: #fff;\n        width: 18px;\n        height: 18px;\n        border-radius: 50%;\n        border: 1px solid #2a2f3c;\n        display: flex;\n        position: absolute;\n        left: 0;\n        justify-content: center;\n        align-items: center;\n        .upload {\n          width: auto;\n          height: 18px;\n          object-fit: cover;\n        }\n      }\n    }\n  }\n}\n",".ProgressSteps {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n  .tab {\n    margin: 0 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    .bar-status {\n      width: 100%;\n      width: calc(100% + 20px);\n      height: 6px;\n      border-radius: 16px;\n      margin-top: 6px;\n      background-color: $white-button-tab;\n    }\n    &-complete {\n      .body-small {\n        color: $green-tab-active-text;\n      }\n      .bar-status {\n        background-color: $green-tab-active;\n      }\n    }\n    &-started {\n      &:hover {\n        .bar-status {\n          background-color: $grey-title;\n        }\n      }\n    }\n  }\n}\n.ant-popover {\n  &-content {\n    .ant-popover-inner {\n      padding: 0;\n    }\n    .popover-content {\n      padding: 10px 8px;\n      border-radius: 10px;\n      width: 240px;\n      position: relative;\n      .body-small {\n        color: #fafcfa;\n        &-w6 {\n          margin-bottom: 6px;\n        }\n      }\n      .divider {\n        height: 1px;\n        width: 100%;\n        margin: 8px 0;\n      }\n      .button {\n        display: flex;\n        gap: 4px;\n        align-items: center;\n      }\n      .flecha-darck,\n      .flecha {\n        display: none;\n        width: 16px;\n        height: 8px;\n      }\n      .felx-between {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n        align-items: center;\n\n        .flex {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          img {\n            margin-right: 5px;\n          }\n        }\n        .button {\n          background-color: transparent;\n          border: none;\n          padding: 0;\n          height: 20px;\n          box-shadow: none;\n          .flecha {\n            margin-left: 5px;\n            width: 12px;\n          }\n        }\n      }\n      .warning {\n        display: none;\n        justify-content: flex-start;\n        align-items: center;\n        gap: 5px;\n        margin-top: 10px;\n        svg {\n          width: 10px;\n          height: 11px;\n          fill: none;\n        }\n        .body-small {\n          margin-bottom: 0;\n          color: $red-warning;\n          text-decoration-line: underline;\n        }\n      }\n      &-complete,\n      &-started {\n        background-color: #587e5b;\n        .divider {\n          background-color: #fafcfa;\n        }\n        .flecha {\n          display: block;\n        }\n        .button {\n          &:hover,\n          &:active,\n          &:focus {\n            color: #fafcfa;\n          }\n        }\n        &::after {\n          content: '*';\n          font-size: 0;\n          width: 0;\n          height: 0;\n          border-left: 10px solid transparent;\n          border-right: 10px solid transparent;\n          border-bottom: 11px solid #587e5b;\n          position: absolute;\n          left: 46%;\n          top: -10px;\n          z-index: 3;\n        }\n      }\n      &-started {\n        background-color: $grey-title;\n        width: 270px;\n        .warning {\n          display: flex;\n          .body-small {\n            color: #ffd4cf;\n          }\n          svg {\n            path {\n              stroke: #ffd4cf;\n            }\n          }\n        }\n        &::after {\n          content: '*';\n          font-size: 0;\n          width: 0;\n          height: 0;\n          border-left: 10px solid transparent;\n          border-right: 10px solid transparent;\n          border-bottom: 11px solid $grey-title;\n          position: absolute;\n          left: 46%;\n          top: -10px;\n          z-index: 3;\n        }\n      }\n      &-not-started {\n        background-color: #ccd3db;\n        width: 270px;\n        .body-small {\n          color: $black;\n        }\n        .warning {\n          display: flex;\n        }\n        svg {\n          path {\n            stroke: $red-warning;\n          }\n        }\n        .button {\n          &:hover,\n          &:active,\n          &:focus {\n            color: $black;\n          }\n        }\n        .divider {\n          background-color: #404859;\n        }\n        .flecha-darck {\n          display: block;\n        }\n        &::after {\n          content: '*';\n          font-size: 0;\n          width: 0;\n          height: 0;\n          border-left: 10px solid transparent;\n          border-right: 10px solid transparent;\n          border-bottom: 11px solid #ccd3db;\n          position: absolute;\n          left: 46%;\n          top: -10px;\n          z-index: 3;\n        }\n      }\n      .green-all {\n        .body-small {\n          color: #c5f0c8;\n        }\n      }\n    }\n  }\n}\n",".TaskProgress {\n  .bar {\n    width: 100%;\n    background-color: #dfe4eb;\n    height: 8px;\n    border-radius: 8px;\n    display: flex;\n    :first-child{\n      border-bottom-left-radius: 8px;\n      border-top-left-radius: 8px;\n    }\n    :last-child{ \n      border-bottom-right-radius: 8px;\n      border-top-right-radius: 8px;\n    }\n    &-percentage {\n      height: 8px;\n    }\n  }\n  .h4 {\n    color: #404859 !important;\n    text-transform: none;\n  }\n}\n",".SelectPrimary {\n  .body-regular {\n    color: #2a2f3c;\n    font-weight: 500;\n  }\n  .ant-space-item {\n    width: 100%;\n  }\n}\n",".state-tag {\n    width: max-content;\n    border-radius: 76px;\n    padding: 4px 8px 4px 7px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n\n    .check {\n        margin-right: 2px;\n    }\n\n    .state-name {\n        font-weight: 600;\n        font-family: Inter;\n        line-height: 11px;\n        letter-spacing: 0.02em;\n        font-size: 10px;\n    }\n\n    &-APPROVED {\n        border-color: $state-approved-background;\n        background: $state-approved-background;\n\n        .state-name {\n            color: $state-approved-text !important;\n        }\n    }\n\n    &-REVIEW {\n        border-color: $state-review-background;\n        background: $state-review-background;\n\n        .state-name {\n            color: $state-review-text !important;\n        }\n    }\n\n    &-REQUEST_ERROR {\n        border-color: $state-error-background;\n        background: $state-error-background;\n\n        .state-name {\n            color: $state-error-text !important;\n        }\n    }\n\n    &-DRAFT {\n        .state-name {\n            color: $black-text !important;\n        }\n    }\n}",".UploadDocs {\n  position: relative;\n  .modal-see-file {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-color: red;\n  }\n  .button-upload {\n    height: 78px;\n    width: 100%;\n    border: 1px dashed #6e7889;\n    p {\n      color: #2a2f3c;\n      font-family: Inter;\n      font-size: 10px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n      span {\n        font-size: 10px;\n        color: #4e8aff;\n      }\n    }\n  }\n  .circles {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 12px;\n    .circle {\n      border-radius: 50%;\n      width: 16px;\n      height: 16px;\n      border: 1px solid #404859;\n      &-review {\n        background-color: $state-review-border;\n        border-color: $state-review;\n      }\n      &-approved {\n        background-color: $state-approved-background;\n        border-color: $state-approved-border;\n      }\n    }\n  }\n  .ant-upload {\n    width: 100%;\n    margin-bottom: 12px;\n  }\n  .button {\n    border-radius: 6px;\n    border: #122536;\n    background: #122536;\n    width: 100%;\n    height: 32px;\n    color: #fff;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.18px;\n    &-transparent {\n      background-color: transparent;\n      border: none !important;\n      box-shadow: none !important;\n    }\n  }\n  .body-small {\n    .blue {\n      color: #4e8aff;\n    }\n  }\n  .upload {\n    width: 20px;\n    height: 20px;\n    margin-bottom: 7px;\n  }\n  .empty-input {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    .small-detail {\n      margin-top: 4px;\n    }\n  }\n  &--container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 12px;\n  }\n\n  .input-content {\n    position: relative;\n    height: 128px;\n    width: 100%;\n    border-radius: 10px;\n    background: var(--colors-gradient);\n    padding: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px dashed #6e7889;\n    .white {\n      background-color: #fff;\n      height: 10px;\n      width: 20px;\n      position: absolute;\n      left: 0px;\n      top: 0px;\n      border-top-left-radius: 5px;\n      z-index: 200;\n    }\n    input {\n      height: 126px;\n      width: 100%;\n      border-radius: 10px;\n      background-color: rgba(255, 0, 0, 0);\n      // background-color: red;\n      font-size: 0 !important;\n      position: absolute;\n      z-index: 2;\n      top: 0;\n      cursor: pointer;\n    }\n    .cont-img {\n      height: 100%;\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: #fff;\n      img {\n        width: 100px;\n      }\n    }\n    &-wh {\n      background: var(--colors-white);\n      box-shadow: -3px 1px 10px -7px var(--colors-black);\n      margin: 30px 40px;\n    }\n    .edit {\n      position: absolute;\n      bottom: 0;\n      height: auto;\n      width: 99px;\n      border-radius: 0;\n    }\n  }\n  .content-flex {\n    align-items: flex-start;\n    gap: 16px;\n    .input-content,\n    .file-ok {\n      width: 50% !important;\n    }\n  }\n}\n",".circle-tag {\n  .circle {\n    width: 20px;\n    height: 20px;\n  \n    &-APPROVED {\n      border-color: $state-approved-border;\n      background-color: $state-approved-background;\n\n      &:hover {\n        background-color: $state-approved-border-dark;\n      }\n    }\n  \n    &-REVIEW {\n      background-color: $state-review-border;\n      border-color: $state-review;\n\n      &:hover {\n        background-color: $state-review-label;\n      }\n    }\n  \n    &-REQUEST_ERROR {\n      background-color: $state-error-background;\n      border-color: $state-error-border;\n\n      &:hover {\n        background-color: $state-error-border;\n      }\n    }\n  }\n}",".MinimumLiquidity {\n  padding-bottom: 30px;\n  .h4 {\n    color: #404859 !important;\n  }\n  .divider-top {\n    padding-top: 10px;\n  }\n  .h4-error {\n    color: #712220 !important;\n    margin-bottom: 7px;\n  }\n  .h2-w8 {\n    color: $black-text !important;\n  }\n}\n",".CardStateAccount {\n  border-radius: 10px;\n  border: 1px solid #7b7b7b;\n  padding: 12px 16px;\n  position: relative;\n\n  .label {\n    border-radius: 100px;\n    min-width: 81px;\n    width: auto;\n    max-width: 95px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 3px 4px;\n    gap: 4px;\n    margin-bottom: 8px;\n    background: #969696;\n    .body-small {\n      margin-bottom: 0;\n    }\n  }\n  &_head {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    width: 100%;\n  }\n\n  .box {\n    .body-card {\n      margin-bottom: 6px;\n    }\n    .body-regular {\n      margin-bottom: 16px;\n    }\n    .file-ok {\n      margin-top: 0 !important;\n    }\n    width: 300px !important;\n    &-error {\n      .flex {\n        .button {\n          &:last-child {\n            display: none !important;\n          }\n        }\n      }\n    }\n    &-success {\n      .flex {\n        .button {\n          &:last-child {\n            display: none !important;\n          }\n        }\n      }\n    }\n  }\n  .divider {\n    border-top: 1px solid #afbdcc;\n    margin-top: 20px;\n  }\n  &--inReview {\n    background: #fdfcff;\n    border: 1px solid #ac78b3;\n    .label {\n      background: #e3ddf0;\n      .body-small {\n        color: #48244d;\n      }\n    }\n    .box {\n      .body-card {\n        color: #48244d;\n        &-dark {\n          color: #2a2f3c;\n        }\n      }\n      .body-regular {\n        color: #48244d;\n      }\n    }\n    .file-ok {\n      .file {\n        &-content {\n          .name {\n            color: #693b6f !important;\n          }\n          .anticon {\n            color: #693b6f !important;\n          }\n        }\n      }\n    }\n  }\n  &--error {\n    border: 1px solid #c94f4a;\n\n    .label {\n      background: #ffd4cf;\n      img {\n        margin-top: 1px;\n      }\n      .body-small {\n        color: #712220;\n      }\n    }\n    .UploadDocs {\n      .input-content {\n        border: 1px dashed #e67f73;\n      }\n    }\n    .row {\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 10px;\n      .box {\n        width: 40%;\n        .body-card {\n          margin-bottom: 4px;\n        }\n      }\n    }\n    .divider {\n      margin-top: 20px;\n      border-top: 1px solid #ffd4cf;\n      padding-top: 8px;\n    }\n  }\n  &--approved {\n    border: 1px solid #3F9545;\n\n    .label {\n      background: #C5F0C8;\n      img {\n        margin-top: 1px;\n      }\n      .body-small {\n        color: #355137;\n      }\n    }\n    .UploadDocs {\n      .input-content {\n        border: 1px dashed #C5F0C8;\n      }\n    }\n    .row {\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 10px;\n      .box {\n        width: 40%;\n        .body-card {\n          margin-bottom: 4px;\n        }\n      }\n    }\n    .divider {\n      margin-top: 20px;\n      border-top: 1px solid #C5F0C8;\n      padding-top: 8px;\n    }\n    .file-ok {\n      .file {\n        &-content {\n          border: 1px solid #75C27A !important;\n          background-color: #C5F0C8 !important;\n          .name {\n            color: #355137 !important;\n          }\n          .anticon {\n            color: #355137 !important;\n          }\n        }\n      }\n    }\n    \n  }\n  .row-btw {\n    .box {\n      width: 100%;\n    }\n  }\n  .section-upload {\n    .UploadDocs {\n      .file-content {\n        height: 28px !important;\n        border-radius: 10px;\n        border: 1px solid #eff3f5 !important;\n        background: #eff3f5 !important;\n        padding-left: 12px !important;\n      }\n      .InputUploadedFile .file-ok .file .circle {\n        display: none;\n      }\n    }\n  }\n}\n",".SectionError {\n  border-radius: 10px;\n  border: 1px solid #c94f4a;\n  padding: 12px 15px;\n\n  .flex-end {\n    button {\n      height: 30px;\n    }\n  }\n\n  .description{\n    overflow: hidden;\n\n    .body-regular {\n      display: -webkit-box; /* Utiliza el modelo de caja flexible de tipo webkit */\n      -webkit-box-orient: vertical; /* Orientación vertical */\n      -webkit-line-clamp: 2; /* Número máximo de líneas */\n      overflow: hidden; /* Oculta el contenido que sobresale */  \n    }\n  }\n\n  .flex-btw {\n    margin-bottom: 5px;\n  }\n  .body-regular {\n    color: #c94f4a;\n  }\n  .body-regular-w6 {\n    color: #712220;\n  }\n  .button {\n    color: #712220;\n    text-align: right;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 140%;\n\n    span {\n      text-decoration: underline;\n\n      &:hover {\n        color: #712220;\n      }\n    } \n\n    .anticon {\n      color: #712220;\n      margin-top: 2px;\n    }\n  }\n}\n",".SectionNewBank {\n  .h4,\n  .body-regular {\n    margin-bottom: 8px;\n    color: #2a2f3c;\n    line-height: 145%;\n  }\n  .button {\n    width: auto !important;\n    font-size: 20px;\n    font-weight: 600;\n  }\n\n  .button-block {\n    width: 100% !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n.card-add-account {\n  border-radius: 10px;\n  border: 1px solid #2a2f3c;\n  padding: 16px;\n  margin-top: 16px;\n  .ModalEndSubmit {\n    .button {\n      margin-bottom: 5px;\n    }\n  }\n  .flex-btw {\n    margin-bottom: 0 !important;\n    .box {\n      height: 100%;\n    }\n  }\n\n  .UploadDocs {\n    .flex-btw {\n      border: none;\n    }\n  }\n  .body-card {\n    color: #404859 !important;\n  }\n  .box {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    .h4 {\n      color: #929fb0;\n      font-style: italic;\n      margin-bottom: 16px;\n    }\n    .ModalEndSubmit {\n      .button {\n        display: none;\n      }\n    }\n  }\n  .button-submit {\n    margin-bottom: 20px;\n    border-radius: 6px;\n\n    span {\n      color: #fff;\n      text-align: center;\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n      letter-spacing: 0.18px;\n    }\n  }\n  .top-InfoExpand {\n    border-top: 1px solid #afbdcc;\n  }\n  // .item {\n  //   .flex-btw {\n  //     border: 0;\n  //     border-top: 1px solid #afbdcc;\n  //     padding-top: 1px;\n  //     margin-top: -15px;\n  //     margin-bottom: 16px !important;\n  //     align-items: flex-end !important;\n  //     width: 90% !important;\n  //     .body-regular {\n  //       margin-bottom: 0;\n  //       span {\n  //         font-size: 12px;\n  //       }\n  //     }\n  //   }\n  // }\n}\n",".DscrQuestionsAgreements {\n  .Step3 {\n    .h2 {\n      margin-top: 4px;\n      margin-bottom: 10px;\n      .blue-bold {\n        color: #5e8eb7;\n        font-weight: 800;\n        text-decoration-line: underline;\n\n        color: #2A2F3C;\n        font-family: Inter;\n        font-size: 24px;\n        font-style: normal;\n        font-weight: 800;\n        line-height: 135%;\n        text-decoration-line: unset;\n      }\n    }\n    .rent-input {\n      border: none;\n      width: auto;\n      display: inline;\n      &.touched {\n        color: #404859;\n      }\n    }\n    .month {\n      color: var(--800-grey, #404859);\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n    #rent-button {\n      margin-top: 16px;\n    }\n    .UploadDocs {\n      .contenedor-flex {\n        display: flex;\n        width: 100%;\n        .cont-files {\n          width: 100%;\n        }\n        .UploadDocs--container {\n          gap: 20px;\n          justify-content: center;\n          align-items: flex-start;\n          flex-direction: row;\n          width: 100%;\n        }\n      }\n    }\n  }\n  .InputAmount-edit {\n    margin-bottom: 0px !important;\n    border: none !important;\n    display: flex;\n    justify-content: space-between;\n    gap: 16px;\n\n    .flex {\n      display: flex;\n      justify-content: flex-end;\n      gap: 16px;\n\n      .text-bold {\n        color: #5e8eb7;\n        font-weight: 600;\n        font-style: normal;\n      }\n      \n      .input-edit {\n        all: unset;\n        color: #6E7889;\n        animation: none;\n        cursor: pointer;\n        font-style: italic;\n        font-weight: 400;\n        line-height: 19.36px;\n        text-align: right;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n      }\n\n    }\n    .button-edit {\n      all: unset;\n      border: none;\n      color: #5E8EB7;\n      animation: none;\n      cursor: pointer;\n      margin-left: 10px;\n  \n      span {\n        margin-left: 5px;\n        font-weight: 500;\n        color: #5E8EB7;\n        font-family: Inter;\n        font-style: normal;\n      }\n\n      &-disabled {\n        span {\n          color: #6E7889 !important;\n        }\n      }\n    }\n  }\n}\n",".CardLeaseAgreements {\n  padding: 16px;\n  border-radius: 4px;\n  border: 1px solid #929fb0;\n  .flex-btw {\n    .flex {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 28px;\n      .circle {\n        border-radius: 50%;\n        width: 16px;\n        height: 16px;\n        border: 1px solid #404859;\n        &--active {\n          background-color: #404859;\n        }\n      }\n    }\n  }\n  &-REVIEW {\n    border: 1px solid $state-review-border;\n\t\tbackground-color: $state-review-background-ligth;\n  }\n\n  &-APPROVED {\n    border: 1px solid $state-approved-border;\n    background-color: $state-approved-background-ligth;\n\n    .h4 {\n      color: $state-approved-text !important;\n    }\n\n    .description {\n      color: $state-approved-text !important;\n    }\n\n    .link {\n      color: $state-approved-text !important;\n    }\n  }\n\n  &-REQUEST_ERROR {\n    border: 1px solid $state-error-border;\n    background-color: $state-error-background-ligth;\n\n    .h4 {\n      color: $state-error-text !important;\n    }\n\n    .description {\n      color: $state-error-text !important;\n    }\n\n    .link {\n      color: $state-error-text !important;\n    }\n  }\n}\n",".CardMarketRent {\n  border-radius: 4px;\n  border: 1px solid #929fb0;\n  padding: 12px 16px;\n  .body-regular-italic {\n    color: #929fb0;\n  }\n  .flex-btw {\n    margin-bottom: 9px !important;\n  }\n  &-REVIEW {\n    border: 1px solid $state-review-border;\n\t\tbackground-color: $state-review-background-ligth;\n  }\n\n  &-APPROVED {\n    border: 1px solid $state-approved-border;\n    background-color: $state-approved-background-ligth;\n\n    .h4 {\n      color: $state-approved-text !important;\n    }\n\n    .description {\n      color: $state-approved-text !important;\n    }\n\n    .link {\n      color: $state-approved-text !important;\n    }\n  }\n\n  &-REQUEST_ERROR {\n    border: 1px solid $state-error-border;\n    background-color: $state-error-background-ligth;\n\n    .h4 {\n      color: $state-error-text !important;\n    }\n\n    .description {\n      color: $state-error-text !important;\n    }\n\n    .link {\n      color: $state-error-text !important;\n    }\n  }\n\n  .ant-form {\n    all: unset;\n    margin-top: 10px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n\n    .form-row {\n      all: unset;\n      display: flex;\n      align-items: baseline;\n      gap: 5px;\n      max-height: 35px;\n\n      .bold {\n        font-weight: 600 !important;\n        color: #404859 !important;\n      }\n    }\n\n    .rent-container {\n      display: flex;\n      align-items: baseline;\n      position: relative;\n    }\n\n    .rent-input {\n      width: auto;\n      min-width: 56px;\n      max-width: 58px;\n      text-align: right;\n      font-weight: 600;\n      color: #404859;\n      border: none;\n      outline: none;\n      background: transparent;\n    }\n\n    .unit-input {\n      width: 25px !important;\n    }\n  }\n  \n}\n",".CardTotalUnits {\n  // border-radius: 4px;\n  border: 1px solid #929fb0;\n  padding: 12px 16px;\n  .body-regular-italic {\n    color: #929fb0;\n  }\n  .flex-btw {\n    margin-bottom: 16px !important;\n  }\n}\n",".EntityGuarantorCreation {\n  .task-footer {\n    .dropdown-blue-bold {\n      span {\n        font-weight: 600;\n        text-decoration-line: underline;\n      }\n\n      height: 26px;\n      display: unset;\n      padding: 0 !important;\n    }\n\n    .dropdown-review-bold {\n      span {\n        font-weight: 600;\n        text-decoration-line: underline;\n      }\n\n      color: $state-review !important;\n      height: 26px;\n      display: unset;\n      padding: 0 !important;\n    }\n\n    .owners-tags {\n      display: flex;\n      justify-content: space-between;\n      align-items: end;\n\n      .circles-tags {\n        display: flex;\n        align-items: end;\n        gap: 10px;\n      }\n\n      .circle {\n        width: 20px;\n        height: 20px;\n      }\n\n      .circle-step3 {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 5px;\n      }\n    }\n  }\n}",".main {\n  position: relative;\n  border-radius: 10px;\n\n  .icon-delete {\n    font-size: 20px;\n    position: absolute;\n    top: 50%;\n    right: -9.5px;\n    transform: translateY(-50%);\n    color: #5E8EB7;\n    cursor: pointer;\n    visibility: hidden;\n  }\n\n  &:hover {\n    .icon-delete {\n      visibility: visible;\n    }\n  }\n\n  .content-card {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    border-radius: 10px;\n    border: 1px solid #ccd3db;\n    min-height: 56px;\n    height: auto;\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    padding: 10px 18px 5px 16px;\n\n    &-hover-removed {\n      &:hover {\n        border: 1px solid #ccd3db !important\n      }\n    }\n\n    &:hover {\n      border: 1px dashed $grey-placeholder;\n    }\n\n    .input-disabled-color {\n      input {\n        &:disabled {\n          color: black;\n        }\n      }\n    }\n\n    &-REVIEW {\n      border: 1px solid $state-review-border;\n      background-color: $state-review-background-ligth;\n\n      .body-regular {\n        color: $state-review-text !important;\n      }\n\n      .bold-lith {\n        color: $state-review-text !important;\n      }\n\n      .ant-input-number-suffix {\n        color: $state-review-text !important;\n      }\n\n      .ant-picker-input {\n        input {\n          color: $state-review-text !important;\n        }\n      }\n\n      .ant-form-item-no-colon {\n        color: $state-review-text !important;\n      }\n\n      .ant-input-number-input-wrap {\n        color: $state-review-text !important;\n\n        input {\n          font-weight: 500;\n        }\n      }\n    }\n\n    &-APPROVED {\n      border: 1px solid $state-approved-border;\n      background-color: $state-approved-background-ligth;\n\n      .body-regular {\n        color: $state-approved-text !important;\n      }\n\n      .bold-lith {\n        color: $state-approved-text !important;\n      }\n\n      .ant-input-number-suffix {\n        color: $state-approved-text !important;\n      }\n\n      .ant-picker-input {\n        input {\n          color: $state-approved-text !important;\n        }\n      }\n\n      .ant-form-item-no-colon {\n        color: $state-approved-text !important;\n      }\n\n      .ant-input-number-input-wrap {\n        color: $state-approved-text !important;\n\n        input {\n          font-weight: 500;\n        }\n      }\n\n      .file-name {\n        color: $state-approved-text !important;\n      }\n    }\n\n    &-REQUEST_ERROR {\n      border: 1px solid $state-error-border;\n      background-color: white;\n\n      .body-regular {\n        color: $state-error-icon !important;\n      }\n\n      .bold-lith {\n        color: $state-error-icon !important;\n      }\n\n      .ant-form-item-no-colon {\n        color: $state-error-icon !important;\n      }\n\n      .ant-picker-input {\n        input {\n          color: $state-error-icon !important;\n        }\n      }\n\n      .ant-input-number-suffix {\n        color: $state-error-icon !important;\n      }\n\n      .ant-input-number-input-wrap {\n        color: $state-error-icon !important;\n\n        input {\n          font-weight: 500;\n        }\n      }\n\n      .file-name {\n        color: $state-error-icon !important;\n      }\n    }\n\n    .card-ownership {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n\n      .section-1 {\n        display: flex;\n        width: 70%;\n        flex-direction: column;\n\n        .names {\n          display: flex;\n          gap: 30px;\n\n          .name {\n            display: flex;\n            flex-direction: column;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            width: auto;\n            gap: 5px;\n\n            span {\n              white-space: nowrap;\n              text-overflow: ellipsis;\n              overflow: hidden;\n              font-size: 16px;\n            }\n\n            label {\n              font-size: 12px;\n            }\n          }\n        }\n\n        .footer {\n\n          .approved {\n            color: $green-tab-active-text;\n          }\n\n          .error {\n            color: $state-error-text;\n          }\n\n          button {\n            color: $grey-text-op;\n\n            .anticon {\n              margin-inline-start: 4px;\n            }\n\n            &:hover {\n              color: $grey-text-op;\n            }\n          }\n\n          span {\n            font-family: Inter;\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 15px;\n          }\n        }\n      }\n\n      .section-2 {\n        display: flex;\n        flex-direction: column;\n        align-items: end;\n\n        .suffix-null {\n          input {\n            margin-top: 18px;\n            padding-right: 0 !important;\n          }  \n        }\n\n        input {\n          width: 100px;\n          text-align: end;\n          padding-right: 13px !important;\n        }\n\n        .guarantor {\n          margin-top: 7px;\n          font-size: 10px;\n          color: #5E8EB7;\n        }\n\n        .ant-input-number-suffix {\n          margin-inline-end: 0px;\n          color: black;\n        }\n\n      }\n    }\n\n    .form-edit {\n      width: 100%;\n      height: auto;\n\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n\n      display: grid;\n      grid-template-columns: 45% 35% 20%;\n      grid-template-areas:\n        'ssn datebirth textedit'\n        'phone email .'\n        'address address address'\n        'identification identification identification'\n        'submit submit submit';\n\n      .ant-input-status-error {\n        color: $state-error-text;\n      }\n\n      .ant-form-item-row {\n        display: block;\n      }\n\n      .ant-form-item-label {\n        text-align: start;\n        height: 27px;\n\n        label {\n          font-family: Inter;\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 14.52px;\n          color: $grey-text-op;\n        }\n      }\n\n      .ant-form-item-control-input {\n        min-height: 20px;\n      }\n\n      .ant-form-item {\n        margin-bottom: 15px;\n      }\n\n      .ssn {\n        grid-area: ssn;\n      }\n\n      .datebirth {\n        grid-area: datebirth;\n\n        .ant-picker-input {\n          input {\n            &::placeholder {\n              color: #929fb0;\n              font-family: Inter;\n              font-style: italic !important;\n              font-weight: 400;\n            }\n\n            &:disabled {\n              color: black;\n            }\n          }\n        }\n      }\n\n      .textedit {\n        grid-area: textedit;\n        font-size: 11px;\n        text-align: end;\n        color: #5E8EB7;\n        display: flex;\n        align-items: start;\n        gap: 6px;\n        justify-content: end;\n        margin-top: 5px;\n      }\n\n      .phone {\n        grid-area: phone;\n      }\n\n      .email {\n        grid-area: email;\n      }\n\n      .address {\n        grid-area: address;\n      }\n\n      .identification {\n        grid-area: identification;\n\n        label {\n          font-family: Inter;\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 15px;\n        }\n      }\n\n      .submit {\n        grid-area: submit;\n      }\n    }\n  }\n}",".step-3 {\n  .blue-bold {\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 800;\n    text-decoration: underline;\n  }\n\n  .owner-REVIEW {\n    color: $state-review-text;\n  }\n\n  .owner-APPROVED {\n    color: $state-approved-text;\n  }\n\n  .owner-REQUEST_ERROR {\n    color: $state-error-text;\n  }\n    \n  .content-cards {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .content-owner-new {\n    display: flex;\n    justify-content: space-between;\n\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n\n    button {\n      padding: 0;\n    }\n\n    .text-add {\n      display: flex;\n      gap: 5px;\n      align-items: center;\n    }\n\n    .total{\n      display: flex;\n      gap: 15px;\n      align-items: center;\n    }\n  }\n}",".action-accept-reject {\n  position: absolute;\n  top: -10px;\n  right: 15px;\n  width: 60px;\n  z-index: 99;\n  \n  .content-actions {\n    display: flex;\n    justify-content: end;\n    gap: 15px;\n    width: 60px;\n  }\n\n  .circle-input {\n    cursor: pointer;\n  }\n}",".EntityDocs {\n    .task-footer {\n        .dropdown-blue-bold {\n            span {\n                font-weight: 600;\n                text-decoration-line: underline;\n            }\n\n            height: 26px;\n            display: unset;\n            padding: 0 !important;\n        }\n\n        .dropdown-review-bold {\n            span {\n                font-weight: 600;\n                text-decoration-line: underline;\n            }\n\n            color: $state-review !important;\n            height: 26px;\n            display: unset;\n            padding: 0 !important;\n        }\n\n        .owners-tags {\n            display: flex;\n            justify-content: space-between;\n            align-items: end;\n\n            .circles-tags {\n                display: flex;\n                align-items: end;\n                gap: 10px;\n            }\n\n            .circle {\n                width: 20px;\n                height: 20px;\n\n                &-APPROVED {\n                    background-color: $state-approved-background;\n                    border-color: $state-approved-border;\n                }\n\n                &-REVIEW {\n                    background-color: $state-review-border;\n                    border-color: $state-review;\n                }\n\n                &-REQUEST_ERROR {\n                    background-color: $state-error-background;\n                    border-color: $state-error-border;\n                }\n            }\n        }\n    }\n}",".entity-docs-step-2 {\n\n    .section-1 {\n        span {\n            font-size: 20px !important;\n        }\n    }\n\n    .dropdown-blue-bold {\n        display: unset;\n        height: auto;\n    }\n\n    .dropdown-review-bold {\n        span {\n            text-decoration-line: underline;\n        }\n\n        color: $state-review !important;\n        display: unset;\n        padding: 0 !important;\n    }\n\n    .submits {\n        display: flex;\n        justify-content: space-between;\n        gap: 15px;\n\n        section {\n            width: 100%;\n        }\n    }\n}",".InvestmentExperienceVerification {\n  .card__generic {\n\n    &-REVIEW {\n      border: 1px solid $state-review-border;\n\t\t  background-color: $state-review-background-ligth;\n    }\n\n    &-REQUEST_ERROR {\n      border: 1px solid $state-error-border;\n\t\t  background-color: $state-error-background-ligth;\n    }\n\n    &-APPROVED {\n      border: 1px solid $state-approved-border;\n\t\t  background-color: $state-approved-background-ligth;\n    }\n\n    .UploadDocs {\n      .input-content,\n      .input-content input {\n        height: 79px;\n      }\n    }\n  }\n\n  .circle {\n    &-review {\n      background-color: $state-review-border;\n      border-color: $state-review !important;\n    }\n\n    &-approved {\n      border: 1px solid $state-approved-border !important;\n\t\t  background-color: $state-approved-background;\n    }\n  }\n}\n",".ConstructionBudget {\n\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  .h2 {\n    margin-top: 30px !important;\n  }\n\n  .UploadDocs {\n\n    .input-content,\n    .input-content input {\n      height: 78px;\n\n      .empty-input {\n        .body-small {\n          color: #2a2f3c;\n        }\n      }\n    }\n  }\n\n  .card__generic {\n    .s-title {\n      .h4 {\n        color: #404859;\n      }\n    }\n\n    .body-regular {\n      margin-bottom: 20px;\n    }\n  }\n\n  .link {\n    color: #5e8eb7;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    text-decoration: none;\n    line-height: 145%;\n\n    .arrow {\n      height: 10px;\n      margin-left: 5px;\n    }\n  }\n}",".title-company-step-1 {\n  border-radius: 10px;\n  border: 1px solid #ccd3db;\n  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);\n  padding: 16px 24px 5px;\n  \n  .ant-form {\n    margin-top: 15px;\n    width: 100%;\n    height: auto;\n    display: grid;\n    grid-template-columns: 50% 5% 45%;\n    grid-template-areas: 'titleCompany titleCompany titleCompany'\n    'name name .'\n    'phone . email'\n    'submit submit submit';\n  }\n\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n\n  &-REVIEW {\n    border: 1px solid $state-review-border;\n    background-color: $state-review-background-ligth;\n\n    .h4 {\n      color: $state-review-text !important;\n    }\n\n    .description {\n      color: $state-review-text !important;\n    }\n\n    .link {\n      color: $state-review-text !important;\n    }\n  }\n\n  &-APPROVED {\n    border: 1px solid $state-approved-border;\n    background-color: $state-approved-background-ligth;\n\n    .h4 {\n      color: $state-approved-text !important;\n    }\n\n    .description {\n      color: $state-approved-text !important;\n    }\n\n    .link {\n      color: $state-approved-text !important;\n    }\n  }\n\n  &-REQUEST_ERROR {\n    border: 1px solid $state-error-border;\n    background-color: $state-error-background-ligth;\n\n    .h4 {\n      color: $state-error-text !important;\n    }\n\n    .description {\n      color: $state-error-text !important;\n    }\n\n    .link {\n      color: $state-error-text !important;\n    }\n  }\n\n  .ant-form-item-row {\n    display: block;\n  }\n\n  .ant-form-item-label {\n    text-align: start;\n    height: 27px;\n\n    label {\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 14.52px;\n      color: $grey-text-op;\n    }\n  }\n\n  .ant-form-item-control-input {\n    min-height: 20px;\n  }\n\n  .ant-form-item {\n    margin-bottom: 15px;\n  }\n\n  .titleCompany {\n    input {\n      font-size: 16px !important;\n    }\n\n    grid-area: titleCompany;\n  }\n\n  .name {\n    grid-area: name;\n  }\n\n  .phone {\n    grid-area: phone;\n  }\n\n  .email {\n    grid-area: email;\n  }\n\n  .submit {\n    grid-area: submit;\n\n    button {\n      border-radius: 6px;\n    }\n  }\n}",".insurance-step-2 {\n    .ant-collapse-header-text {\n        max-width: 335px;\n        margin-inline-end: unset !important;\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 600;\n    }\n\n    .ant-collapse-expand-icon {\n        padding-inline-start: 0px !important;\n    }\n}",".payoff-footer {\n    .dropdown-blue-bold {\n        display: unset;\n        padding: 0 !important;\n        border: none !important;\n        span {\n            background-color: white !important;\n            color: $button-blue !important;\n            padding: 0 !important;\n        }\n    }\n\n    .is-review {\n        color: $state-review !important;\n      }\n}",".insurance-step-2 {\n    .ant-collapse-header-text {\n        max-width: 335px;\n        margin-inline-end: unset !important;\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 600;\n    }\n\n    .ant-collapse-expand-icon {\n        padding-inline-start: 0px !important;\n    }\n}",".entities-list {\n  padding: 24px 25px;\n\n  .top-container {\n    box-sizing: content-box;\n    width: 100%;\n\n    margin-bottom: 33px;\n\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    justify-content: space-between;\n\n    .title {\n      color: var(--800-grey, #404859);\n      font-family: Inter;\n      font-size: 32px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n\n      >span {\n        cursor: pointer;\n\n        color: var(--blue60, #5E8EB7);\n        font-family: Inter;\n        font-size: 32px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        text-decoration-line: underline;\n      }\n    }\n  }\n\n  .entities-container {\n    padding: 16px 0px;\n\n    >* {\n      margin-bottom: 16px;\n      &:last-child {\n        margin-bottom: 0px;\n      }\n    }\n  }\n\n  .search-box {\n    cursor: pointer;\n  \n    box-sizing: border-box;\n    width: 384px;\n    padding: 5px 18px 5px 8px;\n  \n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n  \n    border-radius: 10px;\n    border: 1px solid var(--400-grey, #CCD3DB);\n    background: var(--gray-100, #F9FAFB);\n  \n    color: var(--700-grey, #6E7889);\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%;\n  \n    >input {\n      all: unset;\n      width: 100%;\n      margin-left: 8px;\n    }\n  }\n}","@keyframes horizontal-shaking {\n    0% { transform: translateX(0); }\n    25% { transform: translateX(-3px); }\n    50% { transform: translateX(3px); }\n    75% { transform: translateX(-1px); }\n    100% { transform: translateX(1px); }\n  }\n  ",".Login {\n  display: flex;\n  justify-content: space-between;\n  min-height: calc(100vh - 56px);\n  &-form,\n  .rigth {\n    width: 50%;\n  }\n  &-form {\n    padding: 32px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: flex-start;\n    position: relative;\n    .coin {\n      margin-bottom: 13px;\n    }\n    .h1 {\n      margin-bottom: 24px;\n    }\n    .ant-form {\n      width: 100%;\n    }\n    .error-message {\n      margin-top: 50px;\n      color: $red-warning;\n    }\n    .button {\n      margin-top: 10px;\n    }\n    .link {\n      &:hover {\n        color: #404859;\n      }\n      .body-regular-bold {\n        text-decoration: underline;\n      }\n    }\n    .link-absolute {\n      position: absolute;\n      bottom: 30px;\n      left: 32px;\n      text-decoration: none;\n      .body-regular-bold {\n        text-decoration: underline;\n      }\n    }\n  }\n\n  .right {\n    padding-top: 48px;\n    width: 55%;\n\n    background-color: #F9FAFB;\n\n    position: relative;\n\n    .content {\n      padding-left: 72px;\n      padding-right: 0px;\n    }\n\n    .star {\n      margin-bottom: 16px;\n    }\n\n    .phrase {\n      margin: 0px;;\n      color: #2A2F3C;\n      font-family: Inter;\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 120%; /* 24px */\n\n      margin-bottom: 12px;\n    }\n\n    .author {\n      b {\n        font-weight: 600;\n      }\n      color: #355C7D;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 300;\n      line-height: 140%; /* 22.4px */\n    }\n\n    .home {\n      height: 70vh;\n      position: absolute;\n      bottom: -90px;\n      left: 48px;\n\n      border-color: #355C7D;\n      border-width: 2px 0px 0px 2px;\n      border-style: solid;\n      border-radius: 10px 0px 0px 0px;\n    }\n  }\n  \n  >.right-column {\n    background: #F9FAFB;\n    padding: 64px 64px 0px 56px;\n\n    .testimonial {\n      margin: 0px;\n      margin-bottom: 4px;\n      \n      font-weight: 600;\n      font-size: 24px;\n      line-height: 28.8px;\n      color: #2A2F3C;\n\n      &.description {\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 125%;\n        // line-height: 140%;\n        color: #777b83;\n        margin-bottom: 6px;\n        margin-right: 16px;\n      }\n    }\n\n    .caption {\n      margin: 0px;\n\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 19.6px;\n      color: #404859;\n\n      >b {\n        font-weight: 600;\n      }\n    }\n\n    .welcome-image {\n      position: absolute;\n      bottom: -40px;\n      right: 0px;\n      max-height: 65vh;\n      width: 91%;\n\n      border-color: #355C7D;\n      border-width: 8px 0px 0px 8px;\n      border-style: solid;\n      border-radius: 10px 0px 0px 0px;\n    }\n  }\n\n  @media (min-height: 735px) {\n    .bottom-flex {\n      height: 470px;\n      img {\n        height: 100%;\n        // object-fit: cover;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
